/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 137);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(144);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(151)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export packageInfo */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaders;
/* harmony export (immutable) */ __webpack_exports__["e"] = isGuestUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = isAdminUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = isCommercialUser;
/* harmony export (immutable) */ __webpack_exports__["f"] = isNonCommercialUser;
/* harmony export (immutable) */ __webpack_exports__["g"] = loginGuest;
/* unused harmony export translateRequiredFields */
/* unused harmony export logoutAndRedirect */
/* harmony export (immutable) */ __webpack_exports__["h"] = redirectToSearch;
/* harmony export (immutable) */ __webpack_exports__["i"] = translateTypeIntoEnglish;
/* harmony export (immutable) */ __webpack_exports__["b"] = handleErrors;
var packageInfo=__webpack_require__(258);function defaultHeaders(){var headers=new Headers();var token=localStorage.getItem('token');if(token!==null){headers.append('Authorization','Bearer '+token);}return headers;}function isGuestUser(){var userString=localStorage.getItem('user');if(userString!==null){var user=JSON.parse(userString);return user.role==='guest';}return true;}function isAdminUser(){var userString=localStorage.getItem('user');if(userString!==null){return JSON.parse(userString).role==="admin";}return false;}function isCommercialUser(){var userString=localStorage.getItem('user');if(userString!==null){var user=JSON.parse(userString);return user.role==='commercial';}return false;}function isNonCommercialUser(){var userString=localStorage.getItem('user');if(userString!==null){var user=JSON.parse(userString);return user.role==='none-commercial';}return false;}function loginGuest(afterLoginAction){fetch("/api/login",{method:'POST',headers:{"Content-Type":"application/x-www-form-urlencoded"},body:"username=guest"}).then(function(resp){return resp.json();}).then(function(json){if(json.loggedIn){localStorage.setItem('user',JSON.stringify(json));localStorage.setItem('token',json.token);if(afterLoginAction!==undefined&&afterLoginAction!==null){afterLoginAction();}}});}function translateRequiredFields(string){switch(string){case"categories":return" mind. eine Kategorie ";case"name":return"Was Sie anbieten ";case"references":return" Ihre Spezialisierungsbereiche ";case"dl_agreement":return" Einverständnis-Erklärung";case"description":return" der Zweck Ihres Produkts";case"price":return" Preis ";case"sw_agreement_1":return"Erklärung zum Besitz 1";case"sw_agreement_2":return"Erklärung zum Besitz 2";case"sw_agreement_3":return"Erklärung zum Besitz 3";case"sw_agreement_4":return"Erklärung zum Besitz 4";case"sw_agreement_5":return"Erklärung zum Besitz 5";case"sw_agreement_6":return"Erklärung zum Besitz 6";case"agb_agreement":return"Vereinbarung";default:return string;}}function logoutAndRedirect(messageFunction,history){loginGuest(function(){var pathname=window.location.pathname;if(pathname!=='/'){messageFunction("Ihre Sitzung ist abgelaufen. Sie werden zur Startseite umgeleitet.");}else{}if(pathname!=='/'){setTimeout(function(){return history.push('/');},3000);}else{setTimeout(function(){return history.replace('/');},500);}});return true;}function redirectToSearch(searchString,history){localStorage.setItem('ayacandas_filter','');localStorage.setItem('ayacandas_search',searchString);setTimeout(function(){return history.push('/search');},500);return true;}function translateTypeIntoEnglish(type){switch(type){case"Dokument":return'document';case"Software":return'software';case"Dienstleistung":return"service";case"Ausschreibung":return"tender";case"Gebrauchtsoftware":return"used_software";case"Software F+L":return"researchsoftware";case"Dienstleistung Alt":return"service old";case"Software Alt":return"software old";case"Hardware und sonstige Angebote":return"other";default:return"unknown product type";}}function handleErrors(response){if(!response.ok)throw Error(response.statusText);return response;}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(179);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(176), __esModule: true };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(96);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(204);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(208);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(96);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__variables_js__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_css__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__header_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__footer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.openNav=_this.openNav.bind(_this);_this.closeNav=_this.closeNav.bind(_this);_this.toggleZoom=_this.toggleZoom.bind(_this);_this.state={zoomedIn:false};return _this;}_createClass(Header,[{key:'componentDidMount',value:function componentDidMount(){window.scrollTo(0,0);}},{key:'closeNav',value:function closeNav(){document.getElementById("mySidenav").style.width="0";document.getElementById("content").style.opacity="1";if(document.getElementById("IdFeeBoxNG")!==undefined&&document.getElementById("IdFeeBoxNG")!==null){document.getElementById("IdFeeBoxNG").style.opacity="1";}return true;}},{key:'openNav',value:function openNav(){document.getElementById("mySidenav").style.width="100%";document.getElementById("content").style.opacity="0.1";if(document.getElementById("IdFeeBoxNG")!==undefined&&document.getElementById("IdFeeBoxNG")!==null){document.getElementById("IdFeeBoxNG").style.opacity="0.1";}document.getElementById("nav-icon2").classList.toggle('open');if(!document.getElementById("nav-icon2").classList.contains('open')){this.closeNav();}return true;}},{key:'toggleZoom',value:function toggleZoom(zoomFactor){document.getElementById("app").style.transformOrigin="0 0";document.getElementById("app").style.transform="scale("+zoomFactor/100.0+")";if(zoomFactor>100){this.setState({zoomedIn:true});}else{this.setState({zoomedIn:false});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'headerContainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logoImg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerBeta',id:'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerFirstDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerText0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'headerAyaText',to:'/'},'Ayacandas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerText2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerAyaText'},'  Der Austausch-Marktplatz f\xFCr Kliniken'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerSecondDiv',id:'headerSecondDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'links1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'navSelected',className:'headerLink',to:'/',exact:true},'Startseite')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'navSelected',className:'headerLink',to:'/search'},'Suchen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'navSelected',className:'headerLink',to:'/update'},'Aktuelles')),this.props.username!=='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'navSelected',className:'headerLink',to:'/product-list'},'Meine Angebote')),this.props.username!=='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'navSelected',className:'headerLink',to:'/profile'},'Meine Daten')),__WEBPACK_IMPORTED_MODULE_2__util_js__["c" /* isAdminUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerLink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'navSelected',className:'headerLink',to:'/manage'},'Verwalten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headerLink'},this.props.username==='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeClassName:'navSelected',className:'headerLink',to:'/login',title:this.props.username},'Login'),this.props.username!=='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{onClick:function onClick(){return _this2.props.propagateLogin(true,'guest','guest',__WEBPACK_IMPORTED_MODULE_3__variables_js__["a" /* default */].guestJWT);},className:'headerLink',to:'/',title:this.props.username},'Logout'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' Zoom',id:'zoomtoggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:this.state.zoomedIn===false?{color:'white'}:null,className:'ZoomOut',onClick:function onClick(){return _this2.state.zoomedIn===true&&_this2.toggleZoom(100);}},'A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:this.state.zoomedIn===true?{color:'white'}:null,className:'ZoomIn',onClick:function onClick(){return _this2.toggleZoom(110);}},'A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'headeTextMobil'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'headeTextMobil',to:'/'},'Ayacandas ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Der Austausch-Marktplatz f\xFCr Kliniken')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'mobileNav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'NavIcon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'nav-icon2',onClick:this.openNav},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidenav',id:'mySidenav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeStyle:{color:'#eee197',pointerEvents:'none'},onClick:function onClick(){return _this2.closeNav();},to:'/search'},'Suchen'),(__WEBPACK_IMPORTED_MODULE_2__util_js__["f" /* isNonCommercialUser */]()||__WEBPACK_IMPORTED_MODULE_2__util_js__["d" /* isCommercialUser */]())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeStyle:{color:'#eee197',pointerEvents:'none'},onClick:function onClick(){return _this2.closeNav();},to:'/product-list'},'Anbieten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeStyle:{color:'#eee197',pointerEvents:'none'},onClick:function onClick(){return _this2.closeNav();},to:'/update'},'Aktuelles'),this.props.username!=='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeStyle:{color:'#eee197',pointerEvents:'none'},onClick:function onClick(){return _this2.closeNav();},to:'/profile'},'Meine Daten'),__WEBPACK_IMPORTED_MODULE_2__util_js__["c" /* isAdminUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{activeStyle:{color:'#eee197',pointerEvents:'none'},onClick:function onClick(){return _this2.closeNav();},to:'/manage'},'Verwalten'),this.props.username!=='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:'/',onClick:function onClick(){return _this2.props.propagateLogin(true,'guest','guest',__WEBPACK_IMPORTED_MODULE_3__variables_js__["a" /* default */].guestJWT);}},'Logout'),this.props.username==='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{to:'/login'},'Login')))));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__info_bar_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__footer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resource_contact_svg__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resource_contact_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__resource_contact_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resource_help_svg__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resource_help_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__resource_help_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_Component){_inherits(Footer,_Component);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footerTile',id:'footerTile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footerTileDownOneTile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__resource_help_svg___default.a,alt:'Hilfe'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footerHeaderText'},'Ben\xF6tigen Sie Hilfe oder Informationen?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footerContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__info_bar_js__["a" /* InfoBar */],{faq:this.props.faqs}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footerTileDownOneTile footerTileDownOneTileRight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__resource_contact_svg___default.a,alt:'Kontakt'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footerHeaderText'},'Kontakt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footerContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'F\xA0'),' +49 211-54 76 16 01 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'M\xA0'),' Kontakt@ayacandas.com ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'T\xA0'),' +49 211 54 76 16 0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button marginTop10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'toContactFormText',href:'/contact/#contactform'},'Zum Kontaktformular')),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'toContactFormText',href:'/contact/#contactId'},' \xDCber Ayacandas & Impressum ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(263);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(145);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',

  easeOut: function easeOut(duration, property, delay, easeFunction) {
    easeFunction = easeFunction || this.easeOutFunction;

    if (property && Object.prototype.toString.call(property) === '[object Array]') {
      var transitions = '';
      for (var i = 0; i < property.length; i++) {
        if (transitions) transitions += ',';
        transitions += this.create(duration, property[i], delay, easeFunction);
      }

      return transitions;
    } else {
      return this.create(duration, property, delay, easeFunction);
    }
  },
  create: function create(duration, property, delay, easeFunction) {
    duration = duration || '450ms';
    property = property || 'all';
    delay = delay || '0ms';
    easeFunction = easeFunction || 'linear';

    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(62)('wks');
var uid = __webpack_require__(50);
var Symbol = __webpack_require__(18).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(158);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(159);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(163);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(165);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(57);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(167);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(169);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(171);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(172);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(173);
/* unused harmony reexport withRouter */





























/***/ }),
/* 18 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(13);
var ctx = __webpack_require__(63);
var hide = __webpack_require__(33);
var has = __webpack_require__(24);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(94);
var toPrimitive = __webpack_require__(64);
var dP = Object.defineProperty;

exports.f = __webpack_require__(25) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);

exports.default = {

  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),

  horizontal: horizontal,

  vertical: vertical,

  origin: _propTypes2.default.shape({
    horizontal: horizontal,
    vertical: vertical
  }),

  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),

  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])

};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(36)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ProductDetails */
/* unused harmony export ProductType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ProductTypeWithoutParantheses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ProductTypeWithLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ProductRating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ProductDetailsButtons; });
/* unused harmony export ProductDetailsButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ProductDescriptionTender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ProductDescriptionSoftware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProductDescriptionService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ProductDescriptionUsedSoftware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductDescriptionOther; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ProductTechnicalDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ProductReferenceService; });
/* unused harmony export ProductStatistics */
/* unused harmony export ProductServices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ProductSoftwareNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ProductReviews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ProductMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ProductMediaMultiParent; });
/* unused harmony export ProductMediaMulti */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ProductPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TenderPrice; });
/* unused harmony export ProductPriceService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SoftwareStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ProductReferenceSoftwareNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ProductDescriptionResearchSoftware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProductDescriptionDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommUserInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__product_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__product_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stars__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_stars__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__review__ = __webpack_require__(369);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ProductDetails=function(_Component){_inherits(ProductDetails,_Component);function ProductDetails(props){_classCallCheck(this,ProductDetails);var _this=_possibleConstructorReturn(this,(ProductDetails.__proto__||Object.getPrototypeOf(ProductDetails)).call(this,props));_this.getProductDetails=_this.getProductDetails.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);_this.state={id:_this.props.params['id'],name:'',board:'',uuid:'',type:'',description:'',is_separate_sw:'',separate_sw:'',has_update_offer:'',update_offer:'',price_update:0,sw_type:'',is_kommune:'',tags:[],price:0,price_from:0,price_to:0,direct_database_access:'',direct_database_access_desc:'',has_additional_interface:'',additional_interface:'',has_additional_licence:'',additional_licence:'',data_component_complete:'',data_component_options:'',data_manupulation:'',data_manupulation_protocol:'',manipulation_authorised:'',manipulation_authorised_desc:'',data_update_interval:0,has_update_side_effect:'',update_side_effect:'',has_release_plan:'',release_plan:'',is_preparation_needed:'',preparation_needed:'',has_customer_reference:'',customer_reference:'',service_customer_reference:'',service_expertise:'',warrantor:'',successful_deployment:'',successful_deployment_description:'',clinic_count:'',clinic_count_description:'',statistic_user_counts:'',user_satisfaction:'',user_satisfaction_desc:'',sw_date:'',complexity_rate:'',referenced_services:[],statistics:'',referenced_software:[],reviews:'',numberOfStars:0};_this.getProductDetails(_this.props.params['id']);return _this;}_createClass(ProductDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.params['id'],10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getProductDetails(newID);this.setState({id:newID});}}},{key:'getProductDetails',value:function getProductDetails(productID){var self=this;var url='/api/get-product-details?id='+productID;var headers=Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not product details.',exception);});promise.then(function(json){var obj=JSON.parse(json[5][1]);self.setState({name:obj.name?obj.name:'(kein Name)',board:obj.board?obj.board:'',uuid:obj.uuid?obj.uuid:'',type:obj.type?obj.type:'(von unbekanntem Typ)',description:obj.description?obj.description:'(keine Beschreibung)',is_separate_sw:obj.is_separate_sw?obj.is_separate_sw:'(keine Angabe)',separate_sw:obj.separate_sw?obj.separate_sw:'(keine Beschreibung)',has_update_offer:obj.has_update_offer?obj.has_update_offer:'(keine Angabe)',update_offer:obj.update_offer?obj.update_offer:'(keine Beschreibung)',price_update:obj.price_update?obj.price_update:'(keine Angabe)',sw_type:obj.sw_type?obj.sw_type:'(keine Angabe)',is_kommune:obj.is_kommune?obj.is_kommune:'(keine Angabe)',tags:obj.tags?obj.tags:'(keine Angabe)',price:obj.price?obj.price:'(kein Preis Angegeben)',price_from:obj.price_from?obj.price_from:'(keine Angabe)',price_to:obj.price_to?obj.price_to:'(keine Angabe)',direct_database_access:obj.direct_database_access?obj.direct_database_access:'(keine Angabe)',direct_database_access_desc:obj.direct_database_access_desc?obj.direct_database_access_desc:'(keine Beschreibung)',has_additional_interface:obj.has_additional_interface?obj.has_additional_interface:'(keine Angabe)',additional_interface:obj.additional_interface?obj.additional_interface:'(keine Beschreibung)',has_additional_licence:obj.has_additional_licence?obj.has_additional_licence:'(keine Angabe)',additional_licence:obj.additional_licence?obj.additional_licence:'(keine Beschreibung)',data_component_complete:obj.data_component_complete?obj.data_component_complete:'(keine Angabe)',data_component_options:obj.data_component_options?obj.data_component_options:'(keine Beschreibung)',data_manupulation:obj.data_manupulation?obj.data_manupulation:'(keine Angabe)',data_manupulation_protocol:obj.data_manupulation_protocol?obj.data_manupulation_protocol:'(keine Beschreibung)',manipulation_authorised:obj.software_manipulation_authorised?obj.software_manipulation_authorised:'(keine Angabe)',manipulation_authorised_desc:obj.manipulation_authorised_desc?obj.manipulation_authorised_desc:'(keine Beschreibung)',data_update_interval:obj.data_update_interval?obj.data_update_interval:'(keine Angabe)',has_update_side_effect:obj.has_update_side_effect?obj.has_update_side_effect:'(keine Angabe)',update_side_effect:obj.update_side_effect?obj.update_side_effect:'(keine Beschreibung)',has_release_plan:obj.has_release_plan?obj.has_release_plan:'(keine Angabe)',release_plan:obj.release_plan?obj.release_plan:'(keine Beschreibung)',is_preparation_needed:obj.is_preparation_needed?obj.is_preparation_needed:'(keine Angabe)',preparation_needed:obj.preparation_needed?obj.preparation_needed:'(keine Beschreibung)',has_customer_reference:obj.has_customer_reference?obj.has_customer_reference:'(keine Angabe)',customer_reference:obj.customer_reference?obj.customer_reference:'(keine Beschreibung)',warrantor:obj.warrantor?obj.warrantor:'(keine Angabe)',successful_deployment:obj.successful_deployment?obj.successful_deployment:'(keine Angabe)',successful_deployment_description:obj.successful_deployment_description?obj.successful_deployment_description:'(keine Beschreibung)',clinic_count:obj.clinic_count?obj.clinic_count:'(keine Angabe)',clinic_count_description:obj.clinic_count_description?obj.clinic_count_description:'(keine Beschreibung)',statistic_user_counts:obj.statistic_user_counts?obj.statistic_user_counts:'(keine Angabe)',user_satisfaction:obj.user_satisfaction?obj.user_satisfaction:'(keine Angabe)',user_satisfaction_desc:obj.user_satisfaction_desc?obj.user_satisfaction_desc:'(keine Beschreibung)',sw_date:obj.sw_date?obj.sw_date:'(keine Angabe)',complexity_rate:obj.complexity_rate?obj.complexity_rate:'(keine Angabe)',referenced_services:obj.referenced_services,service_customer_reference:obj.service_customer_reference?obj.service_customer_reference:'(keine Angabe)',service_expertise:obj.service_expertise?obj.service_expertise:'(keine Angabe)',referenced_software:obj.referenced_software?obj.referenced_software:'(keine Angabe)'});return;});return;}},{key:'onSubmit',value:function onSubmit(review,numberOfStars){this.setState({review:review,numberOfStars:numberOfStars});}},{key:'render',value:function render(){if(this.state.type==="Dienstleistung Alt"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDetails',id:'mobileProductDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductDetailsButtons,{history:this.props.history,board:this.state.board,productID:this.state.id,productName:this.state.name,productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductType,{name:this.state.name,productType:this.state.type}),!__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPriceService,{price_from:this.state.price_from,price_to:this.state.price_to}),__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductRating,{uuid:this.state.uuid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsService,{productID:this.state.id,uuid:this.state.uuid,description:this.state.description,tags:this.state.tags,service_customer_reference:this.state.service_customer_reference,service_expertise:this.state.service_expertise,warrantor:this.state.warrantor,referenced_software:this.state.referenced_software}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDetails',id:'mobileProductDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductDetailsButtons,{history:this.props.history,board:this.state.board,productID:this.state.id,productName:this.state.name,productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductType,{name:this.state.name,productType:this.state.type}),!__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductPrice,{price:this.state.price}),__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductRating,{uuid:this.state.uuid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsSoftware,{productID:this.state.id,description:this.state.description,is_separate_sw:this.state.is_separate_sw,separate_sw:this.state.separate_sw,has_update_offer:this.state.has_update_offer,update_offer:this.state.update_offer,price_update:this.state.price_update,sw_type:this.state.sw_type,is_kommune:this.state.is_kommune,tags:this.state.tags,direct_database_access:this.state.direct_database_access,direct_database_access_desc:this.state.direct_database_access_desc,has_additional_interface:this.state.has_additional_interface,additional_interface:this.state.additional_interface,has_additional_licence:this.state.has_additional_licence,additional_licence:this.state.additional_licence,data_component_complete:this.state.data_component_complete,data_component_options:this.state.data_component_options,data_manupulation:this.state.data_manupulation,data_manupulation_protocol:this.state.data_manupulation_protocol,manipulation_authorised:this.state.manipulation_authorised,manipulation_authorised_desc:this.state.manipulation_authorised_desc,data_update_interval:this.state.data_update_interval,has_update_side_effect:this.state.has_update_side_effect,update_side_effect:this.state.update_side_effect,has_release_plan:this.state.has_release_plan,release_plan:this.state.release_plan,is_preparation_needed:this.state.is_preparation_needed,preparation_needed:this.state.preparation_needed,has_customer_reference:this.state.has_customer_reference,customer_reference:this.state.customer_reference,successful_deployment:this.state.successful_deployment,successful_deployment_description:this.state.successful_deployment_description,clinic_count:this.state.clinic_count,clinic_count_description:this.state.clinic_count_description,statistic_user_counts:this.state.statistic_user_counts,user_satisfaction:this.state.user_satisfaction,user_satisfaction_desc:this.state.user_satisfaction_desc,sw_date:this.state.sw_date,complexity_rate:this.state.complexity_rate,referenced_services:this.state.referenced_services}));}}]);return ProductDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsSoftware=function(_Component2){_inherits(ProductTabsSoftware,_Component2);function ProductTabsSoftware(props){_classCallCheck(this,ProductTabsSoftware);var _this2=_possibleConstructorReturn(this,(ProductTabsSoftware.__proto__||Object.getPrototypeOf(ProductTabsSoftware)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsSoftware,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Technische Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===3?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(3);}},'Statistik'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===4?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(4);}},'ref. Dienstleistungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===5?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(5);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===6?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(6);},style:{textDecoration:'line-through'}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductDescriptionSoftware,{style:this.state.activeTab===0?null:{display:'none'},description:this.props.description,is_separate_sw:this.props.is_separate_sw,separate_sw:this.props.separate_sw,has_update_offer:this.props.has_update_offer,update_offer:this.props.update_offer,price_update:this.props.price_update,sw_type:this.props.sw_type,is_kommune:this.props.is_kommune,tags:this.props.tags}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTechnicalDetails,{style:this.state.activeTab===1?null:{display:'none'},direct_database_access:this.props.direct_database_access,direct_database_access_desc:this.props.direct_database_access_desc,has_additional_interface:this.props.has_additional_interface,additional_interface:this.props.additional_interface,has_additional_licence:this.props.has_additional_licence,additional_licence:this.props.additional_licence,data_component_complete:this.props.data_component_complete,data_component_options:this.props.data_component_options,data_manupulation:this.props.data_manupulation,data_manupulation_protocol:this.props.data_manupulation_protocol,manipulation_authorised:this.props.manipulation_authorised,manipulation_authorised_desc:this.props.manipulation_authorised_desc,data_update_interval:this.props.data_update_interval,has_update_side_effect:this.props.has_update_side_effect,update_side_effect:this.props.update_side_effect,has_release_plan:this.props.has_release_plan,release_plan:this.props.release_plan,is_preparation_needed:this.props.is_preparation_needed,preparation_needed:this.props.preparation_needed}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductReferenceSoftware,{style:this.state.activeTab===2?null:{display:'none'},has_customer_reference:this.props.has_customer_reference,customer_reference:this.props.customer_reference}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductStatistics,{style:this.state.activeTab===3?null:{display:'none'},successful_deployment:this.props.successful_deployment,successful_deployment_description:this.props.successful_deployment_description,clinic_count:this.props.clinic_count,clinic_count_description:this.props.clinic_count_description,statistic_user_counts:this.props.statistic_user_counts,user_satisfaction:this.props.user_satisfaction,user_satisfaction_desc:this.props.user_satisfaction_desc,sw_date:this.props.sw_date,complexity_rate:this.props.complexity_rate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductServices,{key:this.props.productID,style:this.state.activeTab===4?null:{display:'none'},referenced_services:this.props.referenced_services}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductReviews,{uuid:this.props.uuid,style:this.state.activeTab===5?null:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductMedia,{style:this.state.activeTab===6?null:{display:'none'}})));}}]);return ProductTabsSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsService=function(_Component3){_inherits(ProductTabsService,_Component3);function ProductTabsService(props){_classCallCheck(this,ProductTabsService);var _this4=_possibleConstructorReturn(this,(ProductTabsService.__proto__||Object.getPrototypeOf(ProductTabsService)).call(this,props));_this4.makeActive=_this4.makeActive.bind(_this4);_this4.state={activeTab:0};return _this4;}_createClass(ProductTabsService,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this5.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this5.makeActive(1);}},'Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this5.makeActive(2);},style:{textDecoration:'line-through'}},'ref. Software'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===3?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this5.makeActive(3);},style:{textDecoration:'line-through'}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===4?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this5.makeActive(4);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductDescriptionService,{style:this.state.activeTab===0?null:{display:'none'},description:this.props.description,service_expertise:this.props.service_expertise,tags:this.props.tags}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductReferenceService,{style:this.state.activeTab===1?null:{display:'none'},service_customer_reference:this.props.service_customer_reference,warrantor:this.props.warrantor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductSoftware,{style:this.state.activeTab===2?null:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductMedia,{style:this.state.activeTab===3?null:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductReviews,{uuid:this.props.uuid,style:this.state.activeTab===4?null:{display:'none'}})));}}]);return ProductTabsService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductType=function(_Component4){_inherits(ProductType,_Component4);function ProductType(){_classCallCheck(this,ProductType);return _possibleConstructorReturn(this,(ProductType.__proto__||Object.getPrototypeOf(ProductType)).apply(this,arguments));}_createClass(ProductType,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductType'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},this.props.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' (',this.props.productType,')'));}}]);return ProductType;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTypeWithoutParantheses=function(_Component5){_inherits(ProductTypeWithoutParantheses,_Component5);function ProductTypeWithoutParantheses(){_classCallCheck(this,ProductTypeWithoutParantheses);return _possibleConstructorReturn(this,(ProductTypeWithoutParantheses.__proto__||Object.getPrototypeOf(ProductTypeWithoutParantheses)).apply(this,arguments));}_createClass(ProductTypeWithoutParantheses,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductType'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:''},this.props.name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.productType));}}]);return ProductTypeWithoutParantheses;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTypeWithLabel=function(_Component6){_inherits(ProductTypeWithLabel,_Component6);function ProductTypeWithLabel(){_classCallCheck(this,ProductTypeWithLabel);return _possibleConstructorReturn(this,(ProductTypeWithLabel.__proto__||Object.getPrototypeOf(ProductTypeWithLabel)).apply(this,arguments));}_createClass(ProductTypeWithLabel,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductType OpenSans Bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:''},'Typ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'FontBlue marginLeft1'},this.props.productType));}}]);return ProductTypeWithLabel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductRating=function(_Component7){_inherits(ProductRating,_Component7);function ProductRating(){_classCallCheck(this,ProductRating);return _possibleConstructorReturn(this,(ProductRating.__proto__||Object.getPrototypeOf(ProductRating)).apply(this,arguments));}_createClass(ProductRating,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Stars'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Bold marginTop2'},' Bewertung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop1 marginLeft1'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__static_stars__["a" /* StaticStars */],{uuid:this.props.uuid}))));}}]);return ProductRating;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDetailsButtons=function(_Component8){_inherits(ProductDetailsButtons,_Component8);function ProductDetailsButtons(props){_classCallCheck(this,ProductDetailsButtons);var _this10=_possibleConstructorReturn(this,(ProductDetailsButtons.__proto__||Object.getPrototypeOf(ProductDetailsButtons)).call(this,props));_this10.getPurchaseURL=_this10.getPurchaseURL.bind(_this10);_this10.getContactURL=_this10.getContactURL.bind(_this10);_this10.addBookmark=_this10.addBookmark.bind(_this10);_this10.state={purchaseURL:'',contactURL:'',board:'',productName:'',price:'',role_name:'',user_name:'',email:'',company:''};_this10.getProductInfo(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* translateTypeIntoEnglish */](_this10.props.productType),_this10.props.productID);return _this10;}_createClass(ProductDetailsButtons,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.board!==this.state.board){this.setState({board:nextProps.board});}if(nextProps.productName!==this.state.productName||nextProps.price!==this.state.price){this.setState({productName:nextProps.productName,price:nextProps.price},function(){if(!__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()){this.getPurchaseURL();this.getContactURL();}});}}},{key:'getPurchaseURL',value:function getPurchaseURL(){var _this11=this;var url='/api/fill-purchase-template';var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();var body='product_name='+encodeURIComponent(this.state.productName)+'&price='+this.state.price;headers.append("Content-Type","application/x-www-form-urlencoded");var promise=fetch(url,{method:'POST',headers:headers,body:body}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not fill in template.',exception);});promise.then(function(json){return json!==undefined?_this11.setState({purchaseURL:''+json.url}):null;});}},{key:'getContactURL',value:function getContactURL(){var _this12=this;var url='/api/fill-contact-template';var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();var body='product_name='+encodeURIComponent(this.state.productName);headers.append("Content-Type","application/x-www-form-urlencoded");var promise=fetch(url,{method:'POST',headers:headers,body:body}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not fill in template.',exception);});promise.then(function(json){return json!==undefined?_this12.setState({contactURL:''+json.url}):null;});}},{key:'addBookmark',value:function addBookmark(productID,productType,productName){var url='/api/add-bookmark';var headers=Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+productID+'&type='+__WEBPACK_IMPORTED_MODULE_3__util__["i" /* translateTypeIntoEnglish */](productType)+'&name='+productName}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not bookmark product.',exception);}).then(function(json){return null;});return;}},{key:'getProductInfo',value:function getProductInfo(table,id){var self=this;fetch('/api/get-product-info?table='+table+'&id='+id,{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Could not get product infos. ",error);}).then(function(json){self.setState({role_name:json[0].name?json[0].name:' (keine Angabe)',user_name:json[0].user_name?json[0].user_name:' (keine Angabe)',email:json[0].email?json[0].email:' (keine Angabe)',company:json[0].company?json[0].company:' (keine Angabe)'});});}},{key:'render',value:function render(){var _this13=this;var self=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDetailButtons'},!__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&this.state.role_name==='none-commercial'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button marginTop2',onClick:function onClick(event){setTimeout(function(){window.open(self.state.contactURL.replace(/html$/,'pdf'),"_blank");self.addBookmark(self.props.productID,self.props.productType,self.props.productName);},3000);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'In einem neuen Tab wird ein Formular generiert, bitte das Formular ausdrucken und unterschrieben an Ayacandas zur\xFCck faxen: +49-211-547616-01.','data-tooltip-position':'bottom'},'ANBIETER KONTAKTIEREN \u24D8')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button marginTop2',onClick:function onClick(event){return _this13.props.history.push('/board/'+_this13.state.board);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'FORUM')),!__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button marginTop2',onClick:function onClick(){_this13.addBookmark(_this13.props.productID,_this13.props.productType,_this13.props.productName);alert('Bookmark wurde gesetzt.');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'BOOKMARK SETZEN')),!__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button marginTop2',onClick:function onClick(event){setTimeout(function(){window.open(self.state.purchaseURL.replace(/html$/,'pdf'),"_blank");self.addBookmark(self.props.productID,self.props.productType,self.props.productName);},3000);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'In einem neuen Tab wird ein Formular generiert, bitte das Formular ausdrucken und unterschrieben an Ayacandas zur\xFCck faxen: +49-211-547616-01.','data-tooltip-position':'bottom'},'ANGEBOT ANFORDERN \u24D8')));}}]);return ProductDetailsButtons;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDetailsButton=function(_Component9){_inherits(ProductDetailsButton,_Component9);function ProductDetailsButton(){_classCallCheck(this,ProductDetailsButton);return _possibleConstructorReturn(this,(ProductDetailsButton.__proto__||Object.getPrototypeOf(ProductDetailsButton)).apply(this,arguments));}_createClass(ProductDetailsButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:this.props.style},this.props.text));}}]);return ProductDetailsButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDescriptionTender=function(_Component10){_inherits(ProductDescriptionTender,_Component10);function ProductDescriptionTender(){_classCallCheck(this,ProductDescriptionTender);return _possibleConstructorReturn(this,(ProductDescriptionTender.__proto__||Object.getPrototypeOf(ProductDescriptionTender)).apply(this,arguments));}_createClass(ProductDescriptionTender,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Beschreibung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.description,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Zweck '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.aim,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Das Produkt ist prim\xE4r f\xFCr '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.target_group)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tags '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.tags)));}}]);return ProductDescriptionTender;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDescriptionSoftware=function(_Component11){_inherits(ProductDescriptionSoftware,_Component11);function ProductDescriptionSoftware(){_classCallCheck(this,ProductDescriptionSoftware);return _possibleConstructorReturn(this,(ProductDescriptionSoftware.__proto__||Object.getPrototypeOf(ProductDescriptionSoftware)).apply(this,arguments));}_createClass(ProductDescriptionSoftware,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Beschreibung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.description,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Diese Software kann f\xFCr K\xE4ufer aus \xF6ffentlichen Institutionen (Gemeinden, Kommunen, Universit\xE4ten, Anstalten des Landes etc.) ohne Ausschreibung und direkt erworben werden '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.is_kommune===true?'Ja':'Nein',' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'ein eigenstehendes Produkt oder eine Implementation '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.is_separate_sw===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.separate_sw)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Gibt es Wartungen oder Updates? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.has_update_offer===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.update_offer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Kosten je Jahr '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.price_update,' \u20AC')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Das Produkt ist prim\xE4r f\xFCr '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.sw_type)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tags '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.tags)));}}]);return ProductDescriptionSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDescriptionService=function(_Component12){_inherits(ProductDescriptionService,_Component12);function ProductDescriptionService(){_classCallCheck(this,ProductDescriptionService);return _possibleConstructorReturn(this,(ProductDescriptionService.__proto__||Object.getPrototypeOf(ProductDescriptionService)).apply(this,arguments));}_createClass(ProductDescriptionService,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Beschreibung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.description),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Auf bestimmte Bereiche spezialisiert '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.service_expertise,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tags '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.tags,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return ProductDescriptionService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDescriptionUsedSoftware=function(_Component13){_inherits(ProductDescriptionUsedSoftware,_Component13);function ProductDescriptionUsedSoftware(){_classCallCheck(this,ProductDescriptionUsedSoftware);return _possibleConstructorReturn(this,(ProductDescriptionUsedSoftware.__proto__||Object.getPrototypeOf(ProductDescriptionUsedSoftware)).apply(this,arguments));}_createClass(ProductDescriptionUsedSoftware,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Zweck der Software'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.aim,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Die Software geschrieben von der Firma:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.company,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Die genaue Bezeichnung des Herstellers zu dieser Software:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.company_name,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Hersteller-Webseite zur genaueren Information \xFCber diese Software:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.company_web,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Ist die Software ein Medizinprodukt'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.is_public===true?'Ja':'Nein')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Braucht die Software ein Update, um auf einer aktuellen Version zu sein '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.is_update_available===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.update_price_text,' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tags '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.tags)));}}]);return ProductDescriptionUsedSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDescriptionOther=function(_Component14){_inherits(ProductDescriptionOther,_Component14);function ProductDescriptionOther(){_classCallCheck(this,ProductDescriptionOther);return _possibleConstructorReturn(this,(ProductDescriptionOther.__proto__||Object.getPrototypeOf(ProductDescriptionOther)).apply(this,arguments));}_createClass(ProductDescriptionOther,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Beschreibung zu dem Produkt'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.aim,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tags '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.tags)));}}]);return ProductDescriptionOther;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTechnicalDetails=function(_Component15){_inherits(ProductTechnicalDetails,_Component15);function ProductTechnicalDetails(){_classCallCheck(this,ProductTechnicalDetails);return _possibleConstructorReturn(this,(ProductTechnicalDetails.__proto__||Object.getPrototypeOf(ProductTechnicalDetails)).apply(this,arguments));}_createClass(ProductTechnicalDetails,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Gibt es einen direkten Datenbankzugriff? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.direct_database_access===true?'Ja':'Nein')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Art des Datenzugriffs '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.direct_database_access_desc)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Werden zus\xE4tzliche Schnittstellen ben\xF6tigt? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.has_additional_interface===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.additional_interface)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Werden zus\xE4tzliche Lizenzen ben\xF6tigt? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.has_additional_licence===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.additional_licence)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Werden alle Komponenten zum Datenzugriff geliefert? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.data_component_complete===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.data_component_options)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Werden Daten am Quellsystem manipuliert? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.data_manupulation===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.data_manupulation_protocol),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Ist der Zugriff zu der Datenquelle authorisiert? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.manipulation_authorised===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.manipulation_authorised_desc)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Aktualisierungsintervall in Minuten '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.data_update_interval)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Gibt es Aktualisierungsnebenwirkungen? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.has_update_side_effect===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.update_side_effect)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Gibt es einen Releaseplan?'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.has_release_plan===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.release_plan)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Sind weitere Vorbereitungen n\xF6tig'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},' ',this.props.is_preparation_needed===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.preparation_needed)));}}]);return ProductTechnicalDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductReferenceSoftware=function(_Component16){_inherits(ProductReferenceSoftware,_Component16);function ProductReferenceSoftware(){_classCallCheck(this,ProductReferenceSoftware);return _possibleConstructorReturn(this,(ProductReferenceSoftware.__proto__||Object.getPrototypeOf(ProductReferenceSoftware)).apply(this,arguments));}_createClass(ProductReferenceSoftware,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'vorhandene Referenzen '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.has_customer_reference===true?'Ja':'Nein',' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.customer_reference)));}}]);return ProductReferenceSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductReferenceService=function(_Component17){_inherits(ProductReferenceService,_Component17);function ProductReferenceService(){_classCallCheck(this,ProductReferenceService);return _possibleConstructorReturn(this,(ProductReferenceService.__proto__||Object.getPrototypeOf(ProductReferenceService)).apply(this,arguments));}_createClass(ProductReferenceService,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'vorhandene Referenzen'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.service_customer_reference)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'B\xFCrgen als Referenz vorhanden'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.warrantor)));}}]);return ProductReferenceService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductStatistics=function(_Component18){_inherits(ProductStatistics,_Component18);function ProductStatistics(){_classCallCheck(this,ProductStatistics);return _possibleConstructorReturn(this,(ProductStatistics.__proto__||Object.getPrototypeOf(ProductStatistics)).apply(this,arguments));}_createClass(ProductStatistics,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'wurde das Produkt schon erfolgreich eingesetzt '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.successful_deployment===true?'Ja':'Nein'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.successful_deployment_description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'welche sind die Einsatzbereiche Ihre Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.clinic_count_description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'wieviele Nutzer hat Ihre Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.statistic_user_counts)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'wieviele davon sind Kliniken '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.clinic_count,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.clinic_count_description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'mittlere Zufriedenheit der Nutzer '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.user_satisfaction),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.user_satisfaction_desc)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'seit wann ist das Produkt in Nutzung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.sw_date)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'pers\xF6nliche Komplexit\xE4tsbewertung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.complexity_rate)));}}]);return ProductStatistics;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductServices=function(_Component19){_inherits(ProductServices,_Component19);function ProductServices(props){_classCallCheck(this,ProductServices);var _this24=_possibleConstructorReturn(this,(ProductServices.__proto__||Object.getPrototypeOf(ProductServices)).call(this,props));_this24.state={services:[]};return _this24;}_createClass(ProductServices,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({services:nextProps.referenced_services.map(function(obj){var url='/product-details/'+obj.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:Math.random(),title:obj.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url},obj.name));})});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{listStyleType:'none',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},this.state.services,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}}]);return ProductServices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductSoftwareNew=function(_Component20){_inherits(ProductSoftwareNew,_Component20);function ProductSoftwareNew(props){_classCallCheck(this,ProductSoftwareNew);var _this25=_possibleConstructorReturn(this,(ProductSoftwareNew.__proto__||Object.getPrototypeOf(ProductSoftwareNew)).call(this,props));_this25.getReferencedSoftwareNames=_this25.getReferencedSoftwareNames.bind(_this25);_this25.state={referenced_software:[],names:''};return _this25;}_createClass(ProductSoftwareNew,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({referenced_software:nextProps.referenced_software.toString().split(/,/).filter(function(item){return parseInt(item,10)===item;}).map(function(str,i){var url='/show-software/'+str;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:Math.random(),title:"Titel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:url},"referenzierte Software "+(i+1)));})});this.getReferencedSoftwareNames(nextProps.referenced_software.toString());}},{key:'getReferencedSoftwareNames',value:function getReferencedSoftwareNames(ids){var self=this;var url='/api/get-software-names?ids='+ids;var headers=Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not fetch referenced software names.',exception);});promise.then(function(json){self.setState({names:json.map(function(obj){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:Math.random(),title:"Titel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/show-software/'+obj.id},''+obj.name));})});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{listStyleType:'none',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.state.names)));}}]);return ProductSoftwareNew;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductSoftware=function(_Component21){_inherits(ProductSoftware,_Component21);function ProductSoftware(){_classCallCheck(this,ProductSoftware);return _possibleConstructorReturn(this,(ProductSoftware.__proto__||Object.getPrototypeOf(ProductSoftware)).apply(this,arguments));}_createClass(ProductSoftware,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{listStyleType:'none',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}}]);return ProductSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductReviews=function(_Component22){_inherits(ProductReviews,_Component22);function ProductReviews(props){_classCallCheck(this,ProductReviews);var _this27=_possibleConstructorReturn(this,(ProductReviews.__proto__||Object.getPrototypeOf(ProductReviews)).call(this,props));_this27.sendReview=_this27.sendReview.bind(_this27);_this27.getReview=_this27.getReview.bind(_this27);_this27.getAllReviews=_this27.getAllReviews.bind(_this27);_this27.state={rating:0,review:'',uuid:'',reviews:[],owner:''};return _this27;}_createClass(ProductReviews,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.uuid!==undefined&&nextProps.uuid!==null&&nextProps.uuid!==''&&nextProps.uuid!==this.state.uuid){this.getReview(nextProps.uuid);this.setState({uuid:nextProps.uuid});}}},{key:'getReview',value:function getReview(uuid){var self=this;var url='/api/get-review?uuid='+uuid;var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not create review node!',exception);}).then(function(json){return json!==undefined?self.setState({rating:json.rating!==undefined?json.rating:0,review:json.review!==undefined?json.review:'',owner:json.product_owner}):json;});}},{key:'sendReview',value:function sendReview(){if(window.confirm('Ihre Bewertung tatsächlich abschicken?')){var url='/api/add-review';var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'uuid='+this.props.uuid+'&rating='+this.state.rating+'&review='+this.state.review}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte das Review nicht in der Datenbank anlegen!');console.error('Could not create review node!',exception);}).then(function(json){return alert('Ihre Bewertung wurde aktualisiert. (Neu laden um die durchschnittliche Bewertung zu sehen.)');});}}},{key:'getAllReviews',value:function getAllReviews(uuid){var self=this;var url='/api/get-all-reviews?uuid='+uuid;var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not get reviews!',exception);}).then(function(json){return self.setState({reviews:json});});}},{key:'render',value:function render(){var _this28=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},!__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()&&JSON.parse(localStorage.getItem('user')).username!==this.state.owner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LabelAndStar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'DetailDiv'},'Ihre Bewertung f\xFCr das Produkt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__stars__["a" /* Stars */],{notifyRatingChanged:function notifyRatingChanged(value){return _this28.setState({rating:value});},rating:this.state.rating})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv ReviewDivText'},'Bemerkungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'RatingContent marginTop10',id:'mobilRatingContent',value:this.state.review,placeholder:'',onChange:function onChange(event){return _this28.setState({review:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ToEndRightV2 marginTop2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(event){return _this28.sendReview();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductDetailsButton,{link:'/',text:'Bewertung abschicken'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv padding2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'alle Bewertungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button margin-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(event){return _this28.getAllReviews(_this28.state.uuid);}},this.state.review===[]?'laden':'neu laden')),this.state.reviews.map(function(obj,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__review__["a" /* ReviewEntry */],{key:i,rating:obj.rating,review:obj.review});})));}}]);return ProductReviews;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductMedia=function(_Component23){_inherits(ProductMedia,_Component23);function ProductMedia(props){_classCallCheck(this,ProductMedia);var _this29=_possibleConstructorReturn(this,(ProductMedia.__proto__||Object.getPrototypeOf(ProductMedia)).call(this,props));_this29.downloadLink=_this29.downloadLink.bind(_this29);_this29.getFileInfo=_this29.getFileInfo.bind(_this29);_this29.state={fileName:null,uuid:null};return _this29;}_createClass(ProductMedia,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.uuid!==this.state.uuid&&nextProps.uuid!==undefined){this.getFileInfo(nextProps.uuid);}}},{key:'getFileInfo',value:function getFileInfo(uuid){var self=this;fetch('/api/get-file-infos?uuids='+uuid,{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Could not get file infos. ",error);}).then(function(json){self.setState({fileName:json[0].fileName,uuid:uuid});});}},{key:'downloadLink',value:function downloadLink(){return window.location.protocol+'//'+window.location.host+'/'+this.state.uuid+'/'+this.state.fileName;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument ProductMedia',style:this.props.style},this.state.uuid===null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{calssName:'openSans'},'Dokumentation '),' '):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Dokumentation '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'bold',color:'#1F6A81'}},this.state.fileName),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:this.downloadLink(),target:'_blank'},' \u2193 ')))));}}]);return ProductMedia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductMediaMultiParent=function(_Component24){_inherits(ProductMediaMultiParent,_Component24);function ProductMediaMultiParent(){_classCallCheck(this,ProductMediaMultiParent);return _possibleConstructorReturn(this,(ProductMediaMultiParent.__proto__||Object.getPrototypeOf(ProductMediaMultiParent)).apply(this,arguments));}_createClass(ProductMediaMultiParent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument ProductMedia',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductMediaMulti,{heading:this.props.heading1,uuids:this.props.uuids1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductMediaMulti,{heading:this.props.heading2,uuids:this.props.uuids2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductMediaMulti,{heading:this.props.heading3,uuids:this.props.uuids3})));}}]);return ProductMediaMultiParent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductMediaMulti=function(_Component25){_inherits(ProductMediaMulti,_Component25);function ProductMediaMulti(props){_classCallCheck(this,ProductMediaMulti);var _this31=_possibleConstructorReturn(this,(ProductMediaMulti.__proto__||Object.getPrototypeOf(ProductMediaMulti)).call(this,props));_this31.downloadLink=_this31.downloadLink.bind(_this31);_this31.getFileInfo=_this31.getFileInfo.bind(_this31);_this31.downloadElements=_this31.downloadElements.bind(_this31);var splitted=_this31.props.uuids.split(/,/);_this31.state={length:splitted.length,fileNames:splitted.map(function(item){return null;}),uuids:splitted.map(function(item){return null;})};return _this31;}_createClass(ProductMediaMulti,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.uuids!==this.state.uuids&&nextProps.uuids!==undefined){this.getFileInfo(nextProps.uuids);}}},{key:'getFileInfo',value:function getFileInfo(uuids){var self=this;fetch('/api/get-file-infos?uuids='+uuids,{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Could not get file infos. ",error);}).then(function(json){var length=json.length;var newFilenames=json.map(function(obj){return obj!==null?obj.fileName:null;});var newUUIDs=json.map(function(obj){return obj!==null?obj.uuid:null;});var newValue='';for(var i=0;i<length;i++){newValue=newValue.concat(newUUIDs[i]!==null?newUUIDs[i].toString():'');if(i+1<length){newValue=newValue.concat(',');}}self.setState({length:length,fileNames:newFilenames,uuids:newUUIDs});});}},{key:'downloadLink',value:function downloadLink(i){return window.location.protocol+'//'+window.location.host+'/'+this.state.uuids[i]+'/'+this.state.fileNames[i];}},{key:'downloadElements',value:function downloadElements(){var self=this;return this.state.fileNames.map(function(fileName,i){if(fileName!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,style:{margin:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'bold',color:'green'}},fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'MediaDownloadArrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:self.downloadLink(i),target:'_blank'},' \u2193 ')));}return null;});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.uuids!==null&&this.state.uuids!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.heading,' '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.downloadElements()):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.heading,' '),' '));}}]);return ProductMediaMulti;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductPrice=function(_Component26){_inherits(ProductPrice,_Component26);function ProductPrice(){_classCallCheck(this,ProductPrice);return _possibleConstructorReturn(this,(ProductPrice.__proto__||Object.getPrototypeOf(ProductPrice)).apply(this,arguments));}_createClass(ProductPrice,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:''},'Preis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'FontBlue marginLeft1'},' ',this.props.price,' \u20AC'));}}]);return ProductPrice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var TenderPrice=function(_Component27){_inherits(TenderPrice,_Component27);function TenderPrice(){_classCallCheck(this,TenderPrice);return _possibleConstructorReturn(this,(TenderPrice.__proto__||Object.getPrototypeOf(TenderPrice)).apply(this,arguments));}_createClass(TenderPrice,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'Bold'},'Finanzielle Gr\xF6\xDFenordnung: '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'FontBlue marginLeft1'},this.props.price));}}]);return TenderPrice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductPriceService=function(_Component28){_inherits(ProductPriceService,_Component28);function ProductPriceService(){_classCallCheck(this,ProductPriceService);return _possibleConstructorReturn(this,(ProductPriceService.__proto__||Object.getPrototypeOf(ProductPriceService)).apply(this,arguments));}_createClass(ProductPriceService,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'nanoSans'},'Preis von: '),' ',this.props.price_from,' \u20AC',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'nanoSans'},' bis: '),' ',this.props.price_to,' \u20AC');}}]);return ProductPriceService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SoftwareStatistics=function(_Component29){_inherits(SoftwareStatistics,_Component29);function SoftwareStatistics(){_classCallCheck(this,SoftwareStatistics);return _possibleConstructorReturn(this,(SoftwareStatistics.__proto__||Object.getPrototypeOf(SoftwareStatistics)).apply(this,arguments));}_createClass(SoftwareStatistics,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'wurde das Produkt schon erfolgreich eingesetzt '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.successful_deployment===true?'Ja':'Nein',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},' ',this.props.successful_deployment_description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'welche sind die Einsatzbereiche Ihre Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.clinic_desc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'wieviele Nutzer hat Ihre Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.user_number),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'wieviele davon sind Kliniken '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.clinic_number,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.clinic_count_description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'mittlere Zufriedenheit der Nutzer '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.satisfaction_rate),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',this.props.rating_desc),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'seit wann ist das Produkt in Nutzung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.date),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'pers\xF6nliche Komplexit\xE4tsbewertung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.complexity_rate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return SoftwareStatistics;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductReferenceSoftwareNew=function(_Component30){_inherits(ProductReferenceSoftwareNew,_Component30);function ProductReferenceSoftwareNew(){_classCallCheck(this,ProductReferenceSoftwareNew);return _possibleConstructorReturn(this,(ProductReferenceSoftwareNew.__proto__||Object.getPrototypeOf(ProductReferenceSoftwareNew)).apply(this,arguments));}_createClass(ProductReferenceSoftwareNew,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'vorhandene Referenzen '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.has_customer_reference===true?'Ja':'Nein','  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},' ',this.props.customer_reference),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return ProductReferenceSoftwareNew;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDescriptionResearchSoftware=function(_Component31){_inherits(ProductDescriptionResearchSoftware,_Component31);function ProductDescriptionResearchSoftware(){_classCallCheck(this,ProductDescriptionResearchSoftware);return _possibleConstructorReturn(this,(ProductDescriptionResearchSoftware.__proto__||Object.getPrototypeOf(ProductDescriptionResearchSoftware)).apply(this,arguments));}_createClass(ProductDescriptionResearchSoftware,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Beschreibung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.desc,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Typ der Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.researchtype,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Wof\xFCr wurde die Software geschrieben? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},' ',this.props.aim,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Funktionsbeschreibung '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.functionality,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Besonderheiten der Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.specialties,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Zielgruppe der Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.target,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Wo wurde die Software verwendet? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.usage,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Ein eigenstehendes Produkt oder eine Implementation '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.is_standalone_sw===true?'Ja':'Nein',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',this.props.standalone_sw,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tags '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.tags,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))));}}]);return ProductDescriptionResearchSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductDescriptionDocument=function(_Component32){_inherits(ProductDescriptionDocument,_Component32);function ProductDescriptionDocument(){_classCallCheck(this,ProductDescriptionDocument);return _possibleConstructorReturn(this,(ProductDescriptionDocument.__proto__||Object.getPrototypeOf(ProductDescriptionDocument)).apply(this,arguments));}_createClass(ProductDescriptionDocument,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductDescriptionDocument',style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Wof\xFCr wurde das Dokument geschrieben? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.aim,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Typ des Dokumentes '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.doctype,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Inhalt des Dokumentes '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.content),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Links '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.links),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Tags '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.tags,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Die Zielgruppe des Dokumentes '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.target,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Besonderheiten des Dokumentes '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.specialties,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Wo wurde das Dokument verwendet? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.usage,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Sind die Dokumente z.B. bereits der DFG oder einer Wirtschaftspr\xFCfungsgesellschaft vorgelegt worden? '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.review1),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Sind die Dokumente schon einmal erfolgreich begutachtet worden? Wenn ja, von wem?'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'ProductDetailAnswers'},this.props.review2,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return ProductDescriptionDocument;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CommUserInfo=function(_Component33){_inherits(CommUserInfo,_Component33);function CommUserInfo(props){_classCallCheck(this,CommUserInfo);var _this39=_possibleConstructorReturn(this,(CommUserInfo.__proto__||Object.getPrototypeOf(CommUserInfo)).call(this,props));_this39.getProductInfo=_this39.getProductInfo.bind(_this39);_this39.state={id:_this39.props.id,table:_this39.props.table,role_name:'',user_name:'',email:'',company:''};_this39.getProductInfo(_this39.state.table,_this39.state.id);return _this39;}_createClass(CommUserInfo,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.id!==this.state.id||nextProps.table!==this.state.table){this.setState({id:nextProps.id,table:nextProps.table});}}},{key:'getProductInfo',value:function getProductInfo(table,id){var self=this;fetch('/api/get-product-info?table='+table+'&id='+id,{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Could not get product infos. ",error);}).then(function(json){self.setState({role_name:json[0].name?json[0].name:' (keine Angabe)',user_name:json[0].user_name?json[0].user_name:' (keine Angabe)',email:json[0].email?json[0].email:' (keine Angabe)',company:json[0].company?json[0].company:' (keine Angabe)'});});}},{key:'render',value:function render(){if(this.state.role_name==='commercial'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'Bold'},' Firma ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'FontBlue marginLeft1'},' ',this.state.company,' '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'Bold'},' E-mail ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'FontBlue marginLeft1'},' ',this.state.email,' ')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' ');}}}]);return CommUserInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategoryPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategoryPathWithLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__product_details_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CategoryPath=function(_Component){_inherits(CategoryPath,_Component);function CategoryPath(props){_classCallCheck(this,CategoryPath);var _this=_possibleConstructorReturn(this,(CategoryPath.__proto__||Object.getPrototypeOf(CategoryPath)).call(this,props));_this.display=_this.display.bind(_this);_this.getFullPaths=_this.getFullPaths.bind(_this);_this.state={ids:null,startID:_this.props.startID,fullPaths:null,shortView:[true,true,true,true,true,true,true,true,true,true,true,true]//<- this fixed length is bad
};return _this;}_createClass(CategoryPath,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.ids!==this.state.ids){this.setState({ids:nextProps.ids});this.getFullPaths(nextProps.ids);}}},{key:'display',value:function display(array,pos){var newArray=[];if(this.state.shortView[pos]===false){for(var i=0;i<array.length;i++){newArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:i+1<array.length?{color:'black'}:{color:'green',fontWeight:'bold'}},array[i]));if(i+1<array.length){newArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+1000,style:{color:'green'}},' \u25B6 '));}}}else{var length=array.length-1;newArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:{color:'green',fontWeight:'bold'}},'\u25B6 ',array[length],' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}return newArray;}},{key:'getFullPaths',value:function getFullPaths(ids){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var url='/api/category-full-paths?ids='+ids+'&startid='+this.props.startID;var promise=fetch(url,{method:'GET',mode:'cors',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte den vollen Kategoriepfad nicht ermitteln!');console.error('Could not retreive category node information!',exception);});promise.then(function(json){self.setState({fullPaths:json});});}},{key:'render',value:function render(){var self=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.fullPaths!==null&&this.state.fullPaths!==undefined?this.state.fullPaths.map(function(elem,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{cursor:'pointer'},key:i,onClick:function onClick(){var newShortView=self.state.shortView.slice();newShortView[i]=!newShortView[i];self.setState({shortView:newShortView});}},' ',self.display(elem,i),' ');}):null));}}]);return CategoryPath;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CategoryPathWithLabel=function(_Component2){_inherits(CategoryPathWithLabel,_Component2);function CategoryPathWithLabel(props){_classCallCheck(this,CategoryPathWithLabel);var _this2=_possibleConstructorReturn(this,(CategoryPathWithLabel.__proto__||Object.getPrototypeOf(CategoryPathWithLabel)).call(this,props));_this2.display=_this2.display.bind(_this2);_this2.getFullPaths=_this2.getFullPaths.bind(_this2);_this2.state={ids:null,startID:_this2.props.startID,fullPaths:null,shortView:[true,true,true,true,true,true,true,true,true,true,true,true]//<- this fixed length is bad
};return _this2;}_createClass(CategoryPathWithLabel,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.ids!==this.state.ids){this.setState({ids:nextProps.ids});this.getFullPaths(nextProps.ids);}}},{key:'display',value:function display(array,pos){var newArray=[];if(this.state.shortView[pos]===false){for(var i=0;i<array.length;i++){newArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:i+1<array.length?{color:'#1F6A81'}:{color:'#1F6A81',fontWeight:'bold'}},array[i]));if(i+1<array.length){newArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+1000,style:{color:'#1F6A81'}},' \u25B6 '));}}}else{var length=array.length-1;newArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:{color:'#1F6A81',fontWeight:'bold'}},'\u25B6 ',array[length],' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}return newArray;}},{key:'getFullPaths',value:function getFullPaths(ids){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var url='/api/category-full-paths?ids='+ids+'&startid='+this.props.startID;var promise=fetch(url,{method:'GET',mode:'cors',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte den vollen Kategoriepfad nicht ermitteln!');console.error('Could not retreive category node information!',exception);});promise.then(function(json){self.setState({fullPaths:json});});}},{key:'render',value:function render(){var self=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Bold'},'Kategorie'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.fullPaths!==null&&this.state.fullPaths!==undefined?this.state.fullPaths.map(function(elem,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{cursor:'pointer'},key:i,onClick:function onClick(){var newShortView=self.state.shortView.slice();newShortView[i]=!newShortView[i];self.setState({shortView:newShortView});}},' ',self.display(elem,i),' ');}):null));}}]);return CategoryPathWithLabel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CategorySelectorList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_selector_rewrite_css__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__category_selector_rewrite_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__category_selector_rewrite_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//TODOS: category search, new category suggestion, help overlay
//       update surrounding form, replace old selector in all product types
//       check requirements again, consider leaves only,
//       show state of category selection (duplicates, finished y/n)
var CategorySelectorList=function(_Component){_inherits(CategorySelectorList,_Component);function CategorySelectorList(props){_classCallCheck(this,CategorySelectorList);var _this=_possibleConstructorReturn(this,(CategorySelectorList.__proto__||Object.getPrototypeOf(CategorySelectorList)).call(this,props));_this.categoryInfo={};_this.addBox=_this.addBox.bind(_this);_this.deleteBox=_this.deleteBox.bind(_this);_this.updateCategory=_this.updateCategory.bind(_this);var initialCategories=[];_this.state={divIDs:[],categories:initialCategories,value:null,finallySelected:null,categoryLimit:_this.props.categoryLimit!==undefined?_this.props.categoryLimit:6};return _this;}_createClass(CategorySelectorList,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){var _this2=this;if(nextProps.value!==this.state.value){var categories=typeof nextProps.value==='string'?nextProps.value.split(','):nextProps.value;categories=categories.map(function(item){return parseInt(item,10);}).filter(function(parsed){return!isNaN(parsed);});if(categories.length===0){categories=new Array(0);categories.push(2);}var newIDs=new Array(0);for(var i=0;i<categories.length;i++){newIDs.push(Math.round(Math.random()*1000000));}var newCategories={};newIDs.map(function(elt,i){return newCategories[elt]=categories[i];});this.setState({divIDs:newIDs,categories:newCategories,value:nextProps.value},function(){return newIDs.map(function(id){return _this2.updateCategory(newCategories[id],id);});});}}},{key:'updateCategory',value:function updateCategory(id,divID){var _this3=this;var categories=this.state.categories;categories[divID]=id;if(this.categoryInfo[id]!==undefined){this.setState({categories:categories},function(){return _this3.setState({finallySelected:serializeCategories(_this3,_this3.state.categoryLimit,_this3.categoryInfo)},function(){return _this3.props.update(_this3.props.slot,_this3.state.finallySelected);});});}else{var self=this;getCategoryInfo(id).then(function(json){self.categoryInfo[id]=json;self.setState({categories:categories},function(){return self.setState({finallySelected:serializeCategories(self,self.state.categoryLimit,self.categoryInfo)},function(){return self.props.update(self.props.slot,self.state.finallySelected);});});});}}},{key:'deleteBox',value:function deleteBox(divID){var _this4=this;var array=this.state.divIDs;array=array.filter(function(id){return id!==divID;});var categories=this.state.categories;delete categories[divID];this.setState({divIDs:array,categories:categories},function(){return _this4.setState({finallySelected:serializeCategories(_this4,_this4.state.categoryLimit,_this4.categoryInfo)},function(){return _this4.props.update(_this4.props.slot,_this4.state.finallySelected);});});}},{key:'addBox',value:function addBox(){var _this5=this;var array=this.state.divIDs;var newID=Math.round(Math.random()*1000000);array.push(newID);var categories=this.state.categories;categories[newID]=2;this.setState({divIDs:array,categories:categories},function(){return _this5.updateCategory(2,newID);});}},{key:'boxes',value:function boxes(){var array=this.state.divIDs;var count=array.length;var max=this.state.categoryLimit;var self=this;array=array.map(function(divID,i){var categoryID=self.state.categories[divID];if(self.categoryInfo[categoryID]!==undefined&&self.categoryInfo[categoryID]!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CategorySelectorBox,{addButton:i===count-1&&count<max?true:false,deleteButton:count>1?true:false,id:'CategorySelectorBox#'+divID,divID:divID,key:divID,addBox:self.addBox,deleteBox:self.deleteBox,selectedCategory:self.state.categories[categoryID],updateCategory:self.updateCategory,selectedCategoryName:self.categoryInfo[categoryID].name,selectedCategoryHasChildren:self.categoryInfo[categoryID].hasChildren,selectedCategoryChildren:self.categoryInfo[categoryID].children,selectedCategoryPath:self.categoryInfo[categoryID].path,selectedCategoryParent:self.categoryInfo[categoryID].parent});}else{return null;}});return array;}},{key:'overview',value:function overview(){if(this.state.finallySelected!==undefined&&this.state.finallySelected!==null){var n=this.state.finallySelected.split(',').filter(function(item){return item!=='';}).length;if(n>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorListOverview',style:{color:'darkgreen'}},n+(n===1?' Kategorie wurde ausgew\xE4hlt. Noch '+(this.state.categoryLimit-n)+' verf\xFCgbar.':' Kategorien wurden ausgew\xE4hlt. Noch '+(this.state.categoryLimit-n)+' verf\xFCgbar.'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorListOverview',style:{color:'red'}},'Bisher wurde noch keine Kategorie ausgew\xE4hlt.');}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorList',id:Math.round(Math.random()*1000000)},this.overview(),this.boxes());}}]);return CategorySelectorList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var CategorySelectorBox=function(_Component2){_inherits(CategorySelectorBox,_Component2);function CategorySelectorBox(props){_classCallCheck(this,CategorySelectorBox);var _this6=_possibleConstructorReturn(this,(CategorySelectorBox.__proto__||Object.getPrototypeOf(CategorySelectorBox)).call(this,props));_this6.search=_this6.search.bind(_this6);_this6.renderSearchResults=_this6.renderSearchResults.bind(_this6);_this6.state={selectedCategoryName:_this6.props.selectedCategoryName,selectedCategoryHasChildren:_this6.props.selectedCategoryHasChildren,selectedCategoryChildren:_this6.props.selectedCategoryChildren,selectedCategoryPath:_this6.props.selectedCategoryPath,selectedCategoryParent:_this6.props.selectedCategoryParent,childrenVisible:false,pathVisible:true,requestVisible:false,requestName:'',id:Math.round(Math.random()*1000000),searchString:'',searchResults:null};return _this6;}_createClass(CategorySelectorBox,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){this.setState({selectedCategoryName:nextProps.selectedCategoryName,selectedCategoryHasChildren:nextProps.selectedCategoryHasChildren,selectedCategoryChildren:nextProps.selectedCategoryChildren,selectedCategoryPath:nextProps.selectedCategoryPath,selectedCategoryParent:nextProps.selectedCategoryParent,searchString:'',searchResults:null});}},{key:'nodeStyle',value:function nodeStyle(i,length){if(length===i+1){return{color:'black',fontWeight:'normal'};}return null;}},{key:'renderPath',value:function renderPath(){var pathLength=this.state.selectedCategoryPath.length;var self=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#1F6A81'}},this.state.selectedCategoryPath.map(function(obj,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CategorySelectorPathSelection',style:self.nodeStyle(i,pathLength),title:"Durch Klick springen Sie an diese Stelle des Kategorienbaumes. ("+obj.name+")",onClick:function onClick(event){return self.props.updateCategory(obj.id,self.props.divID,self);}},obj.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#1F6A81'}},i<pathLength-1?' ▶ ':null,' '));}));}},{key:'search',value:function search(searchString){var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var url='/api/category-search?search='+searchString+'&startid=2';var promise=fetch(url,{method:'GET',mode:'cors',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not retreive category tree search results!',exception);});return promise;}},{key:'renderSearchResults',value:function renderSearchResults(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorSearchResults'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.state.searchResults!==null&&this.state.searchResults.length>0&&this.state.searchResults.map(function(json){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(event){return _this7.props.updateCategory(json.id,_this7.props.divID,_this7);}},json.text);}),this.state.searchResults!==null&&this.state.searchResults.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'red'}},'Keine Treffer.')));}},{key:'render',value:function render(){var _this8=this;var self=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.selectedCategoryHasChildren===true?"CategorySelectorBox CategorySelectionUnfinished":"CategorySelectorBox CategorySelectionFinished",key:this.props.id,id:this.state.id},this.state.selectedCategoryHasChildren===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'15px',color:'black'}},'Bitte w\xE4hlen Sie eine Kategorie aus.'):null,this.state.pathVisible===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CategorySelectorPath'},this.renderPath()),this.state.selectedCategoryParent!==1&&this.state.selectedCategoryHasChildren!==true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'Diese Kategorie bearbeiten.',style:{cursor:"pointer",color:'#1F6A81'},onClick:function onClick(event){return self.props.updateCategory(_this8.state.selectedCategoryParent,self.props.divID,self);}},' \u270E '),this.props.deleteButton===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CategorySelectorBoxDelete',title:'Diese Kategorie l\xF6schen!',onClick:function onClick(event){return _this8.props.deleteBox(_this8.props.divID);}},'\u2717'),this.props.deleteButton===false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CategorySelectorBoxDelete',title:'Diese Kategorie l\xF6schen!',onClick:function onClick(event){return _this8.props.updateCategory(2,self.props.divID,self);}},'\u2717'),this.props.addButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorBoxAdd',title:'Eine weitere Kategorie zur Auswahl hinzuf\xFCgen!',onClick:function onClick(event){return _this8.props.addBox();}},'+ Eine weitere Kategorie ausw\xE4hlen.'),this.state.childrenVisible===true&&this.state.selectedCategoryHasChildren===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorChildrenVisibility',onClick:function onClick(event){return _this8.setState({childrenVisible:false});}},'[Unterkategorien verbergen]'),this.state.childrenVisible===false&&this.state.selectedCategoryHasChildren===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorChildrenVisibility',onClick:function onClick(event){return _this8.setState({childrenVisible:true});}},'[Unterkategorien anzeigen]'),this.state.selectedCategoryHasChildren===true&&this.state.childrenVisible===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorChildren'},this.state.selectedCategoryParent!==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorBack',title:'Durch Klick kehren Sie einen Schritt zur\xFCck in Ihrer Auswahl.',onClick:function onClick(event){return self.props.updateCategory(_this8.state.selectedCategoryParent,self.props.divID,self);}},'\u2190'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.state.selectedCategoryChildren.map(function(child,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:i,onClick:function onClick(event){return self.props.updateCategory(child.id,self.props.divID,self);},className:child.hasChildren===true?"CategorySelectionInnerNode":"CategorySelectionFinalNode"},child.name,child.hasChildren===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'normal',color:'#1F6A81'},title:'Weitere Kategorien folgen.'},' \u25B6 ...'));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'CategorySuggestion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Ihr Kategorievorschlag',onChange:function onChange(event){return _this8.setState({requestName:event.target.value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'buttonInput',onClick:function onClick(event){return requestCategory(JSON.stringify(_this8.state.requestName),JSON.stringify(_this8.state.selectedCategoryPath)).then(function(json){return alertRequest(json);});},value:' abschicken '})))),this.state.selectedCategoryHasChildren===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CategorySelectorSearch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:'Kategoriedirektsuche',value:this.state.searchString,onChange:function onChange(event){return _this8.setState({searchString:event.target.value},function(){return _this8.search(_this8.state.searchString).then(function(json){return _this8.setState({searchResults:json});});});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.searchString.length>=3&&this.renderSearchResults(),this.state.searchString.length>0&&this.state.searchString.length<3&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'red'}},'Geben Sie wenigstens drei Buchstaben Ihres Suchbegriffs ein.'))));}}]);return CategorySelectorBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function getCategoryInfo(id){var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var url='/api/full-category-info?id='+id;var promise=fetch(url,{method:'GET',mode:'cors',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not retreive category node information!',exception);});return promise;}function serializeCategories(self,maxCount,categoryInfo){var removeDuplicates=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var value=new Array(0);var categories=self.state.categories;for(var id in categories){if(categoryInfo[categories[id]]!==undefined&&categoryInfo[categories[id]].hasChildren!==true){value.push(categories[id]);}}if(removeDuplicates===true){value=value.map(function(item){return parseInt(item,10);});value=value.filter(function(item,pos,self){return self.indexOf(item)===pos;});}var length=value.length;for(var i=0;i<maxCount-length;i++){value.push(null);}return value.toString();}function alertRequest(json){var category=json.category;var user=json.user;alert('Lieber '+user+', Ihr Kategorienwunsch '+category+' wurde entgegengenommen. Vielen Dank!');}function requestCategory(category,path){var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/request-category';var promise=fetch(url,{method:'POST',mode:'cors',headers:headers,body:'category='+category+'&path='+path}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not request category!',exception);});return promise;}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logBusinessActivities;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(2);
function logBusinessActivities(description,id,categories,price,fee){var headers=__WEBPACK_IMPORTED_MODULE_0__util__["a" /* defaultHeaders */]();var formData=new FormData();var url="/api/logbusinessactivities";formData.append("description",description);formData.append("activity_id",id);if(categories!==undefined){formData.append("categories",categories);}if(price!==undefined){formData.append("price",price);}if(fee!==undefined){formData.append("fee",fee);}var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){console.error("Could not log business activity data!",exception);});promise.then(function(json){return true;});return true;}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TextInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TextLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TextField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Price; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IntegerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Tags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CheckBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AGBCheckBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SubmitButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ComplexityRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ConfirmedText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Confirmed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ConfirmedTextWithPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Selection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Duallistbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PDFUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MultipleFileUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__file_upload_ng__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__product_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_form_components_css__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_form_components_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_form_components_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// ResearchsoftwareTextInfo
var TextInfo=function(_Component){_inherits(TextInfo,_Component);function TextInfo(){_classCallCheck(this,TextInfo);return _possibleConstructorReturn(this,(TextInfo.__proto__||Object.getPrototypeOf(TextInfo)).apply(this,arguments));}_createClass(TextInfo,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TextInfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CheckBoxContent Width100',dangerouslySetInnerHTML:{__html:this.props.content}}));}}]);return TextInfo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//TextLine
var TextLine=function(_Component2){_inherits(TextLine,_Component2);function TextLine(props){_classCallCheck(this,TextLine);var _this2=_possibleConstructorReturn(this,(TextLine.__proto__||Object.getPrototypeOf(TextLine)).call(this,props));_this2.onChange=_this2.onChange.bind(_this2);_this2.state={value:_this2.props.value!==undefined?_this2.props.value:'',maxLength:_this2.props.maxLength?_this2.props.maxLength:400};return _this2;}_createClass(TextLine,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps!==undefined){this.setState({value:nextProps.value});}}},{key:'onChange',value:function onChange(event){var newValue=event.target.value;if(event.target.value.length<=this.state.maxLength){this.setState({value:newValue});this.props.update(this.props.slot,event.target.value);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TextLine prodHeaderTexts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},'  ',this.props.obligatory===true?'*':null,this.props.heading,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bracketsText'},this.props.heading2),' '),this.props.subheading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bracketsText'},' ',this.props.subheading,' '):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TextLineInput'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'ProdInput',type:'text',placeholder:this.props.placeholder,value:this.state.value,onChange:this.onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},'(noch ',this.state.maxLength-this.state.value.length,' Zeichen)')));}}]);return TextLine;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//ResearchsoftwareTextField
var TextField=function(_Component3){_inherits(TextField,_Component3);function TextField(props){_classCallCheck(this,TextField);var _this3=_possibleConstructorReturn(this,(TextField.__proto__||Object.getPrototypeOf(TextField)).call(this,props));_this3.onChange=_this3.onChange.bind(_this3);_this3.state={value:_this3.props.value!==undefined?_this3.props.value:'',maxLength:_this3.props.maxLength?_this3.props.maxLength:2000};return _this3;}_createClass(TextField,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps!==undefined){this.setState({value:nextProps.value});}}},{key:'onChange',value:function onChange(event){var newValue=event.target.value;if(event.target.value.length<=this.state.maxLength){this.setState({value:newValue});this.props.update(this.props.slot,newValue);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TextField'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?'* ':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'ProdInput',placeholder:this.props.placeholder,value:this.state.value,maxLength:this.props.maxLength,size:this.props.maxLength,onChange:this.onChange,rows:'6',cols:'100'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},'(noch ',this.state.maxLength-this.state.value.length,' Zeichen)'));}}]);return TextField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//Price
var Price=function(_Component4){_inherits(Price,_Component4);function Price(props){_classCallCheck(this,Price);var _this4=_possibleConstructorReturn(this,(Price.__proto__||Object.getPrototypeOf(Price)).call(this,props));_this4.handleClick=function(event){_this4.setState({kostenfrei:!_this4.state.kostenfrei});_this4.setState({value:"0"});_this4.props.update(_this4.props.slot,"0");};_this4.onChange=_this4.onChange.bind(_this4);_this4.state={value:_this4.props.value!==undefined?_this4.props.value:'',maxLength:_this4.props.maxLength?_this4.props.maxLength:6,kostenfrei:_this4.props.kostenfrei!==undefined?_this4.props.kostenfrei:false};return _this4;}_createClass(Price,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps!==undefined){this.setState({value:nextProps.value});}}},{key:'onChange',value:function onChange(event){var newValue=event.target.value;if(event.target.value.length===0){newValue="0";}// parseInt returns an integer and newvalue is String. We can not replace "==" with a "==="
// eslint-disable-next-line eqeqeq
if(event.target.value.length<=this.state.maxLength&&parseInt(newValue,10)==newValue&&parseInt(newValue,10)>=0){this.setState({value:newValue});this.props.update(this.props.slot,newValue);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?'* ':null,this.props.heading,this.props.subheading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bracketsText'},' ',this.props.subheading,' '):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PriceDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',defaultChecked:this.state.kostenfrei,onChange:this.handleClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{'for':'kostenfrei',style:{fontFamily:'Open Sans'}},'Kostenfrei'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:this.props.placeholder,value:this.state.value,maxLength:this.props.maxLength,size:this.props.maxLength,onChange:this.onChange,disabled:this.state.kostenfrei}),' \u20AC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},'(noch ',this.state.maxLength-this.state.value.length,' Zeichen)'));}}]);return Price;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//ResearchsoftwareInteger
var IntegerField=function(_Component5){_inherits(IntegerField,_Component5);function IntegerField(props){_classCallCheck(this,IntegerField);var _this5=_possibleConstructorReturn(this,(IntegerField.__proto__||Object.getPrototypeOf(IntegerField)).call(this,props));_this5.onChange=_this5.onChange.bind(_this5);_this5.state={value:_this5.props.value!==undefined?_this5.props.value:'',maxLength:_this5.props.maxLength?_this5.props.maxLength:20};return _this5;}_createClass(IntegerField,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.setState({value:nextProps.value});}}},{key:'onChange',value:function onChange(event){if(event.target.value.length===0){event.target.value=0;}else{event.target.value=event.target.value;}var newValue=event.target.value;if(newValue.length<=this.state.maxLength&&parseInt(newValue,10)===newValue){this.setState({value:event.target.value});this.props.update(this.props.slot,event.target.value);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.heading,this.props.subheading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bracketsText'},' ',this.props.subheading,' '):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PriceDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',title:this.props.placeholder,placeholder:this.props.placeholder,value:this.state.value,maxLength:this.props.maxLength,size:this.props.maxLength,onChange:this.onChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},'(noch ',this.state.maxLength-this.state.value.length,' Zeichen)')));}}]);return IntegerField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//ResearchsoftwareTags
var Tags=function(_Component6){_inherits(Tags,_Component6);function Tags(props){_classCallCheck(this,Tags);var _this6=_possibleConstructorReturn(this,(Tags.__proto__||Object.getPrototypeOf(Tags)).call(this,props));_this6.onChange=_this6.onChange.bind(_this6);_this6.state={value:_this6.props.value,tags:[],error:false};return _this6;}_createClass(Tags,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps!==undefined){this.onChange(nextProps.value);}}},{key:'componentDidMount',value:function componentDidMount(){this.onChange(this.props.value);}},{key:'onChange',value:function onChange(value){this.setState({error:false});var newValue;if(value!==null){newValue=value;document.getElementById('Tags'+this.props.match.params.id).innerHTML=value;}else{newValue=document.getElementById('Tags'+this.props.match.params.id).textContent;}var newTags=newValue.toString().split(/,/);newTags=newTags.filter(function(string){return string.match(/\S/);});newTags=newTags.map(function(str){return str.replace(/^\s+/,'').replace(/\s+$/,'');});if(newValue.length<=this.props.maxLength&&newTags.length<=this.props.maxTags){this.setState({value:newValue,tags:newTags});this.props.update(this.props.slot,newValue);}else{document.getElementById('Tags'+this.props.match.params.id).innerHTML=this.state.value;alert('Zuviele Zeichen oder zuviele Tags/Stichworte!');this.setState({error:true});}}},{key:'render',value:function render(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Tags'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?'* ':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TagsField',id:'Tags'+this.props.match.params.id,contentEditable:'true',style:{backgroundColor:'#fcfdfe',color:'#3f3f3f'},onKeyUp:function onKeyUp(event){return _this7.onChange(null);},placeholder:this.props.placeholder},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'\u200C')),this.state.error?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#7F0000'}},'Zuviele Zeichen oder Tags!'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},'(noch ',this.props.maxLength-this.state.value.length,' Zeichen, noch ',this.props.maxTags-this.state.tags.length,' weitere Tags )'));}}]);return Tags;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// ResearchsoftwareCheckBox
var CheckBox=function(_Component7){_inherits(CheckBox,_Component7);function CheckBox(props){_classCallCheck(this,CheckBox);var _this8=_possibleConstructorReturn(this,(CheckBox.__proto__||Object.getPrototypeOf(CheckBox)).call(this,props));_this8.onCheck=_this8.onCheck.bind(_this8);_this8.state={value:_this8.props.value===true?true:false};return _this8;}_createClass(CheckBox,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps!==undefined){this.setState({value:nextProps.value});}}},{key:'onCheck',value:function onCheck(event){this.setState({value:!this.state.value});this.props.update(this.props.slot,!this.state.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CheckBox openSans',id:'downLanding'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?"":null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CheckBoxInputANDContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'CheckBoxInput',type:'checkbox',checked:this.state.value,onChange:this.onCheck}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CheckBoxContent textAlign'},'  ',this.props.content,' ')));}}]);return CheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//AGBCheckBox
var AGBCheckBox=function(_Component8){_inherits(AGBCheckBox,_Component8);function AGBCheckBox(props){_classCallCheck(this,AGBCheckBox);var _this9=_possibleConstructorReturn(this,(AGBCheckBox.__proto__||Object.getPrototypeOf(AGBCheckBox)).call(this,props));_this9.onCheck=_this9.onCheck.bind(_this9);_this9.state={value:_this9.props.value===true?true:false};return _this9;}_createClass(AGBCheckBox,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps!==undefined){this.setState({value:nextProps.value});}}},{key:'onCheck',value:function onCheck(event){this.setState({value:!this.state.value});this.props.update(this.props.slot,!this.state.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CheckBox openSans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?"":null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CheckBoxInputANDContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'CheckBoxInput',type:'checkbox',checked:this.state.value,onChange:this.onCheck}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'CheckBoxContent textAlign'},'  ',this.props.content1,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.props.agbUrl,download:true},this.props.fileType),this.props.content2)));}}]);return AGBCheckBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//ResearchsoftwareSubmitButton
var SubmitButton=function(_Component9){_inherits(SubmitButton,_Component9);function SubmitButton(props){_classCallCheck(this,SubmitButton);var _this10=_possibleConstructorReturn(this,(SubmitButton.__proto__||Object.getPrototypeOf(SubmitButton)).call(this,props));_this10.SaveForLater=_this10.SaveForLater.bind(_this10);_this10.SaveAndAnnounce=_this10.SaveAndAnnounce.bind(_this10);return _this10;}_createClass(SubmitButton,[{key:'SaveForLater',value:function SaveForLater(event){event.preventDefault();this.props.onSubmit(false);}},{key:'SaveAndAnnounce',value:function SaveAndAnnounce(event){event.preventDefault();this.props.onSubmit(true);}},{key:'render',value:function render(){var _this11=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ColumnDisplay marginTop40'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ToEndRight'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:this.SaveAndAnnounce},' Speichern und Ver\xF6ffentlichen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ToEndRight ',onClick:this.SaveForLater},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button marginTop30'},' F\xFCr sp\xE4ter speichern ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ToEndRight ',onClick:function onClick(){return window.confirm('Wirklich abbrechen? Nicht gespeicherte Einträge gehen verloren!')&&_this11.props.history.replace('/product-list');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button marginTop30'},' Abbrechen ')));}}]);return SubmitButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//class ResearchsoftwareComplexityRate extends Component {
var ComplexityRate=function(_Component10){_inherits(ComplexityRate,_Component10);function ComplexityRate(props){_classCallCheck(this,ComplexityRate);var _this12=_possibleConstructorReturn(this,(ComplexityRate.__proto__||Object.getPrototypeOf(ComplexityRate)).call(this,props));_this12.onChange=_this12.onChange.bind(_this12);_this12.state={value:_this12.props.value};return _this12;}_createClass(ComplexityRate,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.setState({value:nextProps.value});}}},{key:'onChange',value:function onChange(event){this.setState({value:event.target.value});this.props.update(this.props.slot,event.target.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ComplexityRate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?'* ':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'bracketsText'},this.props.subheading,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.value,onChange:this.onChange},this.props.complexityRate));}}]);return ComplexityRate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//ResearchsoftwareConfirmedText with textfield
var ConfirmedText=function(_Component11){_inherits(ConfirmedText,_Component11);function ConfirmedText(props){_classCallCheck(this,ConfirmedText);var _this13=_possibleConstructorReturn(this,(ConfirmedText.__proto__||Object.getPrototypeOf(ConfirmedText)).call(this,props));_this13.onChangeOnYes=_this13.onChangeOnYes.bind(_this13);_this13.onChangeOnNo=_this13.onChangeOnNo.bind(_this13);_this13.handleInputChange=_this13.handleInputChange.bind(_this13);_this13.state={value:_this13.props.value,value2:_this13.props.value2!==undefined?_this13.props.value2:'',maxLength:_this13.props.maxLength?_this13.props.maxLength:600};return _this13;}_createClass(ConfirmedText,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.setState({value:nextProps.value});}if(nextProps.value2!==this.state.value2&&nextProps.value2!==undefined){this.setState({value2:nextProps.value2});}}},{key:'onChangeOnYes',value:function onChangeOnYes(event){this.setState({value:true});this.props.update(this.props.slot,true);}},{key:'onChangeOnNo',value:function onChangeOnNo(event){this.setState({value:false});this.props.update(this.props.slot,false);}},{key:'handleInputChange',value:function handleInputChange(event){var newValue=event.target.value;if(newValue.length<=this.state.maxLength){this.setState({value2:newValue});this.props.update(this.props.slot2,newValue);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ConfirmedText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?'* ':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'YesNoText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',checked:this.state.value===true,onChange:this.onChangeOnYes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Ja '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',checked:this.state.value===false,onChange:this.onChangeOnNo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Nein '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'ProdInput',placeholder:this.props.placeholder,value:this.state.value2,onChange:this.handleInputChange,rows:'6',cols:'100'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small',fontFamily:'open sans'}},'(noch ',this.state.maxLength-this.state.value2.length,' Zeichen)'));}}]);return ConfirmedText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//ResearchsoftwareConfirmed  without TextField
var Confirmed=function(_Component12){_inherits(Confirmed,_Component12);function Confirmed(props){_classCallCheck(this,Confirmed);var _this14=_possibleConstructorReturn(this,(Confirmed.__proto__||Object.getPrototypeOf(Confirmed)).call(this,props));_this14.onChangeOnYes=_this14.onChangeOnYes.bind(_this14);_this14.onChangeOnNo=_this14.onChangeOnNo.bind(_this14);_this14.state={value:_this14.props.value,maxLength:_this14.props.maxLength?_this14.props.maxLength:400};return _this14;}_createClass(Confirmed,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.setState({value:nextProps.value});}}},{key:'onChangeOnYes',value:function onChangeOnYes(event){this.setState({value:true});this.props.update(this.props.slot,true);}},{key:'onChangeOnNo',value:function onChangeOnNo(event){this.setState({value:false});this.props.update(this.props.slot,false);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ConfirmedText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?'* ':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'YesNoText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',checked:this.state.value===true,onChange:this.onChangeOnYes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Ja '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',checked:this.state.value===false,onChange:this.onChangeOnNo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Nein '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return Confirmed;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// yes/no and a Text-Field and a price-field
var ConfirmedTextWithPrice=function(_Component13){_inherits(ConfirmedTextWithPrice,_Component13);function ConfirmedTextWithPrice(props){_classCallCheck(this,ConfirmedTextWithPrice);var _this15=_possibleConstructorReturn(this,(ConfirmedTextWithPrice.__proto__||Object.getPrototypeOf(ConfirmedTextWithPrice)).call(this,props));_this15.onChangeOnYes=_this15.onChangeOnYes.bind(_this15);_this15.onChangeOnNo=_this15.onChangeOnNo.bind(_this15);_this15.handleInputChange=_this15.handleInputChange.bind(_this15);_this15.handleInputChange2=_this15.handleInputChange2.bind(_this15);_this15.onChange=_this15.onChange.bind(_this15);_this15.state={value:_this15.props.value,value2:_this15.props.value2!==undefined?_this15.props.value2:'',value3:_this15.props.value3!==undefined?_this15.props.value3:'',value4:_this15.props.value4!==undefined?_this15.props.value4:'',maxLength1:_this15.props.maxLength?_this15.props.maxLength:600,maxLength2:_this15.props.maxLength?_this15.props.maxLength:6};return _this15;}_createClass(ConfirmedTextWithPrice,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.setState({value:nextProps.value});}if(nextProps.value2!==this.state.value2&&nextProps.value2!==undefined){this.setState({value2:nextProps.value2});}if(nextProps.value3!==this.state.value3&&nextProps!==undefined){this.setState({value3:nextProps.value3});}if(nextProps.value4!==this.state.value4&&nextProps!==undefined){this.setState({value4:nextProps.value4});}}},{key:'onChangeOnYes',value:function onChangeOnYes(event){this.setState({value:true});this.props.update(this.props.slot,true);}},{key:'onChangeOnNo',value:function onChangeOnNo(event){this.setState({value:false});this.props.update(this.props.slot,false);}},{key:'handleInputChange',value:function handleInputChange(event){this.setState({value2:event.target.value});this.props.update(this.props.slot2,event.target.value);}},{key:'handleInputChange2',value:function handleInputChange2(event){var newValue=event.target.value;if(newValue.length<=this.state.maxLength1){this.setState({value4:newValue});this.props.update(this.props.slot4,newValue);}}},{key:'onChange',value:function onChange(event){if(event.target.value.length===0){event.target.value=0;}else{event.target.value=event.target.value;}var newValue=event.target.value;if(newValue.length<=this.state.maxLength2&&parseInt(newValue,10)===newValue&&parseInt(newValue,10)>=0){this.setState({value3:event.target.value});this.props.update(this.props.slot3,event.target.value);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ConfirmedText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.obligatory===true?'* ':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'YesNoText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',checked:this.state.value===true,onChange:this.onChangeOnYes}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Ja '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'radio',checked:this.state.value===false,onChange:this.onChangeOnNo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,' Nein '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.heading2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PriceDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:this.props.placeholder,value:this.state.value3,maxLength:this.props.maxLength2,size:this.props.maxLength2,onChange:this.onChange}),' \u20AC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},'(noch ',this.state.maxLength2-this.state.value3.length,' Zeichen)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'ProdInput',placeholder:this.props.placeholder,value:this.state.value4,onChange:this.handleInputChange2,rows:'6',cols:'100'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},'(noch ',this.state.maxLength1-this.state.value4.length,' Zeichen)'));}}]);return ConfirmedTextWithPrice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);//DocumentTypeSelection
var Selection=function(_Component14){_inherits(Selection,_Component14);function Selection(props){_classCallCheck(this,Selection);var _this16=_possibleConstructorReturn(this,(Selection.__proto__||Object.getPrototypeOf(Selection)).call(this,props));_this16.onChange=_this16.onChange.bind(_this16);_this16.state={value:''};return _this16;}_createClass(Selection,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value){this.setState({value:nextProps.value});}}},{key:'onChange',value:function onChange(event){this.setState({value:event.target.value});this.props.update(this.props.slot,event.target.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Selection'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},'  ',this.props.obligatory===true?'* ':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SelectionValues'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{value:this.state.value,onChange:this.onChange},this.props.selectionValues)));}}]);return Selection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Duallistbox=function(_Component15){_inherits(Duallistbox,_Component15);function Duallistbox(props){_classCallCheck(this,Duallistbox);var _this17=_possibleConstructorReturn(this,(Duallistbox.__proto__||Object.getPrototypeOf(Duallistbox)).call(this,props));_this17.moveToRight=_this17.moveToRight.bind(_this17);_this17.moveToLeft=_this17.moveToLeft.bind(_this17);_this17.compare=_this17.compare.bind(_this17);_this17.selectByString=_this17.selectByString.bind(_this17);_this17.update=_this17.update.bind(_this17);_this17.fetchReferences=_this17.fetchReferences.bind(_this17);_this17.state={options:[],selected:[],value:''};_this17.fetchReferences();return _this17;}_createClass(Duallistbox,[{key:'fetchReferences',value:function fetchReferences(){var _this18=this;fetch("/api/references",{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Fetching references error: ",error);}).then(function(json){return _this18.setState({options:json.references.sort(_this18.compare),allOptions:json.references.sort(_this18.compare)},function(){return _this18.selectByString(_this18.state.value);});});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this19=this;if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.setState({value:nextProps.value},function(){return _this19.selectByString(nextProps.value);});}}},{key:'selectByString',value:function selectByString(value){if(this.state.allOptions===undefined||this.state.allOptions.length===0){return true;}var valueArray=value.toString().split(/,/).filter(function(item){return parseInt(item,10)===item;});valueArray=valueArray.map(function(item){return parseInt(item,10);});var options=[];var selected=[];this.state.allOptions.map(function(item){return valueArray.indexOf(item.value)>=0?selected.push(item):options.push(item);});this.setState({options:options,selected:selected});return true;}},{key:'compare',value:function compare(a,b){if(a.label.toLowerCase()<b.label.toLowerCase())return-1;if(a.label.toLowerCase()>b.label.toLowerCase())return 1;return 0;}},{key:'update',value:function update(){var references='';var length=this.state.selected.length;for(var i=0;i<length;i++){references=references.concat(this.state.selected[i].value.toString());if(i+1<length){references=references.concat(',');}}this.props.update(this.props.slot,references);}},{key:'moveToRight',value:function moveToRight(item){var _this20=this;var newOptions=this.state.options;var newSelected=this.state.selected;newOptions.splice(newOptions.indexOf(item),1);newSelected.push(item);this.setState({options:newOptions,selected:newSelected},function(){return _this20.update();});}},{key:'moveToLeft',value:function moveToLeft(item){var _this21=this;var newOptions=this.state.options;var newSelected=this.state.selected;newSelected.splice(newSelected.indexOf(item),1);newOptions.push(item);this.setState({options:newOptions,selected:newSelected},function(){return _this21.update();});}},{key:'render',value:function render(){var _this22=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Duallistbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'InfoLabel'},' Klicken Sie um zu verschieben. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LabelBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'Filter_left'},' verf\xFCgbare Referenzen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'Filter_right'},' ausgew\xE4hlte Referenzen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DualList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DualListBox_left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.state.options.sort(this.compare).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(event){return _this22.moveToRight(item);},key:item.value},item.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DualListBox_right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.state.selected.sort(this.compare).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{onClick:function onClick(event){return _this22.moveToLeft(item);},key:item.value},item.label,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));})))));}}]);return Duallistbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PDFUpload=function(_Component16){_inherits(PDFUpload,_Component16);function PDFUpload(props){_classCallCheck(this,PDFUpload);var _this23=_possibleConstructorReturn(this,(PDFUpload.__proto__||Object.getPrototypeOf(PDFUpload)).call(this,props));_this23.onFinish=_this23.onFinish.bind(_this23);_this23.getFileInfo=_this23.getFileInfo.bind(_this23);_this23.onDelete=_this23.onDelete.bind(_this23);_this23.downloadLink=_this23.downloadLink.bind(_this23);_this23.state={value:_this23.props.value,fileName:null,uuid:null,finished:false};return _this23;}_createClass(PDFUpload,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.getFileInfo(nextProps.value);}}},{key:'getFileInfo',value:function getFileInfo(uuid){var self=this;fetch('/api/get-file-infos?uuids='+uuid,{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Could not get file infos. ",error);}).then(function(json){if(json!==undefined&&json[0]!==undefined&&json[0]!==null){self.setState({fileName:json[0].fileName,uuid:json[0].uuid,finished:true});}});}},{key:'onFinish',value:function onFinish(uuid){this.props.update(this.props.slot,uuid);this.getFileInfo(uuid);return true;}},{key:'onDelete',value:function onDelete(){this.setState({fileName:null,finished:false});this.props.update(this.props.slot,null);}},{key:'downloadLink',value:function downloadLink(){return window.location.protocol+'//'+window.location.host+'/'+this.state.uuid+'/'+this.state.fileName;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PDFUpload'});}}]);return PDFUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var MultipleFileUpload=function(_Component17){_inherits(MultipleFileUpload,_Component17);function MultipleFileUpload(props){_classCallCheck(this,MultipleFileUpload);var _this24=_possibleConstructorReturn(this,(MultipleFileUpload.__proto__||Object.getPrototypeOf(MultipleFileUpload)).call(this,props));_this24.onFinish=_this24.onFinish.bind(_this24);_this24.getFileInfo=_this24.getFileInfo.bind(_this24);_this24.onDelete=_this24.onDelete.bind(_this24);_this24.downloadLink=_this24.downloadLink.bind(_this24);_this24.downloadElements=_this24.downloadElements.bind(_this24);var splitted=_this24.props.value.split(/,/);_this24.state={value:_this24.props.value,length:splitted.length,fileNames:splitted.map(function(item){return null;}),uuids:splitted.map(function(item){return null;}),finished:splitted.map(function(item){return false;})};return _this24;}_createClass(MultipleFileUpload,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value&&nextProps.value!==undefined){this.getFileInfo(nextProps.value);}}},{key:'getFileInfo',value:function getFileInfo(uuids){var self=this;fetch('/api/get-file-infos?uuids='+uuids,{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Could not get file infos. ",error);}).then(function(json){var length=json.length;var newFilenames=json.map(function(obj){return obj!==null?obj.fileName:null;});var newUUIDs=json.map(function(obj){return obj!==null?obj.uuid:null;});var newFinished=json.map(function(obj){return obj!==null&&obj.fileName!==undefined?true:false;});var newValue='';for(var i=0;i<length;i++){newValue=newValue.concat(newUUIDs[i]!==null?newUUIDs[i].toString():'');if(i+1<length){newValue=newValue.concat(',');}}self.setState({value:newValue,length:length,fileNames:newFilenames,uuids:newUUIDs,finished:newFinished},function(){return self.props.update(self.props.slot,self.state.value);});});}},{key:'onFinish',value:function onFinish(uuid,index){var newUUIDs=this.state.uuids;newUUIDs[index]=uuid;this.getFileInfo(newUUIDs);return true;}},{key:'onDelete',value:function onDelete(i){var newUUIDs=this.state.uuids;newUUIDs[i]=null;this.getFileInfo(newUUIDs);return true;}},{key:'downloadLink',value:function downloadLink(i){return window.location.protocol+'//'+window.location.host+'/'+this.state.uuids[i]+'/'+this.state.fileNames[i];}},{key:'downloadElements',value:function downloadElements(){var self=this;return this.state.fileNames.map(function(fileName,i){return self.state.finished[i]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,style:{margin:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'bold',color:'#1F6A81'}},i+1,'. ',fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#e50000',cursor:'pointer',margin:'2%'},onClick:function onClick(){return self.onDelete(i);}},' \u2717 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'',to:self.downloadLink(i),target:'_blank'},' \u2193 '))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__file_upload_ng__["a" /* FileUploadNG */],{key:i,title:'',onFinish:self.onFinish,index:i,onNewMessage:self.props.onNewMessage});});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MultipleFileUpload'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts'},' ',this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bracketsText'},' ',this.props.subheading),this.downloadElements());}}]);return MultipleFileUpload;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(157);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var createDesc = __webpack_require__(45);
module.exports = __webpack_require__(25) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(101);
var defined = __webpack_require__(60);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedValue;
function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
  if (keepUnprefixed) {
    return [prefixedValue, value];
  }
  return prefixedValue;
}
module.exports = exports["default"];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(269);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(40);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(114);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(115);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(272);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SvgIcon = __webpack_require__(273);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SvgIcon2.default;

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeeBoxXU; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feebox_ng_css__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feebox_ng_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__feebox_ng_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeeBoxXU=function(_Component){_inherits(FeeBoxXU,_Component);function FeeBoxXU(props){_classCallCheck(this,FeeBoxXU);var _this=_possibleConstructorReturn(this,(FeeBoxXU.__proto__||Object.getPrototypeOf(FeeBoxXU)).call(this,props));_this.state={price:props.price,categoryCount:props.categoryCount,fee:0,feeStepConst:1};return _this;}_createClass(FeeBoxXU,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextProps.price!==this.state.price||nextProps.categorieCount!==this.state.categoryCount||nextState!==this.state){return true;}else{return false;}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){var self=this;this.setState({price:props.price,feeStepConst:props.feeStepConst,categoryCount:props.categoryCount},function(){if(self.props.type==="software"){self.computeSoftwareFee();}else{self.computeServiceFee();}});}},{key:'computeSoftwareFee',value:function computeSoftwareFee(){var catCount=this.state.categoryCount;var price;if(this.state.price!==undefined){price=this.state.price;}else{price=0;}var fee;if(catCount!==0){if(price>=0&&price<=30){fee=catCount*10;}if(price>30&&price<=150){fee=catCount*30;}if(price>150&&price<=500){fee=catCount*100;}if(price>500&&price<=Number.MAX_SAFE_INTEGER){fee=catCount*300;}}else{fee=0;}this.setState({fee:fee});localStorage.setItem('fee',fee);return fee;}},{key:'computeServiceFee',value:function computeServiceFee(){var catCount=this.state.categoryCount;var feeStepConst=this.state.feeStepConst;var price=this.state.price;var feeStep,fee;if(catCount!==0&&price!==0){if(catCount%3!==0){feeStep=Math.floor(catCount/3)+1;}else{feeStep=Math.floor(catCount/3);}fee=feeStep*feeStepConst;}else{fee=0;}this.setState({fee:fee});localStorage.setItem('fee',fee);return fee;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FeeBoxNG',id:'IdFeeBoxNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Geb\xFChr f\xFCrs Einstellen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Summe:'),this.state.fee||0,' EUR'));}}]);return FeeBoxXU;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(60);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(100);
var enumBugKeys = __webpack_require__(68);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Paper = __webpack_require__(267);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Paper2.default;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTab;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTabPanel;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTabList;
function isTab(el) {
  return el.type && el.type.tabsRole === 'Tab';
}
function isTabPanel(el) {
  return el.type && el.type.tabsRole === 'TabPanel';
}
function isTabList(el) {
  return el.type && el.type.tabsRole === 'TabList';
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(58);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(62)('keys');
var uid = __webpack_require__(50);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(13);
var global = __webpack_require__(18);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(49) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(178);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(35);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(34);
var dPs = __webpack_require__(186);
var enumBugKeys = __webpack_require__(68);
var IE_PROTO = __webpack_require__(61)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(95)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(189).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(20).f;
var has = __webpack_require__(24);
var TAG = __webpack_require__(16)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(16);


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(13);
var LIBRARY = __webpack_require__(49);
var wksExt = __webpack_require__(70);
var defineProperty = __webpack_require__(20).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertColorToString = convertColorToString;
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min, max) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function convertColorToString(color) {
  var type = color.type,
      values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    for (var i = 0; i < 3; i++) {
      values[i] = parseInt(values[i]);
    }
  }

  var colorString = void 0;

  if (type.indexOf('hsl') > -1) {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
  } else {
    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
  }

  if (values.length === 4) {
    colorString += ', ' + color.values[3] + ')';
  } else {
    colorString += ')';
  }

  return colorString;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
function convertHexToRGB(color) {
  if (color.length === 4) {
    var extendedColor = '#';
    for (var i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  var values = {
    r: parseInt(color.substr(1, 2), 16),
    g: parseInt(color.substr(3, 2), 16),
    b: parseInt(color.substr(5, 2), 16)
  };

  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values and color names.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {{type: string, values: number[]}} A MUI color object
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');

   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;

  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);

  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);

  if (color.type.indexOf('rgb') > -1) {
    var rgb = color.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
  } else if (color.type.indexOf('hsl') > -1) {
    return color.values[2] / 100;
  }
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value, 0, 1);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return convertColorToString(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return convertColorToString(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient, 0, 1);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i++) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return convertColorToString(color);
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red50 = exports.red50 = '#ffebee';
var red100 = exports.red100 = '#ffcdd2';
var red200 = exports.red200 = '#ef9a9a';
var red300 = exports.red300 = '#e57373';
var red400 = exports.red400 = '#ef5350';
var red500 = exports.red500 = '#f44336';
var red600 = exports.red600 = '#e53935';
var red700 = exports.red700 = '#d32f2f';
var red800 = exports.red800 = '#c62828';
var red900 = exports.red900 = '#b71c1c';
var redA100 = exports.redA100 = '#ff8a80';
var redA200 = exports.redA200 = '#ff5252';
var redA400 = exports.redA400 = '#ff1744';
var redA700 = exports.redA700 = '#d50000';

var pink50 = exports.pink50 = '#fce4ec';
var pink100 = exports.pink100 = '#f8bbd0';
var pink200 = exports.pink200 = '#f48fb1';
var pink300 = exports.pink300 = '#f06292';
var pink400 = exports.pink400 = '#ec407a';
var pink500 = exports.pink500 = '#e91e63';
var pink600 = exports.pink600 = '#d81b60';
var pink700 = exports.pink700 = '#c2185b';
var pink800 = exports.pink800 = '#ad1457';
var pink900 = exports.pink900 = '#880e4f';
var pinkA100 = exports.pinkA100 = '#ff80ab';
var pinkA200 = exports.pinkA200 = '#ff4081';
var pinkA400 = exports.pinkA400 = '#f50057';
var pinkA700 = exports.pinkA700 = '#c51162';

var purple50 = exports.purple50 = '#f3e5f5';
var purple100 = exports.purple100 = '#e1bee7';
var purple200 = exports.purple200 = '#ce93d8';
var purple300 = exports.purple300 = '#ba68c8';
var purple400 = exports.purple400 = '#ab47bc';
var purple500 = exports.purple500 = '#9c27b0';
var purple600 = exports.purple600 = '#8e24aa';
var purple700 = exports.purple700 = '#7b1fa2';
var purple800 = exports.purple800 = '#6a1b9a';
var purple900 = exports.purple900 = '#4a148c';
var purpleA100 = exports.purpleA100 = '#ea80fc';
var purpleA200 = exports.purpleA200 = '#e040fb';
var purpleA400 = exports.purpleA400 = '#d500f9';
var purpleA700 = exports.purpleA700 = '#aa00ff';

var deepPurple50 = exports.deepPurple50 = '#ede7f6';
var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
var deepPurple200 = exports.deepPurple200 = '#b39ddb';
var deepPurple300 = exports.deepPurple300 = '#9575cd';
var deepPurple400 = exports.deepPurple400 = '#7e57c2';
var deepPurple500 = exports.deepPurple500 = '#673ab7';
var deepPurple600 = exports.deepPurple600 = '#5e35b1';
var deepPurple700 = exports.deepPurple700 = '#512da8';
var deepPurple800 = exports.deepPurple800 = '#4527a0';
var deepPurple900 = exports.deepPurple900 = '#311b92';
var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';

var indigo50 = exports.indigo50 = '#e8eaf6';
var indigo100 = exports.indigo100 = '#c5cae9';
var indigo200 = exports.indigo200 = '#9fa8da';
var indigo300 = exports.indigo300 = '#7986cb';
var indigo400 = exports.indigo400 = '#5c6bc0';
var indigo500 = exports.indigo500 = '#3f51b5';
var indigo600 = exports.indigo600 = '#3949ab';
var indigo700 = exports.indigo700 = '#303f9f';
var indigo800 = exports.indigo800 = '#283593';
var indigo900 = exports.indigo900 = '#1a237e';
var indigoA100 = exports.indigoA100 = '#8c9eff';
var indigoA200 = exports.indigoA200 = '#536dfe';
var indigoA400 = exports.indigoA400 = '#3d5afe';
var indigoA700 = exports.indigoA700 = '#304ffe';

var blue50 = exports.blue50 = '#e3f2fd';
var blue100 = exports.blue100 = '#bbdefb';
var blue200 = exports.blue200 = '#90caf9';
var blue300 = exports.blue300 = '#64b5f6';
var blue400 = exports.blue400 = '#42a5f5';
var blue500 = exports.blue500 = '#2196f3';
var blue600 = exports.blue600 = '#1e88e5';
var blue700 = exports.blue700 = '#1976d2';
var blue800 = exports.blue800 = '#1565c0';
var blue900 = exports.blue900 = '#0d47a1';
var blueA100 = exports.blueA100 = '#82b1ff';
var blueA200 = exports.blueA200 = '#448aff';
var blueA400 = exports.blueA400 = '#2979ff';
var blueA700 = exports.blueA700 = '#2962ff';

var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
var lightBlue200 = exports.lightBlue200 = '#81d4fa';
var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
var lightBlue400 = exports.lightBlue400 = '#29b6f6';
var lightBlue500 = exports.lightBlue500 = '#03a9f4';
var lightBlue600 = exports.lightBlue600 = '#039be5';
var lightBlue700 = exports.lightBlue700 = '#0288d1';
var lightBlue800 = exports.lightBlue800 = '#0277bd';
var lightBlue900 = exports.lightBlue900 = '#01579b';
var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
var lightBlueA700 = exports.lightBlueA700 = '#0091ea';

var cyan50 = exports.cyan50 = '#e0f7fa';
var cyan100 = exports.cyan100 = '#b2ebf2';
var cyan200 = exports.cyan200 = '#80deea';
var cyan300 = exports.cyan300 = '#4dd0e1';
var cyan400 = exports.cyan400 = '#26c6da';
var cyan500 = exports.cyan500 = '#00bcd4';
var cyan600 = exports.cyan600 = '#00acc1';
var cyan700 = exports.cyan700 = '#0097a7';
var cyan800 = exports.cyan800 = '#00838f';
var cyan900 = exports.cyan900 = '#006064';
var cyanA100 = exports.cyanA100 = '#84ffff';
var cyanA200 = exports.cyanA200 = '#18ffff';
var cyanA400 = exports.cyanA400 = '#00e5ff';
var cyanA700 = exports.cyanA700 = '#00b8d4';

var teal50 = exports.teal50 = '#e0f2f1';
var teal100 = exports.teal100 = '#b2dfdb';
var teal200 = exports.teal200 = '#80cbc4';
var teal300 = exports.teal300 = '#4db6ac';
var teal400 = exports.teal400 = '#26a69a';
var teal500 = exports.teal500 = '#009688';
var teal600 = exports.teal600 = '#00897b';
var teal700 = exports.teal700 = '#00796b';
var teal800 = exports.teal800 = '#00695c';
var teal900 = exports.teal900 = '#004d40';
var tealA100 = exports.tealA100 = '#a7ffeb';
var tealA200 = exports.tealA200 = '#64ffda';
var tealA400 = exports.tealA400 = '#1de9b6';
var tealA700 = exports.tealA700 = '#00bfa5';

var green50 = exports.green50 = '#e8f5e9';
var green100 = exports.green100 = '#c8e6c9';
var green200 = exports.green200 = '#a5d6a7';
var green300 = exports.green300 = '#81c784';
var green400 = exports.green400 = '#66bb6a';
var green500 = exports.green500 = '#4caf50';
var green600 = exports.green600 = '#43a047';
var green700 = exports.green700 = '#388e3c';
var green800 = exports.green800 = '#2e7d32';
var green900 = exports.green900 = '#1b5e20';
var greenA100 = exports.greenA100 = '#b9f6ca';
var greenA200 = exports.greenA200 = '#69f0ae';
var greenA400 = exports.greenA400 = '#00e676';
var greenA700 = exports.greenA700 = '#00c853';

var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
var lightGreen100 = exports.lightGreen100 = '#dcedc8';
var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
var lightGreen300 = exports.lightGreen300 = '#aed581';
var lightGreen400 = exports.lightGreen400 = '#9ccc65';
var lightGreen500 = exports.lightGreen500 = '#8bc34a';
var lightGreen600 = exports.lightGreen600 = '#7cb342';
var lightGreen700 = exports.lightGreen700 = '#689f38';
var lightGreen800 = exports.lightGreen800 = '#558b2f';
var lightGreen900 = exports.lightGreen900 = '#33691e';
var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
var lightGreenA700 = exports.lightGreenA700 = '#64dd17';

var lime50 = exports.lime50 = '#f9fbe7';
var lime100 = exports.lime100 = '#f0f4c3';
var lime200 = exports.lime200 = '#e6ee9c';
var lime300 = exports.lime300 = '#dce775';
var lime400 = exports.lime400 = '#d4e157';
var lime500 = exports.lime500 = '#cddc39';
var lime600 = exports.lime600 = '#c0ca33';
var lime700 = exports.lime700 = '#afb42b';
var lime800 = exports.lime800 = '#9e9d24';
var lime900 = exports.lime900 = '#827717';
var limeA100 = exports.limeA100 = '#f4ff81';
var limeA200 = exports.limeA200 = '#eeff41';
var limeA400 = exports.limeA400 = '#c6ff00';
var limeA700 = exports.limeA700 = '#aeea00';

var yellow50 = exports.yellow50 = '#fffde7';
var yellow100 = exports.yellow100 = '#fff9c4';
var yellow200 = exports.yellow200 = '#fff59d';
var yellow300 = exports.yellow300 = '#fff176';
var yellow400 = exports.yellow400 = '#ffee58';
var yellow500 = exports.yellow500 = '#ffeb3b';
var yellow600 = exports.yellow600 = '#fdd835';
var yellow700 = exports.yellow700 = '#fbc02d';
var yellow800 = exports.yellow800 = '#f9a825';
var yellow900 = exports.yellow900 = '#f57f17';
var yellowA100 = exports.yellowA100 = '#ffff8d';
var yellowA200 = exports.yellowA200 = '#ffff00';
var yellowA400 = exports.yellowA400 = '#ffea00';
var yellowA700 = exports.yellowA700 = '#ffd600';

var amber50 = exports.amber50 = '#fff8e1';
var amber100 = exports.amber100 = '#ffecb3';
var amber200 = exports.amber200 = '#ffe082';
var amber300 = exports.amber300 = '#ffd54f';
var amber400 = exports.amber400 = '#ffca28';
var amber500 = exports.amber500 = '#ffc107';
var amber600 = exports.amber600 = '#ffb300';
var amber700 = exports.amber700 = '#ffa000';
var amber800 = exports.amber800 = '#ff8f00';
var amber900 = exports.amber900 = '#ff6f00';
var amberA100 = exports.amberA100 = '#ffe57f';
var amberA200 = exports.amberA200 = '#ffd740';
var amberA400 = exports.amberA400 = '#ffc400';
var amberA700 = exports.amberA700 = '#ffab00';

var orange50 = exports.orange50 = '#fff3e0';
var orange100 = exports.orange100 = '#ffe0b2';
var orange200 = exports.orange200 = '#ffcc80';
var orange300 = exports.orange300 = '#ffb74d';
var orange400 = exports.orange400 = '#ffa726';
var orange500 = exports.orange500 = '#ff9800';
var orange600 = exports.orange600 = '#fb8c00';
var orange700 = exports.orange700 = '#f57c00';
var orange800 = exports.orange800 = '#ef6c00';
var orange900 = exports.orange900 = '#e65100';
var orangeA100 = exports.orangeA100 = '#ffd180';
var orangeA200 = exports.orangeA200 = '#ffab40';
var orangeA400 = exports.orangeA400 = '#ff9100';
var orangeA700 = exports.orangeA700 = '#ff6d00';

var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
var deepOrange100 = exports.deepOrange100 = '#ffccbc';
var deepOrange200 = exports.deepOrange200 = '#ffab91';
var deepOrange300 = exports.deepOrange300 = '#ff8a65';
var deepOrange400 = exports.deepOrange400 = '#ff7043';
var deepOrange500 = exports.deepOrange500 = '#ff5722';
var deepOrange600 = exports.deepOrange600 = '#f4511e';
var deepOrange700 = exports.deepOrange700 = '#e64a19';
var deepOrange800 = exports.deepOrange800 = '#d84315';
var deepOrange900 = exports.deepOrange900 = '#bf360c';
var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';

var brown50 = exports.brown50 = '#efebe9';
var brown100 = exports.brown100 = '#d7ccc8';
var brown200 = exports.brown200 = '#bcaaa4';
var brown300 = exports.brown300 = '#a1887f';
var brown400 = exports.brown400 = '#8d6e63';
var brown500 = exports.brown500 = '#795548';
var brown600 = exports.brown600 = '#6d4c41';
var brown700 = exports.brown700 = '#5d4037';
var brown800 = exports.brown800 = '#4e342e';
var brown900 = exports.brown900 = '#3e2723';

var blueGrey50 = exports.blueGrey50 = '#eceff1';
var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
var blueGrey200 = exports.blueGrey200 = '#b0bec5';
var blueGrey300 = exports.blueGrey300 = '#90a4ae';
var blueGrey400 = exports.blueGrey400 = '#78909c';
var blueGrey500 = exports.blueGrey500 = '#607d8b';
var blueGrey600 = exports.blueGrey600 = '#546e7a';
var blueGrey700 = exports.blueGrey700 = '#455a64';
var blueGrey800 = exports.blueGrey800 = '#37474f';
var blueGrey900 = exports.blueGrey900 = '#263238';

var grey50 = exports.grey50 = '#fafafa';
var grey100 = exports.grey100 = '#f5f5f5';
var grey200 = exports.grey200 = '#eeeeee';
var grey300 = exports.grey300 = '#e0e0e0';
var grey400 = exports.grey400 = '#bdbdbd';
var grey500 = exports.grey500 = '#9e9e9e';
var grey600 = exports.grey600 = '#757575';
var grey700 = exports.grey700 = '#616161';
var grey800 = exports.grey800 = '#424242';
var grey900 = exports.grey900 = '#212121';

var black = exports.black = '#000000';
var white = exports.white = '#ffffff';

var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
module.exports = exports["default"];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var configObject={guestJWT:/* expires on 18 June 2029 */"eyJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6Imd1ZXN0IiwiZXhwaXJ5IjoiMjAyOS0wNi0xNVQxMjoyNzowOC4yMTAwMzIrMDI6MDAifQ.BQI6A3cTrCQcSzuhl0nzL948SpjC_h8tCeoPOrINWUY",expiredGuestJWTs:["eyJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6Imd1ZXN0IiwiZXhwaXJ5IjoiMjAxOS0wNS0yOVQxNDo1MTo0OC4yOTUxNDFaIn0.1vGh3vFfZPgAhxiR7kEl39UZzjSCq92-z_4owHJyJsg","eyJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6Imd1ZXN0IiwiZXhwaXJ5IjoiMjAyMC0wNi0xMFQxMzo1OTozMS4yNjQ4NDArMDI6MDAifQ.nqy-ZIkGRLI1x-TX782u3DFZpwP9fIK8TjwXBDzBBk8"]};/* harmony default export */ __webpack_exports__["a"] = (configObject);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _IconButton = __webpack_require__(275);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IconButton2.default;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  once: function once(el, type, callback) {
    var typeArray = type ? type.split(' ') : [];
    var recursiveFunction = function recursiveFunction(event) {
      event.target.removeEventListener(event.type, recursiveFunction);
      return callback(event);
    };

    for (var i = typeArray.length - 1; i >= 0; i--) {
      this.on(el, typeArray[i], recursiveFunction);
    }
  },
  on: function on(el, type, callback) {
    if (el.addEventListener) {
      el.addEventListener(type, callback);
    } else {
      // IE8+ Support
      el.attachEvent('on' + type, function () {
        callback.call(el);
      });
    }
  },
  off: function off(el, type, callback) {
    if (el.removeEventListener) {
      el.removeEventListener(type, callback);
    } else {
      // IE8+ Support
      el.detachEvent('on' + type, callback);
    }
  },
  isKeyboard: function isKeyboard(event) {
    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
  }
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deepMap;
/* harmony export (immutable) */ __webpack_exports__["a"] = deepForEach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(54);
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




function isTabChild(child) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child);
}

function deepMap(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return null;

    if (isTabChild(child)) {
      return callback(child);
    }

    if (child.props && child.props.children && typeof child.props.children === 'object') {
      // Clone the child that has children and map them too
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, _objectSpread({}, child.props, {
        children: deepMap(child.props.children, callback)
      }));
    }

    return child;
  });
}
function deepForEach(children, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].forEach(children, function (child) {
    // null happens when conditionally rendering TabPanel/Tab
    // see https://github.com/reactjs/react-tabs/issues/37
    if (child === null) return;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child) || Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      callback(child);
    } else if (child.props && child.props.children && typeof child.props.children === 'object') {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) callback(child);
      deepForEach(child.props.children, callback);
    }
  });
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(140);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(31);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(88);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(59);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(162)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getMuiTheme = __webpack_require__(105);

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MuiThemeProvider = function (_Component) {
  (0, _inherits3.default)(MuiThemeProvider, _Component);

  function MuiThemeProvider() {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);
    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.Component);

MuiThemeProvider.childContextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MuiThemeProvider.propTypes =  false ? {
  children: _propTypes2.default.element,
  muiTheme: _propTypes2.default.object
} : {};
exports.default = MuiThemeProvider;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(24);
var toObject = __webpack_require__(44);
var IE_PROTO = __webpack_require__(61)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(19);
var core = __webpack_require__(13);
var fails = __webpack_require__(36);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(25) && !__webpack_require__(36)(function () {
  return Object.defineProperty(__webpack_require__(95)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(35);
var document = __webpack_require__(18).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(182);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(194);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(184)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(98)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(49);
var $export = __webpack_require__(19);
var redefine = __webpack_require__(99);
var hide = __webpack_require__(33);
var Iterators = __webpack_require__(46);
var $iterCreate = __webpack_require__(185);
var setToStringTag = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(92);
var ITERATOR = __webpack_require__(16)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(33);


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(24);
var toIObject = __webpack_require__(37);
var arrayIndexOf = __webpack_require__(187)(false);
var IE_PROTO = __webpack_require__(61)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(67);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(65);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(100);
var hiddenKeys = __webpack_require__(68).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(51);
var createDesc = __webpack_require__(45);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(64);
var has = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(94);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(25) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(106);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = getMuiTheme;

var _lodash = __webpack_require__(219);

var _lodash2 = _interopRequireDefault(_lodash);

var _colorManipulator = __webpack_require__(73);

var _lightBaseTheme = __webpack_require__(221);

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

var _zIndex = __webpack_require__(223);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _autoprefixer = __webpack_require__(224);

var _autoprefixer2 = _interopRequireDefault(_autoprefixer);

var _callOnce = __webpack_require__(249);

var _callOnce2 = _interopRequireDefault(_callOnce);

var _rtl = __webpack_require__(250);

var _rtl2 = _interopRequireDefault(_rtl);

var _compose = __webpack_require__(254);

var _compose2 = _interopRequireDefault(_compose);

var _typography = __webpack_require__(255);

var _typography2 = _interopRequireDefault(_typography);

var _colors = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get the MUI theme corresponding to a base theme.
 * It's possible to override the computed theme values
 * by providing a second argument. The calculated
 * theme will be deeply merged with the second argument.
 */
function getMuiTheme(muiTheme) {
  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }

  muiTheme = _lodash2.default.apply(undefined, [{
    zIndex: _zIndex2.default,
    isRtl: false,
    userAgent: undefined
  }, _lightBaseTheme2.default, muiTheme].concat(more));

  var _muiTheme = muiTheme,
      spacing = _muiTheme.spacing,
      fontFamily = _muiTheme.fontFamily,
      palette = _muiTheme.palette;

  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };

  muiTheme = (0, _lodash2.default)({
    appBar: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      height: spacing.desktopKeylineIncrement,
      titleFontWeight: _typography2.default.fontWeightNormal,
      padding: spacing.desktopGutter
    },
    avatar: {
      color: palette.canvasColor,
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
    },
    badge: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      fontWeight: _typography2.default.fontWeightMedium
    },
    bottomNavigation: {
      backgroundColor: palette.canvasColor,
      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      selectedColor: palette.primary1Color,
      height: 56,
      unselectedFontSize: 12,
      selectedFontSize: 14
    },
    button: {
      height: 36,
      minWidth: 88,
      iconButtonSize: spacing.iconSize * 2
    },
    card: {
      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    cardMedia: {
      color: _colors.darkWhite,
      overlayContentBackground: _colors.lightBlack,
      titleColor: _colors.darkWhite,
      subtitleColor: _colors.lightWhite
    },
    cardText: {
      textColor: palette.textColor
    },
    checkbox: {
      boxColor: palette.textColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    chip: {
      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      fontSize: 14,
      fontWeight: _typography2.default.fontWeightNormal,
      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
    },
    datePicker: {
      color: palette.primary1Color,
      textColor: palette.alternateTextColor,
      calendarTextColor: palette.textColor,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor,
      calendarYearBackgroundColor: palette.canvasColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color
    },
    dialog: {
      titleFontSize: 22,
      bodyFontSize: 16,
      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
    },
    dropDownMenu: {
      accentColor: palette.borderColor
    },
    enhancedButton: {
      tapHighlightColor: _colors.transparent
    },
    flatButton: {
      color: _colors.transparent,
      buttonFilterColor: '#999999',
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      textColor: palette.textColor,
      primaryTextColor: palette.primary1Color,
      secondaryTextColor: palette.accent1Color,
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    floatingActionButton: {
      buttonSize: 56,
      miniSize: 40,
      color: palette.primary1Color,
      iconColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryIconColor: palette.alternateTextColor,
      disabledTextColor: palette.disabledColor,
      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
    },
    gridTile: {
      textColor: _colors.white
    },
    icon: {
      color: palette.canvasColor,
      backgroundColor: palette.primary1Color
    },
    inkBar: {
      backgroundColor: palette.accent1Color
    },
    drawer: {
      width: spacing.desktopKeylineIncrement * 4,
      color: palette.canvasColor
    },
    listItem: {
      nestedLevelDepth: 18,
      secondaryTextColor: palette.secondaryTextColor,
      leftIconColor: _colors.grey600,
      rightIconColor: _colors.grey600
    },
    menu: {
      backgroundColor: palette.canvasColor,
      containerBackgroundColor: palette.canvasColor
    },
    menuItem: {
      dataHeight: 32,
      height: 48,
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
      padding: spacing.desktopGutter,
      selectedTextColor: palette.accent1Color,
      rightIconDesktopFill: _colors.grey600
    },
    menuSubheader: {
      padding: spacing.desktopGutter,
      borderColor: palette.borderColor,
      textColor: palette.primary1Color
    },
    overlay: {
      backgroundColor: _colors.lightBlack
    },
    paper: {
      color: palette.textColor,
      backgroundColor: palette.canvasColor,
      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
      })
    },
    radioButton: {
      borderColor: palette.textColor,
      backgroundColor: palette.alternateTextColor,
      checkedColor: palette.primary1Color,
      requiredColor: palette.primary1Color,
      disabledColor: palette.disabledColor,
      size: 24,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor
    },
    raisedButton: {
      color: palette.alternateTextColor,
      textColor: palette.textColor,
      primaryColor: palette.primary1Color,
      primaryTextColor: palette.alternateTextColor,
      secondaryColor: palette.accent1Color,
      secondaryTextColor: palette.alternateTextColor,
      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
      fontSize: _typography2.default.fontStyleButtonFontSize,
      fontWeight: _typography2.default.fontWeightMedium
    },
    refreshIndicator: {
      strokeColor: palette.borderColor,
      loadingStrokeColor: palette.primary1Color
    },
    ripple: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
    },
    slider: {
      trackSize: 2,
      trackColor: palette.primary3Color,
      trackColorSelected: palette.accent3Color,
      handleSize: 12,
      handleSizeDisabled: 8,
      handleSizeActive: 18,
      handleColorZero: palette.primary3Color,
      handleFillColor: palette.alternateTextColor,
      selectionColor: palette.primary1Color,
      rippleColor: palette.primary1Color
    },
    snackbar: {
      textColor: palette.alternateTextColor,
      backgroundColor: palette.textColor,
      actionColor: palette.accent1Color
    },
    subheader: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      fontWeight: _typography2.default.fontWeightMedium
    },
    stepper: {
      backgroundColor: 'transparent',
      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
      iconColor: palette.primary1Color,
      hoveredIconColor: _colors.grey700,
      inactiveIconColor: _colors.grey500,
      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
      connectorLineColor: _colors.grey400
    },
    svgIcon: {
      color: palette.textColor
    },
    table: {
      backgroundColor: palette.canvasColor
    },
    tableFooter: {
      borderColor: palette.borderColor,
      textColor: palette.accent3Color
    },
    tableHeader: {
      borderColor: palette.borderColor
    },
    tableHeaderColumn: {
      textColor: palette.accent3Color,
      height: 56,
      spacing: 24
    },
    tableRow: {
      hoverColor: palette.accent2Color,
      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
      selectedColor: palette.borderColor,
      textColor: palette.textColor,
      borderColor: palette.borderColor,
      height: 48
    },
    tableRowColumn: {
      height: 48,
      spacing: 24
    },
    tabs: {
      backgroundColor: palette.primary1Color,
      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
      selectedTextColor: palette.alternateTextColor
    },
    textField: {
      textColor: palette.textColor,
      hintColor: palette.disabledColor,
      floatingLabelColor: palette.disabledColor,
      disabledTextColor: palette.disabledColor,
      errorColor: _colors.red500,
      focusColor: palette.primary1Color,
      backgroundColor: 'transparent',
      borderColor: palette.borderColor
    },
    timePicker: {
      color: palette.alternateTextColor,
      textColor: palette.alternateTextColor,
      accentColor: palette.primary1Color,
      clockColor: palette.textColor,
      clockCircleColor: palette.clockCircleColor,
      headerColor: palette.pickerHeaderColor || palette.primary1Color,
      selectColor: palette.primary2Color,
      selectTextColor: palette.alternateTextColor
    },
    toggle: {
      thumbOnColor: palette.primary1Color,
      thumbOffColor: palette.accent2Color,
      thumbDisabledColor: palette.borderColor,
      thumbRequiredColor: palette.primary1Color,
      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
      trackOffColor: palette.primary3Color,
      trackDisabledColor: palette.primary3Color,
      labelColor: palette.textColor,
      labelDisabledColor: palette.disabledColor,
      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
    },
    toolbar: {
      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
      height: 56,
      titleFontSize: 20,
      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
    },
    tooltip: {
      color: _colors.white,
      rippleBackgroundColor: _colors.grey700,
      opacity: 0.9
    }
  }, muiTheme, {
    baseTheme: baseTheme, // To provide backward compatibility.
    rawTheme: baseTheme // To provide backward compatibility.
  });

  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
    return t(muiTheme);
  }).filter(function (t) {
    return t;
  });

  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));

  return muiTheme;
}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(107);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(211), __esModule: true };

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}
module.exports = exports["default"];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}
module.exports = exports["default"];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}
module.exports = exports["default"];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(240);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keyboardArrowUp = __webpack_require__(268);

var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);

var _keyboardArrowDown = __webpack_require__(274);

var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);

var _IconButton = __webpack_require__(78);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      top: 0,
      bottom: 0,
      right: 4,
      margin: 'auto',
      position: 'absolute'
    }
  };
}

var CardExpandable = function (_Component) {
  (0, _inherits3.default)(CardExpandable, _Component);

  function CardExpandable() {
    (0, _classCallCheck3.default)(this, CardExpandable);
    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardExpandable, [{
    key: 'render',
    value: function render() {
      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        _IconButton2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
          onClick: this.props.onExpanding,
          iconStyle: this.props.iconStyle
        },
        this.props.expanded ? this.props.openIcon : this.props.closeIcon
      );
    }
  }]);
  return CardExpandable;
}(_react.Component);

CardExpandable.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardExpandable.defaultProps = {
  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
};
CardExpandable.propTypes =  false ? {
  closeIcon: _propTypes2.default.node,
  expanded: _propTypes2.default.bool,
  iconStyle: _propTypes2.default.object,
  onExpanding: _propTypes2.default.func.isRequired,
  openIcon: _propTypes2.default.node,
  style: _propTypes2.default.object
} : {};
exports.default = CardExpandable;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(270);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(271);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__(79);

var _events2 = _interopRequireDefault(_events);

var _keycode = __webpack_require__(80);

var _keycode2 = _interopRequireDefault(_keycode);

var _FocusRipple = __webpack_require__(276);

var _FocusRipple2 = _interopRequireDefault(_FocusRipple);

var _TouchRipple = __webpack_require__(281);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleInjected = false;
var listening = false;
var tabPressed = false;

function injectStyle() {
  if (!styleInjected) {
    // Remove inner padding and border in Firefox 4+.
    var style = document.createElement('style');
    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';

    document.body.appendChild(style);
    styleInjected = true;
  }
}

function listenForTabPresses() {
  if (!listening) {
    _events2.default.on(window, 'keydown', function (event) {
      tabPressed = (0, _keycode2.default)(event) === 'tab';
    });
    listening = true;
  }
}

var EnhancedButton = function (_Component) {
  (0, _inherits3.default)(EnhancedButton, _Component);

  function EnhancedButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnhancedButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isKeyboardFocused: false
    }, _this.handleKeyDown = function (event) {
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
          _this.removeKeyboardFocus(event);
        }
      }
      _this.props.onKeyDown(event);
    }, _this.handleKeyUp = function (event) {
      _this.props.onKeyUp(event);
    }, _this.handleBlur = function (event) {
      _this.cancelFocusTimeout();
      _this.removeKeyboardFocus(event);
      _this.props.onBlur(event);
    }, _this.handleFocus = function (event) {
      if (event) event.persist();
      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
        // setTimeout is needed because the focus event fires first
        // Wait so that we can capture if this was a keyboard focus
        // or touch focus
        _this.focusTimeout = setTimeout(function () {
          if (tabPressed) {
            _this.setKeyboardFocus(event);
            tabPressed = false;
          }
        }, 150);

        _this.props.onFocus(event);
      }
    }, _this.handleClick = function (event) {
      _this.cancelFocusTimeout();
      if (!_this.props.disabled) {
        tabPressed = false;
        _this.removeKeyboardFocus(event);
        _this.props.onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnhancedButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          disabled = _props.disabled,
          disableKeyboardFocus = _props.disableKeyboardFocus,
          keyboardFocused = _props.keyboardFocused;

      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
        this.setState({ isKeyboardFocused: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      injectStyle();
      listenForTabPresses();
      if (this.state.isKeyboardFocused) {
        this.button.focus();
        this.props.onKeyboardFocus(null, true);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        if (nextProps.onKeyboardFocus) {
          nextProps.onKeyboardFocus(null, false);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
    }
  }, {
    key: 'isKeyboardFocused',
    value: function isKeyboardFocused() {
      return this.state.isKeyboardFocused;
    }
  }, {
    key: 'removeKeyboardFocus',
    value: function removeKeyboardFocus(event) {
      if (this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: false });
        this.props.onKeyboardFocus(event, false);
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus(event) {
      if (!this.state.isKeyboardFocused) {
        this.setState({ isKeyboardFocused: true });
        this.props.onKeyboardFocus(event, true);
      }
    }
  }, {
    key: 'cancelFocusTimeout',
    value: function cancelFocusTimeout() {
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
        this.focusTimeout = null;
      }
    }
  }, {
    key: 'createButtonChildren',
    value: function createButtonChildren() {
      var _props2 = this.props,
          centerRipple = _props2.centerRipple,
          children = _props2.children,
          disabled = _props2.disabled,
          disableFocusRipple = _props2.disableFocusRipple,
          disableKeyboardFocus = _props2.disableKeyboardFocus,
          disableTouchRipple = _props2.disableTouchRipple,
          focusRippleColor = _props2.focusRippleColor,
          focusRippleOpacity = _props2.focusRippleOpacity,
          touchRippleColor = _props2.touchRippleColor,
          touchRippleOpacity = _props2.touchRippleOpacity;
      var isKeyboardFocused = this.state.isKeyboardFocused;

      // Focus Ripple

      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
        color: focusRippleColor,
        opacity: focusRippleOpacity,
        show: isKeyboardFocused,
        style: {
          overflow: 'hidden'
        },
        key: 'focusRipple'
      }) : undefined;

      // Touch Ripple
      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
        _TouchRipple2.default,
        {
          centerRipple: centerRipple,
          color: touchRippleColor,
          opacity: touchRippleOpacity,
          key: 'touchRipple'
        },
        children
      ) : undefined;

      return [focusRipple, touchRipple, touchRipple ? undefined : children];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          centerRipple = _props3.centerRipple,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableFocusRipple = _props3.disableFocusRipple,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          disableTouchRipple = _props3.disableTouchRipple,
          focusRippleColor = _props3.focusRippleColor,
          focusRippleOpacity = _props3.focusRippleOpacity,
          href = _props3.href,
          keyboardFocused = _props3.keyboardFocused,
          touchRippleColor = _props3.touchRippleColor,
          touchRippleOpacity = _props3.touchRippleOpacity,
          onBlur = _props3.onBlur,
          onClick = _props3.onClick,
          onFocus = _props3.onFocus,
          onKeyUp = _props3.onKeyUp,
          onKeyDown = _props3.onKeyDown,
          onKeyboardFocus = _props3.onKeyboardFocus,
          style = _props3.style,
          tabIndex = _props3.tabIndex,
          type = _props3.type,
          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          enhancedButton = _context$muiTheme.enhancedButton;


      var mergedStyles = (0, _simpleAssign2.default)({
        border: 10,
        boxSizing: 'border-box',
        display: 'inline-block',
        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
        cursor: disabled ? 'default' : 'pointer',
        textDecoration: 'none',
        margin: 0,
        padding: 0,
        outline: 'none',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        position: 'relative', // This is needed so that ripples do not bleed past border radius.
        verticalAlign: href ? 'middle' : null
      }, style);

      // Passing both background:none & backgroundColor can break due to object iteration order
      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
        mergedStyles.background = 'none';
      }

      if (disabled && href) {
        return _react2.default.createElement(
          'span',
          (0, _extends3.default)({}, other, {
            style: mergedStyles
          }),
          children
        );
      }

      var buttonProps = (0, _extends3.default)({}, other, {
        style: prepareStyles(mergedStyles),
        ref: function ref(node) {
          return _this2.button = node;
        },
        disabled: disabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleClick,
        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
      });

      if (href) buttonProps.href = href;

      var buttonChildren = this.createButtonChildren();

      if (_react2.default.isValidElement(containerElement)) {
        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
      }

      if (!href && containerElement === 'button') {
        buttonProps.type = type;
      }

      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
    }
  }]);
  return EnhancedButton;
}(_react.Component);

EnhancedButton.defaultProps = {
  containerElement: 'button',
  onBlur: function onBlur() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyUp: function onKeyUp() {},
  onKeyboardFocus: function onKeyboardFocus() {},
  tabIndex: 0,
  type: 'button'
};
EnhancedButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
EnhancedButton.propTypes =  false ? {
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  disableFocusRipple: _propTypes2.default.bool,
  disableKeyboardFocus: _propTypes2.default.bool,
  disableTouchRipple: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focusRippleColor: _propTypes2.default.string,
  focusRippleOpacity: _propTypes2.default.number,
  href: _propTypes2.default.string,
  keyboardFocused: _propTypes2.default.bool,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onKeyUp: _propTypes2.default.func,
  onKeyboardFocus: _propTypes2.default.func,
  style: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,
  touchRippleColor: _propTypes2.default.string,
  touchRippleOpacity: _propTypes2.default.number,
  type: _propTypes2.default.string
} : {};
exports.default = EnhancedButton;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(278);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(107);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  isDescendant: function isDescendant(parent, child) {
    var node = child.parentNode;

    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }

    return false;
  },
  offset: function offset(el) {
    var rect = el.getBoundingClientRect();
    return {
      top: rect.top + document.body.scrollTop,
      left: rect.left + document.body.scrollLeft
    };
  }
};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(40);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _Popover = __webpack_require__(123);

var _Popover2 = _interopRequireDefault(_Popover);

var _check = __webpack_require__(341);

var _check2 = _interopRequireDefault(_check);

var _ListItem = __webpack_require__(342);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Menu = __webpack_require__(126);

var _Menu2 = _interopRequireDefault(_Menu);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nestedMenuStyle = {
  position: 'relative'
};

function getStyles(props, context) {
  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
  var textColor = context.muiTheme.baseTheme.palette.textColor;
  var indent = props.desktop ? 64 : 72;
  var sidePadding = props.desktop ? 24 : 16;

  var styles = {
    root: {
      color: props.disabled ? disabledColor : textColor,
      cursor: props.disabled ? 'default' : 'pointer',
      minHeight: props.desktop ? '32px' : '48px',
      lineHeight: props.desktop ? '32px' : '48px',
      fontSize: props.desktop ? 15 : 16,
      whiteSpace: 'nowrap'
    },

    innerDivStyle: {
      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
      paddingRight: props.rightIcon ? indent : sidePadding,
      paddingBottom: 0,
      paddingTop: 0
    },

    secondaryText: {
      float: 'right'
    },

    leftIconDesktop: {
      margin: 0,
      left: 24,
      top: 4
    },

    rightIconDesktop: {
      margin: 0,
      right: 24,
      top: 4,
      fill: context.muiTheme.menuItem.rightIconDesktopFill
    }
  };

  return styles;
}

var MenuItem = function (_Component) {
  (0, _inherits3.default)(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.cloneMenuItem = function (item) {
      return _react2.default.cloneElement(item, {
        onClick: function onClick(event) {
          if (!item.props.menuItems) {
            _this.handleRequestClose();
          }

          if (item.props.onClick) {
            item.props.onClick(event);
          }
        }
      });
    }, _this.handleClick = function (event) {
      event.preventDefault();

      _this.setState({
        open: true,
        anchorEl: _reactDom2.default.findDOMNode(_this)
      });

      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleRequestClose = function () {
      _this.setState({
        open: false,
        anchorEl: null
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.open && nextProps.focusState === 'none') {
        this.handleRequestClose();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.applyFocusState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.state.open) {
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: 'applyFocusState',
    value: function applyFocusState() {
      this.refs.listItem.applyFocusState(this.props.focusState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          children = _props.children,
          desktop = _props.desktop,
          disabled = _props.disabled,
          focusState = _props.focusState,
          innerDivStyle = _props.innerDivStyle,
          insetChildren = _props.insetChildren,
          leftIcon = _props.leftIcon,
          menuItems = _props.menuItems,
          rightIcon = _props.rightIcon,
          secondaryText = _props.secondaryText,
          style = _props.style,
          animation = _props.animation,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);

      // Left Icon
      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
      if (leftIconElement) {
        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
      }

      // Right Icon
      var rightIconElement = void 0;
      if (rightIcon) {
        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
      }

      // Secondary Text
      var secondaryTextElement = void 0;
      if (secondaryText) {
        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;

        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.secondaryText) },
          secondaryText
        );
      }
      var childMenuPopover = void 0;
      if (menuItems) {
        childMenuPopover = _react2.default.createElement(
          _Popover2.default,
          {
            animation: animation,
            anchorOrigin: anchorOrigin,
            anchorEl: this.state.anchorEl,
            open: this.state.open,
            targetOrigin: targetOrigin,
            useLayerForClickAway: false,
            onRequestClose: this.handleRequestClose
          },
          _react2.default.createElement(
            _Menu2.default,
            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
            _react2.default.Children.map(menuItems, this.cloneMenuItem)
          )
        );
        other.onClick = this.handleClick;
      }

      return _react2.default.createElement(
        _ListItem2.default,
        (0, _extends3.default)({}, other, {
          disabled: disabled,
          hoverColor: this.context.muiTheme.menuItem.hoverColor,
          innerDivStyle: mergedInnerDivStyles,
          insetChildren: insetChildren,
          leftIcon: leftIconElement,
          ref: 'listItem',
          rightIcon: rightIconElement,
          role: 'menuitem',
          style: mergedRootStyles
        }),
        children,
        secondaryTextElement,
        childMenuPopover
      );
    }
  }]);
  return MenuItem;
}(_react.Component);

MenuItem.muiName = 'MenuItem';
MenuItem.defaultProps = {
  anchorOrigin: { horizontal: 'right', vertical: 'top' },
  checked: false,
  desktop: false,
  disabled: false,
  focusState: 'none',
  insetChildren: false,
  targetOrigin: { horizontal: 'left', vertical: 'top' }
};
MenuItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
MenuItem.propTypes =  false ? {
  /**
   * Location of the anchor for the popover of nested `MenuItem`
   * elements.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, a left check mark will be rendered.
   */
  checked: _propTypes2.default.bool,
  /**
   * Elements passed as children to the underlying `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   * If true, the menu item will render with compact desktop
   * styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu item will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The focus state of the menu item. This prop is used to set the focus
   * state of the underlying `ListItem`.
   */
  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
  /**
   * Override the inline-styles of the inner div.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented.
   * This is only needed when there is no `leftIcon`.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * `MenuItem` elements to nest within the menu item.
   */
  menuItems: _propTypes2.default.node,
  /**
   * Callback function fired when the menu item is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Can be used to render primary text within the menu item.
   */
  primaryText: _propTypes2.default.node,
  /**
   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * Can be used to render secondary text within the menu item.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Location on the popover of nested `MenuItem` elements that will attach
   * to the anchor's origin.
   * Options:
   * horizontal: [left, middle, right]
   * vertical: [top, center, bottom].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * The value of the menu item.
   */
  value: _propTypes2.default.any
} : {};
exports.default = MenuItem;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactEventListener = __webpack_require__(326);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _RenderToLayer = __webpack_require__(338);

var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(53);

var _Paper2 = _interopRequireDefault(_Paper);

var _lodash = __webpack_require__(339);

var _lodash2 = _interopRequireDefault(_lodash);

var _PopoverAnimationDefault = __webpack_require__(340);

var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  root: {
    display: 'none'
  }
};

var Popover = function (_Component) {
  (0, _inherits3.default)(Popover, _Component);

  function Popover(props, context) {
    (0, _classCallCheck3.default)(this, Popover);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));

    _this.timeout = null;

    _this.renderLayer = function () {
      var _this$props = _this.props,
          animated = _this$props.animated,
          animation = _this$props.animation,
          anchorEl = _this$props.anchorEl,
          anchorOrigin = _this$props.anchorOrigin,
          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
          canAutoPosition = _this$props.canAutoPosition,
          children = _this$props.children,
          onRequestClose = _this$props.onRequestClose,
          style = _this$props.style,
          targetOrigin = _this$props.targetOrigin,
          useLayerForClickAway = _this$props.useLayerForClickAway,
          scrollableContainer = _this$props.scrollableContainer,
          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);


      var styleRoot = style;

      if (!animated) {
        styleRoot = {
          position: 'fixed',
          zIndex: _this.context.muiTheme.zIndex.popover
        };

        if (!_this.state.open) {
          return null;
        }

        return _react2.default.createElement(
          _Paper2.default,
          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
          children
        );
      }

      var Animation = animation || _PopoverAnimationDefault2.default;

      return _react2.default.createElement(
        Animation,
        (0, _extends3.default)({
          targetOrigin: targetOrigin,
          style: styleRoot
        }, other, {
          open: _this.state.open && !_this.state.closing
        }),
        children
      );
    };

    _this.componentClickAway = function () {
      _this.requestClose('clickAway');
    };

    _this.setPlacement = function (scrolling) {
      if (!_this.state.open) {
        return;
      }

      if (!_this.popoverRefs.layer.getLayer()) {
        return;
      }

      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
      if (!targetEl) {
        return;
      }

      var _this$props2 = _this.props,
          targetOrigin = _this$props2.targetOrigin,
          anchorOrigin = _this$props2.anchorOrigin;

      var anchorEl = _this.props.anchorEl || _this.anchorEl;

      var anchor = _this.getAnchorPosition(anchorEl);
      var target = _this.getTargetPosition(targetEl);

      var targetPosition = {
        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
      };

      if (scrolling && _this.props.autoCloseWhenOffScreen) {
        _this.autoCloseWhenOffScreen(anchor);
      }

      if (_this.props.canAutoPosition) {
        target = _this.getTargetPosition(targetEl); // update as height may have changed
        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
      }

      targetEl.style.top = targetPosition.top + 'px';
      targetEl.style.left = targetPosition.left + 'px';
      targetEl.style.maxHeight = window.innerHeight + 'px';
    };

    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);

    _this.popoverRefs = {};

    _this.state = {
      open: props.open,
      closing: false
    };
    return _this;
  }

  (0, _createClass3.default)(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open === this.props.open) {
        return;
      }

      if (nextProps.open) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
        this.setState({
          open: true,
          closing: false
        });
      } else {
        if (nextProps.animated) {
          if (this.timeout !== null) return;
          this.setState({ closing: true });
          this.timeout = setTimeout(function () {
            _this2.setState({
              open: false
            }, function () {
              _this2.timeout = null;
            });
          }, 500);
        } else {
          this.setState({
            open: false
          });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      clearTimeout(this.placementTimeout);
      this.placementTimeout = setTimeout(this.setPlacement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
      this.handleScroll.cancel();

      if (this.placementTimeout) {
        clearTimeout(this.placementTimeout);
        this.placementTimeout = null;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }, {
    key: 'requestClose',
    value: function requestClose(reason) {
      if (this.props.onRequestClose) {
        this.props.onRequestClose(reason);
      }
    }
  }, {
    key: 'getAnchorPosition',
    value: function getAnchorPosition(el) {
      if (!el) {
        el = _reactDom2.default.findDOMNode(this);
      }

      var rect = el.getBoundingClientRect();
      var a = {
        top: rect.top,
        left: rect.left,
        width: el.offsetWidth,
        height: el.offsetHeight
      };

      a.right = rect.right || a.left + a.width;
      a.bottom = rect.bottom || a.top + a.height;
      a.middle = a.left + (a.right - a.left) / 2;
      a.center = a.top + (a.bottom - a.top) / 2;

      return a;
    }
  }, {
    key: 'getTargetPosition',
    value: function getTargetPosition(targetEl) {
      return {
        top: 0,
        center: targetEl.offsetHeight / 2,
        bottom: targetEl.offsetHeight,
        left: 0,
        middle: targetEl.offsetWidth / 2,
        right: targetEl.offsetWidth
      };
    }
  }, {
    key: 'autoCloseWhenOffScreen',
    value: function autoCloseWhenOffScreen(anchorPosition) {
      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
        this.requestClose('offScreen');
      }
    }
  }, {
    key: 'getOverlapMode',
    value: function getOverlapMode(anchor, target, median) {
      if ([anchor, target].indexOf(median) >= 0) return 'auto';
      if (anchor === target) return 'inclusive';
      return 'exclusive';
    }
  }, {
    key: 'getPositions',
    value: function getPositions(anchor, target) {
      var a = (0, _extends3.default)({}, anchor);
      var t = (0, _extends3.default)({}, target);

      var positions = {
        x: ['left', 'right'].filter(function (p) {
          return p !== t.horizontal;
        }),
        y: ['top', 'bottom'].filter(function (p) {
          return p !== t.vertical;
        })
      };

      var overlap = {
        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
      };

      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');

      if (overlap.y !== 'auto') {
        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
        if (overlap.y === 'inclusive') {
          t.vertical = t.vertical;
        }
      }

      if (overlap.x !== 'auto') {
        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
        if (overlap.y === 'inclusive') {
          t.horizontal = t.horizontal;
        }
      }

      return {
        positions: positions,
        anchorPos: a
      };
    }
  }, {
    key: 'applyAutoPositionIfNeeded',
    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
          positions = _getPositions.positions,
          anchorPos = _getPositions.anchorPos;

      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
        if (newTop + target.bottom <= window.innerHeight) {
          targetPosition.top = Math.max(0, newTop);
        } else {
          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
          if (newTop + target.bottom <= window.innerHeight) {
            targetPosition.top = Math.max(0, newTop);
          }
        }
      }

      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
        if (newLeft + target.right <= window.innerWidth) {
          targetPosition.left = Math.max(0, newLeft);
        } else {
          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
          if (newLeft + target.right <= window.innerWidth) {
            targetPosition.left = Math.max(0, newLeft);
          }
        }
      }

      return targetPosition;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var eventListener = this.state.open ? _react2.default.createElement(_reactEventListener2.default, {
        target: this.props.scrollableContainer,
        onScroll: this.handleScroll,
        onResize: this.handleResize
      }) : null;
      return _react2.default.createElement(
        'div',
        { style: styles.root },
        eventListener,
        _react2.default.createElement(_RenderToLayer2.default, {
          ref: function ref(_ref) {
            return _this3.popoverRefs.layer = _ref;
          },
          open: this.state.open,
          componentClickAway: this.componentClickAway,
          useLayerForClickAway: this.props.useLayerForClickAway,
          render: this.renderLayer
        })
      );
    }
  }]);
  return Popover;
}(_react.Component);

Popover.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  animated: true,
  autoCloseWhenOffScreen: true,
  canAutoPosition: true,
  onRequestClose: function onRequestClose() {},
  open: false,
  scrollableContainer: 'window',
  style: {
    overflowY: 'auto'
  },
  targetOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  useLayerForClickAway: true,
  zDepth: 1
};
Popover.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Popover.propTypes =  false ? {
  /**
   * This is the DOM element that will be used to set the position of the
   * popover.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * This is the point on the anchor where the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it is added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * If true, the popover will hide when the anchor is scrolled off the screen.
   */
  autoCloseWhenOffScreen: _propTypes2.default.bool,
  /**
   * If true, the popover (potentially) ignores `targetOrigin`
   * and `anchorOrigin` to make itself fit on screen,
   * which is useful for mobile devices.
   */
  canAutoPosition: _propTypes2.default.bool,
  /**
   * The content of the popover.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Callback function fired when the popover is requested to be closed.
   *
   * @param {string} reason The reason for the close request. Possibles values
   * are 'clickAway' and 'offScreen'.
   */
  onRequestClose: _propTypes2.default.func,
  /**
   * If true, the popover is visible.
   */
  open: _propTypes2.default.bool,
  /**
   * Represents the parent scrollable container.
   * It can be an element or a string like `window`.
   */
  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will render on top of an invisible
   * layer, which will prevent clicks to the underlying
   * elements, and trigger an `onRequestClose('clickAway')` call.
   */
  useLayerForClickAway: _propTypes2.default.bool,
  /**
   * The zDepth of the popover.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Popover;

/***/ }),
/* 124 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Subheader = __webpack_require__(346);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function (_Component) {
  (0, _inherits3.default)(List, _Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var hasSubheader = false;

      var firstChild = _react.Children.toArray(children)[0];
      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
        hasSubheader = true;
      }

      var styles = {
        root: {
          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
        }
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return List;
}(_react.Component);

List.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
List.propTypes =  false ? {
  /**
   * These are usually `ListItem`s that are passed to
   * be part of the list.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = List;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toArray2 = __webpack_require__(118);

var _toArray3 = _interopRequireDefault(_toArray2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(40);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _ClickAwayListener = __webpack_require__(348);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _keycode = __webpack_require__(80);

var _keycode2 = _interopRequireDefault(_keycode);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _List = __webpack_require__(125);

var _List2 = _interopRequireDefault(_List);

var _menuUtils = __webpack_require__(349);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var desktop = props.desktop,
      maxHeight = props.maxHeight,
      width = props.width;
  var muiTheme = context.muiTheme;


  var styles = {
    root: {
      // Nested div because the List scales x faster than it scales y
      zIndex: muiTheme.zIndex.menu,
      maxHeight: maxHeight,
      overflowY: maxHeight ? 'auto' : null
    },
    divider: {
      marginTop: 7,
      marginBottom: 8
    },
    list: {
      display: 'table-cell',
      paddingBottom: desktop ? 16 : 8,
      paddingTop: desktop ? 16 : 8,
      userSelect: 'none',
      width: width
    },
    selectedMenuItem: {
      color: muiTheme.menuItem.selectedTextColor
    }
  };

  return styles;
}

var Menu = function (_Component) {
  (0, _inherits3.default)(Menu, _Component);

  function Menu(props, context) {
    (0, _classCallCheck3.default)(this, Menu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));

    _initialiseProps.call(_this);

    var filteredChildren = _this.getFilteredChildren(props.children);
    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);

    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
      props.onMenuItemFocusChange(null, newFocusIndex);
    }
    _this.state = {
      focusIndex: newFocusIndex,
      isKeyboardFocused: props.initiallyKeyboardFocused,
      keyWidth: props.desktop ? 64 : 56
    };

    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
    return _this;
  }

  (0, _createClass3.default)(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
      this.setScollPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selectedIndex = void 0;
      var filteredChildren = this.getFilteredChildren(nextProps.children);

      if (this.props.multiple !== true) {
        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
      } else {
        selectedIndex = this.state.focusIndex;
      }

      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
        this.props.onMenuItemFocusChange(null, newFocusIndex);
      }
      this.setState({
        focusIndex: newFocusIndex,
        keyWidth: nextProps.desktop ? 64 : 56
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.autoWidth) this.setWidth();
    }
  }, {
    key: 'getValueLink',


    // Do not use outside of this component, it will be removed once valueLink is deprecated
    value: function getValueLink(props) {
      return props.valueLink || {
        value: props.value,
        requestChange: props.onChange
      };
    }
  }, {
    key: 'setKeyboardFocused',
    value: function setKeyboardFocused(keyboardFocused) {
      this.setState({
        isKeyboardFocused: keyboardFocused
      });
    }
  }, {
    key: 'getFilteredChildren',
    value: function getFilteredChildren(children) {
      var filteredChildren = [];
      _react2.default.Children.forEach(children, function (child) {
        if (child) {
          filteredChildren.push(child);
        }
      });
      return filteredChildren;
    }
  }, {
    key: 'cloneMenuItem',
    value: function cloneMenuItem(child, childIndex, styles, index) {
      var _this2 = this;

      var childIsDisabled = child.props.disabled;

      var selectedChildStyles = {};
      if (!childIsDisabled) {
        var selected = this.isChildSelected(child, this.props);

        if (selected) {
          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
        }
      }
      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);

      var extraProps = {
        desktop: this.props.desktop,
        style: mergedChildStyles
      };
      if (!childIsDisabled) {
        var isFocused = childIndex === this.state.focusIndex;
        var focusState = 'none';
        if (isFocused) {
          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
        }

        (0, _simpleAssign2.default)(extraProps, {
          focusState: focusState,
          onClick: function onClick(event) {
            _this2.handleMenuItemClick(event, child, index);
            if (child.props.onClick) child.props.onClick(event);
          },
          ref: isFocused ? 'focusedMenuItem' : null
        });
      }
      return _react2.default.cloneElement(child, extraProps);
    }
  }, {
    key: 'decrementKeyboardFocusIndex',
    value: function decrementKeyboardFocusIndex(event) {
      var index = this.state.focusIndex;

      index--;
      if (index < 0) index = 0;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'getMenuItemCount',
    value: function getMenuItemCount(filteredChildren) {
      var menuItemCount = 0;
      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';
        var childIsDisabled = child.props.disabled;
        if (!childIsADivider && !childIsDisabled) menuItemCount++;
      });
      return menuItemCount;
    }
  }, {
    key: 'getLastSelectedIndex',
    value: function getLastSelectedIndex(props, filteredChildren) {
      var _this3 = this;

      var selectedIndex = -1;
      var menuItemIndex = 0;

      filteredChildren.forEach(function (child) {
        var childIsADivider = child.type && child.type.muiName === 'Divider';

        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
        if (!childIsADivider) menuItemIndex++;
      });

      return selectedIndex;
    }
  }, {
    key: 'setFocusIndexStartsWith',
    value: function setFocusIndexStartsWith(event, keys, filteredChildren) {
      var foundIndex = -1;
      _react2.default.Children.forEach(filteredChildren, function (child, index) {
        if (foundIndex >= 0) {
          return;
        }
        var primaryText = child.props.primaryText;

        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
          foundIndex = index;
        }
      });
      if (foundIndex >= 0) {
        this.setFocusIndex(event, foundIndex, true);
        return true;
      }
      return false;
    }
  }, {
    key: 'handleMenuItemClick',
    value: function handleMenuItemClick(event, item, index) {
      var children = this.props.children;
      var multiple = this.props.multiple;
      var valueLink = this.getValueLink(this.props);
      var menuValue = valueLink.value;
      var itemValue = item.props.value;
      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);

      this.setFocusIndex(event, focusIndex, false);

      if (multiple) {
        menuValue = menuValue || [];

        var itemIndex = menuValue.indexOf(itemValue);

        var _menuValue = menuValue,
            _menuValue2 = (0, _toArray3.default)(_menuValue),
            newMenuValue = _menuValue2.slice(0);

        if (itemIndex === -1) {
          newMenuValue.push(itemValue);
        } else {
          newMenuValue.splice(itemIndex, 1);
        }

        valueLink.requestChange(event, newMenuValue);
      } else if (!multiple && itemValue !== menuValue) {
        valueLink.requestChange(event, itemValue);
      }

      this.props.onItemClick(event, item, index);
    }
  }, {
    key: 'incrementKeyboardFocusIndex',
    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
      var index = this.state.focusIndex;
      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;

      index++;
      if (index > maxIndex) index = maxIndex;

      this.setFocusIndex(event, index, true);
    }
  }, {
    key: 'isChildSelected',
    value: function isChildSelected(child, props) {
      var menuValue = this.getValueLink(props).value;
      var childValue = child.props.value;

      if (props.multiple) {
        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
      } else {
        return child.props.hasOwnProperty('value') && menuValue === childValue;
      }
    }
  }, {
    key: 'setFocusIndex',
    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
      if (this.props.onMenuItemFocusChange) {
        // Do this even if `newIndex === this.state.focusIndex` to allow users
        // to detect up-arrow on the first MenuItem or down-arrow on the last.
        this.props.onMenuItemFocusChange(event, newIndex);
      }
      this.setState({
        focusIndex: newIndex,
        isKeyboardFocused: isKeyboardFocused
      });
    }
  }, {
    key: 'setScollPosition',
    value: function setScollPosition() {
      var desktop = this.props.desktop;
      var focusedMenuItem = this.refs.focusedMenuItem;
      var menuItemHeight = desktop ? 32 : 48;

      if (focusedMenuItem) {
        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;

        // Make the focused item be the 2nd item in the list the user sees
        var scrollTop = selectedOffSet - menuItemHeight;
        if (scrollTop < menuItemHeight) scrollTop = 0;

        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
      }
    }
  }, {
    key: 'cancelScrollEvent',
    value: function cancelScrollEvent(event) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = _reactDom2.default.findDOMNode(this);
      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
      var elWidth = el.offsetWidth;
      var keyWidth = this.state.keyWidth;
      var minWidth = keyWidth * 1.5;
      var keyIncrements = elWidth / keyWidth;
      var newWidth = void 0;

      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
      newWidth = keyIncrements * keyWidth;

      if (newWidth < minWidth) newWidth = minWidth;

      el.style.width = newWidth + 'px';
      listEl.style.width = newWidth + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          desktop = _props.desktop,
          disableAutoFocus = _props.disableAutoFocus,
          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          multiple = _props.multiple,
          onItemClick = _props.onItemClick,
          onEscKeyDown = _props.onEscKeyDown,
          onMenuItemFocusChange = _props.onMenuItemFocusChange,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          menuItemStyle = _props.menuItemStyle,
          style = _props.style,
          value = _props.value,
          valueLink = _props.valueLink,
          width = _props.width,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemClick', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);

      var filteredChildren = this.getFilteredChildren(children);

      var menuItemIndex = 0;
      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
        var childIsDisabled = child.props.disabled;
        var childName = child.type ? child.type.muiName : '';
        var newChild = child;

        switch (childName) {
          case 'MenuItem':
            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
            break;

          case 'Divider':
            newChild = _react2.default.cloneElement(child, {
              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
            });
            break;
        }

        if (childName === 'MenuItem' && !childIsDisabled) {
          menuItemIndex++;
        }

        return newChild;
      });

      return _react2.default.createElement(
        _ClickAwayListener2.default,
        { onClickAway: this.handleClickAway },
        _react2.default.createElement(
          'div',
          {
            onKeyDown: this.handleKeyDown,
            onWheel: this.handleOnWheel,
            style: prepareStyles(mergedRootStyles),
            ref: 'scrollContainer',
            role: 'presentation'
          },
          _react2.default.createElement(
            _List2.default,
            (0, _extends3.default)({}, other, {
              ref: 'list',
              style: mergedListStyles,
              role: 'menu'
            }),
            newChildren
          )
        )
      );
    }
  }]);
  return Menu;
}(_react.Component);

Menu.defaultProps = {
  autoWidth: true,
  desktop: false,
  disableAutoFocus: false,
  initiallyKeyboardFocused: false,
  maxHeight: null,
  multiple: false,
  onChange: function onChange() {},
  onEscKeyDown: function onEscKeyDown() {},
  onItemClick: function onItemClick() {},
  onKeyDown: function onKeyDown() {}
};
Menu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleClickAway = function (event) {
    if (event.defaultPrevented) {
      return;
    }

    var focusIndex = _this5.state.focusIndex;

    if (focusIndex < 0) {
      return;
    }

    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var focusedItem = filteredChildren[focusIndex];
    if (!!focusedItem && focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
      return;
    }

    _this5.setFocusIndex(event, -1, false);
  };

  this.handleKeyDown = function (event) {
    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
    var key = (0, _keycode2.default)(event);
    switch (key) {
      case 'down':
        event.preventDefault();
        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        break;
      case 'esc':
        _this5.props.onEscKeyDown(event);
        break;
      case 'tab':
        event.preventDefault();
        if (event.shiftKey) {
          _this5.decrementKeyboardFocusIndex(event);
        } else {
          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
        }
        break;
      case 'up':
        event.preventDefault();
        _this5.decrementKeyboardFocusIndex(event);
        break;
      default:
        if (key && key.length === 1) {
          var hotKeys = _this5.hotKeyHolder.append(key);
          if (_this5.setFocusIndexStartsWith(event, hotKeys, filteredChildren)) {
            event.preventDefault();
          }
        }
    }
    _this5.props.onKeyDown(event);
  };

  this.handleOnWheel = function (event) {
    var scrollContainer = _this5.refs.scrollContainer;
    // Only scroll lock if the the Menu is scrollable.
    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;

    var scrollTop = scrollContainer.scrollTop,
        scrollHeight = scrollContainer.scrollHeight,
        clientHeight = scrollContainer.clientHeight;

    var wheelDelta = event.deltaY;
    var isDeltaPositive = wheelDelta > 0;

    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
      scrollContainer.scrollTop = scrollHeight;
      return _this5.cancelScrollEvent(event);
    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
      scrollContainer.scrollTop = 0;
      return _this5.cancelScrollEvent(event);
    }
  };
};

Menu.propTypes =  false ? {
  /**
   * If true, the width of the menu will be set automatically
   * according to the widths of its children,
   * using proper keyline increments (64px for desktop,
   * 56px otherwise).
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The content of the menu. This is usually used to pass `MenuItem`
   * elements.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the menu item will render with compact desktop styles.
   */
  desktop: _propTypes2.default.bool,
  /**
   * If true, the menu will not be auto-focused.
   */
  disableAutoFocus: _propTypes2.default.bool,
  /**
   * If true, the menu will be keyboard-focused initially.
   */
  initiallyKeyboardFocused: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the underlying `List` element.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the menu in pixels. If specified,
   * the menu will be scrollable if it is taller than the provided
   * height.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item with `value` not
   * equal to the current `value` of the menu is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   * @param {any}  value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is focused and the *Esc* key
   * is pressed.
   *
   * @param {object} event `keydown` event targeting the menu.
   */
  onEscKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is clicked.
   *
   * @param {object} event Click event targeting the menu item.
   * @param {object} menuItem The menu item.
   * @param {number} index The index of the menu item.
   */
  onItemClick: _propTypes2.default.func,
  /** @ignore */
  onKeyDown: _propTypes2.default.func,
  /**
   * Callback function fired when the focus on a `MenuItem` is changed.
   * There will be some "duplicate" changes reported if two different
   * focusing event happen, for example if a `MenuItem` is focused via
   * the keyboard and then it is clicked on.
   *
   * @param {object} event The event that triggered the focus change.
   * The event can be null since the focus can be changed for non-event
   * reasons such as prop changes.
   * @param {number} newFocusIndex The index of the newly focused
   * `MenuItem` or `-1` if focus was lost.
   */
  onMenuItemFocusChange: _propTypes2.default.func,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   * This component also supports valueLink.
   */
  value: _propTypes2.default.any,
  /**
   * ValueLink for the menu's `value`.
   */
  valueLink: _propTypes2.default.object,
  /**
   * The width of the menu. If not specified, the menu's width
   * will be set according to the widths of its children, using
   * proper keyline increments (64px for desktop, 56px otherwise).
   */
  width: _propTypes4.default.stringOrNumber
} : {};
exports.default = Menu;

/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(358);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(128);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileUploadNG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__file_upload_ng_css__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__file_upload_ng_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__file_upload_ng_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileUploadNG=function(_Component){_inherits(FileUploadNG,_Component);function FileUploadNG(props){_classCallCheck(this,FileUploadNG);var _this=_possibleConstructorReturn(this,(FileUploadNG.__proto__||Object.getPrototypeOf(FileUploadNG)).call(this,props));_this.onClick=_this.onClick.bind(_this);_this.onChange=_this.onChange.bind(_this);_this.onUpload=_this.onUpload.bind(_this);_this.state={fileName:null,fileInputID:'fileInput'+Math.floor(Math.random()*10000000),spanID:'span'+Math.floor(Math.random()*10000000),formID:'form'+Math.floor(Math.random()*10000000),initial:true};return _this;}_createClass(FileUploadNG,[{key:'onClick',value:function onClick(event){var hiddenFileInput=document.getElementById(this.state.fileInputID);if(!this.state.XHRLoad){hiddenFileInput.click();}}},{key:'onChange',value:function onChange(event){var fileInput=document.getElementById(this.state.fileInputID);var file=fileInput.files[0];this.setState({fileName:file.name,success:false,XHRStart:false,XHRLoad:false,XHRError:null,XHRAbort:null,XHRProgress:null,progress:0});}},{key:'onUpload',value:function onUpload(event){var _this2=this;if(this.state.fileName){var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();var self=this;var form=document.getElementById(this.state.formID);var xhr=new XMLHttpRequest();this.setState({XHRStart:true});xhr.addEventListener("load",function(){return _this2.setState({XHRLoad:true});});xhr.addEventListener("error",function(){return console.log('Error during file upload.');});xhr.addEventListener("abort",function(){return console.log('File upload aborted.');});xhr.upload.addEventListener("progress",function(event){return _this2.setState({progress:event.loaded/event.total});});xhr.open('POST',form.action,true);xhr.setRequestHeader("Authorization",headers.get("Authorization"));xhr.onload=function(event){if(this.status===200){if(this.responseText!==null){var json=JSON.parse(this.responseText);if(json.uploadSuccess===true){self.props.onFinish(json.uuid,self.props.index,json.fileName);alert(json.fileName+' wurde hochgeladen.');}else{self.setState({fileName:null,success:false,XHRStart:false,XHRLoad:false});alert('Datei konnte nicht hochgeladen werden.');}}}};xhr.send(new FormData(form));}else{event.preventDefault();}}},{key:'uploadStatus',value:function uploadStatus(){if(this.state.XHRStart){if(this.state.XHRLoad){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#1F6A81',display:'inline-block'}},' \u2713 ');}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'file-upload-ng-spin',style:{color:'red',display:'inline-block'}},' \u2191 ');}}else{if(this.state.fileName!==null&&this.state.fileName!==undefined&&this.state.fileName!==''){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button buttonSmall',onClick:this.onUpload},' Hochladen ');}}return null;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'fileUploadNG',id:this.state.formID,action:'/api/upload',name:'form',method:'post',onSubmit:this.onUpload},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:this.state.spanID},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{style:{display:'none'},type:'file',name:'file',onChange:this.onChange,id:this.state.fileInputID}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'FileUploadInput',type:'text',placeholder:'(durch Klick ausw\xE4hlen)',onClick:this.onClick,name:'submit',value:this.state.fileName,readOnly:true,style:{cursor:'pointer',color:'black'},title:this.props.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'small'}},'Ausgew\xE4hlte Dateien m\xFCssen mit dem "Hochladen" Button" best\xE4tigt werden.'),this.uploadStatus(),this.state.XHRStart&&this.state.progress!==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' (',Math.floor(100*this.state.progress),'%) '));}}]);return FileUploadNG;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__researchSoftwareMinimalDatePicker_css__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__researchSoftwareMinimalDatePicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__researchSoftwareMinimalDatePicker_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function range(start,end){return[].concat(_toConsumableArray(Array(end-start+1).keys())).map(function(n){return start+n;});}function DateOption(props){var label=Math.trunc(props.value/10)>0?props.value:'0'+props.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:label},label);}function parseTimestamp(stamp){var segments=stamp.toString().split('-');if(segments[0]===''||segments[0]===undefined)segments[0]='1960';if(segments[1]===''||segments[1]===undefined)segments[1]='01';if(segments[2]===''||segments[2]===undefined)segments[2]='01';return{year:segments[0],month:segments[1],day:segments[2]};}var ResearchSoftwareMinimalDatePicker=function(_Component){_inherits(ResearchSoftwareMinimalDatePicker,_Component);function ResearchSoftwareMinimalDatePicker(props){_classCallCheck(this,ResearchSoftwareMinimalDatePicker);var _this=_possibleConstructorReturn(this,(ResearchSoftwareMinimalDatePicker.__proto__||Object.getPrototypeOf(ResearchSoftwareMinimalDatePicker)).call(this,props));var timestamp=parseTimestamp(_this.props.value);_this.name=props.name;_this.handleDateChange=_this.handleDateChange.bind(_this);_this.state={value:_this.props.value,day:timestamp.day,month:timestamp.month,year:timestamp.year};return _this;}_createClass(ResearchSoftwareMinimalDatePicker,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value){var timestamp=parseTimestamp(nextProps.value);this.setState({day:timestamp.day,month:timestamp.month,year:timestamp.year,value:nextProps.value});}}},{key:'handleDateChange',value:function handleDateChange(event){var _this2=this;var name=event.target.name;var value=event.target.value;this.setState(_defineProperty({},name,value),function(){_this2.setState({value:_this2.state.year+'-'+_this2.state.month+'-'+_this2.state.day});_this2.props.update(_this2.props.slot,_this2.state.year+'-'+_this2.state.month+'-'+_this2.state.day);});}},{key:'render',value:function render(){var days=range(1,31).map(function(n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DateOption,{key:n,value:n});});var months=range(1,12).map(function(n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DateOption,{key:n,value:n});});var years=range(1960,2018).map(function(n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DateOption,{key:n,value:n});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MinimalDatePicker'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'prodHeaderTexts'},this.props.obligatory===true?'*':null,this.props.heading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.subheading,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'MinimalDatePickerDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'day'},'Tag'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'day',onChange:this.handleDateChange,value:this.state.day},days),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'month'},'Monat'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'month',onChange:this.handleDateChange,value:this.state.month},months),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'year'},'Jahr'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'year',onChange:this.handleDateChange,value:this.state.year},years)));}}]);return ResearchSoftwareMinimalDatePicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ResearchSoftwareMinimalDatePicker);

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export childrenPropType */
/* unused harmony export onSelectPropType */
/* unused harmony export selectedIndexPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(54);


function childrenPropType(props, propName, componentName) {
  var error;
  var tabsCount = 0;
  var panelsCount = 0;
  var tabListFound = false;
  var listTabs = [];
  var children = props[propName];
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["b" /* isTabList */])(child)) {
      if (child.props && child.props.children && typeof child.props.children === 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(child.props.children, function (listChild) {
          return listTabs.push(listChild);
        });
      }

      if (tabListFound) {
        error = new Error("Found multiple 'TabList' components inside 'Tabs'. Only one is allowed.");
      }

      tabListFound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) {
      if (!tabListFound || listTabs.indexOf(child) === -1) {
        error = new Error("Found a 'Tab' component outside of the 'TabList' component. 'Tab' components " + "have to be inside the 'TabList' component.");
      }

      tabsCount++;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) {
      panelsCount++;
    }
  });

  if (!error && tabsCount !== panelsCount) {
    error = new Error("There should be an equal number of 'Tab' and 'TabPanel' in `" + componentName + "`. " + ("Received " + tabsCount + " 'Tab' and " + panelsCount + " 'TabPanel'."));
  }

  return error;
}
function onSelectPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop && typeof prop !== 'function') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied " + ("to `" + componentName + "`, expected `function`."));
  } else if (props.selectedIndex != null && prop == null) {
    error = new Error("The " + location + " `" + name + "` is marked as required in `" + componentName + "`, but " + "its value is `undefined` or `null`.\n" + "`onSelect` is required when `selectedIndex` is also set. Not doing so will " + "make the tabs not do anything, as `selectedIndex` indicates that you want to " + "handle the selected tab yourself.\n" + "If you only want to set the inital tab replace `selectedIndex` with `defaultIndex`.");
  }

  return error;
}
function selectedIndexPropType(props, propName, componentName, location, propFullName) {
  var prop = props[propName];
  var name = propFullName || propName;
  var error = null;

  if (prop != null && typeof prop !== 'number') {
    error = new Error("Invalid " + location + " `" + name + "` of type `" + typeof prop + "` supplied to " + ("`" + componentName + "`, expected `number`."));
  } else if (props.defaultIndex != null && prop != null) {
    return new Error("The " + location + " `" + name + "` cannot be used together with `defaultIndex` " + ("in `" + componentName + "`.\n") + ("Either remove `" + name + "` to let `" + componentName + "` handle the selected ") + "tab internally or remove `defaultIndex` to handle it yourself.");
  }

  return error;
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
/* unused harmony export reset */
// Get a universally unique identifier
var count = 0;
function uuid() {
  return "react-tabs-" + count++;
}
function reset() {
  count = 0;
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTabsCount;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPanelsCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elementTypes__ = __webpack_require__(54);


function getTabsCount(children) {
  var tabCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["a" /* isTab */])(child)) tabCount++;
  });
  return tabCount;
}
function getPanelsCount(children) {
  var panelCount = 0;
  Object(__WEBPACK_IMPORTED_MODULE_0__childrenDeepMap__["a" /* deepForEach */])(children, function (child) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__elementTypes__["c" /* isTabPanel */])(child)) panelCount++;
  });
  return panelCount;
}

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
module.exports = __webpack_require__(143);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(139).enable();
  window.Promise = __webpack_require__(141);
}

// fetch() polyfill for making API calls.
__webpack_require__(142);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(56);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(84);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(84);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 142 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(149);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(56),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(56),r=__webpack_require__(146);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
b>c?b:c;0===b&&(Fh=null);$h(a,b)}
function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(147);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__context_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App',id:'app'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_3__context_js__["a" /* Context */]}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(57);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(152);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(57);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(160);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(58);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(86);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(164);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(166);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(90);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(168);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(58);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(170);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(59);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(90);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(59);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(174);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(88);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(177);
module.exports = __webpack_require__(13).Object.getPrototypeOf;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(44);
var $getPrototypeOf = __webpack_require__(92);

__webpack_require__(93)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(180), __esModule: true };

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(181);
var $Object = __webpack_require__(13).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(19);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(25), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(183), __esModule: true };

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
__webpack_require__(190);
module.exports = __webpack_require__(70).f('iterator');


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(65);
var defined = __webpack_require__(60);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(66);
var descriptor = __webpack_require__(45);
var setToStringTag = __webpack_require__(69);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(33)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var anObject = __webpack_require__(34);
var getKeys = __webpack_require__(47);

module.exports = __webpack_require__(25) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(102);
var toAbsoluteIndex = __webpack_require__(188);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(65);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(18).document;
module.exports = document && document.documentElement;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(191);
var global = __webpack_require__(18);
var hide = __webpack_require__(33);
var Iterators = __webpack_require__(46);
var TO_STRING_TAG = __webpack_require__(16)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(192);
var step = __webpack_require__(193);
var Iterators = __webpack_require__(46);
var toIObject = __webpack_require__(37);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(98)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(195), __esModule: true };

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(196);
__webpack_require__(201);
__webpack_require__(202);
__webpack_require__(203);
module.exports = __webpack_require__(13).Symbol;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(18);
var has = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(25);
var $export = __webpack_require__(19);
var redefine = __webpack_require__(99);
var META = __webpack_require__(197).KEY;
var $fails = __webpack_require__(36);
var shared = __webpack_require__(62);
var setToStringTag = __webpack_require__(69);
var uid = __webpack_require__(50);
var wks = __webpack_require__(16);
var wksExt = __webpack_require__(70);
var wksDefine = __webpack_require__(71);
var enumKeys = __webpack_require__(198);
var isArray = __webpack_require__(199);
var anObject = __webpack_require__(34);
var isObject = __webpack_require__(35);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(64);
var createDesc = __webpack_require__(45);
var _create = __webpack_require__(66);
var gOPNExt = __webpack_require__(200);
var $GOPD = __webpack_require__(104);
var $DP = __webpack_require__(20);
var $keys = __webpack_require__(47);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(103).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(51).f = $propertyIsEnumerable;
  __webpack_require__(72).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(49)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(33)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(50)('meta');
var isObject = __webpack_require__(35);
var has = __webpack_require__(24);
var setDesc = __webpack_require__(20).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(36)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(47);
var gOPS = __webpack_require__(72);
var pIE = __webpack_require__(51);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(67);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(37);
var gOPN = __webpack_require__(103).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 201 */
/***/ (function(module, exports) {



/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71)('asyncIterator');


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71)('observable');


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(205), __esModule: true };

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
module.exports = __webpack_require__(13).Object.setPrototypeOf;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(19);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(207).set });


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(35);
var anObject = __webpack_require__(34);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(63)(Function.call, __webpack_require__(104).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(209), __esModule: true };

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(210);
var $Object = __webpack_require__(13).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(19);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(66) });


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(97);
__webpack_require__(212);
module.exports = __webpack_require__(13).Array.from;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(63);
var $export = __webpack_require__(19);
var toObject = __webpack_require__(44);
var call = __webpack_require__(213);
var isArrayIter = __webpack_require__(214);
var toLength = __webpack_require__(102);
var createProperty = __webpack_require__(215);
var getIterFn = __webpack_require__(216);

$export($export.S + $export.F * !__webpack_require__(218)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(34);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(46);
var ITERATOR = __webpack_require__(16)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(20);
var createDesc = __webpack_require__(45);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(217);
var ITERATOR = __webpack_require__(16)('iterator');
var Iterators = __webpack_require__(46);
module.exports = __webpack_require__(13).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(67);
var TAG = __webpack_require__(16)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(16)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43), __webpack_require__(220)(module)))

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = __webpack_require__(74);

var _colorManipulator = __webpack_require__(73);

var _spacing = __webpack_require__(222);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Light Theme is the default theme used in material-ui. It is guaranteed to
 *  have all theme variables needed for every component. Variables not defined
 *  in a custom theme will default to these values.
 */
exports.default = {
  spacing: _spacing2.default,
  fontFamily: 'Roboto, sans-serif',
  borderRadius: 2,
  palette: {
    primary1Color: _colors.cyan500,
    primary2Color: _colors.cyan700,
    primary3Color: _colors.grey400,
    accent1Color: _colors.pinkA200,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.darkBlack,
    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey300,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
  }
}; /**
    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
    */

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  iconSize: 24,

  desktopGutter: 24,
  desktopGutterMore: 32,
  desktopGutterLess: 16,
  desktopGutterMini: 8,
  desktopKeylineIncrement: 64,
  desktopDropDownMenuItemHeight: 32,
  desktopDropDownMenuFontSize: 15,
  desktopDrawerMenuItemHeight: 48,
  desktopSubheaderHeight: 48,
  desktopToolbarHeight: 56
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  menu: 1000,
  appBar: 1100,
  drawerOverlay: 1200,
  drawer: 1300,
  dialogOverlay: 1400,
  dialog: 1500,
  layer: 2000,
  popover: 2100,
  snackbar: 2900,
  tooltip: 3000
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (muiTheme) {
  var isClient = typeof navigator !== 'undefined';
  var userAgent = muiTheme.userAgent;

  if (userAgent === undefined && isClient) {
    userAgent = navigator.userAgent;
  }

  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;

    hasWarnedAboutUserAgent = true;
  }

  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);

  if (userAgent === false) {
    // Disabled autoprefixer
    return null;
  } else if (userAgent === 'all' || userAgent === undefined) {
    // Prefix for all user agent
    return function (style) {
      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
      var stylePrefixed = prefixAll(style);

      if (isFlex) {
        var display = stylePrefixed.display;
        if (isClient) {
          // We can't apply this join with react-dom:
          // #https://github.com/facebook/react/issues/6467
          stylePrefixed.display = display[display.length - 1];
        } else {
          stylePrefixed.display = display.join('; display: ');
        }
      }

      return stylePrefixed;
    };
  } else {
    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
    var prefixer = new Prefixer({
      userAgent: userAgent
    });

    return function (style) {
      return prefixer.prefix(style);
    };
  }
};

var _createPrefixer = __webpack_require__(225);

var _createPrefixer2 = _interopRequireDefault(_createPrefixer);

var _createPrefixer3 = __webpack_require__(227);

var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);

var _autoprefixerDynamic = __webpack_require__(232);

var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);

var _autoprefixerStatic = __webpack_require__(241);

var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasWarnedAboutUserAgent = false;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(226);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(108);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(109);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(110);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  function prefixAll(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefixAll(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  }

  return prefixAll;
}
module.exports = exports['default'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(75);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var requiredPrefixes = prefixProperties[property];
    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createPrefixer;

var _getBrowserInformation = __webpack_require__(228);

var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);

var _getPrefixedKeyframes = __webpack_require__(231);

var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);

var _capitalizeString = __webpack_require__(75);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _addNewValuesOnly = __webpack_require__(109);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(110);

var _isObject2 = _interopRequireDefault(_isObject);

var _prefixValue = __webpack_require__(108);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
    return style;
  };

  return function () {
    /**
    * Instantiante a new prefixer
    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
    * @param {string} keepUnprefixed - keeps unprefixed properties and values
    */
    function Prefixer() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Prefixer);

      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

      this._userAgent = options.userAgent || defaultUserAgent;
      this._keepUnprefixed = options.keepUnprefixed || false;

      if (this._userAgent) {
        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
      }

      // Checks if the userAgent was resolved correctly
      if (this._browserInfo && this._browserInfo.cssPrefix) {
        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
      } else {
        this._useFallback = true;
        return false;
      }

      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
      if (prefixData) {
        this._requiresPrefix = {};

        for (var property in prefixData) {
          if (prefixData[property] >= this._browserInfo.browserVersion) {
            this._requiresPrefix[property] = true;
          }
        }

        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
      } else {
        this._useFallback = true;
      }

      this._metaData = {
        browserVersion: this._browserInfo.browserVersion,
        browserName: this._browserInfo.browserName,
        cssPrefix: this._browserInfo.cssPrefix,
        jsPrefix: this._browserInfo.jsPrefix,
        keepUnprefixed: this._keepUnprefixed,
        requiresPrefix: this._requiresPrefix
      };
    }

    _createClass(Prefixer, [{
      key: 'prefix',
      value: function prefix(style) {
        // use static prefixer as fallback if userAgent can not be resolved
        if (this._useFallback) {
          return fallback(style);
        }

        // only add prefixes if needed
        if (!this._hasPropsRequiringPrefix) {
          return style;
        }

        return this._prefixStyle(style);
      }
    }, {
      key: '_prefixStyle',
      value: function _prefixStyle(style) {
        for (var property in style) {
          var value = style[property];

          // handle nested objects
          if ((0, _isObject2.default)(value)) {
            style[property] = this.prefix(value);
            // handle array values
          } else if (Array.isArray(value)) {
            var combinedValue = [];

            for (var i = 0, len = value.length; i < len; ++i) {
              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
            }

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (combinedValue.length > 0) {
              style[property] = combinedValue;
            }
          } else {
            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);

            // only modify the value if it was touched
            // by any plugin to prevent unnecessary mutations
            if (_processedValue) {
              style[property] = _processedValue;
            }

            // add prefixes to properties
            if (this._requiresPrefix.hasOwnProperty(property)) {
              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
              if (!this._keepUnprefixed) {
                delete style[property];
              }
            }
          }
        }

        return style;
      }

      /**
      * Returns a prefixed version of the style object using all vendor prefixes
      * @param {Object} styles - Style object that gets prefixed properties added
      * @returns {Object} - Style object with prefixed properties and values
      */

    }], [{
      key: 'prefixAll',
      value: function prefixAll(styles) {
        return fallback(styles);
      }
    }]);

    return Prefixer;
  }();
}
module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrowserInformation;

var _bowser = __webpack_require__(229);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixByBrowser = {
  chrome: 'Webkit',
  safari: 'Webkit',
  ios: 'Webkit',
  android: 'Webkit',
  phantom: 'Webkit',
  opera: 'Webkit',
  webos: 'Webkit',
  blackberry: 'Webkit',
  bada: 'Webkit',
  tizen: 'Webkit',
  chromium: 'Webkit',
  vivaldi: 'Webkit',
  firefox: 'Moz',
  seamoney: 'Moz',
  sailfish: 'Moz',
  msie: 'ms',
  msedge: 'ms'
};


var browserByCanIuseAlias = {
  chrome: 'chrome',
  chromium: 'chrome',
  safari: 'safari',
  firfox: 'firefox',
  msedge: 'edge',
  opera: 'opera',
  vivaldi: 'opera',
  msie: 'ie'
};

function getBrowserName(browserInfo) {
  if (browserInfo.firefox) {
    return 'firefox';
  }

  if (browserInfo.mobile || browserInfo.tablet) {
    if (browserInfo.ios) {
      return 'ios_saf';
    } else if (browserInfo.android) {
      return 'android';
    } else if (browserInfo.opera) {
      return 'op_mini';
    }
  }

  for (var browser in browserByCanIuseAlias) {
    if (browserInfo.hasOwnProperty(browser)) {
      return browserByCanIuseAlias[browser];
    }
  }
}

/**
 * Uses bowser to get default browser browserInformation such as version and name
 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
 * @param {string} userAgent - userAgent that gets evaluated
 */
function getBrowserInformation(userAgent) {
  var browserInfo = _bowser2.default._detect(userAgent);

  if (browserInfo.yandexbrowser) {
    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
  }

  for (var browser in prefixByBrowser) {
    if (browserInfo.hasOwnProperty(browser)) {
      var prefix = prefixByBrowser[browser];

      browserInfo.jsPrefix = prefix;
      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
      break;
    }
  }

  browserInfo.browserName = getBrowserName(browserInfo);

  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  if (browserInfo.version) {
    browserInfo.browserVersion = parseFloat(browserInfo.version);
  } else {
    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
  }

  browserInfo.osVersion = parseFloat(browserInfo.osversion);

  // iOS forces all browsers to use Safari under the hood
  // as the Safari version seems to match the iOS version
  // we just explicitely use the osversion instead
  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
    browserInfo.browserName = 'and_chr';
  }

  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
    browserInfo.browserVersion = browserInfo.osVersion;
  }

  // Samsung browser are basically build on Chrome > 44
  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
    browserInfo.browserName = 'and_chr';
    browserInfo.browserVersion = 44;
  }

  return browserInfo;
}
module.exports = exports['default'];

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(230)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getPrefixedKeyframes;
function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
  var prefixedKeyframes = 'keyframes';

  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
    return cssPrefix + prefixedKeyframes;
  }
  return prefixedKeyframes;
}
module.exports = exports['default'];

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(233);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(234);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(235);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(236);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(237);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(238);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(239);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
}; /* eslint-disable */

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calc(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = {
  flex: true,
  'inline-flex': true
};
function flex(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};

var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};


var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
var properties = Object.keys(alternativeProps).concat(otherProps);

function flexboxOld(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    delete requiresPrefix[property];

    if (!keepUnprefixed && !Array.isArray(style[property])) {
      delete style[property];
    }
    if (property === 'flexDirection' && typeof value === 'string') {
      if (value.indexOf('column') > -1) {
        style.WebkitBoxOrient = 'vertical';
      } else {
        style.WebkitBoxOrient = 'horizontal';
      }
      if (value.indexOf('reverse') > -1) {
        style.WebkitBoxDirection = 'reverse';
      } else {
        style.WebkitBoxDirection = 'normal';
      }
    }
    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
    }
    if (alternativeProps.hasOwnProperty(property)) {
      style[alternativeProps[property]] = alternativeValues[value] || value;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
function gradient(property, value, style, _ref) {
  var browserName = _ref.browserName,
      browserVersion = _ref.browserVersion,
      cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;

var _getPrefixedValue = __webpack_require__(38);

var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};

var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true

  // TODO: chrome & opera support it
};function sizing(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
  }
}
module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(111);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var requiresPrefixDashCased = void 0;

function transition(property, value, style, _ref) {
  var cssPrefix = _ref.cssPrefix,
      keepUnprefixed = _ref.keepUnprefixed,
      requiresPrefix = _ref.requiresPrefix;

  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    // memoize the prefix array for later use
    if (!requiresPrefixDashCased) {
      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _hyphenateProperty2.default)(prop);
      });
    }

    // only split multi values, not cubic beziers
    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

    requiresPrefixDashCased.forEach(function (prop) {
      multipleValues.forEach(function (val, index) {
        if (val.indexOf(prop) > -1 && prop !== 'order') {
          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
        }
      });
    });

    return multipleValues.join(',');
  }
}
module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _calc = __webpack_require__(242);

var _calc2 = _interopRequireDefault(_calc);

var _flex = __webpack_require__(243);

var _flex2 = _interopRequireDefault(_flex);

var _flexboxIE = __webpack_require__(244);

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = __webpack_require__(245);

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

var _gradient = __webpack_require__(246);

var _gradient2 = _interopRequireDefault(_gradient);

var _sizing = __webpack_require__(247);

var _sizing2 = _interopRequireDefault(_sizing);

var _transition = __webpack_require__(248);

var _transition2 = _interopRequireDefault(_transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
}; /* eslint-disable */

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calc;

var _isPrefixedValue = __webpack_require__(76);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];
function calc(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}
module.exports = exports['default'];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
};

function flexboxIE(property, value, style) {
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}
module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(76);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}
module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(111);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(76);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(75);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}
module.exports = exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = callOnce;

var _warning = __webpack_require__(52);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CALLED_ONCE = 'muiPrepared';

function callOnce() {
  if (false) {
    return function (style) {
      if (style[CALLED_ONCE]) {
        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
      }
      style[CALLED_ONCE] = true;
      return style;
    };
  }
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(251);

var _keys2 = _interopRequireDefault(_keys);

exports.default = rtl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;

/**
 * This function ensures that `style` supports both ltr and rtl directions by
 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
 * necessary.
 */
function rtl(muiTheme) {
  if (muiTheme.isRtl) {
    return function (style) {
      if (style.directionInvariant === true) {
        return style;
      }

      var flippedAttributes = {
        // Keys and their replacements.
        right: 'left',
        left: 'right',
        marginRight: 'marginLeft',
        marginLeft: 'marginRight',
        paddingRight: 'paddingLeft',
        paddingLeft: 'paddingRight',
        borderRight: 'borderLeft',
        borderLeft: 'borderRight'
      };

      var newStyle = {};

      (0, _keys2.default)(style).forEach(function (attribute) {
        var value = style[attribute];
        var key = attribute;

        if (flippedAttributes.hasOwnProperty(attribute)) {
          key = flippedAttributes[attribute];
        }

        switch (attribute) {
          case 'float':
          case 'textAlign':
            if (value === 'right') {
              value = 'left';
            } else if (value === 'left') {
              value = 'right';
            }
            break;

          case 'direction':
            if (value === 'ltr') {
              value = 'rtl';
            } else if (value === 'rtl') {
              value = 'ltr';
            }
            break;

          case 'transform':
            if (!value) break;
            var matches = void 0;
            if (matches = value.match(reTranslate)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
            }
            if (matches = value.match(reSkew)) {
              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
            }
            break;

          case 'transformOrigin':
            if (!value) break;
            if (value.indexOf('right') > -1) {
              value = value.replace('right', 'left');
            } else if (value.indexOf('left') > -1) {
              value = value.replace('left', 'right');
            }
            break;
        }

        newStyle[key] = value;
      });

      return newStyle;
    };
  }
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(252), __esModule: true };

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(253);
module.exports = __webpack_require__(13).Object.keys;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(44);
var $keys = __webpack_require__(47);

__webpack_require__(93)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = compose;
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _colors = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Typography = function Typography() {
  (0, _classCallCheck3.default)(this, Typography);

  // text colors
  this.textFullBlack = _colors.fullBlack;
  this.textDarkBlack = _colors.darkBlack;
  this.textLightBlack = _colors.lightBlack;
  this.textMinBlack = _colors.minBlack;
  this.textFullWhite = _colors.fullWhite;
  this.textDarkWhite = _colors.darkWhite;
  this.textLightWhite = _colors.lightWhite;

  // font weight
  this.fontWeightLight = 300;
  this.fontWeightNormal = 400;
  this.fontWeightMedium = 500;

  this.fontStyleButtonFontSize = 14;
};

exports.default = new Typography();

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__landing_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__about_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registration_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ayacandas_210318_js__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__product_list_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contact_us_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__new_show_service_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__document_details__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__new_show_software__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__show_tender__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__other_show__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__used_show_software__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__document__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__researchsoftware__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__researchsoftware_details_js__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__new_software__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__used_software__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__new_services__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__other__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__tender__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__activation_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__verify_email__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__videos_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__board_js__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__update_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__requirements_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__suggestion_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__profile_js__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__manage_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__variables_js__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Context=function(_Component){_inherits(Context,_Component);function Context(props){_classCallCheck(this,Context);var _this=_possibleConstructorReturn(this,(Context.__proto__||Object.getPrototypeOf(Context)).call(this,props));_this.propagateLogin=_this.propagateLogin.bind(_this);var expiredTokens=__WEBPACK_IMPORTED_MODULE_33__variables_js__["a" /* default */].expiredGuestJWTs;if(expiredTokens.indexOf(localStorage.getItem('token'))>-1)localStorage.removeItem('token');if(localStorage.getItem('token')!==null&&localStorage.getItem('user')!==null){var token=localStorage.getItem('token');var user=JSON.parse(localStorage.getItem('user'));_this.state={loggedIn:true,username:user.username,role:user.role,token:token};}else{var _token=__WEBPACK_IMPORTED_MODULE_33__variables_js__["a" /* default */].guestJWT;var _user={loggedIn:true,username:"guest",role:"guest",token:_token};localStorage.setItem('token',_token);localStorage.setItem('user',JSON.stringify(_user));_this.state=_user;}return _this;}_createClass(Context,[{key:'componentWillMount',value:function componentWillMount(){document.title='ayacandas.com';}},{key:'propagateLogin',value:function propagateLogin(loggedIn,username,role,token){var user={loggedIn:loggedIn,username:username,role:role,token:token};this.setState(user);localStorage.setItem('user',JSON.stringify(user));localStorage.setItem('token',token);return true;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Context'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__landing_js__["a" /* Landing */],{history:props.history,username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/about',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__about_js__["a" /* About */],{history:props.history,username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/login/:username?/:password?',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__login_js__["b" /* Login */],Object.assign({},props,{username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/test',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ayacandas_210318_js__["a" /* Test */],{history:props.history,username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/registration/:role',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__registration_js__["a" /* Registration */],{match:props.match,history:props.history,username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/product-list',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__product_list_js__["a" /* ProductList */],{history:props.history,username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/contact',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__contact_us_js__["a" /* Contact */],{history:props.history,username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/search',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__search_js__["a" /* Search */],{history:props.history,username:_this2.state.username,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/show-service/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__new_show_service_js__["a" /* NewServiceDetails */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/document-details/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__document_details__["a" /* DocumentDetails */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/show-software/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__new_show_software__["a" /* NewSoftwareDetails */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/show-tender/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__show_tender__["a" /* TenderDetails */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/show-other/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__other_show__["a" /* OtherDetails */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/show-used-software/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__used_show_software__["a" /* UsedSoftwareDetails */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/create-document',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__document__["a" /* CreateDocument */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update-document/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__document__["b" /* UpdateDocumentWithFeebox */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/create-researchsoftware',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__researchsoftware__["a" /* CreateResearchSoftware */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update-researchsoftware/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__researchsoftware__["b" /* UpdateResearchSoftware */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/researchsoftware-details/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__researchsoftware_details_js__["a" /* ResearchSoftwareDetails */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/create-software',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__new_software__["a" /* CreateSoftware */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update-software/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__new_software__["b" /* UpdateSoftwareWithFeebox */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/create-used-software',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__used_software__["a" /* CreateUsedSoftware */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update-used-software/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__used_software__["b" /* UpdateUsedSoftwareWithFeebox */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/create-service',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__new_services__["a" /* CreateService */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update-service/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__new_services__["b" /* UpdateServiceWithFeebox */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/create-other',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__other__["a" /* CreateOther */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update-other/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__other__["b" /* UpdateOtherWithFeebox */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/create-tender',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__tender__["a" /* CreateTender */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update-tender/:id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__tender__["b" /* UpdateTenderWithFeebox */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/videos',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__videos_js__["a" /* Videos */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/activation',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__activation_js__["a" /* ActivationNotice */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/activation-after-register',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__activation_js__["b" /* ActivationNoticeAfterRegistration */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/verify-email/:token',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__verify_email__["a" /* default */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/board/:uuid',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__board_js__["a" /* Board */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/update',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__update_js__["a" /* Update */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/suggestion',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__suggestion_js__["a" /* Suggestion */],{match:props.match,history:props.history,username:_this2.state.username,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/requirements',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__requirements_js__["a" /* Requirements */],{match:props.match,username:_this2.state.username,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/profile/:oldPassword?',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__profile_js__["a" /* ProfilePage */],{match:props.match,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/manage',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__manage_js__["a" /* ManagePage */],{match:props.match,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{exact:true,path:'/forgot-password',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__login_js__["a" /* ForgotPassword */],{match:props.match,history:props.history,loggedIn:_this2.state.loggedIn,propagateLogin:_this2.propagateLogin,location:props.location,onEnter:function onEnter(){return window.scrollTo(0,0);}});}}));}}]);return Context;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Landing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__landing_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__landing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__landing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resource_magnifier_png__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resource_magnifier_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__resource_magnifier_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_offer_png__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_offer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__resource_offer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resource_news_png__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resource_news_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__resource_news_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resource_informativ_png__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resource_informativ_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__resource_informativ_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resource_searchSuggestion_png__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resource_searchSuggestion_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__resource_searchSuggestion_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqLanding=[{content:"Nur einige Beispiele: <ul><li>Software-Module im Bereich Ihres KIS </li><li>Erweiterungen  Ihres Zentralsystems  mit weiteren Funktionen </li><li>Im System  vorher nicht  vorhandene  Auswertungen,  die Sie oder die für  Sie geschrieben wurden </li><li>Datenschutz-Regelungen und -Umsetzungspapiere </li><li>Vorlagen</li><li>erfolgreiche  oder erfolglose  Anträge (z.B. Großgeräte-Anträge) <Leistungsverzeichnisse</li><li>Strategiepapiere </li><li>Verträge jeglicher Art </li><li>SOPs </li><li>SLAs </li><li>Dienstanweisungen </li><li>Personalratsvorlagen</li><li>nützliche Links </li><li>sinnvolles aus Ministerien, BMG </li><li>Gesetzesvorlagen,  Verordnungen </li><li>Fragebögen </li><li>Excel-Sheets </li><li>Präsentationen und Vorträge </li><li>Outplacement-Verträge</li><li>geschickte Trennungsrechnungs-Konzepte  Skripte</li><li>Hilfen Ihrer Mannschaft  an andere, die Sie als Dienstleistung  anbieten können.</li></ul>",title:"Wollen Sie Vorschläge, was Sie einstellen könnten?",key:"0"},{content:"Anbieten darf jeder, der etwas anzubieten hat, solange es sein (auch geistiges) Eigentum ist: Krankenhäuser, Institutionen, Firmen und Privatpersonen.",title:"Wer darf anbieten?",key:1},{content:"Nur registrierte Mitglieder können:</br><ul><li>Preise angezeigt bekommen,</li><li>an den zugehörigen Foren der Produkte teilnehmen (z.B Fragen stellen),</li><li>eigene Produkte anbieten: Dienstleistungen, Software, Dokumente, Hardware und sonstige Angebote, Gebrauchtsoftware und Software für Forschung und Lehre und Ausschreibungen.</li></ul>",title:"Was haben Sie von einer Registrierung?",key:2},{content:" <ul><li>Sie sind z.B. in einer Klinik oder einer forschenden Einrichtung beschäftigt? Das Einstellen eines Produktes ist kostenlos. Bei einem Verkauf erhält Ayacandas eine Provision und übernimmt dafür aber auch die Gewährleistung. Die Firma Ayacandas übernimmt große Teile der Themen Garantie und Gewährleistung, jedoch muss dazu bei Programmen der Quellcode offengelegt werden, auch für den Käufer.</li><li>Sie bieten als Firma oder Vertretung einer Firma an?   Sie bezahlen eine Gebühr für das Einstellen in den Marktplatz und die oder der Suchende bekommt bei der Ergebnisanzeige Ihre vollständigen Daten.Als kommerzieller Anbieter ist selbstverständlich <u>keine</u> Offenlegung des Codes gefordert.</li><ul>",title:"Wie finanziert sich der Marktplatz? ",key:3},{content:"Sie müssen vertretungsberechtigt sein, das anzubieten, was Sie einstellen  und es wäre ratsam, dass sie Forenanfragen zu Ihrem Produkt beantworten. ",title:"Gibt es Pflichten, wenn ich Produkte einstelle?",key:4}];var Landing=function(_Component){_inherits(Landing,_Component);function Landing(props){_classCallCheck(this,Landing);var _this=_possibleConstructorReturn(this,(Landing.__proto__||Object.getPrototypeOf(Landing)).call(this,props));_this.state={productID:null,username:_this.props.username};return _this;}_createClass(Landing,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.username!==this.state.username){this.setState({username:nextProps.username});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderLanding'},'Ayacandas ist der Online-Austausch-Marktplatz',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'f\xFCr IT-L\xF6sungen im Gesundheitswesen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTiles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileUp marginTop20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileUpContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/search'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__resource_magnifier_png___default.a,alt:'magnifier'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Suche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},'Suchen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Finden ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Inspirieren lassen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',padding:'1%',marginTop:'3%',marginBottom:'5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'landingSearchInput hoverYellow1',placeholder:'im Marktplatz suchen',onChange:function onChange(event){return localStorage.setItem('ayacandas_search',event.target.value);},onKeyPress:function onKeyPress(event){return event.key==='Enter'?_this2.props.history.push("/search"):null;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:"flex",alignSelf:"center",marginLeft:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/search'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__resource_magnifier_png___default.a,alt:'magnifier',height:'25'}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileDown'},(__WEBPACK_IMPORTED_MODULE_5__util_js__["d" /* isCommercialUser */]()||__WEBPACK_IMPORTED_MODULE_5__util_js__["f" /* isNonCommercialUser */]())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileDownOneTileToggle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__resource_searchSuggestion_png___default.a,alt:'searchSuggestion'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Suchanregungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Entlassmanagement',_this2.props.history);}},' Entlassmanagement '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Verordnungsmanagement',_this2.props.history);}},'  Verordnungsmanagement '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('OH KIS',_this2.props.history);}},' OH KIS '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Datenschutz',_this2.props.history);}},' Datenschutz '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('DSGVO',_this2.props.history);}},' DSGVO '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Baurecht',_this2.props.history);}},'Baurecht'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),!__WEBPACK_IMPORTED_MODULE_5__util_js__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_5__util_js__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileDownOneTile center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__resource_searchSuggestion_png___default.a,alt:'searchSuggestion'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Suchanregungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Entlassmanagement',_this2.props.history);}},' Entlassmanagement '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Verordnungsmanagement',_this2.props.history);}},'  Verordnungsmanagement '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('OH KIS',_this2.props.history);}},' OH KIS '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Datenschutz',_this2.props.history);}},' Datenschutz '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('DSGVO',_this2.props.history);}},' DSGVO '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'landingClickableProducts',onClick:function onClick(event){return __WEBPACK_IMPORTED_MODULE_5__util_js__["h" /* redirectToSearch */]('Baurecht',_this2.props.history);}},'Baurecht'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),!__WEBPACK_IMPORTED_MODULE_5__util_js__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_5__util_js__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileDownOneTile center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__resource_offer_png___default.a,alt:'offer'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Anbieten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},'Registrieren ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Publizieren',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Verkaufen lassen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'landingLink',to:'/login'},'Login/Registrieren'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileDown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileDownOneTile center',onClick:function onClick(event){return _this2.props.history.push("/update");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent Hand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__resource_news_png___default.a,alt:'news'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText LandingTileLink'},'Aktuelles'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingTileDownOneTile',onClick:function onClick(event){return _this2.props.history.push("/videos");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent Hand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__resource_informativ_png___default.a,alt:'news'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText LandingTileLink'},'Informatives'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqLanding}));}}]);return Landing;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = {"name":"ayacandas-redesign","version":"2.1.3","private":true,"dependencies":{"babel-polyfill":"^6.26.0","create-react-class":"^15.6.3","material-ui":"^0.20.1","react":"^16.2.0","react-dom":"^16.2.0","react-router-dom":"^4.2.2","react-scripts":"1.1.1","react-tabs":"^3.0.0","ts-react-json-table":"^0.1.1"},"proxy":"http://localhost:8080","scripts":{"start":"react-scripts start","build":"react-scripts build","test":"react-scripts test --env=jsdom","eject":"react-scripts eject"}}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_bar_css__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_bar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__info_bar_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoBar=function(_Component){_inherits(InfoBar,_Component);function InfoBar(props){_classCallCheck(this,InfoBar);var _this=_possibleConstructorReturn(this,(InfoBar.__proto__||Object.getPrototypeOf(InfoBar)).call(this,props));_this.makeCard=function(elem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["Card"],{key:elem.key,zDepth:0,style:{backgroundColor:'white',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["CardHeader"],{title:elem.title,actAsExpander:true,showExpandableButton:true,titleColor:'black',titleStyle:{fontSize:'small',fontFamily:'open sans',backgroundColor:'white',width:'100%'},closeIconStyle:{color:'white'},style:{padding:'0px'},buttonStyle:{color:'white'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Card__["CardText"],{expandable:true,style:{fontSize:'small',maxWidth:'85%',fontFamily:'open sans',padding:'0px',wordWrap:'break-word',fontWeight:'lighter',hyphen:'auto'},dangerouslySetInnerHTML:{__html:elem.content}}));};_this.makeCard=_this.makeCard.bind(_this);return _this;}_createClass(InfoBar,[{key:'render',value:function render(){var _this2=this;if(this.props.faq.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InfoBarGrey',id:'hideInfoBar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider___default.a,{muiTheme:__WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme___default()()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InfoBarHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'/contact/#contactform'},' Zum Kontaktformular  '),' ')));}var items=this.props.faq.map(function(faqElem){return _this2.makeCard(faqElem);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'InfoBarGrey',id:'hideInfoBar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_MuiThemeProvider___default.a,{muiTheme:__WEBPACK_IMPORTED_MODULE_1_material_ui_styles_getMuiTheme___default()()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),items)));}}]);return InfoBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;

var _Card2 = __webpack_require__(262);

var _Card3 = _interopRequireDefault(_Card2);

var _CardHeader2 = __webpack_require__(287);

var _CardHeader3 = _interopRequireDefault(_CardHeader2);

var _CardTitle2 = __webpack_require__(290);

var _CardTitle3 = _interopRequireDefault(_CardTitle2);

var _CardMedia2 = __webpack_require__(291);

var _CardMedia3 = _interopRequireDefault(_CardMedia2);

var _CardText2 = __webpack_require__(292);

var _CardText3 = _interopRequireDefault(_CardText2);

var _CardActions2 = __webpack_require__(293);

var _CardActions3 = _interopRequireDefault(_CardActions2);

var _CardExpandable2 = __webpack_require__(113);

var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Card = _Card3.default;
exports.CardHeader = _CardHeader3.default;
exports.CardTitle = _CardTitle3.default;
exports.CardMedia = _CardMedia3.default;
exports.CardText = _CardText3.default;
exports.CardActions = _CardActions3.default;
exports.CardExpandable = _CardExpandable3.default;
exports.default = _Card3.default;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(53);

var _Paper2 = _interopRequireDefault(_Paper);

var _CardExpandable = __webpack_require__(113);

var _CardExpandable2 = _interopRequireDefault(_CardExpandable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function (_Component) {
  (0, _inherits3.default)(Card, _Component);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: null
    }, _this.handleExpanding = function (event) {
      event.preventDefault();
      var newExpandedState = !_this.state.expanded;
      // no automatic state update when the component is controlled
      if (_this.props.expanded === null) {
        _this.setState({ expanded: newExpandedState });
      }
      if (_this.props.onExpandChange) {
        _this.props.onExpandChange(newExpandedState);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Card, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          containerStyle = _props.containerStyle,
          children = _props.children,
          expandable = _props.expandable,
          expandedProp = _props.expanded,
          initiallyExpanded = _props.initiallyExpanded,
          onExpandChange = _props.onExpandChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);


      var lastElement = void 0;
      var expanded = this.state.expanded;
      var newChildren = _react2.default.Children.map(children, function (currentChild) {
        var doClone = false;
        var newChild = undefined;
        var newProps = {};
        var element = currentChild;
        if (!currentChild || !currentChild.props) {
          return null;
        }
        if (expanded === false && currentChild.props.expandable === true) return;
        if (currentChild.props.actAsExpander === true) {
          doClone = true;
          newProps.onClick = _this2.handleExpanding;
          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
        }
        if (currentChild.props.showExpandableButton === true) {
          doClone = true;
          newChild = _react2.default.createElement(_CardExpandable2.default, {
            closeIcon: currentChild.props.closeIcon,
            expanded: expanded,
            onExpanding: _this2.handleExpanding,
            openIcon: currentChild.props.openIcon,
            iconStyle: currentChild.props.iconStyle
          });
        }
        if (doClone) {
          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
        }
        lastElement = element;
        return element;
      }, this);

      // If the last element is text or a title we should add
      // 8px padding to the bottom of the card
      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');

      var mergedStyles = (0, _simpleAssign2.default)({
        zIndex: 1
      }, style);
      var containerMergedStyles = (0, _simpleAssign2.default)({
        paddingBottom: addBottomPadding ? 8 : 0
      }, containerStyle);

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({}, other, { style: mergedStyles }),
        _react2.default.createElement(
          'div',
          { style: containerMergedStyles },
          newChildren
        )
      );
    }
  }]);
  return Card;
}(_react.Component);

Card.defaultProps = {
  expandable: false,
  expanded: null,
  initiallyExpanded: false
};
Card.propTypes =  false ? {
  /**
   * Can be used to render elements inside the Card.
   */
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the container element.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If true, this card component is expandable. Can be set on any child of the `Card` component.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Whether this card is expanded.
   * If `true` or `false` the component is controlled.
   * if `null` the component is uncontrolled.
   */
  expanded: _propTypes2.default.bool,
  /**
   * Whether this card is initially expanded.
   */
  initiallyExpanded: _propTypes2.default.bool,
  /**
   * Callback function fired when the `expandable` state of the card has changed.
   *
   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
   */
  onExpandChange: _propTypes2.default.func,
  /**
   * If true, this card component will include a button to expand the card. `CardTitle`,
   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
   * of `Card` can implements `showExpandableButton` or forwards the property to a child
   * component supporting it.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Card;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(264), __esModule: true };

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(265);
module.exports = __webpack_require__(13).Object.assign;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(19);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(266) });


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(47);
var gOPS = __webpack_require__(72);
var pIE = __webpack_require__(51);
var toObject = __webpack_require__(44);
var IObject = __webpack_require__(101);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(36)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var rounded = props.rounded,
      circle = props.circle,
      transitionEnabled = props.transitionEnabled,
      zDepth = props.zDepth;
  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      paper = _context$muiTheme.paper,
      borderRadius = _context$muiTheme.borderRadius;


  return {
    root: {
      color: paper.color,
      backgroundColor: paper.backgroundColor,
      transition: transitionEnabled && _transitions2.default.easeOut(),
      boxSizing: 'border-box',
      fontFamily: baseTheme.fontFamily,
      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
    }
  };
}

var Paper = function (_Component) {
  (0, _inherits3.default)(Paper, _Component);

  function Paper() {
    (0, _classCallCheck3.default)(this, Paper);
    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
  }

  (0, _createClass3.default)(Paper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          circle = _props.circle,
          rounded = _props.rounded,
          style = _props.style,
          transitionEnabled = _props.transitionEnabled,
          zDepth = _props.zDepth,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        children
      );
    }
  }]);
  return Paper;
}(_react.Component);

Paper.defaultProps = {
  circle: false,
  rounded: true,
  transitionEnabled: true,
  zDepth: 1
};
Paper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Paper.propTypes =  false ? {
  /**
   * Children passed into the paper element.
   */
  children: _propTypes2.default.node,
  /**
   * Set to true to generate a circular paper container.
   */
  circle: _propTypes2.default.bool,
  /**
   * By default, the paper container will have a border radius.
   * Set this to false to generate a container with sharp corners.
   */
  rounded: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Set to false to disable CSS transitions for the paper element.
   */
  transitionEnabled: _propTypes2.default.bool,
  /**
   * This number represents the zDepth of the paper shadow.
   */
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = Paper;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(39);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(41);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
  );
};
HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
HardwareKeyboardArrowUp.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(114);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(115);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIcon = function (_Component) {
  (0, _inherits3.default)(SvgIcon, _Component);

  function SvgIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SvgIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleMouseEnter = function (event) {
      _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SvgIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          color = _props.color,
          hoverColor = _props.hoverColor,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          style = _props.style,
          viewBox = _props.viewBox,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
      var _context$muiTheme = this.context.muiTheme,
          svgIcon = _context$muiTheme.svgIcon,
          prepareStyles = _context$muiTheme.prepareStyles;


      var offColor = color ? color : 'currentColor';
      var onColor = hoverColor ? hoverColor : offColor;

      var mergedStyles = (0, _simpleAssign2.default)({
        display: 'inline-block',
        color: svgIcon.color,
        fill: this.state.hovered ? onColor : offColor,
        height: 24,
        width: 24,
        userSelect: 'none',
        transition: _transitions2.default.easeOut()
      }, style);

      return _react2.default.createElement(
        'svg',
        (0, _extends3.default)({}, other, {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          style: prepareStyles(mergedStyles),
          viewBox: viewBox
        }),
        children
      );
    }
  }]);
  return SvgIcon;
}(_react.Component);

SvgIcon.muiName = 'SvgIcon';
SvgIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  viewBox: '0 0 24 24'
};
SvgIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
SvgIcon.propTypes =  false ? {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _propTypes2.default.node,
  /**
   * This is the fill color of the svg icon.
   * If not specified, this component will default
   * to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Allows you to redefine what the coordinates
   * without units mean inside an svg element. For example,
   * if the SVG element is 500 (width) by 200 (height), and you
   * pass viewBox="0 0 50 20", this means that the coordinates inside
   * the svg will go from the top left corner (0,0) to bottom right (50,20)
   * and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};
exports.default = SvgIcon;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(39);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(41);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
  );
};
HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
HardwareKeyboardArrowDown.muiName = 'SvgIcon';

exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _EnhancedButton = __webpack_require__(116);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _FontIcon = __webpack_require__(283);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _Tooltip = __webpack_require__(285);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _childUtils = __webpack_require__(286);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var baseTheme = context.muiTheme.baseTheme;


  return {
    root: {
      boxSizing: 'border-box',
      overflow: 'visible',
      transition: _transitions2.default.easeOut(),
      padding: baseTheme.spacing.iconSize / 2,
      width: baseTheme.spacing.iconSize * 2,
      height: baseTheme.spacing.iconSize * 2,
      fontSize: 0
    },
    tooltip: {
      boxSizing: 'border-box'
    },
    disabled: {
      color: baseTheme.palette.disabledColor,
      fill: baseTheme.palette.disabledColor,
      cursor: 'default'
    }
  };
}

var IconButton = function (_Component) {
  (0, _inherits3.default)(IconButton, _Component);

  function IconButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      // Not to be confonded with the touch property.
      // This state is to determined if it's a mobile device.
      touch: false,
      tooltipShown: false
    }, _this.handleBlur = function (event) {
      _this.hideTooltip();
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleFocus = function (event) {
      _this.showTooltip();
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleMouseLeave = function (event) {
      if (!_this.button.isKeyboardFocused()) {
        _this.hideTooltip();
      }
      _this.setState({ hovered: false });
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseOut = function (event) {
      if (_this.props.disabled) _this.hideTooltip();
      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
    }, _this.handleMouseEnter = function (event) {
      _this.showTooltip();

      // Cancel hover styles for touch devices
      if (!_this.state.touch) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });

      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          onKeyboardFocus = _this$props.onKeyboardFocus;

      if (isKeyboardFocused && !disabled) {
        _this.showTooltip();
        if (onFocus) {
          onFocus(event);
        }
      } else {
        _this.hideTooltip();
        if (onBlur) {
          onBlur(event);
        }
      }

      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      if (onKeyboardFocus) {
        onKeyboardFocus(event, isKeyboardFocused);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IconButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disabled) {
        this.setState({ hovered: false });
      }
    }
  }, {
    key: 'setKeyboardFocus',
    value: function setKeyboardFocus() {
      this.button.setKeyboardFocus();
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      if (this.props.tooltip) {
        this.setState({ tooltipShown: true });
      }
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      if (this.props.tooltip) this.setState({ tooltipShown: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          hoveredStyle = _props.hoveredStyle,
          disableTouchRipple = _props.disableTouchRipple,
          children = _props.children,
          iconClassName = _props.iconClassName,
          style = _props.style,
          tooltip = _props.tooltip,
          tooltipPositionProp = _props.tooltipPosition,
          tooltipStyles = _props.tooltipStyles,
          touch = _props.touch,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);

      var fonticon = void 0;

      var styles = getStyles(this.props, this.context);
      var tooltipPosition = tooltipPositionProp.split('-');

      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;

      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});

      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
        label: tooltip,
        show: this.state.tooltipShown,
        touch: touch,
        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
        verticalPosition: tooltipPosition[0],
        horizontalPosition: tooltipPosition[1]
      }) : null;

      if (iconClassName) {
        var iconHoverColor = iconStyle.iconHoverColor,
            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);


        fonticon = _react2.default.createElement(
          _FontIcon2.default,
          {
            className: iconClassName,
            hoverColor: disabled ? null : iconHoverColor,
            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
            color: this.context.muiTheme.baseTheme.palette.textColor
          },
          children
        );
      }

      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;

      return _react2.default.createElement(
        _EnhancedButton2.default,
        (0, _extends3.default)({
          ref: function ref(_ref2) {
            return _this2.button = _ref2;
          }
        }, other, {
          centerRipple: true,
          disabled: disabled,
          onTouchStart: this.handleTouchStart,
          style: mergedRootStyles,
          disableTouchRipple: disableTouchRipple,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onMouseLeave: this.handleMouseLeave,
          onMouseEnter: this.handleMouseEnter,
          onMouseOut: this.handleMouseOut,
          onKeyboardFocus: this.handleKeyboardFocus
        }),
        tooltipElement,
        fonticon,
        (0, _childUtils.extendChildren)(children, {
          style: childrenStyle
        })
      );
    }
  }]);
  return IconButton;
}(_react.Component);

IconButton.muiName = 'IconButton';
IconButton.defaultProps = {
  disabled: false,
  disableTouchRipple: false,
  iconStyle: {},
  tooltipPosition: 'bottom-center',
  touch: false
};
IconButton.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
IconButton.propTypes =  false ? {
  /**
   * Can be used to pass a `FontIcon` element as the icon for the button.
   */
  children: _propTypes2.default.node,
  /**
   * The CSS class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * If true, the element's ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes2.default.bool,
  /**
   * If true, the element will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element when the component is hovered.
   */
  hoveredStyle: _propTypes2.default.object,
  /**
   * The URL to link to when the button is clicked.
   */
  href: _propTypes2.default.string,
  /**
   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
   */
  iconClassName: _propTypes2.default.string,
  /**
   * Override the inline-styles of the icon element.
   * Note: you can specify iconHoverColor as a String inside this object.
   */
  iconStyle: _propTypes2.default.object,
  /** @ignore */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when the button is clicked.
   *
   * @param {object} event Click event targeting the button.
   */
  onClick: _propTypes2.default.func,
  /** @ignore */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function fired when the element is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the element.
   * @param {boolean} keyboardFocused Indicates whether the element is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /** @ignore */
  onMouseOut: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * The text to supply to the element's tooltip.
   */
  tooltip: _propTypes2.default.node,
  /**
   * The vertical and horizontal positions, respectively, of the element's tooltip.
   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
   * "bottom-left", and "top-left".
   */
  tooltipPosition: _propTypes4.default.cornersAndCenter,
  /**
   * Override the inline-styles of the tooltip element.
   */
  tooltipStyles: _propTypes2.default.object,
  /**
   * If true, increase the tooltip element's size. Useful for increasing tooltip
   * readability on mobile devices.
   */
  touch: _propTypes2.default.bool
} : {};
exports.default = IconButton;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(40);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(81);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

var _ScaleIn = __webpack_require__(277);

var _ScaleIn2 = _interopRequireDefault(_ScaleIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pulsateDuration = 750;

var FocusRipple = function (_Component) {
  (0, _inherits3.default)(FocusRipple, _Component);

  function FocusRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FocusRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
      if (!innerCircle) return;

      var startScale = 'scale(1)';
      var endScale = 'scale(0.85)';
      var currentScale = innerCircle.style.transform || startScale;
      var nextScale = currentScale === startScale ? endScale : startScale;

      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FocusRipple, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.show) {
        this.setRippleSize();
        this.pulsate();
      } else {
        if (this.timeout) clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'getRippleElement',
    value: function getRippleElement(props) {
      var color = props.color,
          innerStyle = props.innerStyle,
          opacity = props.opacity;
      var _context$muiTheme = this.context.muiTheme,
          prepareStyles = _context$muiTheme.prepareStyles,
          ripple = _context$muiTheme.ripple;


      var innerStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        opacity: opacity ? opacity : 0.16,
        backgroundColor: color || ripple.color,
        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
      }, innerStyle);

      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
      var height = el.offsetHeight;
      var width = el.offsetWidth;
      var size = Math.max(height, width);

      var oldTop = 0;
      // For browsers that don't support endsWith()
      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
        oldTop = parseInt(el.style.top);
      }
      el.style.height = size + 'px';
      el.style.top = height / 2 - size / 2 + oldTop + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          style = _props.style;


      var mergedRootStyles = (0, _simpleAssign2.default)({
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0
      }, style);

      var ripple = show ? this.getRippleElement(this.props) : null;

      return _react2.default.createElement(
        _ScaleIn2.default,
        {
          maxScale: 0.85,
          style: mergedRootStyles
        },
        ripple
      );
    }
  }]);
  return FocusRipple;
}(_react.Component);

FocusRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FocusRipple.propTypes =  false ? {
  color: _propTypes2.default.string,
  innerStyle: _propTypes2.default.object,
  opacity: _propTypes2.default.number,
  show: _propTypes2.default.bool,
  style: _propTypes2.default.object
} : {};
exports.default = FocusRipple;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(117);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _ScaleInChild = __webpack_require__(280);

var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleIn = function (_Component) {
  (0, _inherits3.default)(ScaleIn, _Component);

  function ScaleIn() {
    (0, _classCallCheck3.default)(this, ScaleIn);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleIn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          childStyle = _props.childStyle,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'relative',
        height: '100%'
      }, style);

      var newChildren = _react2.default.Children.map(children, function (child) {
        return _react2.default.createElement(
          _ScaleInChild2.default,
          {
            key: child.key,
            enterDelay: enterDelay,
            maxScale: maxScale,
            minScale: minScale,
            style: childStyle
          },
          child
        );
      });

      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({}, other, {
          style: prepareStyles(mergedRootStyles),
          component: 'div'
        }),
        newChildren
      );
    }
  }]);
  return ScaleIn;
}(_react.Component);

ScaleIn.defaultProps = {
  enterDelay: 0
};
ScaleIn.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleIn.propTypes =  false ? {
  childStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ScaleIn;

/***/ }),
/* 278 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _autoPrefix = __webpack_require__(81);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaleInChild = function (_Component) {
  (0, _inherits3.default)(ScaleInChild, _Component);

  function ScaleInChild() {
    (0, _classCallCheck3.default)(this, ScaleInChild);
    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScaleInChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');

      this.leaveTimer = setTimeout(callback, 450);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '1';
      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;

      style.opacity = '0';
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');

      this.enterTimer = setTimeout(callback, this.props.enterDelay);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          enterDelay = _props.enterDelay,
          maxScale = _props.maxScale,
          minScale = _props.minScale,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
      }, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
        children
      );
    }
  }]);
  return ScaleInChild;
}(_react.Component);

ScaleInChild.defaultProps = {
  enterDelay: 0,
  maxScale: 1,
  minScale: 0
};
ScaleInChild.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ScaleInChild.propTypes =  false ? {
  children: _propTypes2.default.node,
  enterDelay: _propTypes2.default.number,
  maxScale: _propTypes2.default.number,
  minScale: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = ScaleInChild;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(106);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toArray2 = __webpack_require__(118);

var _toArray3 = _interopRequireDefault(_toArray2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(117);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _dom = __webpack_require__(119);

var _dom2 = _interopRequireDefault(_dom);

var _CircleRipple = __webpack_require__(282);

var _CircleRipple2 = _interopRequireDefault(_CircleRipple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remove the first element of the array
var shift = function shift(_ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      newArray = _ref2.slice(1);

  return newArray;
};

var TouchRipple = function (_Component) {
  (0, _inherits3.default)(TouchRipple, _Component);

  function TouchRipple(props, context) {
    (0, _classCallCheck3.default)(this, TouchRipple);

    // Touch start produces a mouse down event for compat reasons. To avoid
    // showing ripples twice we skip showing a ripple for the first mouse down
    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
    // to avoid re-rendering when we change it.
    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));

    _this.handleMouseDown = function (event) {
      // only listen to left clicks
      if (event.button === 0) {
        _this.start(event, false);
      }
    };

    _this.handleMouseUp = function () {
      _this.end();
    };

    _this.handleMouseLeave = function () {
      _this.end();
    };

    _this.handleTouchStart = function (event) {
      event.stopPropagation();
      // If the user is swiping (not just tapping), save the position so we can
      // abort ripples if the user appears to be scrolling.
      if (_this.props.abortOnScroll && event.touches) {
        _this.startListeningForScrollAbort(event);
        _this.startTime = Date.now();
      }
      _this.start(event, true);
    };

    _this.handleTouchEnd = function () {
      _this.end();
    };

    _this.handleTouchMove = function (event) {
      // Stop trying to abort if we're already 300ms into the animation
      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
      if (timeSinceStart > 300) {
        _this.stopListeningForScrollAbort();
        return;
      }

      // If the user is scrolling...
      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
      if (deltaY > 6 || deltaX > 6) {
        var currentRipples = _this.state.ripples;
        var ripple = currentRipples[0];
        // This clone will replace the ripple in ReactTransitionGroup with a
        // version that will disappear immediately when removed from the DOM
        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
        // Remove the old ripple and replace it with the new updated one
        currentRipples = shift(currentRipples);
        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
        _this.setState({ ripples: currentRipples }, function () {
          // Call end after we've set the ripple to abort otherwise the setState
          // in end() merges with this and the ripple abort fails
          _this.end();
        });
      }
    };

    _this.ignoreNextMouseDown = false;

    _this.state = {
      // This prop allows us to only render the ReactTransitionGroup
      // on the first click of the component, making the inital render faster.
      hasRipples: false,
      nextKey: 0,
      ripples: []
    };
    return _this;
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'start',
    value: function start(event, isRippleTouchGenerated) {
      var theme = this.context.muiTheme.ripple;

      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
        this.ignoreNextMouseDown = false;
        return;
      }

      var ripples = this.state.ripples;

      // Add a ripple to the ripples array
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
        key: this.state.nextKey,
        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
        color: this.props.color || theme.color,
        opacity: this.props.opacity,
        touchGenerated: isRippleTouchGenerated
      })]);

      this.ignoreNextMouseDown = isRippleTouchGenerated;
      this.setState({
        hasRipples: true,
        nextKey: this.state.nextKey + 1,
        ripples: ripples
      });
    }
  }, {
    key: 'end',
    value: function end() {
      var currentRipples = this.state.ripples;
      this.setState({
        ripples: shift(currentRipples)
      });
      if (this.props.abortOnScroll) {
        this.stopListeningForScrollAbort();
      }
    }

    // Check if the user seems to be scrolling and abort the animation if so

  }, {
    key: 'startListeningForScrollAbort',
    value: function startListeningForScrollAbort(event) {
      this.firstTouchY = event.touches[0].clientY;
      this.firstTouchX = event.touches[0].clientX;
      // Note that when scolling Chrome throttles this event to every 200ms
      // Also note we don't listen for scroll events directly as there's no general
      // way to cover cases like scrolling within containers on the page
      document.body.addEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'stopListeningForScrollAbort',
    value: function stopListeningForScrollAbort() {
      document.body.removeEventListener('touchmove', this.handleTouchMove);
    }
  }, {
    key: 'getRippleStyle',
    value: function getRippleStyle(event) {
      var el = _reactDom2.default.findDOMNode(this);
      var elHeight = el.offsetHeight;
      var elWidth = el.offsetWidth;
      var offset = _dom2.default.offset(el);
      var isTouchEvent = event.touches && event.touches.length;
      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
      var pointerX = pageX - offset.left;
      var pointerY = pageY - offset.top;
      var topLeftDiag = this.calcDiag(pointerX, pointerY);
      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
      var rippleSize = rippleRadius * 2;
      var left = pointerX - rippleRadius;
      var top = pointerY - rippleRadius;

      return {
        directionInvariant: true,
        height: rippleSize,
        width: rippleSize,
        top: top,
        left: left
      };
    }
  }, {
    key: 'calcDiag',
    value: function calcDiag(a, b) {
      return Math.sqrt(a * a + b * b);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style;
      var _state = this.state,
          hasRipples = _state.hasRipples,
          ripples = _state.ripples;
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var rippleGroup = void 0;

      if (hasRipples) {
        var mergedStyles = (0, _simpleAssign2.default)({
          height: '100%',
          width: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'hidden',
          pointerEvents: 'none',
          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
        }, style);

        rippleGroup = _react2.default.createElement(
          _TransitionGroup2.default,
          { style: prepareStyles(mergedStyles) },
          ripples
        );
      }

      return _react2.default.createElement(
        'div',
        {
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        },
        rippleGroup,
        children
      );
    }
  }]);
  return TouchRipple;
}(_react.Component);

TouchRipple.defaultProps = {
  abortOnScroll: true
};
TouchRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
TouchRipple.propTypes =  false ? {
  abortOnScroll: _propTypes2.default.bool,
  centerRipple: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object
} : {};
exports.default = TouchRipple;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(40);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _autoPrefix = __webpack_require__(81);

var _autoPrefix2 = _interopRequireDefault(_autoPrefix);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleRipple = function (_Component) {
  (0, _inherits3.default)(CircleRipple, _Component);

  function CircleRipple() {
    (0, _classCallCheck3.default)(this, CircleRipple);
    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
  }

  (0, _createClass3.default)(CircleRipple, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      this.initializeAnimation(callback);
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this.animate();
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this.animate();
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = 0;
      // If the animation is aborted, remove from the DOM immediately
      var removeAfter = this.props.aborted ? 0 : 2000;
      this.enterTimer = setTimeout(callback, removeAfter);
    }
  }, {
    key: 'animate',
    value: function animate() {
      var style = _reactDom2.default.findDOMNode(this).style;
      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
      _autoPrefix2.default.set(style, 'transition', transitionValue);
      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
    }
  }, {
    key: 'initializeAnimation',
    value: function initializeAnimation(callback) {
      var style = _reactDom2.default.findDOMNode(this).style;
      style.opacity = this.props.opacity;
      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
      this.leaveTimer = setTimeout(callback, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          aborted = _props.aborted,
          color = _props.color,
          opacity = _props.opacity,
          style = _props.style,
          touchGenerated = _props.touchGenerated,
          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var mergedStyles = (0, _simpleAssign2.default)({
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        backgroundColor: color
      }, style);

      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
    }
  }]);
  return CircleRipple;
}(_react.Component);

CircleRipple.defaultProps = {
  opacity: 0.1,
  aborted: false
};
CircleRipple.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CircleRipple.propTypes =  false ? {
  aborted: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  opacity: _propTypes2.default.number,
  style: _propTypes2.default.object,
  touchGenerated: _propTypes2.default.bool
} : {};
exports.default = CircleRipple;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FontIcon = __webpack_require__(284);

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon2.default;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var color = props.color,
      hoverColor = props.hoverColor;
  var baseTheme = context.muiTheme.baseTheme;

  var offColor = color || baseTheme.palette.textColor;
  var onColor = hoverColor || offColor;

  return {
    root: {
      color: state.hovered ? onColor : offColor,
      position: 'relative',
      fontSize: baseTheme.spacing.iconSize,
      display: 'inline-block',
      userSelect: 'none',
      transition: _transitions2.default.easeOut()
    }
  };
}

var FontIcon = function (_Component) {
  (0, _inherits3.default)(FontIcon, _Component);

  function FontIcon() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FontIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false
    }, _this.handleMouseLeave = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: false });
      }
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
    }, _this.handleMouseEnter = function (event) {
      // hover is needed only when a hoverColor is defined
      if (_this.props.hoverColor !== undefined) {
        _this.setState({ hovered: true });
      }
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FontIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          hoverColor = _props.hoverColor,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
        onMouseLeave: this.handleMouseLeave,
        onMouseEnter: this.handleMouseEnter,
        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
      }));
    }
  }]);
  return FontIcon;
}(_react.Component);

FontIcon.muiName = 'FontIcon';
FontIcon.defaultProps = {
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
FontIcon.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
FontIcon.propTypes =  false ? {
  /**
   * This is the font color of the font icon. If not specified,
   * this component will default to muiTheme.palette.textColor.
   */
  color: _propTypes2.default.string,
  /**
   * This is the icon color when the mouse hovers over the icon.
   */
  hoverColor: _propTypes2.default.string,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = FontIcon;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var verticalPosition = props.verticalPosition;
  var horizontalPosition = props.horizontalPosition;
  var touchMarginOffset = props.touch ? 10 : 0;
  var touchOffsetTop = props.touch ? -20 : -10;
  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;

  var _context$muiTheme = context.muiTheme,
      baseTheme = _context$muiTheme.baseTheme,
      zIndex = _context$muiTheme.zIndex,
      tooltip = _context$muiTheme.tooltip,
      borderRadius = _context$muiTheme.borderRadius;


  var styles = {
    root: {
      position: 'absolute',
      fontFamily: baseTheme.fontFamily,
      fontSize: '10px',
      lineHeight: '22px',
      padding: '0 8px',
      zIndex: zIndex.tooltip,
      color: tooltip.color,
      overflow: 'hidden',
      top: -10000,
      borderRadius: borderRadius,
      userSelect: 'none',
      opacity: 0,
      right: horizontalPosition === 'left' ? 12 : null,
      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    label: {
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    ripple: {
      position: 'absolute',
      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
      top: verticalPosition === 'bottom' ? 0 : '100%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '50%',
      backgroundColor: 'transparent',
      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    },
    rootWhenShown: {
      top: verticalPosition === 'top' ? touchOffsetTop : 36,
      opacity: tooltip.opacity,
      transform: 'translate(0px, ' + offset + 'px)',
      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
    },
    rootWhenTouched: {
      fontSize: '14px',
      lineHeight: '32px',
      padding: '0 16px'
    },
    rippleWhenShown: {
      backgroundColor: tooltip.rippleBackgroundColor,
      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
    }
  };

  return styles;
}

var Tooltip = function (_Component) {
  (0, _inherits3.default)(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      offsetWidth: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setRippleSize();
      this.setTooltipPosition();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setTooltipPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setRippleSize();
    }
  }, {
    key: 'setRippleSize',
    value: function setRippleSize() {
      var ripple = this.refs.ripple;
      var tooltip = this.refs.tooltip;
      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);

      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
      if (this.props.show) {
        ripple.style.height = rippleDiameter + 'px';
        ripple.style.width = rippleDiameter + 'px';
      } else {
        ripple.style.width = '0px';
        ripple.style.height = '0px';
      }
    }
  }, {
    key: 'setTooltipPosition',
    value: function setTooltipPosition() {
      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          horizontalPosition = _props.horizontalPosition,
          label = _props.label,
          show = _props.show,
          touch = _props.touch,
          verticalPosition = _props.verticalPosition,
          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: 'tooltip',
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
        }),
        _react2.default.createElement('div', {
          ref: 'ripple',
          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
        }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(styles.label) },
          label
        )
      );
    }
  }]);
  return Tooltip;
}(_react.Component);

Tooltip.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Tooltip.propTypes =  false ? {
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
  label: _propTypes2.default.node.isRequired,
  show: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  touch: _propTypes2.default.bool,
  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
} : {};
exports.default = Tooltip;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendChildren = extendChildren;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extendChildren(children, extendedProps, extendedChildren) {
  return _react2.default.Children.map(children, function (child) {
    if (!_react2.default.isValidElement(child)) {
      return child;
    }

    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;

    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;

    return _react2.default.cloneElement(child, newProps, newChildren);
  });
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Avatar = __webpack_require__(288);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      fontWeight: card.fontWeight,
      boxSizing: 'border-box',
      position: 'relative',
      whiteSpace: 'nowrap'
    },
    text: {
      display: 'inline-block',
      verticalAlign: 'top',
      whiteSpace: 'normal',
      paddingRight: '90px'
    },
    avatar: {
      marginRight: 16
    },
    title: {
      color: props.titleColor || card.titleColor,
      display: 'block',
      fontSize: 15
    },
    subtitle: {
      color: props.subtitleColor || card.subtitleColor,
      display: 'block',
      fontSize: 14
    }
  };
}

var CardHeader = function (_Component) {
  (0, _inherits3.default)(CardHeader, _Component);

  function CardHeader() {
    (0, _classCallCheck3.default)(this, CardHeader);
    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          avatarProp = _props.avatar,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          openIcon = _props.openIcon,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          textStyle = _props.textStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          iconStyle = _props.iconStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle', 'iconStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var avatar = avatarProp;

      if ((0, _react.isValidElement)(avatarProp)) {
        avatar = _react2.default.cloneElement(avatar, {
          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
        });
      } else if (avatar !== null) {
        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        avatar,
        _react2.default.createElement(
          'div',
          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
            title
          ),
          _react2.default.createElement(
            'span',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
            subtitle
          )
        ),
        children
      );
    }
  }]);
  return CardHeader;
}(_react.Component);

CardHeader.muiName = 'CardHeader';
CardHeader.defaultProps = {
  avatar: null
};
CardHeader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardHeader.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
   * If `avatar` is an `Avatar` or other element, it will be rendered.
   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
   */
  avatar: _propTypes2.default.node,
  /**
   * Can be used to render elements inside the Card Header.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the iconStyle of the Icon Button.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
   */
  openIcon: _propTypes2.default.node,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in Card Header.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the text.
   */
  textStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in Card Header.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardHeader;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Avatar = __webpack_require__(289);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Avatar2.default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var backgroundColor = props.backgroundColor,
      color = props.color,
      size = props.size;
  var avatar = context.muiTheme.avatar;


  var styles = {
    root: {
      color: color || avatar.color,
      backgroundColor: backgroundColor || avatar.backgroundColor,
      userSelect: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size / 2,
      borderRadius: '50%',
      height: size,
      width: size
    },
    icon: {
      color: color || avatar.color,
      width: size * 0.6,
      height: size * 0.6,
      fontSize: size * 0.6,
      margin: size * 0.2
    }
  };

  return styles;
}

var Avatar = function (_Component) {
  (0, _inherits3.default)(Avatar, _Component);

  function Avatar() {
    (0, _classCallCheck3.default)(this, Avatar);
    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
  }

  (0, _createClass3.default)(Avatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          icon = _props.icon,
          src = _props.src,
          style = _props.style,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      if (src) {
        return _react2.default.createElement('img', (0, _extends3.default)({
          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
        }, other, {
          src: src,
          className: className
        }));
      } else {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({}, other, {
            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
            className: className
          }),
          icon && _react2.default.cloneElement(icon, {
            color: styles.icon.color,
            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
          }),
          this.props.children
        );
      }
    }
  }]);
  return Avatar;
}(_react.Component);

Avatar.muiName = 'Avatar';
Avatar.defaultProps = {
  size: 40
};
Avatar.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
Avatar.propTypes =  false ? {
  /**
   * The backgroundColor of the avatar. Does not apply to image avatars.
   */
  backgroundColor: _propTypes2.default.string,
  /**
   * Can be used, for instance, to render a letter inside the avatar.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root `div` or `img` element.
   */
  className: _propTypes2.default.string,
  /**
   * The icon or letter's color.
   */
  color: _propTypes2.default.string,
  /**
   * This is the SvgIcon or FontIcon to be used inside the avatar.
   */
  icon: _propTypes2.default.element,
  /**
   * This is the size of the avatar in pixels.
   */
  size: _propTypes2.default.number,
  /**
   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
   */
  src: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = Avatar;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var card = context.muiTheme.card;


  return {
    root: {
      padding: 16,
      position: 'relative'
    },
    title: {
      fontSize: 24,
      color: props.titleColor || card.titleColor,
      display: 'block',
      lineHeight: '36px'
    },
    subtitle: {
      fontSize: 14,
      color: props.subtitleColor || card.subtitleColor,
      display: 'block'
    }
  };
}

var CardTitle = function (_Component) {
  (0, _inherits3.default)(CardTitle, _Component);

  function CardTitle() {
    (0, _classCallCheck3.default)(this, CardTitle);
    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          closeIcon = _props.closeIcon,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          subtitle = _props.subtitle,
          subtitleColor = _props.subtitleColor,
          subtitleStyle = _props.subtitleStyle,
          title = _props.title,
          titleColor = _props.titleColor,
          titleStyle = _props.titleStyle,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'closeIcon', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedTitleStyle) },
          title
        ),
        _react2.default.createElement(
          'span',
          { style: prepareStyles(extendedSubtitleStyle) },
          subtitle
        ),
        children
      );
    }
  }]);
  return CardTitle;
}(_react.Component);

CardTitle.muiName = 'CardTitle';
CardTitle.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardTitle.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Title.
   */
  children: _propTypes2.default.node,
  /**
   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
   */
  closeIcon: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * Can be used to render a subtitle in the Card Title.
   */
  subtitle: _propTypes2.default.node,
  /**
   * Override the subtitle color.
   */
  subtitleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the subtitle.
   */
  subtitleStyle: _propTypes2.default.object,
  /**
   * Can be used to render a title in the Card Title.
   */
  title: _propTypes2.default.node,
  /**
   * Override the title color.
   */
  titleColor: _propTypes2.default.string,
  /**
   * Override the inline-styles of the title.
   */
  titleStyle: _propTypes2.default.object
} : {};
exports.default = CardTitle;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardMedia = context.muiTheme.cardMedia;


  return {
    root: {
      position: 'relative'
    },
    overlayContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0
    },
    overlay: {
      height: '100%',
      position: 'relative'
    },
    overlayContent: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      paddingTop: 8,
      background: cardMedia.overlayContentBackground
    },
    media: {},
    mediaChild: {
      verticalAlign: 'top',
      maxWidth: '100%',
      minWidth: '100%',
      width: '100%'
    }
  };
}

var CardMedia = function (_Component) {
  (0, _inherits3.default)(CardMedia, _Component);

  function CardMedia() {
    (0, _classCallCheck3.default)(this, CardMedia);
    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardMedia, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          mediaStyle = _props.mediaStyle,
          overlay = _props.overlay,
          overlayContainerStyle = _props.overlayContainerStyle,
          overlayContentStyle = _props.overlayContentStyle,
          overlayStyle = _props.overlayStyle,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
      var titleColor = this.context.muiTheme.cardMedia.titleColor;
      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
      var color = this.context.muiTheme.cardMedia.color;

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (!child) {
          return child;
        }

        return _react2.default.cloneElement(child, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
        });
      });

      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
        var childMuiName = child && child.type ? child.type.muiName : null;

        if (childMuiName === 'CardHeader' || childMuiName === 'CardTitle') {
          return _react2.default.cloneElement(child, {
            titleColor: titleColor,
            subtitleColor: subtitleColor
          });
        } else if (childMuiName === 'CardText') {
          return _react2.default.cloneElement(child, {
            color: color
          });
        } else {
          return child;
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedMediaStyle) },
          styledChildren
        ),
        overlay ? _react2.default.createElement(
          'div',
          { style: prepareStyles(extendedOverlayContainerStyle) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(extendedOverlayStyle) },
            _react2.default.createElement(
              'div',
              { style: prepareStyles(extendedOverlayContentStyle) },
              overlayChildren
            )
          )
        ) : ''
      );
    }
  }]);
  return CardMedia;
}(_react.Component);

CardMedia.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardMedia.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Media.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the Card Media.
   */
  mediaStyle: _propTypes2.default.object,
  /**
   * Can be used to render overlay element in Card Media.
   */
  overlay: _propTypes2.default.node,
  /**
   * Override the inline-styles of the overlay container.
   */
  overlayContainerStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay content.
   */
  overlayContentStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the overlay element.
   */
  overlayStyle: _propTypes2.default.object,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardMedia;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var cardText = context.muiTheme.cardText;


  return {
    root: {
      padding: 16,
      fontSize: 14,
      color: props.color || cardText.textColor
    }
  };
}

var CardText = function (_Component) {
  (0, _inherits3.default)(CardText, _Component);

  function CardText() {
    (0, _classCallCheck3.default)(this, CardText);
    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          color = _props.color,
          expandable = _props.expandable,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);
      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
        children
      );
    }
  }]);
  return CardText;
}(_react.Component);

CardText.muiName = 'CardText';
CardText.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardText.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Text.
   */
  children: _propTypes2.default.node,
  /**
   * Override the CardText color.
   */
  color: _propTypes2.default.string,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardText;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles() {
  return {
    root: {
      padding: 8,
      position: 'relative'
    },
    action: {
      marginRight: 8
    }
  };
}

var CardActions = function (_Component) {
  (0, _inherits3.default)(CardActions, _Component);

  function CardActions() {
    (0, _classCallCheck3.default)(this, CardActions);
    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
  }

  (0, _createClass3.default)(CardActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actAsExpander = _props.actAsExpander,
          children = _props.children,
          expandable = _props.expandable,
          showExpandableButton = _props.showExpandableButton,
          style = _props.style,
          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var styledChildren = _react2.default.Children.map(children, function (child) {
        if (_react2.default.isValidElement(child)) {
          return _react2.default.cloneElement(child, {
            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
          });
        }
      });

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
        styledChildren
      );
    }
  }]);
  return CardActions;
}(_react.Component);

CardActions.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
CardActions.propTypes =  false ? {
  /**
   * If true, a click on this card component expands the card.
   */
  actAsExpander: _propTypes2.default.bool,
  /**
   * Can be used to render elements inside the Card Action.
   */
  children: _propTypes2.default.node,
  /**
   * If true, this card component is expandable.
   */
  expandable: _propTypes2.default.bool,
  /**
   * If true, this card component will include a button to expand the card.
   */
  showExpandableButton: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = CardActions;

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/contact.8ba361cc.svg";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/help.52440e20.svg";

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAABcRAAAXEQHKJvM/AAAFA0lEQVRYR82YaVSUVRjHB1xO4TmWlKCAjpVlm9pmRh5CjlYHs3NSikisUNl3EIZ1Bhy2WRlQGYiBAWSIndBYZE8hQEFZwiWP2BGX+uIpyvBLcXueV4eGYaY7OuOZPvzu3DPzvM/9v/feZwEWIYT1f4VqYE6oBuaEamBOqAbmhGpgTqgG5oRqYE6oBuaEamBOWH9PT8+jGZkLZjh//ec1ua3d0YWdfWHKzr5QJK+1J/bowKib2nBw/KoFzZmpYQbXdPlZlosnYbkF/ssOf2L5aQhZHZLcHVRQ6Uhz9DBgBq+c0ppHPSPIigDu5MoA7m/Ict/4Oy9GpE58kJHb6yYpaKQ5ehgww7HBHxY+HZxkY+sTZwvCbJDFX0TZeeeVLSjrHlj4Zpx4JOf4SSeaM1ODA/UueR4s6fTLL0+i2ZkQS/ykGTH45VeEfSjIa8H5+6k5m/zzKwKjjtTtjSypnUuxBiVac+3fNQgvqvEOUFT4FnT0rlOvSxWG8CobVoGoPojorS+Ep9xa4sUh9n4JxM6EoD8L92DinJR15b7EIXC0pXvkKjncv/OLdkfeFedrGtAX3HfC2hlAdkoU3QaLqz01zJy/V45K5C5TVkIuXPAaRzC4xCuasAN50xA8xFgc/BPJMhC3LV2e3zZ6cb7B4tSk17VseCtBMo7zoIKqXY+DuBXglLawIeCuPRWU9FdmQyf73nqGB4QaxwRpf1Zj1/bmoXPzng098PvSfbHUhQ0BT2EL/2C/9npUQZrsyy1L9sn7WoHz9VEZp5/YG0NdmAY7kDuNd9hLXsp/IHFnrkwwubC6b2jL+uiMMZyHF9fGPvZlFC5g1L3D+4YvyatqdEa/daeGZ/IuVZg27/Bkp8XH2jequgeesYFjtfcz7t7h3YVTuFnde3bRA+0cIj7azryRc1J2ZYyqnofzVzmCn6z3cKgC9AG1nCyG3f9IrKjTtSZVlDZFXf2eEBg9OHdNy8nDN6eJ0Ace6ZNwpNyKBh+TiIPyYv1GrGjkUPMJB9jBd9WVgiZEF5jb1oTxbxd29LJNIg55O1FamVbXEt4EKWVVEG/S1juOKkQbNgQS7roTT9albx2qEE2gM2buHUdVHwgN6nGcv5d6uNEKekHo/5gy5AABYm8QCeSRXeEE0xP6Ke85M6c7ogrSxeHmE+zXY4SjOBfUtzlCtzy1dn/65efDUi49F8q/BEdFBXbuBjwzBlG/Vt86VCH6gDpYvV2QqworqvnMQ6aUukkUIscEiRBECzfEioSbuJnCzclZQugyZrEZcOJmil+JzhBBkZ8JhJGrNyyNEjcwPjHjYIdY4Q7t07Wt/ENHXNPkMvgsgZZeCX0fA+yKEmqmEo75Lv6JSqjFSrhnxZA+cuHeFb4Umda+v+QbZ7XPc9d+mSWQKkgXfl+V862g5MBi0yAym2avC5cD2aJlPvEE6zO0YlJdNlQn2nhkKV2Wg1M733imF8MknFzdpDNP6UNY3+YK7RbBKEesdkeQoMIqV6PFQUfsjrVQXbbwrzboKNJoz2kC+fFzGxCFeQ7bLvTxsbTA12hxyMZ4Sb+lewiZ7xFK1kVlXK/pH1pKe0aT1pELti9DdKMPi0+CCZTB4Z6L41ZGiZucusPkou9/HLfObvouHprDlLGJmw6av9H49fYUYwcd70rptx08WUMn5+SFy9b43a0//pz1rxGqMy3Q8ZyQv/e9QeL+w26O338AdAbtlK9w9DAAAAAASUVORK5CYII="

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAABcRAAAXEQHKJvM/AAAFb0lEQVRYR82YeVCUZRjAVzE18crKQCEZc7TLpsYZJZrKpsmmchpMwKO8kWu5WUBYYA0YQlwkFUhuEpRdQTwWIrkSgQUUFCRTbgUUQeMIXWWvt/dZ3Z2N1n32W5uxP37D7vK87/Pb93y+ZRFCWExRKpUTxn8mlcstHkplVobGGwIaMC7JRPVrmUJhcqbpqq13Rl7WZxHxjR/zfrzzYVjc4JdRiRfWxaWXp5XXeA2MjJqp4xVabQ0FDdCIEaL59uW/tzpQkd4pG73JtO98yKT1nvSvLzGlPEdfw+fPf+tDrNg8xd7TpZFagiZYHsZy2mJZ5847g8SUDd7EwiWEWLqEkldd/40lZdYWf8KydyfbErNFWoIGjyAaoM3x2kYnSDZrC4cscAtT6JLShsYozZ2CCcvWmWyOP/wL1j9jOfWotd++8/Yij+9VU2flFibHxDSCrqFKs53BxGSdB0k4cy5Uu08MNEANN0cUz7J1gWSokI4RVMAaXOoXNUx39WQsFyM5qUw+7fPIhCuQAEYCk9EFrM+pdKNcaL/xAZaPkVxz901rczo1sH4wCX1M3uBFEs9UBmL5GMld7OxZMWdbAJnvzEUFngTsXhj5iLyiWCwfI7lLXb3LX9oeSOb9H+UaOrptZm/1pyMXgkroA6b1YFEFF8vHSG70wcOZK3n7W6Zv8oMkRm8IuElqW7s+wvIxkgMCsk+mwGEKBysmMp4FbqFK002+ZFngnqExmXwGlstgOfWBeaWn793XPHaPzdzMgUPYYMFHh3AQvXO9SEqZmIPlYySnTXJptT9rrRuZ58RVjYYuGV072mSdJ1mzN0U8/gtjoAGP0XRG78hiWNjjBehoKmZs9iNzd+wiC9k82aPpDFPCdfemT+TI7eG/5qvEGNR2aIAadTUhlSsm0XKpHRY3CIHAy1QIyiSHuPTf9pwsiQExS7oB4PiZTSuTyqsdq7D+n0pOm8s3bi6DqX1ha4BKAm6OUGFBfMUfbavs96VVgSysMxA+VFKluREMnU5j5TSdHyg6y51AyyeYSk7WiTQ6beZv+UYOslY7wrRK4R5dy0+tUsczqeOMlfvHmlkRzO+Gxf4OJ+ruDyeK+allYp41l98DReZcxyDS0Nn9vqoNwxEzWg6QKx6V2z8VVwbNpIUnrD8YsbNX2uxKLl9bzfraidjFpp7D+sFAA/TRdL3XBqqVN7wjpHSaI2kx6WMdzO+B54j4XyuCIMaY6fxP5AZH778Im8ErIy/31tDIkoXuu2WsL7arNoOgqt4Ra4+BBuiDClks9gyXTKdXk3NyzokkekjbxiRXwdmWebbWHWuPgQboo4/K0SkdhYIADuZj4ovOpc0t30BplE6fW7H2GGiAPm4Njlgu8QqXTKQPL64pAqGgusEFqg+QTSsTP2u5YcvFIOfgQYKOnkry/Tk/g2XPVq25/LpGJ6w9BhqgjwdS2dRPww82s77aQdipQiHnMJWzY6vOuLa+gaVYeww0AMPvcL6AtcaVgFiIQJQAm+G9gOj+gZHRV7C2GGgABt2xr9d3dC8fuieZQ19bils6V/b+OWSBtTMENEAPmitp+L7ErKv/7iL1+8F7kmcup6KmtesT78y801kV5z3TymvYPGFhan5dkx/WzhDQAAwqZ8PNER2lD8sxu46cOuCRnnvkeG3jTvo/Rj936QINwBC3dK30TM/Njj5ZnETL+OAwYWECvR3YWDtDQAMwoPCMKygP5x0rzKQkHCqu5Ijqm9dLxqSmWFsMNACjru26jU/m8dxYURk/RFCw3y1FeCynuuGpL30ADcCgx4hNXu2ljVXXOmz3FZRHx5wqjejsv7sYa2cIaIA+xtdq2hXv4x+3jaqA1fwNJ91a22CaT4wAAAAASUVORK5CYII="

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAABcRAAAXEQHKJvM/AAAEKUlEQVRYR82YaUwTURDHWwEPBBFv8QCNkSBGIzExQkzUxBjjEWMUL0RAAbFUBLkEiqiIeIAxCBLxiLfBqGiMIBgPFDVENOgHUQOKAgJqwmmBtju+adn2tRylZbv1w7/vbdp9++vMvJl5KwAAAQMgxBEl7egYwc5RCoYZQF/zKa2LzPzncdPECbA25ezze28+rKe/o/8AX1JP2mQya5fQRJlgVQBYbQwBa68w8Mu4cu/Lz3pXHUDeINWTlrZ2m1nhSb9svffA5CAJOATEgtAzGCbtiIOU+48TW9s7rNWQDMMLoHrS2tY+1C0yuc52iwrOMUjCoOx9I0GwVgSuYYl/LxcWR9M3m9rVPcKxctwpYXC02xoOFuvFsPzw6dKiTxWL+YDUC0drInHxoE27YQSx5rbTV/NqG5qmmhLSIDjWkmO2R4NgnQjGB8TAkZyCJDrdcBmPBsOxmiLaJx/uEwGWG3bB3Oij1SQexfTCDAf50Wg4lRXjmUlktPYKBasNIbD0UPr7d19/LNKBNNqSGrh2w+FYORFITD1oxZG+USA6l51dVl03s7+AnMBRkAqMR8yP08T7pafynkk65HI7NaSBG0YDZ4RbuxPmRhztSTwK1gSBe2xK881X7wLph/bVkpxaTguSiseBpBwuS8p4+6KsfIkWpB5LmgxOAylhMD8O2RwKuLvDLt66XfWnwUnHit1Ccu7WHiGJRm9TxSNa9cjdgkNmc2tPgGhJtKBwXTDMizlWc6e41EfHzcKucCa2XBdQsrPR1agVyZnFFXW/p5vNrd0JUw+WQMHqQJgdfvi3LqBZ4VDo5nH+Mcq2LPvlW9//Aq6zFWOwucXue3vmtTtyhcLS7HC4W0f5RSmTNGka6i88eR3MctAdDq9wGGNj/ffCANK0oisTsh+k/2pqcWQZ5ArGgnfLoaUmBKoaVRuyvlfaxfySiu/zKRBhd9XC5HBYa7HFF3qKYUH8iaoXH8s9aYDe6qwGjuMkTFwoH0niCvu8GaGJjWm5z+LJc6woKL3NKOdwuAsdAlSpAc8aSbcfZja0SofpPJj/rgRjCzM+xpX3qUsFn2s0B3KltfoIxRmcYyeUvU+kqn+LS/1K6uXm/kB1hTNiQ9D5yjnkgCw9rzCWXry/L4GMgmNTA3YWOEZcyckiPZqzGkonXxkrg+BUULEwqPNFD4mrp6XfqtzoBY11Yb/gcBcq35uQw7RHXGr5jaISkRZUH88FhkgvHJYc7GCx5EwV7ZORE1U8KdDqfEXiihMXGgSHUFj/lGdREvTi8zev1jY0OehbkEupJ83SNluX3QcbMUfhqclmSxgMJrVwzfGskveV1e70TaZwYa9wxD1WCxNOVgpW+iuDfU5kcj05b241BxQrrQuy8zwCz1zPzXpUFN74Vzpc58e8gqGUH71tfy5Tg6H6B94GKpEBmMI2AAAAAElFTkSuQmCC"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return About; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var About=function(_Component){_inherits(About,_Component);function About(){_classCallCheck(this,About);return _possibleConstructorReturn(this,(About.__proto__||Object.getPrototypeOf(About)).apply(this,arguments));}_createClass(About,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"About"},"What ever About");}}]);return About;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ForgotPassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource_Icon_LOGIN_fmt_png__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource_Icon_LOGIN_fmt_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__resource_Icon_LOGIN_fmt_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resource_company_png__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resource_company_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__resource_company_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_doctor_png__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_doctor_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__resource_doctor_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resource_private_png__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resource_private_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__resource_private_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__variables_js__ = __webpack_require__(77);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqLogin=[];var Login=function(_Component){_inherits(Login,_Component);function Login(props){_classCallCheck(this,Login);var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.handleUsername=_this.handleUsername.bind(_this);_this.handlePassword=_this.handlePassword.bind(_this);_this.handleSubmit=_this.handleSubmit.bind(_this);_this.login=_this.login.bind(_this);_this.state={username:'',password:''};return _this;}_createClass(Login,[{key:'componentDidMount',value:function componentDidMount(){if('username'in this.props.match.params)this.setState({username:this.props.match.params.username});if('password'in this.props.match.params)this.setState({password:this.props.match.params.password});}},{key:'handleUsername',value:function handleUsername(event){this.setState({username:event.target.value.trim()});}},{key:'handlePassword',value:function handlePassword(event){this.setState({password:event.target.value});}},{key:'handleSubmit',value:function handleSubmit(event){var login=this.login(this.state.username,this.state.password);var self=this;login.then(function(json){if(json.loggedIn===true){self.props.propagateLogin(true,json.username,json.role,json.token);self.props.history.replace('/');}else{self.props.propagateLogin(true,'guest','guest',__WEBPACK_IMPORTED_MODULE_9__variables_js__["a" /* default */].guestJWT);alert('LOGIN fehlgeschlagen.');};if(json.temporaryPassword===true){alert('Ihr Passwort ist temporär, bitte ändern Sie es.');window.location.href='profile/'+self.state.password+'#content2';}}).catch(function(){self.props.propagateLogin(true,'guest','guest',__WEBPACK_IMPORTED_MODULE_9__variables_js__["a" /* default */].guestJWT);alert('LOGIN fehlgeschlagen.');});return true;}},{key:'login',value:function login(username,password){var url='/api/login';var promise=fetch(url,{method:'POST',headers:{"Content-Type":"application/x-www-form-urlencoded"},body:'username='+username+'&password='+password}).then(function(response){return response.json();}).catch(function(exception){console.error('Login failed? Is the server running?',exception);});return promise;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),this.props.username==='guest'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Login'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDown marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDownOneTile backgroundTransparent '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{autoFocus:'autofocus',placeholder:'Name/Mailadresse',className:'loginInput margin-right',type:'text',onKeyUp:function onKeyUp(event){return event.key==='Enter'?_this2.handleSubmit():true;},onChange:this.handleUsername,value:this.state.username}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonDiv LoginButtonDesktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:this.handleSubmit},'Login',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'buttonIcon',src:__WEBPACK_IMPORTED_MODULE_5__resource_Icon_LOGIN_fmt_png___default.a,alt:'logo'}),' '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDownOneTile backgroundTransparent '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Passwort',className:'loginInput',type:'password',onKeyUp:function onKeyUp(event){return event.key==='Enter'?_this2.handleSubmit():true;},onChange:this.handlePassword,value:this.state.password}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonDiv LoginButtonMobil'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:this.handleSubmit},'Login',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'buttonIcon',src:__WEBPACK_IMPORTED_MODULE_5__resource_Icon_LOGIN_fmt_png___default.a,alt:'logo'}),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:function onClick(event){return _this2.props.history.push({pathname:"/forgot-password",state:{username:_this2.state.username}});}},'Passwort vergessen?')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText marginTop50'},'Registrierung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDown marginTop30 pointer justifyContentBetween'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDownOneTileSmall center',onClick:function onClick(event){return _this2.props.history.push("/registration/non_commercial");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margin10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__resource_private_png___default.a,alt:'private'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentText FontMedium'},'als Privatperson ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDownOneTileSmall center pointer',onClick:function onClick(event){return _this2.props.history.push("/registration/non_commercial");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margin10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__resource_doctor_png___default.a,alt:'gesundheistwesen'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentText FontMedium'},'als Mitarbeitende im Gesundheitswesen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDownOneTileSmall center pointer',onClick:function onClick(event){return _this2.props.history.push("/registration/commercial");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'margin10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__resource_company_png___default.a,alt:'hersteller'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentText FontMedium'},'als Herstellende ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))))),__WEBPACK_IMPORTED_MODULE_4__util_js__["d" /* isCommercialUser */]()||__WEBPACK_IMPORTED_MODULE_4__util_js__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Sie sind bereits eingeloggt')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqLogin}));}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ForgotPassword=function(_Component2){_inherits(ForgotPassword,_Component2);function ForgotPassword(props){_classCallCheck(this,ForgotPassword);var _this3=_possibleConstructorReturn(this,(ForgotPassword.__proto__||Object.getPrototypeOf(ForgotPassword)).call(this,props));_this3.handleUsername=function(event){_this3.setState({username:event.target.value.trim()});};_this3.resendPassword=function(event){event.preventDefault();var url='/api/reset-password';if(window.confirm('Wirklich das Passwort f\xFCr \''+_this3.state.username+'\' zur\xFCcksetzen?')){fetch(url,{method:'POST',headers:{"Content-Type":"application/x-www-form-urlencoded"},body:'username='+_this3.state.username}).then(__WEBPACK_IMPORTED_MODULE_4__util_js__["b" /* handleErrors */]).then(function(response){return response.json();}).then(function(json){return alert('Eine Email mit dem neuen Passwort wurde Ihnen zugeschickt.');}).then(function(){return _this3.props.history.push('/login');}).catch(function(exception){alert('Benutzerkonto nicht gefunden. Benutzen Sie Ihren Nutzernamen oder Ihre Emailadresse.');});}};_this3.state={username:_this3.props.location.state.username};return _this3;}_createClass(ForgotPassword,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackgroundShort'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loginTileDownOneTile backgroundTransparent horizontallyCenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{autoFocus:'autofocus',placeholder:'Name/Mailadresse',className:'loginInput',type:'text',value:this.state.username,onChange:this.handleUsername}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonDiv LoginButtonDesktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:this.resendPassword},'Passwort Zur\xFCcksetzen',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'buttonIcon',src:__WEBPACK_IMPORTED_MODULE_5__resource_Icon_LOGIN_fmt_png___default.a,alt:'logo'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqLogin}));}}]);return ForgotPassword;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAABcRAAAXEQHKJvM/AAACGklEQVQ4T2P4//8/Ay0wQQXkYpwS33/9ZkLj8//49ZsTSHOjiTMSbbBFVTcjErsXiE8A8T8g/g/EP4D4GhA3ATEvyS4WTS5vAeL/QPwCiLuAOBWIJYE4AYi7gfgpVH4+TA9LRC7cQSiGcccUgr0vl1mzB4j/A3EEsjyQz4jGD4Sq24fTxVXLNsEM3QlVLI3LN8gWANlcUPXbsBoMdbEbVJEoLkOxWQCkJUH6+OKKA7AazBVT8A2ooB+by4gwvBxo8H8MgwsXrLHgjSsCuZYDqpAPRMtn1RI0HKqeB2jw+/z5q41RDJbLrBWRSqtyhPEVsusuKeXUpxEyEBkDDX4ANHgK2ODdl24EMPim/pfNAIVtLQaWyah9KZ1eU0HIUKjBR4AGr0UY7IfP4Jr/Clm11YQMhRq8B2jwGrDB+6/c4mcKy7FWzK53lc2syQYaZgzEYkD8QCy5YrVjw0QuQgbCIhBo8F2gwbPABsMkQYEOijwkxfyEDMTi4jdAc/xQDAZhaHJrg/HlSUtu6ViTGwgDM0g6KKETMgyLobzQDJKK1WCoomPQ3CeErBmLOiYk9jsgPo8sj+5imAvOQA3XwWUYlK8PVXcV3WJ83pwH1XQTiKuAWAPqZXUo/xRUfiVMDzAo4BbjNBgs6Z8mBMTzgfgxEP9nCABi/7S/QPwWiCcCsS5OvbgkTt5+wIjG5z51+wHnSQhmRBJHCR4YBgAbkM8fK15T2wAAAABJRU5ErkJggg=="

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABcRAAAXEQHKJvM/AAAEhElEQVRIS62Wf1DTdRjHv1uQzCY/59ANGBugePSDMvOSg8qgw4QDDAlSEBDlx4BkwJgwfokEipBF/lGp6Z2XlBcqZVRaUgHiAFFCKCmk084rwLqrLtH03efzsS0YG3PE7p4bn+/38zyv53k+7+czOACctTZ+65bt+Pg4z9I+U2Zxg7HFxMbapdTsqYxNSHS1tHdWgOQjFK6KO8/xbX0s7Z0xcGVwsO3EtTgi/jTvPps5hiB8vo2lGFYB2UYn1yhx2EufikKiDrslqUbmh649Kl4d1yxc4p9syXdGQJ7fE7sXVx+EQl0DWWYZ5Pk7sbj6AAi40ZLvjICc98NlCk0dPNK1BlNoauH89Oq3LPnOEPiQCWDd7ABHRkenzBjnsSjbq3D3JCBdO64I3mUihtkZnTabsPWJy1elvpwmeXR5hFPImia5qmoSkK5dIxO+miv3jbL19ktfERYV9Pft2/zpYpp/wXE8nn/APpGyHJ5EKAuUZRAnq2/KMorhkqyGe1oRpJs0NyXKUniR1ipItYKg55uONzXZmotpEUjbJcsqw/yNBXhuez0CtLVYsEmDyJ1vQpFZAk8CfyTvFUhTCyHLKofLM+H7F0ok/x/IrVXiQEsH3j7VBnFKAT67MIDAkjp80NGDfV+04/64bHhmb2NA4jcLwBfSWfCjZ8+TCrei49JlhFTUY+jnUZzq/ZYklAHZv0Aenz8zIDWHZUGltFVcdAbebe3E4dYuBmy5OIhnt72OnstXcLyzF/yYTFahU2DoG9PFI8bnsnJUQhupPMLOwztMIPNhZufhFSrw9AkXhUY3yogoTALLCXBID1Sy20ccvu6kQL4ows5dEaKPRY2zF61p1XU6swpzSsofdFdVwzO3CnKDVbNvWh2R/x3aUktAj/SiO7T9dFT0/npzTCuBbujKyrtAbamvJE0L9wnzZWz3BjTvPy9ehbODw4EGoJQ8lJK5ctyQB+ekfDgl5t2VOpG9NUAZMTcSh/rTOA4bclkc+4TcyUD7xHwsLdiBE9192Pt5G95vP8dkT52sAbqmaPC4Zgca2rrYCFEFB5W8ysZqEtAxSY0lWyrIfPXj0Nc6fNzTR1T4GhxJptYAxeSCeLJoF3u2//QZ6L4fhr+6CvwXM00AcypwsneADfhH3d8w2RuA0SaARmPxH7AGTV297EJo/24IS0nF9L3OuKWPFVTjyJlzqG9uwUECDSiuhYtRS99r68bCzRR4yWxLaZx3SHU0Dn0XWFwHXozSWDTF5HCLICRqogdtn6CCZKJoolLR3HMRx3QXINqoRv/Vawit3IOrY7/hy/5BNqdMNBnFBpE4EAEK43NYnCmisTQWgnVbUHDoGDL2NkBEfim0DR+yS7uy8ROUHTmBB0jgex6L7K1aX9fNhSwTqRmjUqftomckIXvnkQ7QSmnmdO1GumPOl9rc9TkU+BQD5tfWL5OkFv05XYa0VfqE6N80ATpzdE3PVN96k76ZpRBEJv3a0Tfgx4Bjv/8xZ/iXMfGPI2OSqXbdxDMr341el/7w0zXRXzdusP8E/gH8t5AJ6PR+igAAAABJRU5ErkJggg=="

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABcRAAAXEQHKJvM/AAAE9ElEQVRIS6WVe0xbVRzHb0sLrCsDWlr6og+Y4NzEDJRNXgMVKI8p21qGGc+N0vKGArJSHu10DiVu6hSNbmLmfE0Jm4Jm8YGJS2ZmYjJ1idEh4oMhLUTj1IChx9+55Xbl0Xub8Mcv5557zv19zvd3fr/fJRBCBJPNLywEeM8XXChkfn6e5WudzmgX9Xo9C4xNzUvNHdnGk4Mv1p05/7Fx4MxgWZslr6i4mIfXtFothwnGCPRsIghxcIp2SGTqRhEGCxJWtiNhlQWJTD2Id1/hKBEQSKodGxtjVEoHIZ2wONwgqb7qSkzn00hZ0wVmdbnHLnLE7+VlTRdhPxUJ1lr+GIGU8bdsN6ibH1uCrTISqmntQ4RicweTL0Ygi83mRGTvPaduOeqtbIVZXRrzMcTemfXhpcuXeesDcrg8Ud7+EVXjEV8KSVM3PYoCUvM+u3TlS8H6gOwALih8R+0G+lDY5VKbH0esnVkXv/r6G/66gNg2bU9uiLacQEpTp0+FmrYnEKHe0snkixZIZSk3TCiKqj58XdPWh5TGzkUvpS6YI80j/UhR2eogAoMVeL82N3d9WYotSCxLjzJa5mJAKb4vnLV4jD58HKnqbU6eOlbH5MMvIIj0nJbDD5WGp2m7RfnFFyCRPhLlFp0T7Mpv4ApEUs9+FotWHS2QCqm3AWBAsCuvLYDHF0Tk7HtDeP9DL/jzHSPQ+yN2ULA49O40Y9iOjBpJkeF7CCES5ejewqP04Zrx0MQUO2RyP1cojrz1vW+lPk+CDRImTrrf+G2M9RnEvyOhOmxHZh9+VjXYUbTlOBJm7j69MS6+LMb6LJKXNowHimVJTEp9qgsURsbLDtT9gJND03oMRT5YMrxBdVtGlKFjZnPP80he3uzgb008JNEbvsB1ipuDoqJlOkiiSKYTsWxis9mWYOJ4WUn9j54earKSGQmhrd+gjr1Xojv0arBMlRJyZ1ITrkFYXyQ7DkDhIFPBMmW6X0DKIgvLP9e0P4mUtd3LmjS+t9B70u14DzSERnL91h53E4BGLi02XfMnpOQGguDosBPVqnZmdWEgVg0Jkkb1UFC3rOXh+1XV90IChFQxAd0vbk/6gAzTWm3MrWgxPDW7AMJrxo49EajrodS6cHSI2MQRRuDRkwPbiOT839y/o7WbNVagqDBf42niCqVFhqskFEDQ/v6FVvcfqRyiQKTuvlFn7U2gBfa/OVROaEsQ5QQ7XwUk13rwXVqEDxSexaHHoYVafFt2ABINhxnUEvnlqHVgsIYWeGJ07AihqwXH+MSWeXlp488rgC6sHhx/tykhuQJqb1IFzrEiDIeW9x4VWkJfizpev/AKPXDkUxuxrwap6nohvVumoXc+576Xbo86aVH11SCZMgMK/iD1Y8bAiBzdEH9rglFRaXbgyOCDd5w9/7L/wArzjCCz4LR32mOAICOfdCKAw1AhXwK+GxKf1Kw42DanarBRwJdogU+9/4md2GNEClAkKWueDU3PG5RD0cuN2DoRfpZVtt4U5OhHpWVNTrmpi3wfBQcJz9ozzNuW2CKtMP+pgAMTe02o/bXhU0wKewmdWyFk4u/CzIJTquXFTdZiNKS9utHuyWSsUIQV3kUptPun8I+//wm5Pu2ImnTMyX6acUZOTN0Iw8+Tjtk1zOu9c04+MTUdPvHLrxsnZ5wSvDYOfmb/uhm2Evg/aHgaCtGDjkUAAAAASUVORK5CYII="

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABcRAAAXEQHKJvM/AAAES0lEQVRIS2P4//8/Ay6ck5PDiMwvqKpRKpsw3bZmybrsoqZ2s/zKagW42txcZnxmwTBuCQYGuGUM7Jwygq7By6TSq/5LZdX9l0yr+i+d0/hfMqX8P6eeeQ2SHoKWEnQRMzefnERo6iWFks7/spk1/2UzqoEYQsvlNPxXKGr/L2TvPRubQ0m2kJGJiUXMO2KrYmnXf7mM6j9yQAtRcfU/+ez6/0pl3f95NAySCTmeoIUsvPwK8jn1/+Wyav9jWgbFGdX/FApb/0uEJJ9hYGYRpchCPkPLMoX8ZtyWIWHForb/TCIStmRbCAxOViFHn3nywHgiZBnQl38VS7r+M4lKOZJtIQjzm9jWEe/DdqAPJcn3IQiz8Aupyec2Eo7Dgtb/kuHpFxhY2MQpshCExQPi1yoCU6FcRhVmKgVaJpdd91+povc/r55ZPiGz8FoIy09sQmIi0vEFL5WrJgB9WgeOL6Bl/0AWgnwGskzUI3Q9AyMjM0QfI/n5EIaZObiEBSyc2mXTKn8rAgsAxeKO/9CscJ5X1zQHaAcTSB0o3xIyC78kI6pruVS07LiUNJxYhcVNOOWU7Tkk5VQIWUCUhejFE5uYpImoZ9hm6bj8R0IO3tEgMaCPe2QSi++J+8ft4JCWJ5g68VoIw0xs7HxAgztAqVQ+rwkcjMCS549ESMpJcBwWtv0HZRv53Ia3QrYe9YQsw2ohLNLZhMX1pKKz7yjkt/xHKt7+gS1HK+5A5SnIMcAUvYCZh5eNaAuBABz5rEKiOtIxOfcUClrw50EUXAu2VMwnagWSeRgpFlswMkuGppwApUTiLYP5tO4/yJFC9l7TCfrQyckZ7DtgnNWDqhuQZlh+Ix4DqytgXIMKch4NfXDiamhoYMSw8PWbN4zQIBCXis19DMpr0AxOhCWYWLG4/b9EcOIpoHkceIOUQVWvUam8h6CBBPA/YKr9rwD0KQMrTwrUbEYMC139/GU43cMugeMOVEaCUiMw9RFhAZJFjbDi7x+oyGNQ1F2JzYdg270T0jz5YwsQlgCDVDat4jsRFkEw0IHSsXmPZFMrvoHYoDzKYOp6q2XCZA2sQepfWFUslA5xKagGkEkqeQ9sz2wjNqWCKmphF//F0nF5j0FBCvItg3Po786FywIwLHzz/gNXWOe0tQKJpVDN9f9lU8u/ApP3TIiFhC0FpU5gQZ4nGZ52GVxpA0OIITz3/4Qdh7owLHz39btk+MQFx3liC/9Lp1f/lwY2AQVdAtbwWblMlgEaBhYDtknxYdm85v9MAiIGwj7Rh2SBpRNIjCEw/X/v5r2NmBZ+/ioSMWHePoGEkv/y0CKM39i6SsDSuZNgqw2KQRkeWHvYigfGHwaVOCAxhpDM//1b9tVjWPj37z+mlx8+idx/9Ub64et3Ug9fv5W6/+QZ3/2nz/hgfEyMJv7mnfS9Bw/ZHrx4JfLwzXsZkNidF69lP3z9xotsIQCTqxLCBq8yawAAAABJRU5ErkJggg=="

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Registration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registration_css__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registration_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__registration_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registration_old_css__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registration_old_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__registration_old_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqReg=[];var Registration=function(_Component){_inherits(Registration,_Component);function Registration(props){_classCallCheck(this,Registration);var _this=_possibleConstructorReturn(this,(Registration.__proto__||Object.getPrototypeOf(Registration)).call(this,props));_this.errorMessages={password_mismatch:"Die angegebenen Passwörter stimmen nicht überein",registration_failed:"Ein Fehler ist aufgetreten. Verwenden Sie keine Nutzernamen und E-Mail Adressen mehrfach.",username_invalid:"Benutzername ungültig",error:"Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."};_this.onSubmit=_this.onSubmit.bind(_this);_this.state={firstname:'',lastname:'',username:'',company:'',department:'',email:'',password:'',password_verification:'',street:'',street_number:'',additional_address:'',zip_code:'',city:'',country:'Deutschland',non_commercial_confirm:false,error:{required_fields:[]}};return _this;}_createClass(Registration,[{key:'onSubmit',value:function onSubmit(event){var _this2=this;event.preventDefault();var fd=new FormData();fd.append("firstname",this.state.firstname);fd.append("lastname",this.state.lastname);fd.append("username",this.state.username);fd.append("email",this.state.email);fd.append("password",this.state.password);fd.append("password_verification",this.state.password_verification);fd.append("role",this.props.match.params.role==='non_commercial'?3:2);fd.append("company",this.state.company);fd.append("department",this.state.department);fd.append("street",this.state.street);fd.append("street_number",this.state.street_number);fd.append("additional_address",this.state.additional_address);fd.append("zip_code",this.state.zip_code);fd.append("city",this.state.city);fd.append("country",this.state.country);fd.append("non_commercial_confirm",this.state.non_commercial_confirm);if(true){fetch('/api/register',{method:'POST',body:fd}).then(function(resp){resp.json().then(function(json){if(resp.status>=400){_this2.setState({error:json});window.confirm('Ein Fehler ist aufgetreten. Nutzername oder E-Mail Adresse sind bereits vergeben.');}else{_this2.props.history.replace("/activation-after-register");}});}).catch(function(error){console.log("Error: ",error);window.confirm('Ein Fehler ist aufgetreten. Nutzername oder E-Mail Adresse sind bereits vergeben.');});}}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Registrierung als ',this.props.match.params.role==='non_commercial'?'Privatperson oder Mitarbeiter im Gesundheitswesen':'Herstellende'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'regTileDown marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'regHeaderTexts'},'Allgemeine Angaben'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Vorname',onChange:function onChange(event){return _this3.setState({firstname:event.target.value.trim()});},className:'regInput '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Name',onChange:function onChange(event){return _this3.setState({lastname:event.target.value.trim()});},className:'regInput'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Email',onChange:function onChange(event){return _this3.setState({email:event.target.value.trim()});},className:'regInput'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Nutzername - wird zur Anzeige in den Foren verwendet',onChange:function onChange(event){return _this3.setState({username:event.target.value.trim()});},className:'regInput'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Passwort',type:'password',onChange:function onChange(event){return _this3.setState({password:event.target.value});},className:'regInput'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Passwort Best\xE4tigung',type:'password',onChange:function onChange(event){return _this3.setState({password_verification:event.target.value});},className:'regInput'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'regHeaderTexts'},'Unternehmen (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Firma',onChange:function onChange(event){return _this3.setState({company:event.target.value});},className:'regInput '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Abteilung',onChange:function onChange(event){return _this3.setState({department:event.target.value});},className:'regInput'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'regHeaderTexts'},'Adresse (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Strasse',onChange:function onChange(event){return _this3.setState({street:event.target.value});},className:'regInput '}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Hausnummer',onChange:function onChange(event){return _this3.setState({street_number:event.target.value});},className:'regInput'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Adresszusatz',onChange:function onChange(event){return _this3.setState({additional_address:event.target.value});},className:'regInput'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'PLZ',onChange:function onChange(event){return _this3.setState({zip_code:event.target.value});},className:'regInput'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Ort',onChange:function onChange(event){return _this3.setState({city:event.target.value});},className:'regInput'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'regHeaderTextSmall'},'Land'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:function onChange(event){return _this3.setState({country:event.target.value});},className:'styledSelect',id:'styledSelect',name:'country'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Deutschland'},'Deutschland'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'\xD6sterreich'},'\xD6sterreich'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Liechtenstein'},'Liechtenstein'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Belgien'},'Belgien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Italien'},'Italien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Schweiz'},'Schweiz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Luxemburg'},'Luxemburg'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'D\xE4nemark'},'D\xE4nemark'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Polen'},'Polen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'Frankreich'},'Frankreich'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:'England'},'England')),this.props.match.params.role==='non_commercial'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Reg_checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{clasName:'Reg_checkbox_label',htmlFor:'non_commercial_confirm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'non_commercial_confirm',type:'checkbox',value:this.state.non_commercial_confirm,onChange:function onChange(event){return _this3.setState({non_commercial_confirm:event.target.checked});}}),'Ich oder meine Organisation leben nicht PRIM\xC4R vom Handel mit Produkten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:this.onSubmit},' Registrieren '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonDiv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},' Bereits Registriert? Zum Login ')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqReg}));}}]);return Registration;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Test; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ayacandas_210318_web_resources_css_ayacandas_210318_css__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ayacandas_210318_web_resources_css_ayacandas_210318_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ayacandas_210318_web_resources_css_ayacandas_210318_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Test=function(_Component){_inherits(Test,_Component);function Test(){_classCallCheck(this,Test);return _possibleConstructorReturn(this,(Test.__proto__||Object.getPrototypeOf(Test)).apply(this,arguments));}_createClass(Test,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('head',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('meta',{charset:'utf-8'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'ayacandas_210318'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{href:'ayacandas_210318-web-resources/css/ayacandas_210318.css',rel:'stylesheet',type:'text/css'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('body',{id:'ayacandas_210318'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links ParaOverride-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-1'},'Farben:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Blau: 30/105/128. #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Gelb: 245/229/152, #'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Schwarz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Wei\xDF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Grau  50%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links ParaOverride-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-1'},'Fl\xE4chen/K\xE4stchen: ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links ParaOverride-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-2'},'Wei\xDF 70% Transparenz')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Buttons:  Gelb: 245/229/152'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Suchleiste & Fill-In-Formular-Hintergrund: Grau 200/200/200'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-4'},'Schriften:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-1'},'Header: Open Sans Condensed 40px Wei\xDF')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'Navi: Open Sans Condensed 20px Gelb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-5'},'Titel_01: open sans 40px Blau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert ParaOverride-3'},'Titel_02: open sans 30px Blau'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-6'},'Titel_03: Open Sans Bold 20px')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'Titel_04: Open Sans Condensed 18px'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-7'},'Text-01 (Untertitel-01): Open Sans bold 14px blau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-2'},'Text-02: Open Sans Regular 14px'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert ParaOverride-4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Link: Open Sans SemiBold '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-9'},'14px blau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-10'},'Kontaktformular Open Sans Light 10px ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Titel_01'},'FAQ-Titel_01: Open Sans Condensed 8pt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text'},'FAQ-Text: Open Sans Regular 7pt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Button '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2'},'open sans Bold ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-11'},'14px blau'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Ayacandas ist ein Online-Austausch-Marktplatz f\xFCr IT-L\xF6sungen im Gesundheitswesen.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Suche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},'Suchen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},'Finden'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},'Inspirieren lassen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Fill-In-Text'},'      ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-12'},' I  '),'    ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Suchanregungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Entlassmanagement')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Verordnungsmanagement')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'OH KIS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Datenschutz')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'DSGVO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Baurecht '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Wei-eFl-chen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Aktuelles')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Aktuelles_fmt.png',alt:'Icon_Aktuelles.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_SUCHANREGUNGEN_fmt.png',alt:'Icon_SUCHANREGUNGEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Suche_fmt.png',alt:'Icon_Suche.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Anbieten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},' Registrieren'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},'Publizieren'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},'Verkaufen lassen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-5'},'Login/Registrierung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Informatives')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Anbieten_fmt.png',alt:'Icon_Anbieten.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Informatives_fmt.png',alt:'Icon_Informatives.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'Suchen'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Hier k\xF6nnen Sie nach Begriffen \xFCber den Marktplatz hinweg suchen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text-01--Untertitel-01-'},'Mehrere Begriffe k\xF6nnen durch Leerzeichen getrennt eingegeben werden. Produkte, die alle Begriffe in Titel oder Beschreibung enthalten, werden gefunden. Foren k\xF6nnen nur lokal im jeweiligen Forum durchsucht werden.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-15'},' I '),'     ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Suche filtern nach Typ  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Angebote aus dem Gesundheitswesen  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Angebote von Firmen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Angebote von Personen Dienstleistung '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Software '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Gebraucht-Software '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Dokumente '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Software Forschung & Lehre '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Hardware '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-6'},'Ausschreibung  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Suchergebnisse')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Wei-eFl-chen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Integrated Care Manager (ICM) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/14595.png',alt:'14595.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Eingeklappte Beschreibung der Suchergebnisse mit maximal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'zwei Spalten Text, am Ende steht an logischer Stelle ein...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Typ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt.png',alt:'Icon_DOKUMENTE.png'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Integrated Care Manager (ICM) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/14743.png',alt:'14743.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ausgeklappte Beschreibung der Suchergebnisse mit maximal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'sechs Spalten Text der logisch beendet wird. Die genaue ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Produktbeschreibung gibt es dann auf der jweiligen Produktseite ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'- zu errreichen \xFCber den \u201EZum Angebot\u201C-Button.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Typ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt1.png',alt:'Icon_DOKUMENTE.png'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Wei-eFl-chen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Integrated Care Manager (ICM) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/26301.png',alt:'26301.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Eingeklappte Beschreibung der Suchergebnisse mit maximal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'zwei Spalten Text, am Ende steht an logischer Stelle ein...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Typ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt2.png',alt:'Icon_DOKUMENTE.png'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon__MitarbeitendeGesundheitswesen_fmt.png',alt:'Icon__MitarbeitendeGesundheitswesen.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_Herstellende_fmt.png',alt:'Icon_Herstellende.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_PRIVATperson_fmt.png',alt:'Icon_PRIVATperson.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_dienstleistungen_fmt.png',alt:'Icon_dienstleistungen.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_SOFTWARE_fmt.png',alt:'Icon_SOFTWARE.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_GEBRAUCHSTSOFTWARE_fmt.png',alt:'Icon_GEBRAUCHSTSOFTWARE.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt3.png',alt:'Icon_DOKUMENTE.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_LEHRE%2bFORSCHUNG_fmt.png',alt:'Icon_LEHRE%2bFORSCHUNG.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-6',src:'ayacandas_210318-web-resources/image/Icon_Hardware_fmt.png',alt:'Icon_Hardware.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-6',src:'ayacandas_210318-web-resources/image/Icon_Ausschreibung_fmt.png',alt:'Icon_Ausschreibung.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt1.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt2.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt3.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt4.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt5.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt6.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt7.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt8.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt9.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Filter zur\xFCcksetzen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Angebot')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Angebot')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Angebot')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/868.png',alt:'868.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'Suchen'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Produkt Produktname ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Typ ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt4.png',alt:'Icon_DOKUMENTE.png'})),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen oder andere L\xF6sung finden')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Bewertung            ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(123)  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Preis ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'XX,XX \u20AC'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Hier steht die ausf\xFChrliche Beschreibung des ausgew\xE4hlten Produktes. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Gliederung wie gehabt: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Inhalt des Dokumentes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ja, Name des Gesellschaft '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Links'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'https://www.lda.bayern.de/de/datenschutz_eu.html')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Tags'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Datenschutz, DSGVO , IT-Sicherheit, BDSG(neu), Gesetz')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Zielgruppe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Krankenh\xE4user, Kliniken, Reha'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Besonderheiten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Online'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Bisherige Verwendung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'KRankenhaus-IT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Vorlage bei der DFG oder einer Wirtschaftspr\xFCfungsgesellschaft'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ja, Name des Gesellschaft '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Erfolgreiche Begutachtung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Hier steht dann der Name des Gutachtenden')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Beschreibung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-ohne-HG'},'Bookmark')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zur\xFCck zu den Suchergebnissen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Produktforum')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt10.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'Reviews'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'Medien'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Anbietende kontaktieren')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Angebot anfordern')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Produkt kaufen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'Suchen'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Produkt Produktname ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Typ ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt5.png',alt:'Icon_DOKUMENTE.png'})),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen oder andere L\xF6sung finden')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Bewertung            ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(123)  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Preis ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'XX,XX \u20AC'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Ihre Bewertung f\xFCr das Produkt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Bemerkungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-19'},'    |')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-8'},'Bewertung abschicken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Alle Bewertungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Bewertung vom: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'12.03.2018 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25847.png',alt:'25847.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25848.png',alt:'25848.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25849.png',alt:'25849.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25850.png',alt:'25850.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25851.png',alt:'25851.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-9'},'Bemerkung: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Bewertung vom: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'10.03.2018 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25840.png',alt:'25840.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25841.png',alt:'25841.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25842.png',alt:'25842.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25843.png',alt:'25843.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25844.png',alt:'25844.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-9'},'Bemerkung: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Bewertung vom: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'08.02.2018 ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25855.png',alt:'25855.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25856.png',alt:'25856.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25857.png',alt:'25857.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25858.png',alt:'25858.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-8',src:'ayacandas_210318-web-resources/image/25859.png',alt:'25859.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-9'},'Bemerkung: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. Hier die Bemerkung rein. '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'Beschreibung'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-ohne-HG'},'Bookmark')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zur\xFCck zu den Suchergebnissen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Produktforum')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt11.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'Reviews')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'Medien'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Anbietende kontaktieren')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Angebot anfordern')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Produkt kaufen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'Suchen'),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Produkt: Integrated Care Manager (ICM) ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Typ ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt6.png',alt:'Icon_DOKUMENTE.png'})),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen oder andere L\xF6sung finden')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Bewertung            ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(123)  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-7'},'Preis ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'XX,XX \u20AC'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Dokumentation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Beschreibende Bilder oder Screenshots'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Videos')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'Beschreibung'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-ohne-HG'},'Bookmark')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zur\xFCck zu den Suchergebnissen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Produktforum')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt12.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'Reviews'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'Medien')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Anbietende kontaktieren')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Angebot anfordern')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Produkt kaufen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Aktuelles'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Forum zu Name des Produktes hier rein')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Wei-eFl-chen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Thema XXXXX'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/25186.png',alt:'25186.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Eingeklappter Forumstext mit maximal  zwei Spalten Text, ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'am Ende steht an logischer Stelle ein...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Autor*in ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'KWI')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Integrated Care Manager (ICM) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/25172.png',alt:'25172.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ausgeklappter Forumstext mit maximal sechs Spalten Text der logisch beendet wird. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Autor*in ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'KWI'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zur\xFCck')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Neues Thema erstellen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi ParaOverride-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Registrierung/Login'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Login')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Name/Mailadresse              '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-7'},'Login ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_LOGIN_fmt.png',alt:'Icon_LOGIN.png'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Registrierung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-11'},'als Privatperson')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_PRIVATperson_fmt1.png',alt:'Icon_PRIVATperson.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-11'},'als Mitarbeitende ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'im Gesundheitswesen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon__MitarbeitendeGesundheitswesen_fmt1.png',alt:'Icon__MitarbeitendeGesundheitswesen.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Passwort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-7'},'Passwort vergessen?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-11'},'als Herstellende')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Herstellende_fmt1.png',alt:'Icon_Herstellende.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi ParaOverride-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Registrierung/Login'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Registrierung als Privatperson')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Allgemeine Angaben'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Vorname'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Nutzername'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Passwort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Passowrt-Best\xE4tigung  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Unternehmen (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Firma'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Abteilung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Adresse (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Stra\xDFe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Hausnummer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Adresszusatz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'PLZ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Ort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-21'},'Land ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'L-nderauswahl'},'Deutschland'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-7',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt13.png',alt:'Icon_HAKEN.png'})),' Ich oder meine Organisation leben nicht ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'prim\xE4r vom Handel mit Produkten '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-7'},'Registrieren')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi ParaOverride-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Registrierung/Login'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Registrierung als Mitarbeitende im Gesundheitswesen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Allgemeine Angaben'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Vorname'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Nutzername'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Passwort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Passowrt-Best\xE4tigung  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Unternehmen (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Firma'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Abteilung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Adresse (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Stra\xDFe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Hausnummer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Adresszusatz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'PLZ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Ort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-21'},'Land ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'L-nderauswahl'},'Deutschland'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-7'},'Registrieren')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi ParaOverride-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Registrierung/Login'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Registrierung als Herstellende')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Allgemeine Angaben'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Vorname'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Email'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Nutzername'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Passwort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Passowrt-Best\xE4tigung  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Unternehmen (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Firma'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Abteilung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Adresse (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Stra\xDFe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Hausnummer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Adresszusatz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'PLZ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Ort'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-21'},'Land ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'L-nderauswahl'},'Deutschland'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-7'},'Registrieren')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},'   ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'Meine Daten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Meine Daten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Nutzername  Mailadresse Mail aktiviert '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Vorname Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Eingeloggt als Firma'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Abteilung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Adresse '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand'},'Adresszusatz Land')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-7'},'Daten  und Passwort bearbeiten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'MMF')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'MartinaMusterfrau@Mustermail.de')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'Martina Musterfrau')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'Privatperson')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'Musterkrankenhaus')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'Musterabteilung'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'Stra\xDFe Nr.  PLZ Ort/Stadt')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'VH, 3.OG')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'Deutschland'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-5',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt14.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-9',src:'ayacandas_210318-web-resources/image/Icon_PRIVATperson_fmt2.png',alt:'Icon_PRIVATperson.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},'   ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'Meine Daten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Meine Daten bearbeiten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Allgemeine Angaben'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Martina'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Musterfrau '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'MartinaMusterfrau@Mustermail.de'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'MMF'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Unternehmen (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Musterkrankenhaus'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Musterbteilung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-2'},'Adresse (Freiwillige Angaben)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Mustergasse'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'15 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'VH 3.OG'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'10997'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Musterstadt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG ParaOverride-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-21'},'Land ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'L-nderauswahl'},'Deutschland'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'Passwort \xE4ndern'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Altes Passwort eingeben '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Neues Passwort eingeben'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'login-reg'},'Neues Passwort wiederholen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Abschicken')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},' Anbieten '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Willkommen auf Ihrer Produkt-Seite. Hier k\xF6nnen Sie Dokumente, Dienstleistungen und vieles mehr anbieten.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Dienstleistung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Software'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Gebraucht-Software'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Ausschreibung ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Meine bisherigen Angebote',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'   Name Typ Preis Ver\xF6ffentlicht'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Produktname'),' Dokument XX,XX,- xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt.png',alt:'Icon_bearbeiten.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'(= Link zum Produkt)'),' Dokument XX,XX,- xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt1.png',alt:'Icon_bearbeiten.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Produktname'),' Dokument XX,XX,- xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt2.png',alt:'Icon_bearbeiten.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Produktname '),' Dokument XX,XX,- xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt3.png',alt:'Icon_bearbeiten.png'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Meine bisherigen K\xE4ufe',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'   Name Typ Preis Gekauft am'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Produktname'),' Dokument XX,XX,- xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt4.png',alt:'Icon_bearbeiten.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'(= Link zum Produkt)'),' Dokument XX,XX,- xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt5.png',alt:'Icon_bearbeiten.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Produktname'),' Dokument XX,XX,- xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt6.png',alt:'Icon_bearbeiten.png'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Bookmarks',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-2'},'   Name Typ  Gesucht am'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Produktname hier'),' Dokument  xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt7.png',alt:'Icon_bearbeiten.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'(= Link zur Suche)'),' Dokument  xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt8.png',alt:'Icon_bearbeiten.png'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Produktname'),' Dokument  xx.xx.xxxx ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-10',src:'ayacandas_210318-web-resources/image/Icon_bearbeiten_fmt9.png',alt:'Icon_bearbeiten.png'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_dienstleistungen_fmt1.png',alt:'Icon_dienstleistungen.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_SOFTWARE_fmt1.png',alt:'Icon_SOFTWARE.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_GEBRAUCHSTSOFTWARE_fmt1.png',alt:'Icon_GEBRAUCHSTSOFTWARE.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-11',src:'ayacandas_210318-web-resources/image/Icon_Ausschreibung_fmt1.png',alt:'Icon_Ausschreibung.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Dokumente'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Software ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Forschung & Lehre',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Hardware')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt7.png',alt:'Icon_DOKUMENTE.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_LEHRE%2bFORSCHUNG_fmt1.png',alt:'Icon_LEHRE%2bFORSCHUNG.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-12',src:'ayacandas_210318-web-resources/image/Icon_Hardware_fmt1.png',alt:'Icon_Hardware.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},' Anbieten '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Anbieten einer Dienstleistung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-11'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Preis auffindbar.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Produktitel ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(Was bieten Sie an?)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular ParaOverride-13'},'|'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Kategorien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Informations- und Kommunikationstechnologien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'(IT, IKT) f\xFCr Praxen und Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Datenschutzverordnungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Preisangabe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche-geteilt ParaOverride-13'},'EUR Preis von   EUR Preis bis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Beschreibung des Produktes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Dienstleistungs- oder Firmenprofil als PDF-Datei  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Spezialisierungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe der Produktspezialiserungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe ihrer Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'B\xFCrgen als Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-15'},'Verf\xFCgbare Referenzen Ausgew\xE4hlte Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'AiDKlinik\xAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'arztkonsultation.de'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'ClipMed '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Cyber-Defense IT-Sicherheit '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Healthcare X.0 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'iMedOne\xAE Krankenhaus-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Informationssystem '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Internet Proxy-Server '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Stichworte '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Max. 7 Tags, durch Komma getrennt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Produkt hochladen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Geb\xFChr f\xFCrs Einstellen dieses Produkts oder Dienstleistung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'0,00 EUR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Einverst\xE4ndnis-Erkl\xE4rung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe die anfallenden Geb\xFChren zum Einstellen zur Kenntnis genommen und m\xF6chte meinen Eintrag kostenpflichtig ver\xF6ffentlichen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt15.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt16.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Speichern und Ver\xF6ffentlichen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'F\xFCr sp\xE4ter speichern'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},' Anbieten '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Anbieten eines Dokuments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-11'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Preis auffindbar.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Produktitel ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(Was bieten Sie an?)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular ParaOverride-13'},'|'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Kategorien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Informations- und Kommunikationstechnologien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'(IT, IKT) f\xFCr Praxen und Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Datenschutzverordnungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Preisangabe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche-geteilt ParaOverride-13'},'EUR Preis von   EUR Preis bis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Beschreibung des Produktes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Dienstleistungs- oder Firmenprofil als PDF-Datei  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Spezialisierungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe der Produktspezialiserungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe ihrer Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'B\xFCrgen als Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-15'},'Verf\xFCgbare Referenzen Ausgew\xE4hlte Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'AiDKlinik\xAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'arztkonsultation.de'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'ClipMed '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Cyber-Defense IT-Sicherheit '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Healthcare X.0 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'iMedOne\xAE Krankenhaus-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Informationssystem '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Internet Proxy-Server '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Stichworte '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Max. 7 Tags, durch Komma getrennt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Produkt hochladen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Geb\xFChr f\xFCrs Einstellen dieses Produkts oder Dienstleistung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'0,00 EUR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Einverst\xE4ndnis-Erkl\xE4rung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe die anfallenden Geb\xFChren zum Einstellen zur Kenntnis genommen und m\xF6chte meinen Eintrag kostenpflichtig ver\xF6ffentlichen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt17.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt18.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Speichern und Ver\xF6ffentlichen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'F\xFCr sp\xE4ter speichern'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},' Anbieten '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Anbieten einer Software'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-11'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Preis auffindbar.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Produktitel ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(Was bieten Sie an?)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular ParaOverride-13'},'|'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Kategorien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Informations- und Kommunikationstechnologien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'(IT, IKT) f\xFCr Praxen und Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Datenschutzverordnungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Preisangabe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche-geteilt ParaOverride-13'},'EUR Preis von   EUR Preis bis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Beschreibung des Produktes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Dienstleistungs- oder Firmenprofil als PDF-Datei  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Spezialisierungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe der Produktspezialiserungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe ihrer Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'B\xFCrgen als Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-15'},'Verf\xFCgbare Referenzen Ausgew\xE4hlte Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'AiDKlinik\xAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'arztkonsultation.de'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'ClipMed '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Cyber-Defense IT-Sicherheit '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Healthcare X.0 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'iMedOne\xAE Krankenhaus-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Informationssystem '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Internet Proxy-Server '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Stichworte '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Max. 7 Tags, durch Komma getrennt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Produkt hochladen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Geb\xFChr f\xFCrs Einstellen dieses Produkts oder Dienstleistung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'0,00 EUR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Einverst\xE4ndnis-Erkl\xE4rung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe die anfallenden Geb\xFChren zum Einstellen zur Kenntnis genommen und m\xF6chte meinen Eintrag kostenpflichtig ver\xF6ffentlichen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt19.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt20.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Speichern und Ver\xF6ffentlichen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'F\xFCr sp\xE4ter speichern'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},' Anbieten '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Anbieten einer Software f\xFCr ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Forschung und Lehre'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-11'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Preis auffindbar.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Produktitel ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(Was bieten Sie an?)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular ParaOverride-13'},'|'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Kategorien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Informations- und Kommunikationstechnologien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'(IT, IKT) f\xFCr Praxen und Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Datenschutzverordnungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Preisangabe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche-geteilt ParaOverride-13'},'EUR Preis von   EUR Preis bis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Beschreibung des Produktes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Dienstleistungs- oder Firmenprofil als PDF-Datei  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Spezialisierungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe der Produktspezialiserungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe ihrer Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'B\xFCrgen als Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-15'},'Verf\xFCgbare Referenzen Ausgew\xE4hlte Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'AiDKlinik\xAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'arztkonsultation.de'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'ClipMed '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Cyber-Defense IT-Sicherheit '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Healthcare X.0 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'iMedOne\xAE Krankenhaus-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Informationssystem '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Internet Proxy-Server '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Stichworte '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Max. 7 Tags, durch Komma getrennt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Produkt hochladen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Geb\xFChr f\xFCrs Einstellen dieses Produkts oder Dienstleistung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'0,00 EUR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Einverst\xE4ndnis-Erkl\xE4rung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe die anfallenden Geb\xFChren zum Einstellen zur Kenntnis genommen und m\xF6chte meinen Eintrag kostenpflichtig ver\xF6ffentlichen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt21.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt22.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Speichern und Ver\xF6ffentlichen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'F\xFCr sp\xE4ter speichern'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},' Anbieten '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Anbieten einer Gebrauchtsoftware '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-11'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Preis auffindbar.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Produktitel ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(Was bieten Sie an?)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular ParaOverride-13'},'|'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Kategorien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Informations- und Kommunikationstechnologien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'(IT, IKT) f\xFCr Praxen und Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Datenschutzverordnungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Preisangabe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche-geteilt ParaOverride-13'},'EUR Preis von   EUR Preis bis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Beschreibung des Produktes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Dienstleistungs- oder Firmenprofil als PDF-Datei  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Spezialisierungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe der Produktspezialiserungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe ihrer Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'B\xFCrgen als Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-15'},'Verf\xFCgbare Referenzen Ausgew\xE4hlte Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'AiDKlinik\xAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'arztkonsultation.de'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'ClipMed '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Cyber-Defense IT-Sicherheit '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Healthcare X.0 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'iMedOne\xAE Krankenhaus-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Informationssystem '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Internet Proxy-Server '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Stichworte '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Max. 7 Tags, durch Komma getrennt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Produkt hochladen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Geb\xFChr f\xFCrs Einstellen dieses Produkts oder Dienstleistung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'0,00 EUR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Einverst\xE4ndnis-Erkl\xE4rung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe die anfallenden Geb\xFChren zum Einstellen zur Kenntnis genommen und m\xF6chte meinen Eintrag kostenpflichtig ver\xF6ffentlichen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt23.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt24.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Speichern und Ver\xF6ffentlichen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'F\xFCr sp\xE4ter speichern'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},' Anbieten '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Anbieten von Hardware und Sonstigem '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-11'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Preis auffindbar.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Produktitel ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'d\xFCnn'},'(Was bieten Sie an?)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular ParaOverride-13'},'|'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Kategorien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Informations- und Kommunikationstechnologien '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'(IT, IKT) f\xFCr Praxen und Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-13'},'Datenschutzverordnungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Kategoriensuche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Preisangabe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche-geteilt ParaOverride-13'},'EUR Preis von   EUR Preis bis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Beschreibung des Produktes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Dienstleistungs- oder Firmenprofil als PDF-Datei  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Spezialisierungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe der Produktspezialiserungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Angabe ihrer Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'B\xFCrgen als Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04 ParaOverride-15'},'Verf\xFCgbare Referenzen Ausgew\xE4hlte Referenzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'AiDKlinik\xAE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'arztkonsultation.de'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'ClipMed '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Cyber-Defense IT-Sicherheit '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Healthcare X.0 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'iMedOne\xAE Krankenhaus-',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Informationssystem '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'FAQ-Text ParaOverride-15'},'Internet Proxy-Server '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Stichworte '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Kategoriensuche ParaOverride-13'},'Max. 7 Tags, durch Komma getrennt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-14'},'Produkt hochladen '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-13'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Datei hochladen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Geb\xFChr f\xFCrs Einstellen dieses Produkts oder Dienstleistung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},'0,00 EUR')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04_Links_Abstand ParaOverride-13'},'Einverst\xE4ndnis-Erkl\xE4rung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe die anfallenden Geb\xFChren zum Einstellen zur Kenntnis genommen und m\xF6chte meinen Eintrag kostenpflichtig ver\xF6ffentlichen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG ParaOverride-16'},'Ich habe den Einstellvertrag gelesen und akzeptiere diesen und stehe als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt25.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-14',src:'ayacandas_210318-web-resources/image/Icon_HAKEN_fmt26.png',alt:'Icon_HAKEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Speichern und Ver\xF6ffentlichen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'F\xFCr sp\xE4ter speichern'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'\xDCber Ayacandas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text-01--Untertitel-01-'},'Ayacandas ist ein gut sortierter Online-Marktplatz, auf dem Sie IT-L\xF6sungen f\xFCr das Gesundheitswesen auf einfachem Weg finden und Ihre eigenen Produkte risikolos anbieten k\xF6nnen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text-01--Untertitel-01-'},'Viele Krankenh\xE4user und andere Akteure im Gesundheitswesen entwickeln IT-L\xF6sungen und Formulare in denen viel Zeit, Herzblut, Energie und Geld steckt. Mitarbeitende im Gesundheitssystem suchen oft genau solche L\xF6sungen oder Dokumente. Doch diese sind meist schwer erh\xE4ltlich.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text-01--Untertitel-01-'},'Ayacandas bietet einen sicheren Weg IT-L\xF6sungen von ausgezeichneten Kliniken und ausgew\xE4hlte Produkten von Drittanbietern zu finden und stellt dar\xFCber hinaus Foren zum Wissens- und Erfahrungsaustausch zur Verf\xFCgung.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'Kontakt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Fett'},'T'),'   +49 211 54 76 16 0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Fett'},'F'),'   +49 211-54 76 16 01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Fett'},'M'),'   Kontak@ayacandas.com')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'Kontaktformular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular'},'Vorname'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular'},'Mailadresse'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular'},'Betreff'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular ParaOverride-17'},'Nachricht')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'Danksagung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Die Software, die diesem Marktplatz zugrunde liegt, wurde vollst\xE4ndig neu entwickelt von der Firma m-creations, Acker 2, 55116 Mainz, www.m-creations.com unter ihren Gesch\xE4ftsf\xFChrern Kambiz Darabi und Frank Pacholak.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ihnen und dem Team der m-creations m\xF6chte ich hier f\xFCr Ihre st\xE4ndige tatkr\xE4ftige Unterst\xFCtzung explizit danken. Eine technisch komplexe Entwicklung ist nur mit wenigen Firmen m\xF6glich, denn diese braucht nicht nur Vertrauen, sondern auch ein gutes gegenseitiges Verst\xE4ndnis Die Software ist')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'Datenschutzverordnung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Die Software, die diesem Marktplatz zugrunde liegt, wurde vollst\xE4ndig neu entwickelt von der Firma m-creations, Acker 2, 55116 Mainz, www.m-creations.com unter ihren Gesch\xE4ftsf\xFChrern Kambiz Darabi und Frank Pacholak.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ihnen und dem Team der m-creations m\xF6chte ich hier f\xFCr Ihre st\xE4ndige tatkr\xE4ftige Unterst\xFCtzung explizit danken. Eine technisch komplexe Entwicklung ist nur mit wenigen Firmen m\xF6glic')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'Impressum'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Scrollbar??'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'zugleich Anbieterkennung im Sinne von \xA7\xA7 5 TMG, 55 RStV'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ayacandas GmbH'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'In der Aue 9'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'40591 D\xFCsseldorf'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'vertreten durch ihren Gesch\xE4ftsf\xFChrer:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Dr. Stefan Walther'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'E-Mail: walther[at]ayacandas.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ihnen und dem Team der m-creations m\xF6chte ich hier f\xFCr Ihre st\xE4ndige tatkr\xE4ftige Unterst\xFCtzung explizit danken. Eine technisch komplexe Entwicklung ist nur mit wenigen Firmen m\xF6glich, denn diese braucht nicht nur Vertrauen, sondern auch ein gutes gegenseitiges Verst\xE4ndnis Die Software ist eine der wenigen \u2013 falls nicht die einzige - Multi-Vendor-Marktpl\xE4tze, deren Code komplett in europ\xE4ischer Hand liegt. Ihnen und dem Team der m-creations m\xF6chte ich hier f\xFCr Ihre st\xE4ndige tatkr\xE4ftige Unterst\xFCtzung explizit danken. Eine technisch komplexe Entwicklung ist nur mit tt in europ\xE4ischer Hand liegt. Ihnen und dem Team der m-creations m\xF6chte ich hier f\xFCr Ihre st\xE4ndige tatkr\xE4ftige Unterst\xFCtzung explizit danken. Eine technisch komplexe Entwicklung ist nur mit ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'Gesch\xE4ftsf\xFChrung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'Dr. Stefan Max Walther '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Fett'},'T'),'   +49 211 54 76 16 0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Fett'},'F'),'   +49 211-54 76 16 01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Fett'},'M '),'  Walther@ayacandas.com')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'kontaktformular'},'Nachname  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Hier finden Sie aktuelle Hinweise zu den Produkten, zu Sicherheit und Datenschutz sowie Empfehlungen der Redaktion')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Empfehlungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Kurze und Knappe Titel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'vielleicht sowas wie')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Gesetze und Verordnungen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Studien')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Formulare')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'weitere Empfehlungen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Aktuelles '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},'It-Sicherheit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},'Empfehlungen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Empfehlungen_fmt.png',alt:'Icon_Empfehlungen.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'IT-Sicherheit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Kurze und Knappe Titel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Organisatorische Unterst\xFCtzung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Datenschutz ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Abrechnung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'weitere Hinweise'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_SICHERHEIT_fmt.png',alt:'Icon_SICHERHEIT.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Aktuelles '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'It-Sicherheit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},'Empfehlungen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Aktuelle gesetzliche Anforderungen ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'2017/2018 - Legislative Anforderungen an die Krankenhaus-IT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'2017/2018 - Legislative Anforderungen an die Krankenhaus-IT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'2017/2018 - Legislative Anforderungen an die Krankenhaus-IT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'1. Organisatorische Unterst\xFCtzung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'2. Datenschutz & IT-Sicherheit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'3. Abrechnung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'1. Organisatorische Unterst\xFCtzung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'1.1. Vorbereitung Krankenhaus-Arztnummer (ab 2020)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'K\xFCnftig lebenslange Arztnummer auch f\xFCr \xC4rzte im Krankenhaus (KANR)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'keine Doppelvergabe mit LANR (XOR)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'1.1.1. RS214-17_Gesetz zur Fortschreibung der Vorschriften f\xFCr Blut- und Gewebezubereitungen und zur \xC4nderung anderer Vorschriften.pdf'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'1.2. Personaluntergrenzen in der Pflege'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},' Nachweispflichten f\xFCr Personal IT-technisch zu unterst\xFCtzen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'1.1. Meldung Krankenhausstandorte nach \xA7 2a Abs. 1 KHG i.V.m. \xA7 293 Abs. 6 SGB V (ab Mitte 2018)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'2017/2018 - Legislative Anforderungen an die Krankenhaus-IT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'2017/2018 - Legislative Anforderungen an die Krankenhaus-IT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_03_Einzug'},'2017/2018 - Legislative Anforderungen an die Krankenhaus-IT'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'1. Organisatorische Unterst\xFCtzung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'2. Datenschutz & IT-Sicherheit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02-LINKS_EINZUG_AUFZ-HLUNG'},'3. Abrechnung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'  Aktuelles '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},'It-Sicherheit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-14'},'Empfehlungen')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Wir k\xF6nnen Ihnen folgende Produkte und Verweise besonders empfehlen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Wei-eFl-chen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Integrated Care Manager (ICM) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/27680.png',alt:'27680.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Eingeklappte Beschreibung der Suchergebnisse mit maximal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'zwei Spalten Text, am Ende steht an logischer Stelle ein...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Typ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt8.png',alt:'Icon_DOKUMENTE.png'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Integrated Care Manager (ICM) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/27667.png',alt:'27667.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Ausgeklappte Beschreibung der Suchergebnisse mit maximal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'sechs Spalten Text der logisch beendet wird. Die genaue ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Produktbeschreibung gibt es dann auf der jweiligen Produktseite ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'- zu errreichen \xFCber den \u201EZum Angebot\u201C-Button.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Typ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt9.png',alt:'Icon_DOKUMENTE.png'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Wei-eFl-chen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Integrated Care Manager (ICM) '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen _idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-3',src:'ayacandas_210318-web-resources/image/27694.png',alt:'27694.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Eingeklappte Beschreibung der Suchergebnisse mit maximal ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'zwei Spalten Text, am Ende steht an logischer Stelle ein...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Typ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-16'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-4',src:'ayacandas_210318-web-resources/image/Icon_DOKUMENTE_fmt10.png',alt:'Icon_DOKUMENTE.png'})),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Dokument ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_04'},'Kategorie ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'Link CharOverride-8'},'Europ. DSGVO | Bitte abk\xFCrzen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Angebot')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Angebot')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot'},'Zum Angebot')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Responsive navi geschlossen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-15',src:'ayacandas_210318-web-resources/image/Header_fmt.png',alt:'Header.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-16',src:'ayacandas_210318-web-resources/image/1358_fmt.png',alt:'1358.jpg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Responsive navi ge\xF6ffnet'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Text_02_LINKS_EINZUG'},'Hintergrund Ayacandas Blau 70 % Transparenz')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Grafikrahmen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-15',src:'ayacandas_210318-web-resources/image/Header_fmt1.png',alt:'Header.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-17',src:'ayacandas_210318-web-resources/image/1358_fmt1.png',alt:'1358.jpg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'AYACANDAS    ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'DER AUSTAUSCH-MARKTPLATZ F\xDCR KLINIKEN'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'AYACANDAS    ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-23'},'DER AUSTAUSCH-MARKTPLATZ F\xDCR KLINIKEN'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_01_Links'},'Ayacandas ist ein Online-Austausch-Marktplatz f\xFCr IT-L\xF6sungen im Gesundheitswesen.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Suche'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Fill-In-Text'},'      ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-12'},' I  '),'    ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Suchanregungen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Wei-eFl-chen'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Aktuelles')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-24'},'Suchen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-25'},'Anbieten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-24'},'Aktuelles')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi ParaOverride-18'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-24'},'It-Sicherheit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi ParaOverride-18'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-24'},'Empfehlungen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-24'},'Meine Daten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'navi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{'class':'CharOverride-24'},'Logout '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Aktuelles_fmt1.png',alt:'Icon_Aktuelles.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_SUCHANREGUNGEN_fmt1.png',alt:'Icon_SUCHANREGUNGEN.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Suche_fmt1.png',alt:'Icon_Suche.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},'Anbieten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Button-Zum-Angebot ParaOverride-5'},' Login/Registrierung')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'Einfacher-Textrahmen'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{'class':'Titel_02-Zentriert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Informatives')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Anbieten_fmt1.png',alt:'Icon_Anbieten.png'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'_idGenPageitem-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{'class':'_idGenPageitem-1',src:'ayacandas_210318-web-resources/image/Icon_Informatives_fmt1.png',alt:'Icon_Informatives.png'}))));}}]);return Test;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductList; });
/* unused harmony export Bookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_list_css__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_list_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__product_list_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resource_service_png__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__resource_service_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__resource_service_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_softwareforschung_png__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_softwareforschung_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__resource_softwareforschung_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resource_tender_png__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__resource_tender_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__resource_tender_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resource_doc_png__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resource_doc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__resource_doc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resource_gb_png__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__resource_gb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__resource_gb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__resource_software_png__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__resource_software_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__resource_software_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__resource_hardware_png__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__resource_hardware_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__resource_hardware_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductList=[{content:"Nur einige Beispiele: <ul><li>Software-Module im Bereich Ihres KIS </li><li>Erweiterungen  Ihres Zentralsystems  mit weiteren Funktionen </li><li>Im System  vorher nicht  vorhandene  Auswertungen,  die Sie oder die für  Sie geschrieben wurden </li><li>Datenschutz-Regelungen und -Umsetzungspapiere </li><li>Vorlagen</li><li>erfolgreiche  oder erfolglose  Anträge (z.B. Großgeräte-Anträge) <Leistungsverzeichnisse</li><li>Strategiepapiere </li><li>Verträge jeglicher Art </li><li>SOPs </li><li>SLAs </li><li>Dienstanweisungen </li><li>Personalratsvorlagen</li><li>nützliche Links </li><li>sinnvolles aus Ministerien, BMG </li><li>Gesetzesvorlagen,  Verordnungen </li><li>Fragebögen </li><li>Excel-Sheets </li><li>Präsentationen und Vorträge </li><li>Outplacement-Verträge</li><li>geschickte Trennungsrechnungs-Konzepte  Skripte</li><li>Hilfen Ihrer Mannschaft  an andere, die Sie als Dienstleistung  anbieten können.</li></ul>",title:"Was Sie einstellen können?",key:"0"},{content:"Ein Weiterverkauf innerhalb der meisten Förderprogramme ist unproblematisch, da er den Förderzweck nicht entfremdet. Ein Weiterverkauf verstößt somit <u>nicht</u> gegen die Bedingungen des Förderbescheids. Eine Mehrwerterschaffung sollte jedoch von der jeweiligen  Klinik an das zuständige Ministerium gemeldet werden.<br /><br />Das Anbieten ist unkritisch, sofern vom ursprünglichen Förderbescheid kein Geld entwendet oder veräußert wird und nicht gegen die Begutachtungslinie der DFG gehandelt wird. In diesem Zusammenhang darf nur Eigenleistung verkauft werden.",title:"Gibt es Probleme, wenn das Produkt mit der Hilfe von Förderbescheiden entwickelt wurde?",key:"1"},{content:"Einnahmen gehen, falls Sie nicht als Privatperson verkaufen, oft nicht an Sie, sondern an die Institution, in deren Namen Sie verkaufen. Solche Einnahmen können Sie Sich im Rahmen des Controllings als eigene Einnahmen durch Verrechnung gutschreiben lassen. ",title:"Was habe ich davon, wenn ich für meine Institution etwas verkaufe - das Geld gehört doch dann weder mir noch meiner Abteilung?",key:"2"},{content:"Wenn Sie als nicht-kommerzieller Nutzer ein Produkt anbieten, wird Ayacandas wesentliche Punkte für Sie übernehmen.",title:"Was ist mit dem Thema Haftung und Gewährleistung beim Einstellen von Produkten?",key:"3"}];var info={"dienstleistung":"• Hilfen Ihres Personals an andere, die Sie als Dienstleistung anbieten \n• Dienstleistungen von Anbietern\n• Strategie-Beraterinnen und -Berater als Anbieter-Börse ohne Provision (Eigenvermittlung)\n• Fachberaterinnen und -berater als Anbieter-Börse ohne Provision\n• Fachberatung in sehr speziellen Gebieten (diese werden hier im Marktplatz sichtbar und suchbar)","dokument":"• Dienstanweisungen\n• Datenschutz-Regelungen und -Umsetzungspapiere\n• Vorstands-Vorlagen\n• Erfolgreiche oder erfolglose Anträge (z.B. Großgeräte-Anträge)\n• Strategie-Papiere\n• Verträge jeglicher Art\n• SOPs\n• SLAs\n• Personalratsvorlagen\n• Nützliche Links\n• Gesetzesvorlagen, Verordnungen\n• Fragebögen\n• Präsentationen und Vorträge\n• Geschickte Trennungsrechnungs-Konzepte\n• Skripte\n• Im System vorher nicht vorhandene Auswertungen, die Sie oder die für Sie geschrieben wurden\n• Sinnvolles aus Ministerien (z.B. Landesministerien, BMG)\n• Outplacement-Veträge","software":"• Software - Module im Bereich Ihres KIS\n• Im Klinikum erstellte Masken oder Maskenfolgen für klinische Spezialbereiche\n• Sinnvolle und nützliche Skripte oder Automatisierungen jeglicher Art\n• Excel-Sheets, die sich bei Ihnen bewährt haben\n• Word- oder Excel-Vorlagen, die für besondere Einsatzzwecke auch für andere nützlich sein können\n• Window-Administrative Skripte für den Kliniksbereich, die man sonst nicht finden kann\n• Software im Bereich von Kliniken, die man nicht als OpenSource freigeben möchte oder darf, die man  jedoch mit geringem Aufwand kostenpflichtig verkaufen möchte.","softwareFUndL":"• Erweiterung Ihres KIS mit Funktionen, die Sie speziell für Forschungsbereiche implementiert haben\n• Software, die Sie für Studien geschrieben oder verändert haben\n• Software, die Sie für das Erhöhen von Studienteilnehmer-Zahlen eingebaut haben\n• Software für das Verwalten von Studierenden-Anforderungen","gebrauchtSoftware":"• Ungenutzte Lizenzen - zum Beispiel nach einem Anbieterwechsel (Sprachdiktat-Software)\n• Microsoft Lizenzen, z.B. nach einer Umstellung des Lizenzmodells\n• Sprachdiktat-Lizensen nach einem Anbieter-Wechsel\n• Datenbank-Lizenzen nach einem Architektur-Wechsel","sonstiges":"• Gebrauchte Server nach einem Architektur-Wechsel\n• Gebrauchte Altserver, die noch für reduzierte Zwecke verwendbar sind\n• ältere, aber noch nutzbare PCs\n• Thin Client-Endgeräte nach einem Anbieterwechsel"};var ProductList=function(_Component){_inherits(ProductList,_Component);function ProductList(){_classCallCheck(this,ProductList);return _possibleConstructorReturn(this,(ProductList.__proto__||Object.getPrototypeOf(ProductList)).apply(this,arguments));}_createClass(ProductList,[{key:'render',value:function render(){var _this2=this;if(__WEBPACK_IMPORTED_MODULE_4__util_js__["e" /* isGuestUser */]()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'F\xFCr nicht eingeloggte Nutzer ist die Seite nicht sichtbar.'))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Willkommen auf Ihrer Produkt-Seite. Hier k\xF6nnen Sie Dokumente, Dienstleistungen und vieles mehr anbieten.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListTiles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDownOneTile center pointer',title:info.dienstleistung,onClick:function onClick(event){return _this2.props.history.push("/create-service");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__resource_service_png___default.a,alt:'Dienstleistung'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Dienstleistung'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDownOneTile center pointer',title:info.dokument,onClick:function onClick(event){return _this2.props.history.push("/create-document");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__resource_doc_png___default.a,alt:'Dokumente'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Dokumente'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDownOneTile center pointer',title:info.software,onClick:function onClick(event){return _this2.props.history.push("/create-software");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_11__resource_software_png___default.a,alt:'Software'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Software'))),!__WEBPACK_IMPORTED_MODULE_4__util_js__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDownOneTile center  pointer',title:info.softwareFUndL,onClick:function onClick(event){return _this2.props.history.push("/create-researchsoftware");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__resource_softwareforschung_png___default.a,alt:'Software Forschung & Lehre'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Software Forschung & Lehre'))),!__WEBPACK_IMPORTED_MODULE_4__util_js__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDownOneTile center pointer',title:info.gebrauchtSoftware,onClick:function onClick(event){return _this2.props.history.push("/create-used-software");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__resource_gb_png___default.a,alt:'Gebraucht-Software'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Gebraucht-Software'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDownOneTile center pointer',title:info.sonstiges,onClick:function onClick(event){return _this2.props.history.push("/create-other");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__resource_hardware_png___default.a,alt:'sonstige Angebote'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Hardware und sonstige Angebote'))),!__WEBPACK_IMPORTED_MODULE_4__util_js__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDownOneTile center pointer',onClick:function onClick(event){return _this2.props.history.push("/create-tender");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__resource_tender_png___default.a,alt:'Ausschreibung'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Ausschreibung')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDown Bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListTabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Meine bisherigen Angebote'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OldProductList,{history:this.props.history})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productListTileDown Bold marginTop50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListTabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bookmark,{history:this.props.history})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqProductList}));}}}]);return ProductList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var OldProductList=function(_Component2){_inherits(OldProductList,_Component2);function OldProductList(props){_classCallCheck(this,OldProductList);var _this3=_possibleConstructorReturn(this,(OldProductList.__proto__||Object.getPrototypeOf(OldProductList)).call(this,props));_this3.getUsersProducts=_this3.getUsersProducts.bind(_this3);_this3.onDeleteProduct=_this3.onDeleteProduct.bind(_this3);_this3.onViewDetails=_this3.onViewDetails.bind(_this3);_this3.onViewDocumentDetails=_this3.onViewDocumentDetails.bind(_this3);_this3.onUpdate=_this3.onUpdate.bind(_this3);_this3.onUpdateDocument=_this3.onUpdateDocument.bind(_this3);_this3.onDeleteDocument=_this3.onDeleteDocument.bind(_this3);_this3.onDeleteResearchsoftware=_this3.onDeleteResearchsoftware.bind(_this3);_this3.onUpdateResearchsoftware=_this3.onUpdateResearchsoftware.bind(_this3);_this3.onViewResearchsoftwareDetails=_this3.onViewResearchsoftwareDetails.bind(_this3);_this3.onUpdateNewService=_this3.onUpdateNewService.bind(_this3);_this3.onUpdateTender=_this3.onUpdateTender.bind(_this3);_this3.onDeleteTender=_this3.onDeleteTender.bind(_this3);_this3.onViewTenderDetails=_this3.onViewTenderDetails.bind(_this3);_this3.onDeleteNewService=_this3.onDeleteNewService.bind(_this3);_this3.onViewNewServiceDetails=_this3.onViewNewServiceDetails.bind(_this3);_this3.onUpdateNewSoftware=_this3.onUpdateNewSoftware.bind(_this3);_this3.onDeleteNewSoftware=_this3.onDeleteNewSoftware.bind(_this3);_this3.onViewNewSoftwareDetails=_this3.onViewNewSoftwareDetails.bind(_this3);_this3.onDeleteUsedSoftware=_this3.onDeleteUsedSoftware.bind(_this3);_this3.onUpdateUsedSoftware=_this3.onUpdateUsedSoftware.bind(_this3);_this3.onViewUsedSoftwareDetails=_this3.onViewUsedSoftwareDetails.bind(_this3);_this3.onDeleteOther=_this3.onDeleteOther.bind(_this3);_this3.onUpdateOther=_this3.onUpdateOther.bind(_this3);_this3.onViewOtherDetails=_this3.onViewOtherDetails.bind(_this3);_this3.state={products:[]};_this3.getUsersProducts();return _this3;}_createClass(OldProductList,[{key:'getUsersProducts',value:function getUsersProducts(){var self=this;var url='/api/products-by-user';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.ok?response.json():null;}).catch(function(exception){console.error('Could not load users products.',exception);});promise.then(function(json){if(json===null){self.setState({products:[]});return;}var products=JSON.parse(json[3][1]).map(function(obj,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:obj.name,description:obj.description,published:obj.published,type:obj.type,key:obj.id,id:obj.id,order:i,owner:obj.owner,onUpdate:self.onUpdate,onDeleteProduct:self.onDeleteProduct,onViewDetails:self.onViewDetails});});var lengthSoFar=products.length;var documents=json[4][1];for(var i=0;i<documents.length;i++){var _doc=documents[i];products.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:_doc.name,type:'Dokument',key:'document'+_doc.id,id:_doc.id,published:_doc.published,onUpdate:self.onUpdateDocument,owner:true,onDeleteProduct:self.onDeleteDocument,order:lengthSoFar+i,onViewDetails:self.onViewDocumentDetails}));}lengthSoFar=lengthSoFar+documents.length;var researchsoftwares=json[5][1];for(var _i=0;_i<researchsoftwares.length;_i++){var ressoft=researchsoftwares[_i];products.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:ressoft.name,type:'Software F+L',key:'reseachsoftware'+ressoft.id,id:ressoft.id,published:ressoft.published,onUpdate:self.onUpdateResearchsoftware,owner:true,onDeleteProduct:self.onDeleteResearchsoftware,order:lengthSoFar+_i,onViewDetails:self.onViewResearchsoftwareDetails}));}lengthSoFar=lengthSoFar+researchsoftwares.length;var serviceList=json[6][1];for(var _i2=0;_i2<serviceList.length;_i2++){var _service=serviceList[_i2];products.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:_service.name,type:'Dienstleistung',key:'service'+_service.id,id:_service.id,published:_service.published,onUpdate:self.onUpdateNewService,owner:true,onDeleteProduct:self.onDeleteNewService,order:lengthSoFar+_i2,onViewDetails:self.onViewNewServiceDetails}));}lengthSoFar=lengthSoFar+serviceList.length;var tenderList=json[7][1];for(var _i3=0;_i3<tenderList.length;_i3++){var _tender=tenderList[_i3];products.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:_tender.name,type:'Ausschreibung',key:'tender'+_tender.id,id:_tender.id,published:_tender.published,onUpdate:self.onUpdateTender,owner:true,onDeleteProduct:self.onDeleteTender,order:lengthSoFar+_i3,onViewDetails:self.onViewTenderDetails}));}lengthSoFar=lengthSoFar+tenderList.length;var softwareList=json[8][1];for(var _i4=0;_i4<softwareList.length;_i4++){var _software=softwareList[_i4];products.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:_software.name,type:'Software',key:'software'+_software.id,id:_software.id,published:_software.published,onUpdate:self.onUpdateNewSoftware,owner:true,onDeleteProduct:self.onDeleteNewSoftware,order:lengthSoFar+_i4,onViewDetails:self.onViewNewSoftwareDetails}));}lengthSoFar=lengthSoFar+softwareList.length;var usedsoftwareList=json[9][1];for(var _i5=0;_i5<usedsoftwareList.length;_i5++){var usedsoft=usedsoftwareList[_i5];products.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:usedsoft.name,type:'Gebrauchtsoftware',key:'usedsoftware'+usedsoft.id,id:usedsoft.id,published:usedsoft.published,onUpdate:self.onUpdateUsedSoftware,owner:true,onDeleteProduct:self.onDeleteUsedSoftware,order:lengthSoFar+_i5,onViewDetails:self.onViewUsedSoftwareDetails}));}lengthSoFar=lengthSoFar+usedsoftwareList.length;var otherList=json[10][1];for(var _i6=0;_i6<otherList.length;_i6++){var other=otherList[_i6];products.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsRow,{name:other.name,type:'Hardware und sonstige Angebote',key:'other'+other.id,id:other.id,published:other.published,onUpdate:self.onUpdateOther,owner:true,onDeleteProduct:self.onDeleteOther,order:lengthSoFar+_i6,onViewDetails:self.onViewOtherDetails}));}lengthSoFar=lengthSoFar+otherList.length;self.setState({products:products});});}},{key:'onDeleteProduct',value:function onDeleteProduct(productID){if(window.confirm('Möchten Sie Ihr Produkt wirklich löschen?')){var self=this;var url='/api/delete-product';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var promise=fetch(url,{method:'POST',headers:headers,body:'id='+productID}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not delete product.',exception);});promise.then(function(json){self.getUsersProducts();});return;}}},{key:'onViewDetails',value:function onViewDetails(productID){this.props.history.push('/product-details/'+productID);return;}},{key:'onViewDocumentDetails',value:function onViewDocumentDetails(productID){this.props.history.push('/document-details/'+productID);return;}},{key:'onViewResearchsoftwareDetails',value:function onViewResearchsoftwareDetails(productID){this.props.history.push('/researchsoftware-details/'+productID);return;}},{key:'onViewNewServiceDetails',value:function onViewNewServiceDetails(productID){this.props.history.push('/show-service/'+productID);return;}},{key:'onViewTenderDetails',value:function onViewTenderDetails(productID){this.props.history.push('/show-tender/'+productID);}},{key:'onViewNewSoftwareDetails',value:function onViewNewSoftwareDetails(productID){this.props.history.push('/show-software/'+productID);return;}},{key:'onViewUsedSoftwareDetails',value:function onViewUsedSoftwareDetails(productID){this.props.history.push('/show-used-software/'+productID);return;}},{key:'onViewOtherDetails',value:function onViewOtherDetails(productID){this.props.history.push('/show-other/'+productID);return;}},{key:'onUpdate',value:function onUpdate(productID,productType){var url=productType==='Software'?'software':'services';this.props.history.push('/'+url+'/'+productID+'/edit');return;}},{key:'onUpdateDocument',value:function onUpdateDocument(id){this.props.history.push('/update-document/'+id);}},{key:'onUpdateResearchsoftware',value:function onUpdateResearchsoftware(id){this.props.history.push('/update-researchsoftware/'+id);}},{key:'onUpdateNewService',value:function onUpdateNewService(id){this.props.history.push('/update-service/'+id);}},{key:'onUpdateTender',value:function onUpdateTender(id){this.props.history.push('/update-tender/'+id);}},{key:'onUpdateNewSoftware',value:function onUpdateNewSoftware(id){this.props.history.push('/update-software/'+id);}},{key:'onUpdateUsedSoftware',value:function onUpdateUsedSoftware(id){this.props.history.push('/update-used-software/'+id);}},{key:'onUpdateOther',value:function onUpdateOther(id){this.props.history.push('/update-other/'+id);}},{key:'onDeleteDocument',value:function onDeleteDocument(id){var _this4=this;if(window.confirm("Möchte Sie ihr Produkt wirklich löschen?")){var url='/api/delete-document';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(resp){return resp.json();}).then(function(json){return _this4.getUsersProducts();});}}},{key:'onDeleteResearchsoftware',value:function onDeleteResearchsoftware(id){var _this5=this;if(window.confirm("Möchte Sie ihr Produkt wirklich löschen?")){var url='/api/delete-researchsoftware';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(resp){return resp.json();}).then(function(json){return _this5.getUsersProducts();});}}},{key:'onDeleteNewService',value:function onDeleteNewService(id){var _this6=this;if(window.confirm("Möchte Sie ihr Produkt wirklich löschen?")){var url='/api/new-delete-service';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(resp){return resp.json();}).then(function(json){return _this6.getUsersProducts();});}}},{key:'onDeleteTender',value:function onDeleteTender(id){var _this7=this;if(window.confirm("Möchte Sie ihr Produkt wirklich löschen?")){var url='/api/delete-tender';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(resp){return resp.json();}).then(function(json){return _this7.getUsersProducts();});}}},{key:'onDeleteNewSoftware',value:function onDeleteNewSoftware(id){var _this8=this;if(window.confirm("Möchte Sie ihr Produkt wirklich löschen?")){var url='/api/new-delete-software';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(resp){return resp.json();}).then(function(json){return _this8.getUsersProducts();});}}},{key:'onDeleteUsedSoftware',value:function onDeleteUsedSoftware(id){var _this9=this;if(window.confirm("Möchte Sie ihr Produkt wirklich löschen?")){var url='/api/delete-used-software';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(resp){return resp.json();}).then(function(json){return _this9.getUsersProducts();});}}},{key:'onDeleteOther',value:function onDeleteOther(id){var _this10=this;if(window.confirm("Möchte Sie ihr Produkt wirklich löschen?")){var url='/api/delete-other-product';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(resp){return resp.json();}).then(function(json){return _this10.getUsersProducts();});}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsList,{products:this.state.products,history:this.props.history}));}}]);return OldProductList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductsList=function(_Component3){_inherits(ProductsList,_Component3);function ProductsList(){_classCallCheck(this,ProductsList);return _possibleConstructorReturn(this,(ProductsList.__proto__||Object.getPrototypeOf(ProductsList)).apply(this,arguments));}_createClass(ProductsList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductsList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductsHeader,null),this.props.products);}}]);return ProductsList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductsHeader=function(_Component4){_inherits(ProductsHeader,_Component4);function ProductsHeader(){_classCallCheck(this,ProductsHeader);return _possibleConstructorReturn(this,(ProductsHeader.__proto__||Object.getPrototypeOf(ProductsHeader)).apply(this,arguments));}_createClass(ProductsHeader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductsHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderText,{text:'Name'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderText,{text:'ver\xF6ffentlicht'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderText,{text:'Typ'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderButton,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderButton,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderButton,null));}}]);return ProductsHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductsRow=function(_Component5){_inherits(ProductsRow,_Component5);function ProductsRow(){_classCallCheck(this,ProductsRow);return _possibleConstructorReturn(this,(ProductsRow.__proto__||Object.getPrototypeOf(ProductsRow)).apply(this,arguments));}_createClass(ProductsRow,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductsRow',title:this.props.description},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowTextName,{text:this.props.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowText,{text:this.props.published===true?'ja':'nein'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowText,{text:this.props.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowButton,{text:'Ansicht',id:this.props.id,job:'viewDetails',onViewDetails:this.props.onViewDetails}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowButton,{text:'\xE4ndern',disabled:this.props.owner!==true,id:this.props.id,job:'update',onUpdate:this.props.onUpdate,type:this.props.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowButton,{text:'l\xF6schen',disabled:this.props.owner!==true,id:this.props.id,job:'delete',onDeleteProduct:this.props.onDeleteProduct}));}}]);return ProductsRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var HeaderText=function(_Component6){_inherits(HeaderText,_Component6);function HeaderText(){_classCallCheck(this,HeaderText);return _possibleConstructorReturn(this,(HeaderText.__proto__||Object.getPrototypeOf(HeaderText)).apply(this,arguments));}_createClass(HeaderText,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HeaderText openSans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.text));}}]);return HeaderText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var RowText=function(_Component7){_inherits(RowText,_Component7);function RowText(){_classCallCheck(this,RowText);return _possibleConstructorReturn(this,(RowText.__proto__||Object.getPrototypeOf(RowText)).apply(this,arguments));}_createClass(RowText,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RowText openSans ProductListBorder'},this.props.text);}}]);return RowText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* Add row TextBlue just to have blue for names in table.*/var RowTextName=function(_Component8){_inherits(RowTextName,_Component8);function RowTextName(){_classCallCheck(this,RowTextName);return _possibleConstructorReturn(this,(RowTextName.__proto__||Object.getPrototypeOf(RowTextName)).apply(this,arguments));}_createClass(RowTextName,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RowText RowTextBlue openSans ProductListBorder'},this.props.text);}}]);return RowTextName;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var HeaderButton=function(_Component9){_inherits(HeaderButton,_Component9);function HeaderButton(){_classCallCheck(this,HeaderButton);return _possibleConstructorReturn(this,(HeaderButton.__proto__||Object.getPrototypeOf(HeaderButton)).apply(this,arguments));}_createClass(HeaderButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HeaderButton'});}}]);return HeaderButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var RowButton=function(_Component10){_inherits(RowButton,_Component10);function RowButton(props){_classCallCheck(this,RowButton);var _this18=_possibleConstructorReturn(this,(RowButton.__proto__||Object.getPrototypeOf(RowButton)).call(this,props));_this18.onClick=_this18.onClick.bind(_this18);return _this18;}_createClass(RowButton,[{key:'onClick',value:function onClick(event){switch(this.props.job){case'viewDetails':this.props.onViewDetails(this.props.id);break;case'delete':this.props.onDeleteProduct(this.props.id);break;case'update':this.props.onUpdate(this.props.id,this.props.type);break;default:console.error("RowButton: Slipped unexpectedlty through switch-case.");}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.disabled===true?"button disabled margin2":"BookmarkRowButton",onClick:this.onClick},this.props.text);}}]);return RowButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Old and some new Bookmark code follows
var BookmarkHeaderButton=function(_Component11){_inherits(BookmarkHeaderButton,_Component11);function BookmarkHeaderButton(){_classCallCheck(this,BookmarkHeaderButton);return _possibleConstructorReturn(this,(BookmarkHeaderButton.__proto__||Object.getPrototypeOf(BookmarkHeaderButton)).apply(this,arguments));}_createClass(BookmarkHeaderButton,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BookmarkHeaderButton'});}}]);return BookmarkHeaderButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BookmarkRowText=function(_Component12){_inherits(BookmarkRowText,_Component12);function BookmarkRowText(){_classCallCheck(this,BookmarkRowText);return _possibleConstructorReturn(this,(BookmarkRowText.__proto__||Object.getPrototypeOf(BookmarkRowText)).apply(this,arguments));}_createClass(BookmarkRowText,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RowText openSans ProductListBorder'},this.props.text);}}]);return BookmarkRowText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Add this new component identical to BookmarkRowText just to
// have the names in blue color.
var BookmarkRowTextName=function(_Component13){_inherits(BookmarkRowTextName,_Component13);function BookmarkRowTextName(){_classCallCheck(this,BookmarkRowTextName);return _possibleConstructorReturn(this,(BookmarkRowTextName.__proto__||Object.getPrototypeOf(BookmarkRowTextName)).apply(this,arguments));}_createClass(BookmarkRowTextName,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'RowText RowTextBlue openSans ProductListBorder'},this.props.text);}}]);return BookmarkRowTextName;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BookmarkHeaderText=function(_Component14){_inherits(BookmarkHeaderText,_Component14);function BookmarkHeaderText(){_classCallCheck(this,BookmarkHeaderText);return _possibleConstructorReturn(this,(BookmarkHeaderText.__proto__||Object.getPrototypeOf(BookmarkHeaderText)).apply(this,arguments));}_createClass(BookmarkHeaderText,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'HeaderText openSans'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.text));}}]);return BookmarkHeaderText;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BookmarksHeader=function(_Component15){_inherits(BookmarksHeader,_Component15);function BookmarksHeader(){_classCallCheck(this,BookmarksHeader);return _possibleConstructorReturn(this,(BookmarksHeader.__proto__||Object.getPrototypeOf(BookmarksHeader)).apply(this,arguments));}_createClass(BookmarksHeader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductsHeader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkHeaderText,{text:'Name'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkHeaderText,{text:'Typ'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkHeaderButton,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkHeaderButton,null));}}]);return BookmarksHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BookmarkRowButton=function(_Component16){_inherits(BookmarkRowButton,_Component16);function BookmarkRowButton(props){_classCallCheck(this,BookmarkRowButton);var _this24=_possibleConstructorReturn(this,(BookmarkRowButton.__proto__||Object.getPrototypeOf(BookmarkRowButton)).call(this,props));_this24.onClick=_this24.onClick.bind(_this24);return _this24;}_createClass(BookmarkRowButton,[{key:'onClick',value:function onClick(event){switch(this.props.job){case'viewDetails':this.props.onViewDetails(this.props.type,this.props.id);break;case'remove':this.props.onRemoveBookmark(this.props.id,this.props.type);break;default:console.error("RowButton: Slipped unexpectedlty through switch-case.");}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.disabled===true?"RowButton disabled":"BookmarkRowButton",onClick:this.onClick},this.props.text);}}]);return BookmarkRowButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var BookmarkProductsRow=function(_Component17){_inherits(BookmarkProductsRow,_Component17);function BookmarkProductsRow(props){_classCallCheck(this,BookmarkProductsRow);var _this25=_possibleConstructorReturn(this,(BookmarkProductsRow.__proto__||Object.getPrototypeOf(BookmarkProductsRow)).call(this,props));_this25.translateTypeIntoGerman=_this25.translateTypeIntoGerman.bind(_this25);return _this25;}_createClass(BookmarkProductsRow,[{key:'translateTypeIntoGerman',value:function translateTypeIntoGerman(type){switch(type){case"document":return'Dokument';case"software":return'Software';case"service":return"Dienstleistung";case"tender":return"Ausschreibung";case"used_software":return"Gebrauchtsoftware";case"research_software":return"Software F+L";case"service old":return"Dienstleistung Alt";case"software old":return"Software Alt";case"other":return"Hardware und sonstige Angebote";default:return"Unbekannter Produkttyp";}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductsRow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkRowTextName,{text:this.props.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkRowText,{text:this.translateTypeIntoGerman(this.props.type)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkRowButton,{text:'Ansicht',id:this.props.id,type:this.props.type,job:'viewDetails',onViewDetails:this.props.onViewDetails}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkRowButton,{text:'Entfernen',id:this.props.id,type:this.props.type,job:'remove',onRemoveBookmark:this.props.onRemoveBookmark}));}}]);return BookmarkProductsRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Bookmark=function(_Component18){_inherits(Bookmark,_Component18);function Bookmark(props){_classCallCheck(this,Bookmark);var _this26=_possibleConstructorReturn(this,(Bookmark.__proto__||Object.getPrototypeOf(Bookmark)).call(this,props));_this26.onViewDetails=_this26.onViewDetails.bind(_this26);_this26.onRemoveBookmark=_this26.onRemoveBookmark.bind(_this26);_this26.getBookmarkedProducts=_this26.getBookmarkedProducts.bind(_this26);_this26.state={bookmarkList:[]};return _this26;}_createClass(Bookmark,[{key:'componentWillMount',value:function componentWillMount(){this.getBookmarkedProducts();}},{key:'onViewDetails',value:function onViewDetails(type,id){switch(type){case"document":this.props.history.push('/document-details/'+id);return;case"software":this.props.history.push('/show-software/'+id);return;case"service":this.props.history.push('/show-service/'+id);return;case"tender":this.props.history.push('/show-tender/'+id);return;case"used_software":this.props.history.push('/show-used-software/'+id);return;case"research_software":this.props.history.push('/researchsoftware-details/'+id);return;case"other":this.props.history.push('/show-other/'+id);return;default:this.props.history.push('/product-details/'+id);return;}}},{key:'onRemoveBookmark',value:function onRemoveBookmark(productID,productType){if(window.confirm('Möchten Sie das Produkt aus der Bookmarkliste entfernen?')){var self=this;var url='/api/remove-bookmark';var headers=Object(__WEBPACK_IMPORTED_MODULE_5__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var promise=fetch(url,{method:'POST',headers:headers,body:'id='+productID+'&type='+productType}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not delete product.',exception);});promise.then(function(json){self.getBookmarkedProducts();});return;}}},{key:'getBookmarkedProducts',value:function getBookmarkedProducts(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util_js__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var url='/api/get-bookmarks';var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.ok?response.json():null;}).catch(function(exception){console.error('Could not retrieve bookmarked products!',exception);});promise.then(function(json){self.setState({bookmarkList:json||[]});});}},{key:'render',value:function render(){var _this27=this;var items=this.state.bookmarkList.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarkProductsRow,{name:item.name,type:item.type,id:item.id,order:i,onViewDetails:_this27.onViewDetails,onRemoveBookmark:_this27.onRemoveBookmark});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductListTabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Bookmarks'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductsList'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BookmarksHeader,null),items));}}]);return Bookmark;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// Old Bookmarks code ends

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAABcRAAAXEQHKJvM/AAAFV0lEQVRYR81Xe1BUZRSHVdNQDAFBCVgls6kGtaYmCQdz0h5OM46RU/GQh64or2V5Liz74CkBsyCvAQkMkFdIyEspFGhihuhl/OFoNsCIzRSGDZqUyLJf51z2bvduq1+hzO2P39y93znfOb/vvO63FoQQi/8rqApCgqogJKgKQoKqICSoCkKCqiAkqApCgqogJKgKQoKqICSoCkKCqiAkqApCgqogJMwtWtI2LQDM+uS93NXpFnHfb9+ZXjk1Pb2chzscmMrMyU11De9o28S3yCy5yak/jMwVDe1L9mQfl3qp8s5tis28+Xx81vhCYHPs0ZseityBt3PKUwKLa1az/ofHJyx55G78PsWwVtS3b3E+nDz2yPtSssI/hjwWELugsN4fQ5aCLytf2e2s0927zUWOIdY0cMH98RDFNG4QH1ES1yNKvavhCevE8WAicYKnK19m/L32UBJZI0kkLnNrsxw5EYeqZnHv6gNy4gR6YpP9tkHxZH2YmlT2DHgZiIl4NbdNlfflMt8oNMRsRAPoyD44gawLVekgDZfdwtWTqwLjCJIVhyr1uI6kbQLiyNNRaVfdYzKG0RGSQBl7SDwwZIS8KM++CDZu2YANF3hHGwbyemvIFMh+6bt4xYqX1tovvt5j5RfNGGBPhMTwlJvjjvb6F1a7JtS0LvIrqFq+I6WgAZ2icSQBdTkTcrzBO6CoWiQprRNJT5x69QV59qQDyDCCDgfl5PWM4i55bauzurET5Va7M0tK8NAuHH8I0bsRJLGuTcojV3CmT7XCP5qnjI7dYzKvF5ztszWtBc9k7fcYoVUAWVWzxlQeUdkksQtKIHZA4Ln4rJ8/G7pkbarzivrYBTvYzyW3zFdG9mkr2nnkiro+T8LQc8k5QLo8ldoyrkHYyNTCy8naeCS3LkytDy6p3YprsdUtovia00ynhZTVuzwZmXIDm2qH5tgZU2II79wP05A8l9xSnyiyXZ0/xiOX19GThjnnk2MiN2jO8BsZxVUrodvQeEx1i5+pXNt+3tM5JJlgbUGdfcWugz3jmNibU96IHcuLHJDzzi3v45Gr6hsMtvKT8RSx+7DuYLzIuI4/aO3e+4wsnelMjN6u9KIr+Z29jqw8qa7NEhyfR2JYw0hS1dgRxbWR3drt85Q0lZkAxo4GLHkvkhwub1DyyI2MTyx2C9dMYhqwywwdNIsNgemFpji5VZErhY4uxE5dI0li5KA7iyTg9/WXknJStim1iU+Ea37AiIoNXejEdLaKgKwDOj5qozS1wv5AAmMX97PdigeFw8y0DA65cckxoS7t7n8To4FFKv57k46dcexzLRBz5cwxHDm4hpF2OqSYi/hceRjGhHIWD4MNhuuoYyCsM9hg5ijWm6zqkwxuhHm1EnnilATrAMcAOuQM3QeB/l4yDAL6gS8EjptGDhdLI7mJW1PGQt1fVL3x2ej0VkjzlGGSz8wDdw3P+xBT6pAYZsNLnZ/P+h8dnzBePoxR+270J961JaziY7GktHb7hgiNB6TCAwz+F2wCvAa4Zo4Y1jWmGWs8+qPmSNbnt8NjvFsRL60PG0DksjlitobhuzOt6C1WN6+zx/yVaSEAzm0AP/JSiZ8ziBimsrJ3wIfVTWvuol82HybMkNNj19rC6JGU1u9j9VKazt7z5k11Ml9wyeGcw9sMjJk/d6YWbmF1YDrc9y8B1cl88aivzN5RkjiKxPC7vSut8Jq8rm0DK7/662/U/ypUJ/MFXK8WwwVyxOKdMLj1xo3U9X/DfOLWR2iopFhQFR4EZef6A4OKTzbmdfYy/xE+Hbr0r4khqArzhDkS/xgVNPwF3lzPC9u2A30AAAAASUVORK5CYII="

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAABcRAAAXEQHKJvM/AAAFQklEQVRYR81WeVCUZRhnbSomahIXuYRIcRArLf9wsmA0xlE7dMISQgkhBBbY3RaRaxd22eW25VhOcblZOVcOLQgr02iwc1AzqWCqCZxsxsqakak0fHuebw+/vfg+tObrj9/M7vf+3vf5vc/5OhFCnP6vYCRwCUYCl2AkcAlGApdgJHAJRgKXYCRwCUYCl2AkcAlGApdgJHAJRgKXYCRwCUYCl2AkcAlGAgvwWHBuC4wEa5y88I2NmJFzE4H6j8YFH0xMLbdeO/v9zG2LZyQgBIe77RrYml8T9WhqYZdz5P4/nHYJiWtMxu9+yQrdrrLGbfb4EZqWBQmddzFUrbU5bFNu5frtJfWax9OKz7vvyyJLAd6CbAKi5jzjZdR/n8Qc8sj+gvEdJfWqpIaeNfT9+X0jvKQG+5dlFHfw2LuLrL+ltvV7P6OszFqbVjS2DIQsjkknnvFS4pskJw/ZAYrDdeTB/zkQejpEWRWfqO12tz67ZPAdh0Idqk7XDbiEKCsjnkgvfn+lWHnDPS7LIAgMg8Gb9kRZgeJ4J2QT9Cju9xcp/9qUq+l7qbQhNKy86X42nrPwVJpuIGhzXtXhwJT8S3iw275M4pUgYytoPqE3UST/tQyC3g+Q5H0Lly/K6ji2jm5/+uerd1l4rqB/JAC8cwgO+MUbhLjFZlK3dRS2OwWGHS/uCmFHG4GS/Gn4Xihu7l1qFMYzi8s4MrgaPNWxQqSkPLUEbudjCN9/Bh/wHjoBBfqLldchWtWSlqP+DsN6oH3gwQhN8/YgefkgVN+fmGMYUh/2eeYIxvyTEQ840xiV37YW1LZE1+i2oO3c3iH+tsLaqt4z424WYc3TD9tUzMuljV6QvELIjS884VDoYQahgoV51BRCjIhvopxAgY3trmyJiaxq86TbC8opE3rESWdA5BILcXSImvU2rQSapzc01opVkrxJNISV5xU/f5GYeqDx/5fPFdXJxU3mnDJDpR+m7O1UaxNcolKvx9Z1mPuijTg6oJJcQt/QbqF/g80vQL97G8J+jQ854x4npTyDQtFLKBxDt+ZA0a+PpRb2QS4F0/c/nVO2GVqKnUg1KHhhIgKe28RKXHJjjy8aWilWkfVSdfUrFc0WhmJqj4g2yErfWy7MJSgUWsTfT8rUb4WVNYXRecLG3pCNCk0XehHy7Sp9TTf6KeW5ZwtrO51CE0lR/4m9rMRhaT8sVMxi9VJjCfIt4PW8CzvVDRmK7iHzkBdou1ZDzqhgrPndEq5bFV7RXAxjbhL7Gu73NKTCOXu21mWUnFwULiZR1e0lrMSJmnrdQdw1Y9ionoQVjKFEodAbR4LlFSmR1W3OhsvoFwfLy9NhXH2OQlypMSejCoGWj+et7byo1vKhnczeHSEhMD1a2YrzgNyaNYkztQUcYVi5CBS6Qpj7I4jSwwvliqmBo7dMfHqhwF4bcTndbzrDXhUvXNS342C9hJW46Np2L6+E7BsM7WMOXyV8oyi/ZMOocsSHdjFJt9H54Wf2Bv+tCTEfNmSXnoUSv5NGTO1BL2PYoCX1MNk0gZHQevpjmLuqUWwRpv6GYaWQJLeZv8ZXC/V9mSCHmN54WPVPZZcNj339nSuTTUZxn0z9wJu49JPZ5XDw89Ay2iD/pl1eTSX3AZz3pJB7AffsllBewd+4hv9xzRWqHAroKygq7d6a9o2msy7OXLZp9AsSZ8Kpi5MWOaEZOsWHRrlW2nk8EVqIIr6+MxMMd4WXN52JPdTRIes8Lt1T2apIaTkaXXdiNABevg/Q909dvsLqFcxKHA2sD/239v8DfWvaP0pvyjwAAAAASUVORK5CYII="

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAACXBIWXMAABcRAAAXEQHKJvM/AAAFYklEQVRYR8VXe1BUVRjfBcWyHEEWUMRHatkDHynNhJFpzaRZUAiKaATI+7nEYxd2eSwg+wB2WWphl7e8FiFmGKEaN7QcQsiBtAEKlSmcycYZHNMZcaqZ4vR9C3e9uy3cK+j0x+/ec8+95/t+9zvf63AIIZz/G/QHG6aPHyHMdBkvF8euGydF+i7b1zKVqldFxbedwtKJa5SYrJ6Ba6SYrIvNJm7RmWbzTHCNFBm/35oqG/dW6GSU4svjv9qaSExNTRkJtPZ9746Knzz2MdkQn3PjPZn21Lsyba23XFf/9glNg4+iQrtXUnp+3wlN2zvS8pMHpOX1bIDr9+So659LzBu3C+STlREZpLFnYMsMAa7JEr1XfnZ0BgLLg1MJKNw7mxlRQGZL11EW5raKQHWdNxLhHReSH67fWGSyBF4+KKzU2AQkkO6hK570Rcquc04Z+s4lOA4oqW1cfIRPxC2dO5mUzQVdd+9+jl8siapsKTAjsSEuh+wUKvotF8C2/AX7OIJj9IktKdIBHCfUfmZr+S0byDoMRvNvT5P1eQgVE3QS3GeAxHaBXI0TERV6k+ceVtVol4KPgG80413S/qUvk6LZ0Dk4bJL7PD+/zlNcPEknwXkhKZ+sihBV0RftECouhGmbU9ACSz9MJh7phb9R73Znq9eCf+xaG5PlMRfWRGd6wPrXi06ftafLtg9Ja9mdXXLXjAQww9AzkVgUkMjDKImsaEkGK5zk+MeRwNI6FfUeHRidy5EFQCF5EX6STgLmTzGSWBkhcnAIFRBwxjyt4Vu7PZLSM55ipQH+7m98H1PVyocwLfdR6FTTqKDB/PmNHHVlfE3bsYcm4Z5c4IQ5Y31cNnkpueAeJK+rOMYwpgt7GPRfG+dSY551EnlmJBAhZY3yZUEpTasiRU1gmSZY2Byh0ycwKWMDkDW3T/gWVXEtFyFiq1qtzs8Hs1jCfDsKT3fbbebnT6FfYP4HaxD74DQCYfULkwI2YLUdTwel8JzD08kusbIHQiwY8n4AhOggpu1pkmdtHEMFy8BRn5oLawCOoUKz8JwhYWU7koyWqKYmQYCDQ4iAhOv0EmrOX1ld6TTjmPg9hvBysA6G6wNYPqeSJ44mgQWVY3QSs0SHuSWQBC9MSCBjSqm5A1JtHRUdQZqGZiBlOKSq+YKOw1aeoYoaIFRNJXyGhDXHNCcB5lqBCp3DM+6uCBWcAXzuEpFxD7MnXdh8wRgdFPYXlLVCOr/1skA+gXg2MXciWNOoZVLABoyOebC46rG3eawsATWfu0MgH10fm/0POiFEB4Hxn5C+e5kUsAGrPAEFi4fhuJmfNwH+0AkVtmNTQu5tzBlMCmbD2M1bTGk7/z/RAcrJ8fKmTGrOr7haS0XHK+mFV7emSH+H5mSCCfAj99/M/aSbTohVAaNIQP3IouYOFlXpsHzjGIR+A4KGIJNeYgLklmHYRgMjCWxqXMIzTCSgGXWCZwId1ySQGQBBF8EnJhcSotduTpi2w8FKU8N1i8okXlklavoiMPkI+sDGBAkcASTGcweE7TkmZWwA8qqhJNynk+BADiBgsguWH8s7vloNdcIZ2jMXkb7TjUk4EzoHh4zhvy1NNgKNrqldNF4gvVZiG97Wf8kLnz/SNDyysm2Jmq/7/Dm+0SSxtp0qCVzji/M/ji2BFI3NLnkr71MfJkHzxb6CMr/FRxKNrQF9Ho6B04fT9u8uu2+Ml0ziR3C/AyE4AufHn+A+uiCkSke3pcqG18Vk/cE5FE+gdbwDujZRVjCSwAt1IEaAJQReWap+DFuICIIHo4UAZWDWhYa35/3CijhKDxwDHxyIaWZ57DWDBjOf+xc3RsO44ZyGNwAAAABJRU5ErkJggg=="

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAABcRAAAXEQHKJvM/AAADcUlEQVRIS2P4//8/Az0xQQXUxgQVUBsTVEBtTFABtTFBBdTGBBVQGxNUQG1MUAG1MS4JRkIaycF//v5lwim5/8ot3a6Nu3trVmyeC8QL6lZuWVBLBq5ctnHlpO0HKj58/cYNMpfhzacvjHFTFqd7tk3b4Ns5Y5lf54ylIb1zlitm178SS6l8BBSbGNg9q86zdVqjVxth7N02vRGk1qN1KohuCuqZnS2UWPZi35WbQWALbz1/paOUXf/asqpnh3VN727b2v7dINq4vHOTcUXXjvIlG0IIBRUh7Nw0afuJW/c9wRaevvPQ06a27wSIU7F0I3vp4vVslUs3soL4Het3hxuUtp+pXbFFEiiujQ+XAXHRwnW6KTOWaaw4eo4VZhlQzhZo/qIrj54pQyy8+9AJ6IKDuFwXPWnBVKCl5yyqeo4RwmaV3SeA+Fz9qm1NMP1Zc1YGONRPnH3z6UtRsIV3nr+SM63o2t69aa8fskXXH78gK6V2b9yjY1vXfwHGB0bNvKCeORNhfIbHb95LerROm1W4YK0zIcOIwWkzlikalXUeiJywQAnEd2uZsgaYkDrgFoIIYKps9Wib2oSumRycMHUxj2PDxMle7dNjJm8/wBrRP29t+ZKNoSgW+nbMyAZG7D4Qu3fzXrKCEoYrl23iAWaPjtQZyzyTpy/V82iZOnvqzkOqKBaG98/LAGaF04QMIxYH984JDeqePbFs8QZzy+qefUUL16qjWAjMBvrOjZOWpc1cbknIMHw4f/4acOhETpjvaFPbvzSga1ZmQPestchqwET18k3q9vUTgCXMXBdChhKDq5dvtrCrn7DYqrp3oX/nzKkgMWDiZIRbuOzIaQ6f9unrSxatryJkGDF40cGTnD4dM1ap5Td+zZu3OghZjuH9l29gm4Hx2ANUtBjEblq9nYmQofjwxtOX2JwaJx1QyW342LhmuyGKhTCGa/OUCmCJspSQYcRiYAot1yxoed6xYZciVguB4W5pV9d/UC6rtlAkqdxOMq3KG4xTcWB0OSBfAkhzRhf6qOc1GZlVdM0Dpou96A5B4dSv2hqsUdD8GFgufrWq6X0NxtU4MDY5oJglkDYo7fhmWtH9sH/rfnDptfvSDUYUC3//+QsXAKYmkVcfP8u8/PBJ6uXHz1JgGhvGJQcUf/7+owzQDEFsQQ0A2eBTM69MRM0AAAAASUVORK5CYII="

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABcRAAAXEQHKJvM/AAADaUlEQVRYR2P4//8/w2DCDP/+/WckpIhe+N///4xgxsbTl0J6N+9tnrrjUCW98cSt+2sW7D9R8ufvX1aQW8AO0i5q/cAQlPmfK6aI7pglIu+/aHLF/y8/fvLAHWRT23dXMKH0v0xGzX/5rNr/Cll1/+Uya/8B8X9aYHmg2co5DWC2RGrVf42C5i9ff/zkxnCQRGrlf/PK7jdahS1LpNNrVgE1rKY2lgVipZz6xda1fSdAnhdPqYQ46CeagwTiS/9LAl3r3zUrkFDiowZ2b5kqAQohuIOwhZA8MKrEUysdCBlGDQy0RxPooD+SuKJMAOggaBy7EzKMGhhojzYQ/4OnIYwoG3UQmoMGXZSNOmjIOWg0UQ85Bw26KEN3kCDUQdLp1XRxENAe4qJMLa/JgpBh1MDAWl5GNqPmD14HSaZV/XdomDiha+NuZmCTVrRl7Q6xVhBeB6Wx8ddh4eNht6/fKQZstnIE986JBzUIxVIqcDsI2Pz4AwzK/yA2CAvSCIPMBjVbQVGGtflhVtn9CilRg5uytMbA6ALbBYoVYDL5D3QQL9xBXm3Tj0Ad9AkJf4biT0j0J2B7+BOwefsZmAY+AEP0FVDsNQyD+MA08V4qreqzPJo+LGaBaWBD7bduceud7z9/scMdNG//cVaptGppoGvFgYpwYqAl4kB14sBolTCt6BKXSa8RA4rDMVBczLCsQxzYSZAAOlgc6EC85oEwMAqlgQHCCUvsIIKsjmLtii2awFC9BTT0AAzzxhXfy5q90oWQXhyYER5C5OCihWs9+OMR6Q6EgQ76nzRtSQ4hvfgwQQW4cO68VV7M4Xn/hZPK4ZgxLOd/7OSF+YT0UuyghQdPYY3WmEkLi1NmLEuC4aiJC0qBZYwANrWP37wnKmkQVHD+/hOwQY1rton4dsxoNSnvWu7dPn2pV9u0OUE9szsDu2f1wDCID5Sb5do8GSS/wq9zZm/s5EVqMLNuPH1J0FEEHQTCQMO3gPrhoEJMjvgu9j9YIQvsCb/deu6qNMisYzfv43UUQcfMP3BCUSW38Z9gQhkpjoFjUMEH8kzP5r2RIPOO3LhHmYOAXespoJERWJFPKgZ5hCks979STsMLQnYR5SBgOlgOLAQ/guo7crFVTe9L27r+k0nTl3AQsg+v5J+/fwkmQmpjADbd20eFxznOAAAAAElFTkSuQmCC"

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Contact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__product_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contact_us_css__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contact_us_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__contact_us_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqContact=[];var Contact=function(_Component){_inherits(Contact,_Component);function Contact(){_classCallCheck(this,Contact);return _possibleConstructorReturn(this,(Contact.__proto__||Object.getPrototypeOf(Contact)).apply(this,arguments));}_createClass(Contact,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'\xDCber Ayacandas'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2 contactHeader2'},'Ayacandas ist ein gut sortierter Online-Marktplatz, auf dem Sie IT-L\xF6sungen f\xFCr das Gesundheitswesen auf einfachem Weg finden und Ihre eigenen Produkte risikolos anbieten k\xF6nnen. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Viele Krankenh\xE4user und andere Akteure im Gesundheitswesen entwickeln IT- L\xF6sungen und Formulare in denen viel Zeit, Herzblut, Energie und Geld steckt. Mitarbeitende im Gesundheitssystem suchen oft genau solche L\xF6sungen oder Dokumente. Doch diese sind meist schwer erh\xE4ltlich. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ayacandas bietet einen sicheren Weg IT-L\xF6sungen von ausgezeichneten Kliniken und ausgew\xE4hlte Produkten von Drittanbietern zu finden und stellt dar\xFCber hinaus Foren zum Wissens- und Erfahrungsaustausch zur Verf\xFCgung.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactListTileDownRow marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'Kontakt'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactText marginTop10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'T\xA0'),' +49 211 54 76 16 0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'F\xA0'),' +49 211-54 76 16 01 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'M\xA0'),' Kontakt@ayacandas.com ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactOneTileContent margin-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'Gesch\xE4ftsf\xFChrung'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactText marginTop10'},'Dr. Stefan Max Walther',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'T\xA0'),' +49 211 54 76 16 0 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'F\xA0'),' +49 211-54 76 16 01 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'M\xA0'),' Walther@ayacandas.com ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactListTileDownColumn marginTop30 padding2',id:'contactform'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts marginTop10'},'Kontaktformular'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productRowInputs marginTop20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Vorname',className:'contactInputShort',name:'firstname',type:'text',required:true,onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Nachname',className:'contactInputShort',name:'lastname',type:'text',required:true,onChange:this.handleInputChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{placeholder:'Emailadresse',className:'contactInputLong',name:'email',type:'email',required:true,onChange:this.handleInputChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop20 contactCategory'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'openSans',name:'subject',required:true,onChange:this.handleInputChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{selected:true},'Kategorieanfrage'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Suchanfrage'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',null,'Sonstiges'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{placeholder:'Nachricht',className:'contactTextAreaLong',name:'message',required:true,onChange:this.handleInputChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ToEndRightV2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'submit',className:'buttonInput',value:'Abschicken'}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactListTileDownColumn marginTop30 padding2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'Danksagung'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',null,'Die Software, die diesem Marktplatz zugrunde liegt, wurde von der Firma m-creations vollst\xE4ndig neu entwickelt. (m-creations finden sie unter ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'noopener noreferrer',href:'http://www.m-creations.com'},' www.m-creations.com'),', Gesch\xE4ftsf\xFChrung: Kambiz Darabi und Frank Pacholak).',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ihnen und dem gesamten Team der m-creations m\xF6chte ich hier f\xFCr Ihre tatkr\xE4ftige Unterst\xFCtzung explizit danken. Eine technisch so komplexe Entwicklung wie die vorliegende Software ist nur mit wenigen Firmen m\xF6glich: Denn diese braucht nicht nur Vertrauen, sondern auch ein gutes gegenseitiges Verst\xE4ndnis.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Software ist eine der wenigen Multi-Vendor-Marktpl\xE4tze, deren Code komplett in europ\xE4ischer und deutscher Hand liegt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Software selbst ist Eigentum der Firma Sadnacaya GmbH & Co. KG in D\xFCsseldorf.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactListTileDownColumn marginTop30 padding2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Informationen nach Art. 246 \xA7 2 in Verbindung mit \xA7 1 Abs. 1 und 2 EGBGB und nach \xA7 312g Abs. 1 Satz 1 BGB in Verbindung mit Artikel 246 \xA7 3 EGBGB ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die AGBs der Firma Ayacandas k\xF6nnen Sie hier einsehen:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'AGBs'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Identit\xE4t des Unternehmens, ladungsf\xE4hige Anschrift, Vertretungsberechtigter, \xF6ffentliches Unternehmensregister, Registernummer, Herausgeber, Betreiber und verantwortlich f\xFCr den Inhalt der Website',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ayacandas GmbH',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In der Aue 9',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'40591 D\xFCsseldorf',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Fon: +49-211-547616-0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Fax: +49-211-547616-01',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'zentralmail@ayacandas.com',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Gesch\xE4ftsf\xFChrung',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ayacandas GmbH, vertreten durch den Gesch\xE4ftsf\xFChrer',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Dr. Stefan Max Walther',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Registergericht',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'D\xFCsseldorf HRB 79816, 07.02.2017',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Herausgeber, Betreiber und inhaltlich Verantwortlicher f\xFCr den Inhalt der Website im Sinne des \xA755 Abs.2 RStV',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Dr. Walther',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Umsatzsteuer-Identifikationsnummer',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'106/5775/5272',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Ayacandas GmbH hat eine Berufs- und Verm\xF6gensschadenhaftpflichversicherung abgeschlossen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Social-Media-Profile',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Dieses Impressum gilt auch f\xFCr die folgenden Social-Media-Profile:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'https://www.xing.com/profile/DrStefanMax_Walther',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'https://www.facebook.com/stefan.walther.5249',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'https://www.facebook.com/Ayacandas-17995145848288',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'https://twitter.com/Ayacandas',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Haftungsausschluss',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Haftung f\xFCr Inhalte',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Inhalte unserer Seiten wurden mit gr\xF6\xDFter Sorgfalt erstellt. F\xFCr die Richtigkeit, Vollst\xE4ndigkeit und Aktualit\xE4t der Inhalte k\xF6nnen wir jedoch keine Gew\xE4hr \xFCbernehmen. Als Diensteanbieter sind wir gem\xE4\xDF \xA77 Abs.1 TMG f\xFCr eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach \xA7\xA78 bis \xA7\xA710 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, \xFCbermittelte oder gespeicherte fremde Informationen zu \xFCberwachen oder nach Umst\xE4nden zu forschen, die auf eine rechtswidrige T\xE4tigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber\xFChrt. Eine diesbez\xFCgliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung m\xF6glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Haftung f\xFCr Links',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Unser Angebot enth\xE4lt Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k\xF6nnen wir f\xFCr diese fremden Inhalte auch keine Gew\xE4hr \xFCbernehmen. F\xFCr die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m\xF6gliche Rechtsverst\xF6\xDFe \xFCberpr\xFCft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Urheberrecht',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf\xE4ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au\xDFerhalb der Grenzen des Urheberrechtes bed\xFCrfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f\xFCr den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{title:'Per Klick die europ\xE4ische Datenschutzerkl\xE4rung als PDF runterladen.',href:'/DSGVO.pdf'},'Datenschutz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Mehr Informationen zum Datenschutz bei Ayacandas.com und dem Umgang mit Ihren personenbezogenen Daten finden Sie in unserer Datenschutzerkl\xE4rung.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Besondere Merkmale:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die wesentlichen Merkmale der Angebote des Marktplatzes k\xF6nnen Sie der Beschreibung der einzelnen im Marktplatz enthaltenen Produkte entnehmen. Der Vertrag kommt zustande, indem Sie nach Abschluss Ihres Bestellvorgangs Ihre Bestellung im Online-Shop absenden und wir den Eingang dieser Bestellung best\xE4tigen. Die einzelnen Schritte des Bestellvorgangs lauten: Produkt ausw\xE4hlen, zugeh\xF6rigen Vertrag am Ende der beschreibenden Seite ausdrucken, ausf\xFCllen und der Firma Ayacandas zusenden, zumailen oder zufaxen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Einzelheiten hinsichtlich der Zahlung',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Einzelheiten zu Liefer- und Versandzeitr\xE4umen und \u2013arten entnehmen Sie bitte dem Vertrag, den Sie bei einer Bestellung zu einzelnen Produkten zusenden. F\xFCr gew\xF6hnlich werden Bestellungen noch am gleichen Tage abgearbeitet. F\xFCr R\xFCckfragen oder Notwendigkeiten besteht die M\xF6glichkeit, anzurufen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Unsere Widerrufsbelehrung finden Sie hier.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Unsere Angaben zur Gew\xE4hrleistung und Garantiebedingungen finden Sie im Vertrag, den Sie bei einem gemeinsamen Gesch\xE4ft herunterladen und best\xE4tigen m\xFCssen. Der Vertrag kann nur in deutscher Sprache abgeschlossen werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Entgelte sind sofort nach Zugang einer durch die Firma Ayacandas ausgestellten Rechnung, die auch maschinell und ohne Unterschrift erstellt werden darf, f\xE4llig. Der Vertragspartner kommt in Verzug, wenn er nicht innerhalb von 30 Tagen nach F\xE4lligkeit und Zugang der Rechnung die Zahlung leistet. Der Verzugszins betr\xE4gt f\xFCr das Jahr 5 Prozentpunkte \xFCber dem Basiszinssatz. Zur Zur\xFCckbehaltung von Zahlungen aufgrund behaupteter M\xE4ngel, ist der Vertragspartner nur dann berechtigt, wenn die zur\xFCckgehaltene Zahlung in einem angemessenen Verh\xE4ltnis zu den geltend gemachten M\xE4ngeln steht.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contactListTileDownColumn marginTop30 padding2',style:{maxHeight:'300px',overflow:'scroll'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Bold'},'Datenschutzerkl\xE4rung'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Wir freuen uns sehr \xFCber Ihr Interesse an unserem Unternehmen. Datenschutz hat einen besonders hohen Stellenwert f\xFCr die Gesch\xE4ftsleitung der Ayacandas GmbH. Eine Nutzung der Internetseiten der Ayacandas GmbH ist grunds\xE4tzlich ohne jede Angabe personenbezogener Daten m\xF6glich. Sofern eine betroffene Person besondere Services unseres Unternehmens \xFCber unsere Internetseite in Anspruch nehmen m\xF6chte, k\xF6nnte jedoch eine Verarbeitung personenbezogener Daten erforderlich werden. Ist die Verarbeitung personenbezogener Daten erforderlich und besteht f\xFCr eine solche Verarbeitung keine gesetzliche Grundlage, holen wir generell eine Einwilligung der betroffenen Person ein.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Die Verarbeitung personenbezogener Daten, beispielsweise des Namens, der Anschrift, E-Mail-Adresse oder Telefonnummer einer betroffenen Person, erfolgt stets im Einklang mit der Datenschutz-Grundverordnung und in \xDCbereinstimmung mit den f\xFCr die Ayacandas GmbH geltenden landesspezifischen Datenschutzbestimmungen. Mittels dieser Datenschutzerkl\xE4rung m\xF6chte unser Unternehmen die \xD6ffentlichkeit \xFCber Art, Umfang und Zweck der von uns erhobenen, genutzten und verarbeiteten personenbezogenen Daten informieren. Ferner werden betroffene Personen mittels dieser Datenschutzerkl\xE4rung \xFCber die ihnen zustehenden Rechte aufgekl\xE4rt.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Die Ayacandas GmbH hat als f\xFCr die Verarbeitung Verantwortlicher zahlreiche technische und organisatorische Ma\xDFnahmen umgesetzt, um einen m\xF6glichst l\xFCckenlosen Schutz der \xFCber diese Internetseite verarbeiteten personenbezogenen Daten sicherzustellen. Dennoch k\xF6nnen Internetbasierte Daten\xFCbertragungen grunds\xE4tzlich Sicherheitsl\xFCcken aufweisen, sodass ein absoluter Schutz nicht gew\xE4hrleistet werden kann. Aus diesem Grund steht es jeder betroffenen Person frei, personenbezogene Daten auch auf alternativen Wegen, beispielsweise telefonisch, an uns zu \xFCbermitteln.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'1. Begriffsbestimmungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Die Datenschutzerkl\xE4rung der Ayacandas GmbH beruht auf den Begrifflichkeiten, die durch den Europ\xE4ischen Richtlinien- und Verordnungsgeber beim Erlass der Datenschutz-Grundverordnung (DS-GVO) verwendet wurden. Unsere Datenschutzerkl\xE4rung soll sowohl f\xFCr die \xD6ffentlichkeit als auch f\xFCr unsere Kunden und Gesch\xE4ftspartner einfach lesbar und verst\xE4ndlich sein. Um dies zu gew\xE4hrleisten, m\xF6chten wir vorab die verwendeten Begrifflichkeiten erl\xE4utern.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Wir verwenden in dieser Datenschutzerkl\xE4rung unter anderem die folgenden Begriffe:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'a) personenbezogene Daten '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder identifizierbare nat\xFCrliche Person (im Folgenden \u201Ebetroffene Person\u201C) beziehen. Als identifizierbar wird eine nat\xFCrliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung oder zu einem oder mehreren besonderen Merkmalen, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identit\xE4t dieser nat\xFCrlichen Person sind, identifiziert werden kann.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'b) betroffene Person '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,' Betroffene Person ist jede identifizierte oder identifizierbare nat\xFCrliche Person, deren personenbezogene Daten von dem f\xFCr die Verarbeitung Verantwortlichen verarbeitet werden.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'c) Verarbeitung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Verarbeitung ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgef\xFChrte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten wie das Erheben, das Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder Ver\xE4nderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung durch \xDCbermittlung, Verbreitung oder eine andere Form der Bereitstellung, den Abgleich oder die Verkn\xFCpfung, die Einschr\xE4nkung, das L\xF6schen oder die Vernichtung.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'d) Einschr\xE4nkung der Verarbeitung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Einschr\xE4nkung der Verarbeitung ist die Markierung gespeicherter personenbezogener Daten mit dem Ziel, ihre k\xFCnftige Verarbeitung einzuschr\xE4nken.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'e) Profiling'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Profiling ist jede Art der automatisierten Verarbeitung personenbezogener Daten, die darin besteht, dass diese personenbezogenen Daten verwendet werden, um bestimmte pers\xF6nliche Aspekte, die sich auf eine nat\xFCrliche Person beziehen, zu bewerten, insbesondere, um Aspekte bez\xFCglich Arbeitsleistung, wirtschaftlicher Lage, Gesundheit, pers\xF6nlicher Vorlieben, Interessen, Zuverl\xE4ssigkeit, Verhalten, Aufenthaltsort oder Ortswechsel dieser nat\xFCrlichen Person zu analysieren oder vorherzusagen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'f) Pseudonymisierung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Pseudonymisierung ist die Verarbeitung personenbezogener Daten in einer Weise, auf welche die personenbezogenen Daten ohne Hinzuziehung zus\xE4tzlicher Informationen nicht mehr einer spezifischen betroffenen Person zugeordnet werden k\xF6nnen, sofern diese zus\xE4tzlichen Informationen gesondert aufbewahrt werden und technischen und organisatorischen Ma\xDFnahmen unterliegen, die gew\xE4hrleisten, dass die personenbezogenen Daten nicht einer identifizierten oder identifizierbaren nat\xFCrlichen Person zugewiesen werden.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'g) Verantwortlicher oder f\xFCr die Verarbeitung Verantwortlicher '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Verantwortlicher oder f\xFCr die Verarbeitung Verantwortlicher ist die nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen \xFCber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet. Sind die Zwecke und Mittel dieser Verarbeitung durch das Unionsrecht oder das Recht der Mitgliedstaaten vorgegeben, so kann der Verantwortliche beziehungsweise k\xF6nnen die bestimmten Kriterien seiner Benennung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten vorgesehen werden.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'h) Auftragsverarbeiter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Auftragsverarbeiter ist eine nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle, die personenbezogene Daten im Auftrag des Verantwortlichen verarbeitet.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'i) Empf\xE4nger'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Empf\xE4nger ist eine nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle, der personenbezogene Daten offengelegt werden, unabh\xE4ngig davon, ob es sich bei ihr um einen Dritten handelt oder nicht. Beh\xF6rden, die im Rahmen eines bestimmten Untersuchungsauftrags nach dem Unionsrecht oder dem Recht der Mitgliedstaaten m\xF6glicherweise personenbezogene Daten erhalten, gelten jedoch nicht als Empf\xE4nger.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'j) Dritter'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Dritter ist eine nat\xFCrliche oder juristische Person, Beh\xF6rde, Einrichtung oder andere Stelle au\xDFer der betroffenen Person, dem Verantwortlichen, dem Auftragsverarbeiter und den Personen, die unter der unmittelbaren Verantwortung des Verantwortlichen oder des Auftragsverarbeiters befugt sind, die personenbezogenen Daten zu verarbeiten.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'k) Einwilligung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Einwilligung ist jede von der betroffenen Person freiwillig f\xFCr den bestimmten Fall in informierter Weise und unmissverst\xE4ndlich abgegebene Willensbekundung in Form einer Erkl\xE4rung oder einer sonstigen eindeutigen best\xE4tigenden Handlung, mit der die betroffene Person zu verstehen gibt, dass sie mit der Verarbeitung der sie betreffenden personenbezogenen Daten einverstanden ist.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'2. Name und Anschrift des f\xFCr die Verarbeitung Verantwortlichen'),'Verantwortlicher im Sinne der Datenschutz-Grundverordnung, sonstiger in den Mitgliedstaaten der Europ\xE4ischen Union geltenden Datenschutzgesetze und anderer Bestimmungen mit datenschutzrechtlichem Charakter ist die:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ayacandas GmbH',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'In der Aue 9',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'40591 D\xFCsseldorf',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Deutschland',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Tel.: 0049-211-547616-0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'E-Mail: zentralmail@ayacandas.com',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Website: www.ayacandas.com'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'3. Cookies'),'Die Internetseiten der Ayacandas GmbH verwenden Cookies. Cookies sind Textdateien, welche \xFCber einen Internetbrowser auf einem Computersystem abgelegt und gespeichert werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Zahlreiche Internetseiten und Server verwenden Cookies. Viele Cookies enthalten eine sogenannte Cookie-ID. Eine Cookie-ID ist eine eindeutige Kennung des Cookies. Sie besteht aus einer Zeichenfolge, durch welche Internetseiten und Server dem konkreten Internetbrowser zugeordnet werden k\xF6nnen, in dem das Cookie gespeichert wurde. Dies erm\xF6glicht es den besuchten Internetseiten und Servern, den individuellen Browser der betroffenen Person von anderen Internetbrowsern, die andere Cookies enthalten, zu unterscheiden. Ein bestimmter Internetbrowser kann \xFCber die eindeutige Cookie-ID wiedererkannt und identifiziert werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Durch den Einsatz von Cookies kann die Ayacandas GmbH den Nutzern dieser Internetseite nutzerfreundlichere Services bereitstellen, die ohne die Cookie-Setzung nicht m\xF6glich w\xE4ren.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Mittels eines Cookies k\xF6nnen die Informationen und Angebote auf unserer Internetseite im Sinne des Benutzers optimiert werden. Cookies erm\xF6glichen uns, wie bereits erw\xE4hnt, die Benutzer unserer Internetseite wiederzuerkennen. Zweck dieser Wiedererkennung ist es, den Nutzern die Verwendung unserer Internetseite zu erleichtern. Der Benutzer einer Internetseite, die Cookies verwendet, muss beispielsweise nicht bei jedem Besuch der Internetseite erneut seine Zugangsdaten eingeben, weil dies von der Internetseite und dem auf dem Computersystem des Benutzers abgelegten Cookie \xFCbernommen wird. Ein weiteres Beispiel ist das Cookie eines Warenkorbes im Online-Shop. Der Online-Shop merkt sich die Artikel, die ein Kunde in den virtuellen Warenkorb gelegt hat, \xFCber ein Cookie.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die betroffene Person kann die Setzung von Cookies durch unsere Internetseite jederzeit mittels einer entsprechenden Einstellung des genutzten Internetbrowsers verhindern und damit der Setzung von Cookies dauerhaft widersprechen. Ferner k\xF6nnen bereits gesetzte Cookies jederzeit \xFCber einen Internetbrowser oder andere Softwareprogramme gel\xF6scht werden. Dies ist in allen g\xE4ngigen Internetbrowsern m\xF6glich. Deaktiviert die betroffene Person die Setzung von Cookies in dem genutzten Internetbrowser, sind unter Umst\xE4nden nicht alle Funktionen unserer Internetseite vollumf\xE4nglich nutzbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'4. Erfassung von allgemeinen Daten und Informationen'),'Die Internetseite der Ayacandas GmbH erfasst mit jedem Aufruf der Internetseite durch eine betroffene Person oder ein automatisiertes System eine Reihe von allgemeinen Daten und Informationen. Diese allgemeinen Daten und Informationen werden in den Logfiles des Servers gespeichert. Erfasst werden k\xF6nnen die (1) verwendeten Browsertypen und Versionen, (2) das vom zugreifenden System verwendete Betriebssystem, (3) die Internetseite, von welcher ein zugreifendes System auf unsere Internetseite gelangt (sogenannte Referrer), (4) die Unterwebseiten, welche \xFCber ein zugreifendes System auf unserer Internetseite angesteuert werden, (5) das Datum und die Uhrzeit eines Zugriffs auf die Internetseite, (6) eine Internet-Protokoll-Adresse (IP-Adresse), (7) der Internet-Service-Provider des zugreifenden Systems und (8) sonstige \xE4hnliche Daten und Informationen, die der Gefahrenabwehr im Falle von Angriffen auf unsere informationstechnologischen Systeme dienen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Bei der Nutzung dieser allgemeinen Daten und Informationen zieht die Ayacandas GmbH keine R\xFCckschl\xFCsse auf die betroffene Person. Diese Informationen werden vielmehr ben\xF6tigt, um (1) die Inhalte unserer Internetseite korrekt auszuliefern, (2) die Inhalte unserer Internetseite sowie die Werbung f\xFCr diese zu optimieren, (3) die dauerhafte Funktionsf\xE4higkeit unserer informationstechnologischen Systeme und der Technik unserer Internetseite zu gew\xE4hrleisten sowie (4) um Strafverfolgungsbeh\xF6rden im Falle eines Cyberangriffes die zur Strafverfolgung notwendigen Informationen bereitzustellen. Diese anonym erhobenen Daten und Informationen werden durch die Ayacandas GmbH daher einerseits statistisch und ferner mit dem Ziel ausgewertet, den Datenschutz und die Datensicherheit in unserem Unternehmen zu erh\xF6hen, um letztlich ein optimales Schutzniveau f\xFCr die von uns verarbeiteten personenbezogenen Daten sicherzustellen. Die anonymen Daten der Server-Logfiles werden getrennt von allen durch eine betroffene Person angegebenen personenbezogenen Daten gespeichert.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'5. Registrierung auf unserer Internetseite'),'Die betroffene Person hat die M\xF6glichkeit, sich auf der Internetseite des f\xFCr die Verarbeitung Verantwortlichen unter Angabe von personenbezogenen Daten zu registrieren. Welche personenbezogenen Daten dabei an den f\xFCr die Verarbeitung Verantwortlichen \xFCbermittelt werden, ergibt sich aus der jeweiligen Eingabemaske, die f\xFCr die Registrierung verwendet wird. Die von der betroffenen Person eingegebenen personenbezogenen Daten werden ausschlie\xDFlich f\xFCr die interne Verwendung bei dem f\xFCr die Verarbeitung Verantwortlichen und f\xFCr eigene Zwecke erhoben und gespeichert. Der f\xFCr die Verarbeitung Verantwortliche kann die Weitergabe an einen oder mehrere Auftragsverarbeiter, beispielsweise einen Paketdienstleister, veranlassen, der die personenbezogenen Daten ebenfalls ausschlie\xDFlich f\xFCr eine interne Verwendung, die dem f\xFCr die Verarbeitung Verantwortlichen zuzurechnen ist, nutzt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Durch eine Registrierung auf der Internetseite des f\xFCr die Verarbeitung Verantwortlichen wird ferner die vom Internet-Service-Provider (ISP) der betroffenen Person vergebene IP-Adresse, das Datum sowie die Uhrzeit der Registrierung gespeichert. Die Speicherung dieser Daten erfolgt vor dem Hintergrund, dass nur so der Missbrauch unserer Dienste verhindert werden kann, und diese Daten im Bedarfsfall erm\xF6glichen, begangene Straftaten aufzukl\xE4ren. Insofern ist die Speicherung dieser Daten zur Absicherung des f\xFCr die Verarbeitung Verantwortlichen erforderlich. Eine Weitergabe dieser Daten an Dritte erfolgt grunds\xE4tzlich nicht, sofern keine gesetzliche Pflicht zur Weitergabe besteht oder die Weitergabe der Strafverfolgung dient.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Registrierung der betroffenen Person unter freiwilliger Angabe personenbezogener Daten dient dem f\xFCr die Verarbeitung Verantwortlichen dazu, der betroffenen Person Inhalte oder Leistungen anzubieten, die aufgrund der Natur der Sache nur registrierten Benutzern angeboten werden k\xF6nnen. Registrierten Personen steht die M\xF6glichkeit frei, die bei der Registrierung angegebenen personenbezogenen Daten jederzeit abzu\xE4ndern oder vollst\xE4ndig aus dem Datenbestand des f\xFCr die Verarbeitung Verantwortlichen l\xF6schen zu lassen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Der f\xFCr die Verarbeitung Verantwortliche erteilt jeder betroffenen Person jederzeit auf Anfrage Auskunft dar\xFCber, welche personenbezogenen Daten \xFCber die betroffene Person gespeichert sind. Ferner berichtigt oder l\xF6scht der f\xFCr die Verarbeitung Verantwortliche personenbezogene Daten auf Wunsch oder Hinweis der betroffenen Person, soweit dem keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Ein in dieser Datenschutzerkl\xE4rung namentlich benannter Datenschutzbeauftragter und die Gesamtheit der Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen stehen der betroffenen Person in diesem Zusammenhang als Ansprechpartner zur Verf\xFCgung.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'6. Abonnement unseres Newsletter'),'Auf der Internetseite der Ayacandas GmbH wird den Benutzern die M\xF6glichkeit einger\xE4umt, den Newsletter unseres Unternehmens zu abonnieren. Welche personenbezogenen Daten bei der Bestellung des Newsletters an den f\xFCr die Verarbeitung Verantwortlichen \xFCbermittelt werden, ergibt sich aus der hierzu verwendeten Eingabemaske.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Ayacandas GmbH informiert ihre Kunden und Gesch\xE4ftspartner in regelm\xE4\xDFigen Abst\xE4nden im Wege eines Newsletters \xFCber Angebote des Unternehmens. Der Newsletter unseres Unternehmens kann von der betroffenen Person grunds\xE4tzlich nur dann empfangen werden, wenn (1) die betroffene Person \xFCber eine g\xFCltige E-Mail-Adresse verf\xFCgt und (2) die betroffene Person sich f\xFCr den Newsletterversand registriert. An die von einer betroffenen Person erstmalig f\xFCr den Newsletterversand eingetragene E-Mail-Adresse wird aus rechtlichen Gr\xFCnden eine Best\xE4tigungsmail im Double-Opt-In-Verfahren versendet. Diese Best\xE4tigungsmail dient der \xDCberpr\xFCfung, ob der Inhaber der E-Mail-Adresse als betroffene Person den Empfang des Newsletters autorisiert hat.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Bei der Anmeldung zum Newsletter speichern wir ferner die vom Internet-Service-Provider (ISP) vergebene IP-Adresse des von der betroffenen Person zum Zeitpunkt der Anmeldung verwendeten Computersystems sowie das Datum und die Uhrzeit der Anmeldung. Die Erhebung dieser Daten ist erforderlich, um den(m\xF6glichen) Missbrauch der E-Mail-Adresse einer betroffenen Person zu einem sp\xE4teren Zeitpunkt nachvollziehen zu k\xF6nnen und dient deshalb der rechtlichen Absicherung des f\xFCr die Verarbeitung Verantwortlichen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die im Rahmen einer Anmeldung zum Newsletter erhobenen personenbezogenen Daten werden ausschlie\xDFlich zum Versand unseres Newsletters verwendet. Ferner k\xF6nnten Abonnenten des Newsletters per E-Mail informiert werden, sofern dies f\xFCr den Betrieb des Newsletter-Dienstes oder eine diesbez\xFCgliche Registrierung erforderlich ist, wie dies im Falle von \xC4nderungen am Newsletterangebot oder bei der Ver\xE4nderung der technischen Gegebenheiten der Fall sein k\xF6nnte. Es erfolgt keine Weitergabe der im Rahmen des Newsletter-Dienstes erhobenen personenbezogenen Daten an Dritte. Das Abonnement unseres Newsletters kann durch die betroffene Person jederzeit gek\xFCndigt werden. Die Einwilligung in die Speicherung personenbezogener Daten, die die betroffene Person uns f\xFCr den Newsletterversand erteilt hat, kann jederzeit widerrufen werden. Zum Zwecke des Widerrufs der Einwilligung findet sich in jedem Newsletter ein entsprechender Link. Ferner besteht die M\xF6glichkeit, sich jederzeit auch direkt auf der Internetseite des f\xFCr die Verarbeitung Verantwortlichen vom Newsletterversand abzumelden oder dies dem f\xFCr die Verarbeitung Verantwortlichen auf andere Weise mitzuteilen.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'7. Newsletter-Tracking'),'Die Newsletter der Ayacandas GmbH enthalten sogenannte Z\xE4hlpixel. Ein Z\xE4hlpixel ist eine Miniaturgrafik, die in solche E-Mails eingebettet wird, welche im HTML-Format versendet werden, um eine Logdatei-Aufzeichnung und eine Logdatei-Analyse zu erm\xF6glichen. Dadurch kann eine statistische Auswertung des Erfolges oder Misserfolges von Online-Marketing-Kampagnen durchgef\xFChrt werden. Anhand des eingebetteten Z\xE4hlpixels kann die Ayacandas GmbH erkennen, ob und wann eine E-Mail von einer betroffenen Person ge\xF6ffnet wurde und welche in der E-Mail befindlichen Links von der betroffenen Person aufgerufen wurden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Solche \xFCber die in den Newslettern enthaltenen Z\xE4hlpixel erhobenen personenbezogenen Daten, werden von dem f\xFCr die Verarbeitung Verantwortlichen gespeichert und ausgewertet, um den Newsletterversand zu optimieren und den Inhalt zuk\xFCnftiger Newsletter noch besser den Interessen der betroffenen Person anzupassen. Diese personenbezogenen Daten werden nicht an Dritte weitergegeben. Betroffene Personen sind jederzeit berechtigt, die diesbez\xFCgliche gesonderte, \xFCber das Double-Opt-In-Verfahren abgegebene Einwilligungserkl\xE4rung zu widerrufen. Nach einem Widerruf werden diese personenbezogenen Daten von dem f\xFCr die Verarbeitung Verantwortlichen gel\xF6scht. Eine Abmeldung vom Erhalt des Newsletters deutet die Ayacandas GmbH automatisch als Widerruf.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'8. Kontaktm\xF6glichkeit \xFCber die Internetseite'),'Die Internetseite der Ayacandas GmbH enth\xE4lt aufgrund von gesetzlichen Vorschriften Angaben, die eine schnelle elektronische Kontaktaufnahme zu unserem Unternehmen sowie eine unmittelbare Kommunikation mit uns erm\xF6glichen, was ebenfalls eine allgemeine Adresse der sogenannten elektronischen Post (E-Mail-Adresse) umfasst. Sofern eine betroffene Person per E-Mail oder \xFCber ein Kontaktformular den Kontakt mit dem f\xFCr die Verarbeitung Verantwortlichen aufnimmt, werden die von der betroffenen Person \xFCbermittelten personenbezogenen Daten automatisch gespeichert. Solche auf freiwilliger Basis von einer betroffenen Person an den f\xFCr die Verarbeitung Verantwortlichen \xFCbermittelten personenbezogenen Daten werden f\xFCr Zwecke der Bearbeitung oder der Kontaktaufnahme zur betroffenen Person gespeichert. Es erfolgt keine Weitergabe dieser personenbezogenen Daten an Dritte.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'9. Kommentarfunktion im Blog auf der Internetseite'),'Die Ayacandas GmbH bietet den Nutzern auf einem Blog, der sich auf der Internetseite des f\xFCr die Verarbeitung Verantwortlichen befindet, die M\xF6glichkeit, individuelle Kommentare zu einzelnen Blog-Beitr\xE4gen zu hinterlassen. Ein Blog ist ein auf einer Internetseite gef\xFChrtes, in der Regel \xF6ffentlich einsehbares Portal, in welchem eine oder mehrere Personen, die Blogger oder Web-Blogger genannt werden, Artikel posten oder Gedanken in sogenannten Blogposts niederschreiben k\xF6nnen. Die Blogposts k\xF6nnen in der Regel von Dritten kommentiert werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Hinterl\xE4sst eine betroffene Person einen Kommentar in dem auf dieser Internetseite ver\xF6ffentlichten Blog, werden neben den von der betroffenen Person hinterlassenen Kommentaren auch Angaben zum Zeitpunkt der Kommentareingabe sowie zu dem von der betroffenen Person gew\xE4hlten Nutzernamen (Pseudonym) gespeichert und ver\xF6ffentlicht. Ferner wird die vom Internet-Service-Provider (ISP) der betroffenen Person vergebene IP-Adresse mitprotokolliert. Diese Speicherung der IP-Adresse erfolgt aus Sicherheitsgr\xFCnden und f\xFCr den Fall, dass die betroffene Person durch einen abgegebenen Kommentar die Rechte Dritter verletzt oder rechtswidrige Inhalte postet. Die Speicherung dieser personenbezogenen Daten erfolgt daher im eigenen Interesse des f\xFCr die Verarbeitung Verantwortlichen, damit sich dieser im Falle einer Rechtsverletzung gegebenenfalls exkulpieren k\xF6nnte. Es erfolgt keine Weitergabe dieser erhobenen personenbezogenen Daten an Dritte, sofern eine solche Weitergabe nicht gesetzlich vorgeschrieben ist oder der Rechtsverteidigung des f\xFCr die Verarbeitung Verantwortlichen dient.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'10. Abonnement von Kommentaren im Blog auf der Internetseite'),'Die im Blog der Ayacandas GmbH abgegebenen Kommentare k\xF6nnen grunds\xE4tzlich von Dritten abonniert werden. Insbesondere besteht die M\xF6glichkeit, dass ein Kommentator die seinem Kommentar nachfolgenden Kommentare zu einem bestimmten Blog-Beitrag abonniert.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sofern sich eine betroffene Person f\xFCr die Option entscheidet, Kommentare zu abonnieren, versendet der f\xFCr die Verarbeitung Verantwortliche eine automatische Best\xE4tigungsmail, um im Double-Opt-In-Verfahren zu \xFCberpr\xFCfen, ob sich wirklich der Inhaber der angegebenen E-Mail-Adresse f\xFCr diese Option entschieden hat. Die Option zum Abonnement von Kommentaren kann jederzeit beendet werden.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'11. Routinem\xE4\xDFige L\xF6schung und Sperrung von personenbezogenen Daten'),'Der f\xFCr die Verarbeitung Verantwortliche verarbeitet und speichert personenbezogene Daten der betroffenen Person nur f\xFCr den Zeitraum, der zur Erreichung des Speicherungszwecks erforderlich ist oder sofern dies durch den Europ\xE4ischen Richtlinien- und Verordnungsgeber oder einen anderen Gesetzgeber in Gesetzen oder Vorschriften, welchen der f\xFCr die Verarbeitung Verantwortliche unterliegt, vorgesehen wurde.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Entf\xE4llt der Speicherungszweck oder l\xE4uft eine vom Europ\xE4ischen Richtlinien- und Verordnungsgeber oder einem anderen zust\xE4ndigen Gesetzgeber vorgeschriebene Speicherfrist ab, werden die personenbezogenen Daten routinem\xE4\xDFig und entsprechend den gesetzlichen Vorschriften gesperrt oder gel\xF6scht.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'12. Rechte der betroffenen Person'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'a) Recht auf Best\xE4tigung'),'Jede betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber einger\xE4umte Recht, von dem f\xFCr die Verarbeitung Verantwortlichen eine Best\xE4tigung dar\xFCber zu verlangen, ob sie betreffende personenbezogene Daten verarbeitet werden. M\xF6chte eine betroffene Person dieses Best\xE4tigungsrecht in Anspruch nehmen, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen wenden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'b) Recht auf Auskunft'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, jederzeit von dem f\xFCr die Verarbeitung Verantwortlichen unentgeltliche Auskunft \xFCber die zu seiner Person gespeicherten personenbezogenen Daten und eine Kopie dieser Auskunft zu erhalten. Ferner hat der Europ\xE4ische Richtlinien- und Verordnungsgeber der betroffenen Person Auskunft \xFCber folgende Informationen zugestanden:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'die Verarbeitungszwecke',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'die Kategorien personenbezogener Daten, die verarbeitet werden',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'die Empf\xE4nger oder Kategorien von Empf\xE4ngern, gegen\xFCber denen die personenbezogenen Daten offengelegt worden sind oder noch offengelegt werden, insbesondere bei Empf\xE4ngern in Drittl\xE4ndern oder bei internationalen Organisationen',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'falls m\xF6glich die geplante Dauer, f\xFCr die die personenbezogenen Daten gespeichert werden, oder, falls dies nicht m\xF6glich ist, die Kriterien f\xFCr die Festlegung dieser Dauer',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'das Bestehen eines Rechts auf Berichtigung oder L\xF6schung der sie betreffenden personenbezogenen Daten oder auf Einschr\xE4nkung der Verarbeitung durch den Verantwortlichen oder eines Widerspruchsrechts gegen diese Verarbeitung',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'das Bestehen eines Beschwerderechts bei einer Aufsichtsbeh\xF6rde',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'wenn die personenbezogenen Daten nicht bei der betroffenen Person erhoben werden: Alle verf\xFCgbaren Informationen \xFCber die Herkunft der Daten',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'das Bestehen einer automatisierten Entscheidungsfindung einschlie\xDFlich Profiling gem\xE4\xDF Artikel 22 Abs.1 und 4 DS-GVO und \u2014 zumindest in diesen F\xE4llen \u2014 aussagekr\xE4ftige Informationen \xFCber die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen einer derartigen Verarbeitung f\xFCr die betroffene Person',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ferner steht der betroffenen Person ein Auskunftsrecht dar\xFCber zu, ob personenbezogene Daten an ein Drittland oder an eine internationale Organisation \xFCbermittelt wurden. Sofern dies der Fall ist, so steht der betroffenen Person im \xDCbrigen das Recht zu, Auskunft \xFCber die geeigneten Garantien im Zusammenhang mit der \xDCbermittlung zu erhalten.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'M\xF6chte eine betroffene Person dieses Auskunftsrecht in Anspruch nehmen, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen wenden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'c) Recht auf Berichtigung'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, die unverz\xFCgliche Berichtigung sie betreffender unrichtiger personenbezogener Daten zu verlangen. Ferner steht der betroffenen Person das Recht zu, unter Ber\xFCcksichtigung der Zwecke der Verarbeitung, die Vervollst\xE4ndigung unvollst\xE4ndiger personenbezogener Daten \u2014 auch mittels einer erg\xE4nzenden Erkl\xE4rung \u2014 zu verlangen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'M\xF6chte eine betroffene Person dieses Berichtigungsrecht in Anspruch nehmen, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen wenden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'d) Recht auf L\xF6schung (Recht auf Vergessen werden)'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, von dem Verantwortlichen zu verlangen, dass die sie betreffenden personenbezogenen Daten unverz\xFCglich gel\xF6scht werden, sofern einer der folgenden Gr\xFCnde zutrifft und soweit die Verarbeitung nicht erforderlich ist:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die personenbezogenen Daten wurden f\xFCr solche Zwecke erhoben oder auf sonstige Weise verarbeitet, f\xFCr welche sie nicht mehr notwendig sind.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die betroffene Person widerruft ihre Einwilligung, auf die sich die Verarbeitung gem\xE4\xDF Art. 6 Abs. 1 Buchstabe a DS-GVO oder Art. 9 Abs. 2 Buchstabe a DS-GVO st\xFCtzte, und es fehlt an einer anderweitigen Rechtsgrundlage f\xFCr die Verarbeitung.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die betroffene Person legt gem\xE4\xDF Art. 21 Abs. 1 DS-GVO Widerspruch gegen die Verarbeitung ein, und es liegen keine vorrangigen berechtigten Gr\xFCnde f\xFCr die Verarbeitung vor, oder die betroffene Person legt gem\xE4\xDF Art. 21 Abs. 2 DS-GVO Widerspruch gegen die Verarbeitung ein.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die personenbezogenen Daten wurden unrechtm\xE4\xDFig verarbeitet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die L\xF6schung der personenbezogenen Daten ist zur Erf\xFCllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gem\xE4\xDF Art. 8 Abs. 1 DS-GVO erhoben.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sofern einer der oben genannten Gr\xFCnde zutrifft und eine betroffene Person die L\xF6schung von personenbezogenen Daten, die bei der Ayacandas GmbH gespeichert sind, veranlassen m\xF6chte, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen wenden. Der Datenschutzbeauftragte der Ayacandas GmbH oder ein anderer Mitarbeiter wird veranlassen, dass dem L\xF6schverlangen unverz\xFCglich nachgekommen wird.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Wurden die personenbezogenen Daten von der Ayacandas GmbH \xF6ffentlich gemacht und ist unser Unternehmen als Verantwortlicher gem\xE4\xDF Art. 17 Abs. 1 DS-GVO zur L\xF6schung der personenbezogenen Daten verpflichtet, so trifft die Ayacandas GmbH unter Ber\xFCcksichtigung der verf\xFCgbaren Technologie und der Implementierungskosten angemessene Ma\xDFnahmen, auch technischer Art, um andere f\xFCr die Datenverarbeitung Verantwortliche, welche die ver\xF6ffentlichten personenbezogenen Daten verarbeiten, dar\xFCber in Kenntnis zu setzen, dass die betroffene Person von diesen anderen f\xFCr die Datenverarbeitung Verantwortlichen die L\xF6schung s\xE4mtlicher Links zu diesen personenbezogenen Daten oder von Kopien oder Replikationen dieser personenbezogenen Daten verlangt hat, soweit die Verarbeitung nicht erforderlich ist. Der Datenschutzbeauftragte der Ayacandas GmbH oder ein anderer Mitarbeiter wird im Einzelfall das Notwendige veranlassen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'e) Recht auf Einschr\xE4nkung der Verarbeitung'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, von dem Verantwortlichen die Einschr\xE4nkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Richtigkeit der personenbezogenen Daten wird von der betroffenen Person bestritten, und zwar f\xFCr eine Dauer, die es dem Verantwortlichen erm\xF6glicht, die Richtigkeit der personenbezogenen Daten zu \xFCberpr\xFCfen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Verarbeitung ist unrechtm\xE4\xDFig, die betroffene Person lehnt die L\xF6schung der personenbezogenen Daten ab und verlangt stattdessen die Einschr\xE4nkung der Nutzung der personenbezogenen Daten.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Der Verantwortliche ben\xF6tigt die personenbezogenen Daten f\xFCr die Zwecke der Verarbeitung nicht l\xE4nger, die betroffene Person ben\xF6tigt sie jedoch zur Geltendmachung, Aus\xFCbung oder Verteidigung von Rechtsanspr\xFCchen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die betroffene Person hat Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt und es steht noch nicht fest, ob die berechtigten Gr\xFCnde des Verantwortlichen gegen\xFCber denen der betroffenen Person \xFCberwiegen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sofern eine der oben genannten Voraussetzungen gegeben ist und eine betroffene Person die Einschr\xE4nkung von personenbezogenen Daten, die bei der Ayacandas GmbH gespeichert sind, verlangen m\xF6chte, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen wenden. Der Datenschutzbeauftragte der Ayacandas GmbH oder ein anderer Mitarbeiter wird die Einschr\xE4nkung der Verarbeitung veranlassen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'f) Recht auf Daten\xFCbertragbarkeit'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, die sie betreffenden personenbezogenen Daten, welche durch die betroffene Person einem Verantwortlichen bereitgestellt wurden, in einem strukturierten, g\xE4ngigen und maschinenlesbaren Format zu erhalten. Sie hat au\xDFerdem das Recht, diese Daten einem anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem die personenbezogenen Daten bereitgestellt wurden, zu \xFCbermitteln, sofern die Verarbeitung auf der Einwilligung gem\xE4\xDF Art. 6 Abs. 1 Buchstabe a DS-GVO oder Art. 9 Abs. 2 Buchstabe a DS-GVO oder auf einem Vertrag gem\xE4\xDF Art. 6 Abs. 1 Buchstabe b DS-GVO beruht und die Verarbeitung mithilfe automatisierter Verfahren erfolgt, sofern die Verarbeitung nicht f\xFCr die Wahrnehmung einer Aufgabe erforderlich ist, die im \xF6ffentlichen Interesse liegt oder in Aus\xFCbung \xF6ffentlicher Gewalt erfolgt, welche dem Verantwortlichen \xFCbertragen wurde.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ferner hat die betroffene Person bei der Aus\xFCbung ihres Rechts auf Daten\xFCbertragbarkeit gem\xE4\xDF Art. 20 Abs. 1 DS-GVO das Recht, zu erwirken, dass die personenbezogenen Daten direkt von einem Verantwortlichen an einen anderen Verantwortlichen \xFCbermittelt werden, soweit dies technisch machbar ist und sofern hiervon nicht die Rechte und Freiheiten anderer Personen beeintr\xE4chtigt werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Zur Geltendmachung des Rechts auf Daten\xFCbertragbarkeit kann sich die betroffene Person jederzeit an den von der Ayacandas GmbH bestellten Datenschutzbeauftragten oder einen anderen Mitarbeiter wenden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'g) Recht auf Widerspruch'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, aus Gr\xFCnden, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung sie betreffender personenbezogener Daten, die aufgrund von Art. 6 Abs. 1 Buchstaben e oder f DS-GVO erfolgt, Widerspruch einzulegen. Dies gilt auch f\xFCr ein auf diese Bestimmungen gest\xFCtztes Profiling.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die Ayacandas GmbH verarbeitet die personenbezogenen Daten im Falle des Widerspruchs nicht mehr, es sei denn, wir k\xF6nnen zwingende schutzw\xFCrdige Gr\xFCnde f\xFCr die Verarbeitung nachweisen, die den Interessen, Rechten und Freiheiten der betroffenen Person \xFCberwiegen, oder die Verarbeitung dient der Geltendmachung, Aus\xFCbung oder Verteidigung von Rechtsanspr\xFCchen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Verarbeitet die Ayacandas GmbH personenbezogene Daten, um Direktwerbung zu betreiben, so hat die betroffene Person das Recht, jederzeit Widerspruch gegen die Verarbeitung der personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen. Dies gilt auch f\xFCr das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Widerspricht die betroffene Person gegen\xFCber der Ayacandas GmbH der Verarbeitung f\xFCr Zwecke der Direktwerbung, so wird die Ayacandas GmbH die personenbezogenen Daten nicht mehr f\xFCr diese Zwecke verarbeiten.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Zudem hat die betroffene Person das Recht, aus Gr\xFCnden, die sich aus ihrer besonderen Situation ergeben, gegen die sie betreffende Verarbeitung personenbezogener Daten, die bei der Ayacandas GmbH zu wissenschaftlichen oder historischen Forschungszwecken oder zu statistischen Zwecken gem\xE4\xDF Art. 89 Abs. 1 DS-GVO erfolgen, Widerspruch einzulegen, es sei denn, eine solche Verarbeitung ist zur Erf\xFCllung einer im \xF6ffentlichen Interesse liegenden Aufgabe erforderlich.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Zur Aus\xFCbung des Rechts auf Widerspruch kann sich die betroffene Person direkt an den Datenschutzbeauftragten der Ayacandas GmbH oder einen anderen Mitarbeiter wenden. Der betroffenen Person steht es ferner frei, im Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft, ungeachtet der Richtlinie 2002/58/EG, ihr Widerspruchsrecht mittels automatisierter Verfahren auszu\xFCben, bei denen technische Spezifikationen verwendet werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'h) Automatisierte Entscheidungen im Einzelfall einschlie\xDFlich Profiling'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, nicht einer ausschlie\xDFlich auf einer automatisierten Verarbeitung \u2014 einschlie\xDFlich Profiling \u2014 beruhenden Entscheidung unterworfen zu werden, die ihr gegen\xFCber rechtliche Wirkung entfaltet oder sie in \xE4hnlicher Weise erheblich beeintr\xE4chtigt, sofern die Entscheidung (1) nicht f\xFCr den Abschluss oder die Erf\xFCllung eines Vertrags zwischen der betroffenen Person und dem Verantwortlichen erforderlich ist, oder (2) aufgrund von Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der Verantwortliche unterliegt, zul\xE4ssig ist und diese Rechtsvorschriften angemessene Ma\xDFnahmen zur Wahrung der Rechte und Freiheiten sowie der berechtigten Interessen der betroffenen Person enthalten oder (3) mit ausdr\xFCcklicher Einwilligung der betroffenen Person erfolgt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ist die Entscheidung (1) f\xFCr den Abschluss oder die Erf\xFCllung eines Vertrags zwischen der betroffenen Person und dem Verantwortlichen erforderlich oder (2) erfolgt sie mit ausdr\xFCcklicher Einwilligung der betroffenen Person, trifft die Ayacandas GmbH angemessene Ma\xDFnahmen, um die Rechte und Freiheiten sowie die berechtigten Interessen der betroffenen Person zu wahren, wozu mindestens das Recht auf Erwirkung des Eingreifens einer Person seitens des Verantwortlichen, auf Darlegung des eigenen Standpunkts und auf Anfechtung der Entscheidung geh\xF6rt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'M\xF6chte die betroffene Person Rechte mit Bezug auf automatisierte Entscheidungen geltend machen, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen wenden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'i) Recht auf Widerruf einer datenschutzrechtlichen Einwilligung'),'Jede von der Verarbeitung personenbezogener Daten betroffene Person hat das vom Europ\xE4ischen Richtlinien- und Verordnungsgeber gew\xE4hrte Recht, eine Einwilligung zur Verarbeitung personenbezogener Daten jederzeit zu widerrufen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'M\xF6chte die betroffene Person ihr Recht auf Widerruf einer Einwilligung geltend machen, kann sie sich hierzu jederzeit an unseren Datenschutzbeauftragten oder einen anderen Mitarbeiter des f\xFCr die Verarbeitung Verantwortlichen wenden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'13. Datenschutzbestimmungen zu Einsatz und Verwendung von Facebook'),'Der f\xFCr die Verarbeitung Verantwortliche hat auf dieser Internetseite Komponenten des Unternehmens Facebook integriert. Facebook ist ein soziales Netzwerk.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ein soziales Netzwerk ist ein im Internet betriebener sozialer Treffpunkt, eine Online-Gemeinschaft, die es den Nutzern in der Regel erm\xF6glicht, untereinander zu kommunizieren und im virtuellen Raum zu interagieren. Ein soziales Netzwerk kann als Plattform zum Austausch von Meinungen und Erfahrungen dienen oder erm\xF6glicht es der Internetgemeinschaft, pers\xF6nliche oder unternehmensbezogene Informationen bereitzustellen. Facebook erm\xF6glicht den Nutzern des sozialen Netzwerkes unter anderem die Erstellung von privaten Profilen, den Upload von Fotos und eine Vernetzung \xFCber Freundschaftsanfragen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Betreibergesellschaft von Facebook ist die Facebook, Inc., 1 Hacker Way, Menlo Park, CA 94025, USA. F\xFCr die Verarbeitung personenbezogener Daten Verantwortlicher ist, wenn eine betroffene Person au\xDFerhalb der USA oder Kanada lebt, die Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ireland.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Durch jeden Aufruf einer der Einzelseiten dieser Internetseite, die durch den f\xFCr die Verarbeitung Verantwortlichen betrieben wird und auf welcher eine Facebook-Komponente (Facebook-Plug-In) integriert wurde, wird der Internetbrowser auf dem informationstechnologischen System der betroffenen Person automatisch durch die jeweilige Facebook-Komponente veranlasst, eine Darstellung der entsprechenden Facebook-Komponente von Facebook herunterzuladen. Eine Gesamt\xFCbersicht \xFCber alle Facebook-Plug-Ins kann unter https://developers.facebook.com/docs/plugins/?locale=de_DE abgerufen werden. Im Rahmen dieses technischen Verfahrens erh\xE4lt Facebook Kenntnis dar\xFCber, welche konkrete Unterseite unserer Internetseite durch die betroffene Person besucht wird.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sofern die betroffene Person gleichzeitig bei Facebook eingeloggt ist, erkennt Facebook mit jedem Aufruf unserer Internetseite durch die betroffene Person und w\xE4hrend der gesamten Dauer des jeweiligen Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite unserer Internetseite die betroffene Person besucht. Diese Informationen werden durch die Facebook-Komponente gesammelt und durch Facebook dem jeweiligen Facebook-Account der betroffenen Person zugeordnet. Bet\xE4tigt die betroffene Person einen der auf unserer Internetseite integrierten Facebook-Buttons, beispielsweise den \u201EGef\xE4llt mir\u201C-Button, oder gibt die betroffene Person einen Kommentar ab, ordnet Facebook diese Information dem pers\xF6nlichen Facebook-Benutzerkonto der betroffenen Person zu und speichert diese personenbezogenen Daten.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Facebook erh\xE4lt \xFCber die Facebook-Komponente immer dann eine Information dar\xFCber, dass die betroffene Person unsere Internetseite besucht hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer Internetseite gleichzeitig bei Facebook eingeloggt ist; dies findet unabh\xE4ngig davon statt, ob die betroffene Person die Facebook-Komponente anklickt oder nicht. Ist eine derartige \xDCbermittlung dieser Informationen an Facebook von der betroffenen Person nicht gewollt, kann diese die \xDCbermittlung dadurch verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem Facebook-Account ausloggt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die von Facebook ver\xF6ffentlichte Datenrichtlinie, die unter https://de-de.facebook.com/about/privacy/ abrufbar ist, gibt Aufschluss \xFCber die Erhebung, Verarbeitung und Nutzung personenbezogener Daten durch Facebook. Ferner wird dort erl\xE4utert, welche Einstellungsm\xF6glichkeiten Facebook zum Schutz der Privatsph\xE4re der betroffenen Person bietet. Zudem sind unterschiedliche Applikationen erh\xE4ltlich, die es erm\xF6glichen, eine Daten\xFCbermittlung an Facebook zu unterdr\xFCcken, beispielsweise der Facebook-Blocker des Anbieters Webgraph, der unter http://webgraph.com/resources/facebookblocker/ beschafft werden kann. Solche Applikationen k\xF6nnen durch die betroffene Person genutzt werden, um eine Daten\xFCbermittlung an Facebook zu unterdr\xFCcken.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'14. Datenschutzbestimmungen zu Einsatz und Verwendung von Google Analytics (mit Anonymisierungsfunktion)'),'Der f\xFCr die Verarbeitung Verantwortliche hat auf dieser Internetseite die Komponente Google Analytics (mit Anonymisierungsfunktion) integriert. Google Analytics ist ein Web-Analyse-Dienst. Web-Analyse ist die Erhebung, Sammlung und Auswertung von Daten \xFCber das Verhalten von Besuchern von Internetseiten. Ein Web-Analyse-Dienst erfasst unter anderem Daten dar\xFCber, von welcher Internetseite eine betroffene Person auf eine Internetseite gekommen ist (sogenannte Referrer), auf welche Unterseiten der Internetseite zugegriffen oder wie oft und f\xFCr welche Verweildauer eine Unterseite betrachtet wurde. Eine Web-Analyse wird \xFCberwiegend zur Optimierung einer Internetseite und zur Kosten-Nutzen-Analyse von Internetwerbung eingesetzt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Betreibergesellschaft der Google-Analytics-Komponente ist die Google Inc., 1600 Amphitheatre Pkwy, Mountain View, CA 94043-1351, USA.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Der f\xFCr die Verarbeitung Verantwortliche verwendet f\xFCr die Web-Analyse \xFCber Google Analytics den Zusatz "_gat._anonymizeIp". Mittels dieses Zusatzes wird die IP-Adresse des Internetanschlusses der betroffenen Person von Google gek\xFCrzt und anonymisiert, wenn der Zugriff auf unsere Internetseiten aus einem Mitgliedstaat der Europ\xE4ischen Union oder aus einem anderen Vertragsstaat des Abkommens \xFCber den Europ\xE4ischen Wirtschaftsraum erfolgt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Der Zweck der Google-Analytics-Komponente ist die Analyse der Besucherstr\xF6me auf unserer Internetseite. Google nutzt die gewonnenen Daten und Informationen unter anderem dazu, die Nutzung unserer Internetseite auszuwerten, um f\xFCr uns Online-Reports, welche die Aktivit\xE4ten auf unseren Internetseiten aufzeigen, zusammenzustellen, und um weitere mit der Nutzung unserer Internetseite in Verbindung stehende Dienstleistungen zu erbringen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Google Analytics setzt ein Cookie auf dem informationstechnologischen System der betroffenen Person. Was Cookies sind, wurde oben bereits erl\xE4utert. Mit Setzung des Cookies wird Google eine Analyse der Benutzung unserer Internetseite erm\xF6glicht. Durch jeden Aufruf einer der Einzelseiten dieser Internetseite, die durch den f\xFCr die Verarbeitung Verantwortlichen betrieben wird und auf welcher eine Google-Analytics-Komponente integriert wurde, wird der Internetbrowser auf dem informationstechnologischen System der betroffenen Person automatisch durch die jeweilige Google-Analytics-Komponente veranlasst, Daten zum Zwecke der Online-Analyse an Google zu \xFCbermitteln. Im Rahmen dieses technischen Verfahrens erh\xE4lt Google Kenntnis \xFCber personenbezogene Daten, wie der IP-Adresse der betroffenen Person, die Google unter anderem dazu dienen, die Herkunft der Besucher und Klicks nachzuvollziehen und in der Folge Provisionsabrechnungen zu erm\xF6glichen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Mittels des Cookies werden personenbezogene Informationen, beispielsweise die Zugriffszeit, der Ort, von welchem ein Zugriff ausging und die H\xE4ufigkeit der Besuche unserer Internetseite durch die betroffene Person, gespeichert. Bei jedem Besuch unserer Internetseiten werden diese personenbezogenen Daten, einschlie\xDFlich der IP-Adresse des von der betroffenen Person genutzten Internetanschlusses, an Google in den Vereinigten Staaten von Amerika \xFCbertragen. Diese personenbezogenen Daten werden durch Google in den Vereinigten Staaten von Amerika gespeichert. Google gibt diese \xFCber das technische Verfahren erhobenen personenbezogenen Daten unter Umst\xE4nden an Dritte weiter.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die betroffene Person kann die Setzung von Cookies durch unsere Internetseite, wie oben bereits dargestellt, jederzeit mittels einer entsprechenden Einstellung des genutzten Internetbrowsers verhindern und damit der Setzung von Cookies dauerhaft widersprechen. Eine solche Einstellung des genutzten Internetbrowsers w\xFCrde auch verhindern, dass Google ein Cookie auf dem informationstechnologischen System der betroffenen Person setzt. Zudem kann ein von Google Analytics bereits gesetzter Cookie jederzeit \xFCber den Internetbrowser oder andere Softwareprogramme gel\xF6scht werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Ferner besteht f\xFCr die betroffene Person die M\xF6glichkeit, einer Erfassung der durch Google Analytics erzeugten, auf eine Nutzung dieser Internetseite bezogenen Daten sowie der Verarbeitung dieser Daten durch Google zu widersprechen und eine solche zu verhindern. Hierzu muss die betroffene Person ein Browser-Add-On unter dem Link https://tools.google.com/dlpage/gaoptout herunterladen und installieren. Dieses Browser-Add-On teilt Google Analytics \xFCber JavaScript mit, dass keine Daten und Informationen zu den Besuchen von Internetseiten an Google Analytics \xFCbermittelt werden d\xFCrfen. Die Installation des Browser-Add-Ons wird von Google als Widerspruch gewertet. Wird das informationstechnologische System der betroffenen Person zu einem sp\xE4teren Zeitpunkt gel\xF6scht, formatiert oder neu installiert, muss durch die betroffene Person eine erneute Installation des Browser-Add-Ons erfolgen, um Google Analytics zu deaktivieren. Sofern das Browser-Add-On durch die betroffene Person oder einer anderen Person, die ihrem Machtbereich zuzurechnen ist, deinstalliert oder deaktiviert wird, besteht die M\xF6glichkeit der Neuinstallation oder der erneuten Aktivierung des Browser-Add-Ons.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Weitere Informationen und die geltenden Datenschutzbestimmungen von Google k\xF6nnen unter https://www.google.de/intl/de/policies/privacy/ und unter http://www.google.com/analytics/terms/de.html abgerufen werden. Google Analytics wird unter diesem Link https://www.google.com/intl/de_de/analytics/ genauer erl\xE4utert.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'15. Datenschutzbestimmungen zu Einsatz und Verwendung von Shariff'),'Der f\xFCr die Verarbeitung Verantwortliche hat auf dieser Internetseite die Komponente Shariff integriert. Die Shariff-Komponente stellt Social-Media-Buttons zur Verf\xFCgung, die datenschutzkonform sind. Shariff wurde f\xFCr die deutsche Computerzeitschrift c\'t entwickelt und wird \xFCber die GitHub, Inc. publiziert.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Entwickler der Komponente ist GitHub, Inc. 88 Colin P. Kelly Junior Street, San Francisco, CA 94107, USA.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\xDCblicherweise \xFCbertragen die von den sozialen Netzwerken bereitgestellten Button-L\xF6sungen bereits dann personenbezogene Daten an das jeweilige soziale Netzwerk, wenn ein Nutzer eine Internetseite besucht, in welche ein Social-Media-Button integriert wurde. Durch die Nutzung der Shariff-Komponente werden erst dann personenbezogene Daten an soziale Netzwerke \xFCbermittelt, wenn der Besucher einer Internetseite aktiv einen der Social-Media-Buttons bet\xE4tigt. Weitere Informationen zur Shariff-Komponente werden von der Computerzeitschrift c\'t unter http://www.heise.de/newsticker/meldung/Datenschutz-und-Social-Media-Der-c-t-Shariff-ist-im-Einsatz-2470103.html bereitgehalten. Der Einsatz der Shariff-Komponente hat den Zweck, die personenbezogenen Daten der Besucher unserer Internetseite zu sch\xFCtzen und uns gleichzeitig zu erm\xF6glichen, eine Button-L\xF6sung f\xFCr soziale Netzwerke auf dieser Internetseite zu integrieren.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Weitere Informationen und die geltenden Datenschutzbestimmungen von GitHub k\xF6nnen unter https://help.github.com/articles/github-privacy-policy/ abgerufen werden.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'16. Datenschutzbestimmungen zu Einsatz und Verwendung von Twitter'),'Der f\xFCr die Verarbeitung Verantwortliche hat auf dieser Internetseite Komponenten von Twitter integriert. Twitter ist ein multilingualer \xF6ffentlich zug\xE4nglicher Mikroblogging-Dienst, auf welchem die Nutzer sogenannte Tweets, also Kurznachrichten, die auf 140 Zeichen begrenzt sind, ver\xF6ffentlichen und verbreiten k\xF6nnen. Diese Kurznachrichten sind f\xFCr jedermann, also auch f\xFCr nicht bei Twitter angemeldete Personen abrufbar. Die Tweets werden aber auch den sogenannten Followern des jeweiligen Nutzers angezeigt. Follower sind andere Twitter-Nutzer, die den Tweets eines Nutzers folgen. Ferner erm\xF6glicht Twitter \xFCber Hashtags, Verlinkungen oder Retweets die Ansprache eines breiten Publikums.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Betreibergesellschaft von Twitter ist die Twitter, Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Durch jeden Aufruf einer der Einzelseiten dieser Internetseite, die durch den f\xFCr die Verarbeitung Verantwortlichen betrieben wird und auf welcher eine Twitter-Komponente (Twitter-Button) integriert wurde, wird der Internetbrowser auf dem informationstechnologischen System der betroffenen Person automatisch durch die jeweilige Twitter-Komponente veranlasst, eine Darstellung der entsprechenden Twitter-Komponente von Twitter herunterzuladen. Weitere Informationen zu den Twitter-Buttons sind unter https://about.twitter.com/de/resources/buttons abrufbar. Im Rahmen dieses technischen Verfahrens erh\xE4lt Twitter Kenntnis dar\xFCber, welche konkrete Unterseite unserer Internetseite durch die betroffene Person besucht wird. Zweck der Integration der Twitter-Komponente ist es, unseren Nutzern eine Weiterverbreitung der Inhalte diese Internetseite zu erm\xF6glichen, diese Internetseite in der digitalen Welt bekannt zu machen und unsere Besucherzahlen zu erh\xF6hen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sofern die betroffene Person gleichzeitig bei Twitter eingeloggt ist, erkennt Twitter mit jedem Aufruf unserer Internetseite durch die betroffene Person und w\xE4hrend der gesamten Dauer des jeweiligen Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite unserer Internetseite die betroffene Person besucht. Diese Informationen werden durch die Twitter-Komponente gesammelt und durch Twitter dem jeweiligen Twitter-Account der betroffenen Person zugeordnet. Bet\xE4tigt die betroffene Person einen der auf unserer Internetseite integrierten Twitter-Buttons, werden die damit \xFCbertragenen Daten und Informationen dem pers\xF6nlichen Twitter-Benutzerkonto der betroffenen Person zugeordnet und von Twitter gespeichert und verarbeitet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Twitter erh\xE4lt \xFCber die Twitter-Komponente immer dann eine Information dar\xFCber, dass die betroffene Person unsere Internetseite besucht hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer Internetseite gleichzeitig bei Twitter eingeloggt ist; dies findet unabh\xE4ngig davon statt, ob die betroffene Person die Twitter-Komponente anklickt oder nicht. Ist eine derartige \xDCbermittlung dieser Informationen an Twitter von der betroffenen Person nicht gewollt, kann diese die \xDCbermittlung dadurch verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem Twitter-Account ausloggt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die geltenden Datenschutzbestimmungen von Twitter sind unter https://twitter.com/privacy?lang=de abrufbar.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'17. Datenschutzbestimmungen zu Einsatz und Verwendung von Xing'),'Der f\xFCr die Verarbeitung Verantwortliche hat auf dieser Internetseite Komponenten von Xing integriert. Xing ist ein Internetbasiertes soziales Netzwerk, das die Konnektierung der Nutzer mit bestehenden Gesch\xE4ftskontakten sowie das Kn\xFCpfen von neuen Businesskontakten erm\xF6glicht. Die einzelnen Nutzer k\xF6nnen bei Xing ein pers\xF6nliches Profil von sich anlegen. Unternehmen k\xF6nnen beispielsweise Unternehmensprofile erstellen oder Stellenangebote auf Xing ver\xF6ffentlichen.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Betreibergesellschaft von Xing ist die XING AG, Dammtorstra\xDFe 30, 20354 Hamburg, Deutschland.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Durch jeden Aufruf einer der Einzelseiten dieser Internetseite, die durch den f\xFCr die Verarbeitung Verantwortlichen betrieben wird und auf welcher eine Xing-Komponente (Xing-Plug-In) integriert wurde, wird der Internetbrowser auf dem informationstechnologischen System der betroffenen Person automatisch durch die jeweilige Xing-Komponente veranlasst, eine Darstellung der entsprechenden Xing-Komponente von Xing herunterzuladen. Weitere Informationen zum den Xing-Plug-Ins k\xF6nnen unter https://dev.xing.com/plugins abgerufen werden. Im Rahmen dieses technischen Verfahrens erh\xE4lt Xing Kenntnis dar\xFCber, welche konkrete Unterseite unserer Internetseite durch die betroffene Person besucht wird.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sofern die betroffene Person gleichzeitig bei Xing eingeloggt ist, erkennt Xing mit jedem Aufruf unserer Internetseite durch die betroffene Person und w\xE4hrend der gesamten Dauer des jeweiligen Aufenthaltes auf unserer Internetseite, welche konkrete Unterseite unserer Internetseite die betroffene Person besucht. Diese Informationen werden durch die Xing-Komponente gesammelt und durch Xing dem jeweiligen Xing-Account der betroffenen Person zugeordnet. Bet\xE4tigt die betroffene Person einen der auf unserer Internetseite integrierten Xing-Buttons, beispielsweise den \u201EShare\u201C-Button, ordnet Xing diese Information dem pers\xF6nlichen Xing-Benutzerkonto der betroffenen Person zu und speichert diese personenbezogenen Daten.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Xing erh\xE4lt \xFCber die Xing-Komponente immer dann eine Information dar\xFCber, dass die betroffene Person unsere Internetseite besucht hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer Internetseite gleichzeitig bei Xing eingeloggt ist; dies findet unabh\xE4ngig davon statt, ob die betroffene Person die Xing-Komponente anklickt oder nicht. Ist eine derartige \xDCbermittlung dieser Informationen an Xing von der betroffenen Person nicht gewollt, kann diese die \xDCbermittlung dadurch verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem Xing-Account ausloggt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die von Xing ver\xF6ffentlichten Datenschutzbestimmungen, die unter https://www.xing.com/privacy abrufbar sind, geben Aufschluss \xFCber die Erhebung, Verarbeitung und Nutzung personenbezogener Daten durch Xing. Ferner hat Xing unter https://www.xing.com/app/share?op=data_protection Datenschutzhinweise f\xFCr den XING-Share-Button ver\xF6ffentlicht.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'18. Datenschutzbestimmungen zu Einsatz und Verwendung von YouTube'),'Der f\xFCr die Verarbeitung Verantwortliche hat auf dieser Internetseite Komponenten von YouTube integriert. YouTube ist ein Internet-Videoportal, dass Video-Publishern das kostenlose Einstellen von Videoclips und anderen Nutzern die ebenfalls kostenfreie Betrachtung, Bewertung und Kommentierung dieser erm\xF6glicht. YouTube gestattet die Publikation aller Arten von Videos, weshalb sowohl komplette Film- und Fernsehsendungen, aber auch Musikvideos, Trailer oder von Nutzern selbst angefertigte Videos \xFCber das Internetportal abrufbar sind.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Betreibergesellschaft von YouTube ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA. Die YouTube, LLC ist einer Tochtergesellschaft der Google Inc., 1600 Amphitheatre Pkwy, Mountain View, CA 94043-1351, USA.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Durch jeden Aufruf einer der Einzelseiten dieser Internetseite, die durch den f\xFCr die Verarbeitung Verantwortlichen betrieben wird und auf welcher eine YouTube-Komponente (YouTube-Video) integriert wurde, wird der Internetbrowser auf dem informationstechnologischen System der betroffenen Person automatisch durch die jeweilige YouTube-Komponente veranlasst, eine Darstellung der entsprechenden YouTube-Komponente von YouTube herunterzuladen. Weitere Informationen zu YouTube k\xF6nnen unter https://www.youtube.com/yt/about/de/ abgerufen werden. Im Rahmen dieses technischen Verfahrens erhalten YouTube und Google Kenntnis dar\xFCber, welche konkrete Unterseite unserer Internetseite durch die betroffene Person besucht wird.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Sofern die betroffene Person gleichzeitig bei YouTube eingeloggt ist, erkennt YouTube mit dem Aufruf einer Unterseite, die ein YouTube-Video enth\xE4lt, welche konkrete Unterseite unserer Internetseite die betroffene Person besucht. Diese Informationen werden durch YouTube und Google gesammelt und dem jeweiligen YouTube-Account der betroffenen Person zugeordnet.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'YouTube und Google erhalten \xFCber die YouTube-Komponente immer dann eine Information dar\xFCber, dass die betroffene Person unsere Internetseite besucht hat, wenn die betroffene Person zum Zeitpunkt des Aufrufs unserer Internetseite gleichzeitig bei YouTube eingeloggt ist; dies findet unabh\xE4ngig davon statt, ob die betroffene Person ein YouTube-Video anklickt oder nicht. Ist eine derartige \xDCbermittlung dieser Informationen an YouTube und Google von der betroffenen Person nicht gewollt, kann diese die \xDCbermittlung dadurch verhindern, dass sie sich vor einem Aufruf unserer Internetseite aus ihrem YouTube-Account ausloggt.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Die von YouTube ver\xF6ffentlichten Datenschutzbestimmungen, die unter https://www.google.de/intl/de/policies/privacy/ abrufbar sind, geben Aufschluss \xFCber die Erhebung, Verarbeitung und Nutzung personenbezogener Daten durch YouTube und Google.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'19. Rechtsgrundlage der Verarbeitung'),'Art. 6 I lit. a DS-GVO dient unserem Unternehmen als Rechtsgrundlage f\xFCr Verarbeitungsvorg\xE4nge, bei denen wir eine Einwilligung f\xFCr einen bestimmten Verarbeitungszweck einholen. Ist die Verarbeitung personenbezogener Daten zur Erf\xFCllung eines Vertrags, dessen Vertragspartei die betroffene Person ist, erforderlich, wie dies beispielsweise bei Verarbeitungsvorg\xE4ngen der Fall ist, die f\xFCr eine Lieferung von Waren oder die Erbringung einer sonstigen Leistung oder Gegenleistung notwendig sind, so beruht die Verarbeitung auf Art. 6 I lit. b DS-GVO. Gleiches gilt f\xFCr solche Verarbeitungsvorg\xE4nge die zur Durchf\xFChrung vorvertraglicher Ma\xDFnahmen erforderlich sind, etwa in F\xE4llen von Anfragen zur unseren Produkten oder Leistungen. Unterliegt unser Unternehmen einer rechtlichen Verpflichtung durch welche eine Verarbeitung von personenbezogenen Daten erforderlich wird, wie beispielsweise zur Erf\xFCllung steuerlicher Pflichten, so basiert die Verarbeitung auf Art. 6 I lit. c DS-GVO. In seltenen F\xE4llen k\xF6nnte die Verarbeitung von personenbezogenen Daten erforderlich werden, um lebenswichtige Interessen der betroffenen Person oder einer anderen nat\xFCrlichen Person zu sch\xFCtzen. Dies w\xE4re beispielsweise der Fall, wenn ein Besucher in unserem Betrieb verletzt werden w\xFCrde und daraufhin sein Name, sein Alter, seine Krankenkassendaten oder sonstige lebenswichtige Informationen an einen Arzt, ein Krankenhaus oder sonstige Dritte weitergegeben werden m\xFCssten. Dann w\xFCrde die Verarbeitung auf Art. 6 I lit. d DS-GVO beruhen. Letztlich k\xF6nnten Verarbeitungsvorg\xE4nge auf Art. 6 I lit. f DS-GVO beruhen. Auf dieser Rechtsgrundlage basieren Verarbeitungsvorg\xE4nge, die von keiner der vorgenannten Rechtsgrundlagen erfasst werden, wenn die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich ist, sofern die Interessen, Grundrechte und Grundfreiheiten des Betroffenen nicht \xFCberwiegen. Solche Verarbeitungsvorg\xE4nge sind uns insbesondere deshalb gestattet, weil sie durch den Europ\xE4ischen Gesetzgeber besonders erw\xE4hnt wurden. Er vertrat insoweit die Auffassung, dass ein berechtigtes Interesse anzunehmen sein k\xF6nnte, wenn die betroffene Person ein Kunde des Verantwortlichen ist (Erw\xE4gungsgrund 47 Satz 2 DS-GVO).',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'20. Berechtigte Interessen an der Verarbeitung, die von dem Verantwortlichen oder einem Dritten verfolgt werden'),'Basiert die Verarbeitung personenbezogener Daten auf Artikel 6 I lit. f DS-GVO ist unser berechtigtes Interesse die Durchf\xFChrung unserer Gesch\xE4ftst\xE4tigkeit zugunsten des Wohlergehens all unserer Mitarbeiter und unserer Anteilseigner.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'21. Dauer, f\xFCr die die personenbezogenen Daten gespeichert werden'),'Das Kriterium f\xFCr die Dauer der Speicherung von personenbezogenen Daten ist die jeweilige gesetzliche Aufbewahrungsfrist. Nach Ablauf der Frist werden die entsprechenden Daten routinem\xE4\xDFig gel\xF6scht, sofern sie nicht mehr zur Vertragserf\xFCllung oder Vertragsanbahnung erforderlich sind.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'22. Gesetzliche oder vertragliche Vorschriften zur Bereitstellung der personenbezogenen Daten; Erforderlichkeit f\xFCr den Vertragsabschluss; Verpflichtung der betroffenen Person, die personenbezogenen Daten bereitzustellen; m\xF6gliche Folgen der Nichtbereitstellung'),'Wir kl\xE4ren Sie dar\xFCber auf, dass die Bereitstellung personenbezogener Daten zum Teil gesetzlich vorgeschrieben ist (z.B. Steuervorschriften) oder sich auch aus vertraglichen Regelungen (z.B. Angaben zum Vertragspartner) ergeben kann. Mitunter kann es zu einem Vertragsschluss erforderlich sein, dass eine betroffene Person uns personenbezogene Daten zur Verf\xFCgung stellt, die in der Folge durch uns verarbeitet werden m\xFCssen. Die betroffene Person ist beispielsweise verpflichtet uns personenbezogene Daten bereitzustellen, wenn unser Unternehmen mit ihr einen Vertrag abschlie\xDFt. Eine Nichtbereitstellung der personenbezogenen Daten h\xE4tte zur Folge, dass der Vertrag mit dem Betroffenen nicht geschlossen werden k\xF6nnte. Vor einer Bereitstellung personenbezogener Daten durch den Betroffenen muss sich der Betroffene an unseren Datenschutzbeauftragten wenden. Unser Datenschutzbeauftragter kl\xE4rt den Betroffenen einzelfallbezogen dar\xFCber auf, ob die Bereitstellung der personenbezogenen Daten gesetzlich oder vertraglich vorgeschrieben oder f\xFCr den Vertragsabschluss erforderlich ist, ob eine Verpflichtung besteht, die personenbezogenen Daten bereitzustellen, und welche Folgen die Nichtbereitstellung der personenbezogenen Daten h\xE4tte.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'23. Bestehen einer automatisierten Entscheidungsfindung'),'Als verantwortungsbewusstes Unternehmen verzichten wir auf eine automatische Entscheidungsfindung oder ein Profiling.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Diese Datenschutzerkl\xE4rung wurde durch den Datenschutzerkl\xE4rungs-Generator der DGD Deutsche Gesellschaft f\xFCr Datenschutz GmbH, die als externer Datenschutzbeauftragter t\xE4tig ist, in Kooperation mit der RC GmbH, die gebrauchte Computer wiederverwertet und der Kanzlei WILDE BEUGER SOLMECKE | Rechtsanw\xE4lte erstellt.')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqContact}));}}]);return Contact;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ListItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* unused harmony export SimilarProducts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_DropDownMenu__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_DropDownMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_DropDownMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__landing_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__landing_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__landing_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_css__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__search_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__search_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqSearch=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];function ListItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,props.children);}var typeToLabel={'non-comm':'Angebote aus dem Gesundheitswesen oder Personen','comm':'Angebote von Firmen','software':'Software','service':'Dienstleistung','document':'Dokumente','used-software':'Gebraucht-Software','research-software':'Software Forschung & Lehre','tender':'Ausschreibung','other':'Hardware und Sonstige','regulation':''/* christos: I did not find anything relevant to regulation */};var Search=function(_Component){_inherits(Search,_Component);function Search(props){_classCallCheck(this,Search);var _this=_possibleConstructorReturn(this,(Search.__proto__||Object.getPrototypeOf(Search)).call(this,props));_this.handleFilterChange=function(event,index,filter){// return, if the current filter was selected again
if(filter===_this.state.filter)return;_this.setState({filter:filter,searchInProgress:true},function(){_this.doSearch(function(){return localStorage.setItem('ayacandas_filter',filter);});});};_this.state={filter:"",numberOfStars:0,query:"",lastSentQuery:'',searchInProgress:false,results:[]// debounce by some ms to avoid sending each keystroke as a separate backend request
};_this.debouncedHandleQueryChange=__WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(_this.debouncedHandleQueryChange,600);_this.handleQueryChange=_this.handleQueryChange.bind(_this);return _this;}_createClass(Search,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var storedQuery=localStorage.getItem('ayacandas_search')||'';var storedFilter=localStorage.getItem('ayacandas_filter')||'';this.setState({query:storedQuery,filter:storedFilter},function(){return _this2.doSearch();});}},{key:'handleQueryChange',value:function handleQueryChange(event){this.setState({query:event.target.value});this.debouncedHandleQueryChange(event.target.value);}},{key:'debouncedHandleQueryChange',value:function debouncedHandleQueryChange(query){var _this3=this;var oldQuery=this.state.lastSentQuery.trim();if(oldQuery!==query.trim()){this.setState({query:query,searchInProgress:true},function(){_this3.doSearch(function(){return localStorage.setItem('ayacandas_search',query);});});}else{// no search, just update the search input field
this.setState({query:query});}}},{key:'doSearch',value:function doSearch(callback){var _this4=this;var _state=this.state,filter=_state.filter,query=_state.query,numberOfStars=_state.numberOfStars;var url='/api/search?q='+query;if(filter!==null&&filter!==''){url+='&filter='+filter;}if(numberOfStars>=0){url+='&numberOfStars='+numberOfStars;}fetch(url,{headers:__WEBPACK_IMPORTED_MODULE_8__util_js__["a" /* defaultHeaders */]()}).then(function(resp){_this4.setState({searchInProgress:false});return resp.json();}).then(function(json){if(json&&json.results)_this4.setState({results:json.results,lastSentQuery:query},callback);}).catch(function(err){_this4.setState({searchInProgress:false});});}},{key:'render',value:function render(){var self=this;var detailLink=function detailLink(type,id){switch(type){case"document":return'/document-details/'+id;case"researchsoftware":return'/researchsoftware-details/'+id;case"software":return'/show-software/'+id;case"service":return'/show-service/'+id;case"tender":return'/show-tender/'+id;case"used-software":return'/show-used-software/'+id;case"other":return'/show-other/'+id;default:return'/search';}};var items=this.state.results.map(function(result,index){var shorten=function shorten(string){if(string!==undefined&&string!==null&&string.length>200){return string.substring(0,200)+'[...]';}else{return string;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem,{key:result.type+'-'+result.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundColor:'white',wordWrap:'break-word',width:'100%',padding:'3%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Bold WordWrap SearchLabels'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:detailLink(result.type,result.id)},result.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SearchLabels'},result.product_role==='commercial'?result.product_company:null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'Description'},shorten(result.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'Description'},shorten(result.desc)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'Description'},shorten(result.aim)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ToEndRightV2'},result.id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:detailLink(result.type,result.id)},'Zum Angebot'),' ')),result.categories_text!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#1F6A81',fontFamily:'open sans'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SearchLabels blackColor'},'Kategorie'),result.categories_text.map(function(obj,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'cat'+i,style:{marginBottom:'1%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimilarProducts,{category:obj,categoryID:result.categories_as_array[i],productUUID:result.uuid}));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null))),index+1<self.state.results.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',{className:'hr'})):null);});var styles={menu:{display:'block',fontFamily:'open sans',flex:1,backgroundColor:'#fcfdfe',fontSize:'large',padding:'0px 0px 0px 0px'},item:{fontFamily:'open sans',fontSize:'large'},icon:{display:'inline-block',height:'48px',width:'12px',right:'0px',color:'rgba(0, 0, 0, 0.87)',fill:'rgb(0, 0, 0)',transition:'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchMobilLabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SearchFilter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchInputLabelSmall'},'Kategorie:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_DropDownMenu___default.a,{value:this.state.filter,onChange:this.handleFilterChange,style:styles.menu,iconStyle:styles.icon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'',primaryText:'Alle Angebotskategorien',style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'non-comm',primaryText:typeToLabel['non-comm'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'comm',primaryText:typeToLabel['comm'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'service',primaryText:typeToLabel['service'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'software',primaryText:typeToLabel['software'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'used-software',primaryText:typeToLabel['used-software'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'document',primaryText:typeToLabel['document'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'research-software',primaryText:typeToLabel['research-software'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'other',primaryText:typeToLabel['other'],style:styles.item}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_MenuItem___default.a,{value:'tender',primaryText:typeToLabel['tender'],style:styles.item})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchMobilLabel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchInputLabel'},'Suchbegriffe:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexGrow:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'SearchInput hoverYellow1',type:'search',placeholder:'z.B. nach Entlassmanagement oder DSGVO suchen',value:this.state.query,onChange:this.handleQueryChange,autoFocus:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'blabla'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'searchResult',id:'searchResult'},this.state.searchInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'searchingText'},'Die Suche l\xE4uft...'),items)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__footer_js__["a" /* Footer */],{faqs:faqSearch}));}}]);return Search;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SimilarProducts=function(_Component2){_inherits(SimilarProducts,_Component2);function SimilarProducts(props){_classCallCheck(this,SimilarProducts);var _this5=_possibleConstructorReturn(this,(SimilarProducts.__proto__||Object.getPrototypeOf(SimilarProducts)).call(this,props));_this5.getNeighbours=_this5.getNeighbours.bind(_this5);_this5.state={neighbours:null,expanded:false};return _this5;}_createClass(SimilarProducts,[{key:'getNeighbours',value:function getNeighbours(){if(this.state.expanded===false){this.setState({expanded:true});var url='/api/similar-products?categoryid='+this.props.categoryID+'&uuid='+this.props.productUUID;var self=this;var headers=__WEBPACK_IMPORTED_MODULE_8__util_js__["a" /* defaultHeaders */]();var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte aehnliche Produkte nicht laden.');console.error('Could not load similar products.',exception);});promise.then(function(json){self.setState({neighbours:json});});}else{this.setState({expanded:false});}}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SimilarProducts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:this.state.expanded===true?{fontWeight:'bold',cursor:'pointer'}:{cursor:'pointer'},onClick:function onClick(){return _this6.getNeighbours();},title:'Aufklappen um \xE4hnliche Produkte zu sehen'},this.props.category),this.state.expanded===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'SearchNeighbours'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,this.state.neighbours!==undefined&&this.state.neighbours!==null&&this.state.neighbours.map(function(obj){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:obj.product_link},obj.product_name));}))):null);}}]);return SimilarProducts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MenuItem = __webpack_require__(122);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MenuItem2.default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(327));
var _createClass = _interopDefault(__webpack_require__(328));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(329));
var _getPrototypeOf = _interopDefault(__webpack_require__(331));
var _inherits = _interopDefault(__webpack_require__(332));
var _typeof = _interopDefault(__webpack_require__(124));
var _objectWithoutProperties = _interopDefault(__webpack_require__(334));
var _extends = _interopDefault(__webpack_require__(336));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(1));
var warning = _interopDefault(__webpack_require__(337));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 328 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(124);

var assertThisInitialized = __webpack_require__(330);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 330 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 331 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(333);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 333 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(335);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 335 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 336 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _dom = __webpack_require__(119);

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
var RenderToLayer = function (_Component) {
  (0, _inherits3.default)(RenderToLayer, _Component);

  function RenderToLayer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RenderToLayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      if (!_this.props.componentClickAway) {
        return;
      }

      if (!_this.props.open) {
        return;
      }

      var el = _this.layer;
      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
        _this.props.componentClickAway(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RenderToLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderLayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unrenderLayer();
    }
  }, {
    key: 'getLayer',
    value: function getLayer() {
      return this.layer;
    }
  }, {
    key: 'unrenderLayer',
    value: function unrenderLayer() {
      if (!this.layer) {
        return;
      }

      if (this.props.useLayerForClickAway) {
        this.layer.style.position = 'relative';
        this.layer.removeEventListener('click', this.onClickAway);
      } else {
        window.removeEventListener('click', this.onClickAway);
      }

      (0, _reactDom.unmountComponentAtNode)(this.layer);
      document.body.removeChild(this.layer);
      this.layer = null;
    }

    /**
     * By calling this method in componentDidMount() and
     * componentDidUpdate(), you're effectively creating a "wormhole" that
     * funnels React's hierarchical updates through to a DOM node on an
     * entirely different part of the page.
     */

  }, {
    key: 'renderLayer',
    value: function renderLayer() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          render = _props.render;


      if (open) {
        if (!this.layer) {
          this.layer = document.createElement('div');
          document.body.appendChild(this.layer);

          if (this.props.useLayerForClickAway) {
            this.layer.addEventListener('click', this.onClickAway);
            this.layer.style.position = 'fixed';
            this.layer.style.top = 0;
            this.layer.style.bottom = 0;
            this.layer.style.left = 0;
            this.layer.style.right = 0;
            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
          } else {
            setTimeout(function () {
              window.addEventListener('click', _this2.onClickAway);
            }, 0);
          }
        }

        var layerElement = render();
        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
      } else {
        this.unrenderLayer();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return RenderToLayer;
}(_react.Component);

RenderToLayer.defaultProps = {
  useLayerForClickAway: true
};
RenderToLayer.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
RenderToLayer.propTypes =  false ? {
  componentClickAway: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired,
  render: _propTypes2.default.func.isRequired,
  useLayerForClickAway: _propTypes2.default.bool
} : {};
exports.default = RenderToLayer;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

var _Paper = __webpack_require__(53);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
      maxHeight: '100%'
    },
    horizontal: {
      maxHeight: '100%',
      overflowY: 'auto',
      transform: open ? 'scaleX(1)' : 'scaleX(0)',
      opacity: open ? 1 : 0,
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
    },
    vertical: {
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
    }
  };
}

var PopoverAnimationDefault = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationDefault, _Component);

  function PopoverAnimationDefault() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationDefault, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        _react2.default.createElement(
          'div',
          { style: prepareStyles(styles.horizontal) },
          _react2.default.createElement(
            'div',
            { style: prepareStyles(styles.vertical) },
            this.props.children
          )
        )
      );
    }
  }]);
  return PopoverAnimationDefault;
}(_react.Component);

PopoverAnimationDefault.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationDefault.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationDefault.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationDefault;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(39);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(41);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationCheck = function NavigationCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
  );
};
NavigationCheck = (0, _pure2.default)(NavigationCheck);
NavigationCheck.displayName = 'NavigationCheck';
NavigationCheck.muiName = 'SvgIcon';

exports.default = NavigationCheck;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _shallowEqual = __webpack_require__(40);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _colorManipulator = __webpack_require__(73);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

var _EnhancedButton = __webpack_require__(116);

var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);

var _IconButton = __webpack_require__(78);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _expandLess = __webpack_require__(343);

var _expandLess2 = _interopRequireDefault(_expandLess);

var _expandMore = __webpack_require__(344);

var _expandMore2 = _interopRequireDefault(_expandMore);

var _NestedList = __webpack_require__(345);

var _NestedList2 = _interopRequireDefault(_NestedList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
      insetChildren = props.insetChildren,
      leftAvatar = props.leftAvatar,
      leftCheckbox = props.leftCheckbox,
      leftIcon = props.leftIcon,
      nestedItems = props.nestedItems,
      nestedLevel = props.nestedLevel,
      rightAvatar = props.rightAvatar,
      rightIcon = props.rightIcon,
      rightIconButton = props.rightIconButton,
      rightToggle = props.rightToggle,
      secondaryText = props.secondaryText,
      secondaryTextLines = props.secondaryTextLines;
  var muiTheme = context.muiTheme;
  var listItem = muiTheme.listItem;


  var textColor = muiTheme.baseTheme.palette.textColor;
  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
  var twoLine = secondaryText && secondaryTextLines === 1;
  var threeLine = secondaryText && secondaryTextLines > 1;

  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;

  var styles = {
    root: {
      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
      color: textColor,
      display: 'block',
      fontSize: 16,
      lineHeight: '16px',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },

    // This inner div is needed so that ripples will span the entire container
    innerDiv: {
      marginLeft: nestedLevel * listItem.nestedLevelDepth,
      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
      paddingBottom: singleAvatar ? 20 : 16,
      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
      position: 'relative'
    },

    icons: {
      height: 24,
      width: 24,
      display: 'block',
      position: 'absolute',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      margin: 12
    },

    leftIcon: {
      left: 4
    },

    rightIcon: {
      right: 4
    },

    avatars: {
      position: 'absolute',
      top: singleAvatar ? 8 : 16
    },

    label: {
      cursor: 'pointer'
    },

    leftAvatar: {
      left: 16
    },

    rightAvatar: {
      right: 16
    },

    leftCheckbox: {
      position: 'absolute',
      display: 'block',
      width: 24,
      top: twoLine ? 24 : singleAvatar ? 16 : 12,
      left: 16
    },

    primaryText: {},

    rightIconButton: {
      position: 'absolute',
      display: 'block',
      top: twoLine ? 12 : singleAvatar ? 4 : 0,
      right: 4
    },

    rightToggle: {
      position: 'absolute',
      display: 'block',
      width: 54,
      top: twoLine ? 25 : singleAvatar ? 17 : 13,
      right: 8
    },

    secondaryText: {
      fontSize: 14,
      lineHeight: threeLine ? '18px' : '16px',
      height: threeLine ? 36 : 16,
      margin: 0,
      marginTop: 4,
      color: listItem.secondaryTextColor,

      // needed for 2 and 3 line ellipsis
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: threeLine ? null : 'nowrap',
      display: threeLine ? '-webkit-box' : null,
      WebkitLineClamp: threeLine ? 2 : null,
      WebkitBoxOrient: threeLine ? 'vertical' : null
    }
  };

  return styles;
}

var ListItem = function (_Component) {
  (0, _inherits3.default)(ListItem, _Component);

  function ListItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hovered: false,
      isKeyboardFocused: false,
      open: false,
      rightIconButtonHovered: false,
      rightIconButtonKeyboardFocused: false,
      touch: false
    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
      _this.setState({ isKeyboardFocused: isKeyboardFocused });
      _this.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleMouseEnter = function (event) {
      if (!_this.state.touch) _this.setState({ hovered: true });
      _this.props.onMouseEnter(event);
    }, _this.handleMouseLeave = function (event) {
      _this.setState({ hovered: false });
      _this.props.onMouseLeave(event);
    }, _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }

      if (_this.props.primaryTogglesNestedList) {
        _this.handleNestedListToggle(event);
      }
    }, _this.handleNestedListToggle = function (event) {
      if (_this.props.leftCheckbox) {
        event.preventDefault();
      }
      event.stopPropagation();

      if (_this.props.open === null) {
        _this.setState({ open: !_this.state.open }, function () {
          _this.props.onNestedListToggle(_this);
        });
      } else {
        // Exposing `this` in the callback is quite a bad API.
        // I'm doing a one level deep clone to expose a fake state.open.
        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
          state: {
            open: !_this.state.open
          }
        }));
      }
    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
      if (isKeyboardFocused) {
        _this.setState({
          isKeyboardFocused: false,
          rightIconButtonKeyboardFocused: isKeyboardFocused
        });
      }

      var iconButton = _this.props.rightIconButton;

      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
    }, _this.handleRightIconButtonMouseLeave = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: false });
      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
    }, _this.handleRightIconButtonMouseEnter = function (event) {
      var iconButton = _this.props.rightIconButton;
      _this.setState({ rightIconButtonHovered: true });
      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
    }, _this.handleRightIconButtonMouseUp = function (event) {
      var iconButton = _this.props.rightIconButton;
      event.stopPropagation();
      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
    }, _this.handleRightIconButtonClick = function (event) {
      var iconButton = _this.props.rightIconButton;

      // Stop the event from bubbling up to the list-item
      event.stopPropagation();
      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
    }, _this.handleTouchStart = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchStart(event);
    }, _this.handleTouchEnd = function (event) {
      _this.setState({ touch: true });
      _this.props.onTouchEnd(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({
        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // update the state when the component is controlled.
      if (nextProps.open !== null) this.setState({ open: nextProps.open });
      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
    }

    // This method is needed by the `MenuItem` component.

  }, {
    key: 'applyFocusState',
    value: function applyFocusState(focusState) {
      if (this.button) {
        var buttonEl = _reactDom2.default.findDOMNode(this.button);

        switch (focusState) {
          case 'none':
            buttonEl.blur();
            break;
          case 'focused':
            buttonEl.focus();
            break;
          case 'keyboard-focused':
            this.button.setKeyboardFocus();
            buttonEl.focus();
            break;
        }
      }
    }
  }, {
    key: 'createDisabledElement',
    value: function createDisabledElement(styles, contentChildren, additionalProps) {
      var _props = this.props,
          innerDivStyle = _props.innerDivStyle,
          style = _props.style;


      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createLabelElement',
    value: function createLabelElement(styles, contentChildren, additionalProps) {
      var _props2 = this.props,
          innerDivStyle = _props2.innerDivStyle,
          style = _props2.style;


      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);

      return _react2.default.createElement(
        'label',
        (0, _extends3.default)({}, additionalProps, {
          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
        }),
        contentChildren
      );
    }
  }, {
    key: 'createTextElement',
    value: function createTextElement(styles, data, key) {
      var prepareStyles = this.context.muiTheme.prepareStyles;

      if (_react2.default.isValidElement(data)) {
        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
        if (typeof data.type === 'string') {
          // if element is a native dom node
          style = prepareStyles(style);
        }
        return _react2.default.cloneElement(data, {
          key: key,
          style: style
        });
      }

      return _react2.default.createElement(
        'div',
        { key: key, style: prepareStyles(styles) },
        data
      );
    }
  }, {
    key: 'pushElement',
    value: function pushElement(children, element, baseStyles, additionalProps) {
      if (element) {
        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
          key: children.length,
          style: styles
        }, additionalProps)));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
          children = _props3.children,
          containerElement = _props3.containerElement,
          disabled = _props3.disabled,
          disableKeyboardFocus = _props3.disableKeyboardFocus,
          hoverColor = _props3.hoverColor,
          initiallyOpen = _props3.initiallyOpen,
          innerDivStyle = _props3.innerDivStyle,
          insetChildren = _props3.insetChildren,
          leftAvatar = _props3.leftAvatar,
          leftCheckbox = _props3.leftCheckbox,
          leftIcon = _props3.leftIcon,
          nestedItems = _props3.nestedItems,
          nestedLevel = _props3.nestedLevel,
          nestedListStyle = _props3.nestedListStyle,
          onKeyboardFocus = _props3.onKeyboardFocus,
          isKeyboardFocused = _props3.isKeyboardFocused,
          onMouseEnter = _props3.onMouseEnter,
          onMouseLeave = _props3.onMouseLeave,
          onNestedListToggle = _props3.onNestedListToggle,
          onTouchStart = _props3.onTouchStart,
          onClick = _props3.onClick,
          rightAvatar = _props3.rightAvatar,
          rightIcon = _props3.rightIcon,
          rightIconButton = _props3.rightIconButton,
          rightToggle = _props3.rightToggle,
          primaryText = _props3.primaryText,
          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
          secondaryText = _props3.secondaryText,
          secondaryTextLines = _props3.secondaryTextLines,
          style = _props3.style,
          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context, this.state);
      var contentChildren = [children];

      if (leftIcon) {
        var additionalProps = {
          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
        };
        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
      }

      if (rightIcon) {
        var _additionalProps = {
          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
        };
        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
      }

      if (leftAvatar) {
        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
      }

      if (rightAvatar) {
        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
      }

      if (leftCheckbox) {
        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
      }

      // RightIconButtonElement
      var hasNestListItems = nestedItems.length;
      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;

      if (rightIconButton || needsNestedIndicator) {
        var rightIconButtonElement = rightIconButton;
        var rightIconButtonHandlers = {
          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
          onMouseEnter: this.handleRightIconButtonMouseEnter,
          onMouseLeave: this.handleRightIconButtonMouseLeave,
          onClick: this.handleRightIconButtonClick,
          onMouseDown: this.handleRightIconButtonMouseUp,
          onMouseUp: this.handleRightIconButtonMouseUp
        };

        // Create a nested list indicator icon if we don't have an icon on the right
        if (needsNestedIndicator) {
          rightIconButtonElement = this.state.open ? _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandLess2.default, null)
          ) : _react2.default.createElement(
            _IconButton2.default,
            null,
            _react2.default.createElement(_expandMore2.default, null)
          );
          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
        }

        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
      }

      if (rightToggle) {
        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
      }

      if (primaryText) {
        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
        contentChildren.push(primaryTextElement);
      }

      if (secondaryText) {
        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
        contentChildren.push(secondaryTextElement);
      }

      var nestedList = nestedItems.length ? _react2.default.createElement(
        _NestedList2.default,
        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
        nestedItems
      ) : undefined;

      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);

      return _react2.default.createElement(
        'div',
        null,
        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
          _EnhancedButton2.default,
          (0, _extends3.default)({
            containerElement: containerElement
          }, other, {
            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
            onKeyboardFocus: this.handleKeyboardFocus,
            onMouseLeave: this.handleMouseLeave,
            onMouseEnter: this.handleMouseEnter,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd,
            onClick: this.handleClick,
            disabled: disabled,
            ref: function ref(node) {
              return _this2.button = node;
            },
            style: (0, _simpleAssign2.default)({}, styles.root, style)
          }),
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
            contentChildren
          )
        ),
        nestedList
      );
    }
  }]);
  return ListItem;
}(_react.Component);

ListItem.muiName = 'ListItem';
ListItem.defaultProps = {
  autoGenerateNestedIndicator: true,
  containerElement: 'span',
  disableKeyboardFocus: false,
  disabled: false,
  initiallyOpen: false,
  insetChildren: false,
  nestedItems: [],
  nestedLevel: 0,
  onKeyboardFocus: function onKeyboardFocus() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  onNestedListToggle: function onNestedListToggle() {},
  onTouchEnd: function onTouchEnd() {},
  onTouchStart: function onTouchStart() {},
  open: null,
  primaryTogglesNestedList: false,
  secondaryTextLines: 1
};
ListItem.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
ListItem.propTypes =  false ? {
  /**
   * If true, generate a nested-list-indicator icon when nested list
   * items are detected. Note that an indicator will not be created
   * if a `rightIcon` or `rightIconButton` has been provided to
   * the element.
   */
  autoGenerateNestedIndicator: _propTypes2.default.bool,
  /**
   * Children passed into the `ListItem`.
   */
  children: _propTypes2.default.node,
  /**
   * The element to use as the container for the ListItem. Either a string to
   * use a DOM element or a ReactElement. This is useful for wrapping the
   * ListItem in a custom Link component. If a ReactElement is given, ensure
   * that it passes all of its given props through to the underlying DOM
   * element and renders its children prop for proper integration.
   */
  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  /**
   * If true, the element will not be able to be focused by the keyboard.
   */
  disableKeyboardFocus: _propTypes2.default.bool,
  /**
   * If true, the element will not be clickable
   * and will not display hover effects.
   * This is automatically disabled if either `leftCheckbox`
   * or `rightToggle` is set.
   */
  disabled: _propTypes2.default.bool,
  /**
  * Override the hover background color.
  */
  hoverColor: _propTypes2.default.string,
  /**
   * If true, the nested `ListItem`s are initially displayed.
   */
  initiallyOpen: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the inner div element.
   */
  innerDivStyle: _propTypes2.default.object,
  /**
   * If true, the children will be indented by 72px.
   * This is useful if there is no left avatar or left icon.
   */
  insetChildren: _propTypes2.default.bool,
  /**
   * Use to control if the list item should render as keyboard focused.  If
   * undefined (default), this will be automatically managed.  If provided,
   * it will change the components style.  Note that this will not change the
   * actual focus - and should only be used when you want to simulate
   * keyboard focus (eg. in a rich text input autocomplete).
   */
  isKeyboardFocused: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the left side.
   */
  leftAvatar: _propTypes2.default.element,
  /**
   * This is the `Checkbox` element to be displayed on the left side.
   */
  leftCheckbox: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
   */
  leftIcon: _propTypes2.default.element,
  /**
   * An array of `ListItem`s to nest underneath the current `ListItem`.
   */
  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
  /**
   * Controls how deep a `ListItem` appears.
   * This property is automatically managed, so modify at your own risk.
   */
  nestedLevel: _propTypes2.default.number,
  /**
   * Override the inline-styles of the nested items' `NestedList`.
   */
  nestedListStyle: _propTypes2.default.object,
  /**
   * Callback function fired when the list item is clicked.
   *
   * @param {object} event Click event targeting the list item.
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
   *
   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /** @ignore */
  onMouseEnter: _propTypes2.default.func,
  /** @ignore */
  onMouseLeave: _propTypes2.default.func,
  /**
   * Callback function fired when the `ListItem` toggles its nested list.
   *
   * @param {object} listItem The `ListItem`.
   */
  onNestedListToggle: _propTypes2.default.func,
  /** @ignore */
  onTouchEnd: _propTypes2.default.func,
  /** @ignore */
  onTouchStart: _propTypes2.default.func,
  /**
   * Control toggle state of nested list.
   */
  open: _propTypes2.default.bool,
  /**
   * This is the block element that contains the primary text.
   * If a string is passed in, a div tag will be rendered.
   */
  primaryText: _propTypes2.default.node,
  /**
   * If true, clicking or tapping the primary text of the `ListItem`
   * toggles the nested list.
   */
  primaryTogglesNestedList: _propTypes2.default.bool,
  /**
   * This is the `Avatar` element to be displayed on the right side.
   */
  rightAvatar: _propTypes2.default.element,
  /**
   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
   */
  rightIcon: _propTypes2.default.element,
  /**
   * This is the `IconButton` to be displayed on the right side.
   * Hovering over this button will remove the `ListItem` hover.
   * Also, clicking on this button will not trigger a
   * ripple on the `ListItem`; the event will be stopped and prevented
   * from bubbling up to cause a `ListItem` click.
   */
  rightIconButton: _propTypes2.default.element,
  /**
   * This is the `Toggle` element to display on the right side.
   */
  rightToggle: _propTypes2.default.element,
  /**
   * This is the block element that contains the secondary text.
   * If a string is passed in, a div tag will be rendered.
   */
  secondaryText: _propTypes2.default.node,
  /**
   * Can be 1 or 2. This is the number of secondary
   * text lines before ellipsis will show.
   */
  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = ListItem;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(39);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(41);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandLess = function NavigationExpandLess(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
  );
};
NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
NavigationExpandLess.displayName = 'NavigationExpandLess';
NavigationExpandLess.muiName = 'SvgIcon';

exports.default = NavigationExpandLess;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(39);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(41);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationExpandMore = function NavigationExpandMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
  );
};
NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
NavigationExpandMore.displayName = 'NavigationExpandMore';
NavigationExpandMore.muiName = 'SvgIcon';

exports.default = NavigationExpandMore;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = __webpack_require__(125);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NestedList = function NestedList(props) {
  var children = props.children,
      open = props.open,
      nestedLevel = props.nestedLevel,
      style = props.style;


  if (!open) {
    return null;
  }

  return _react2.default.createElement(
    _List2.default,
    { style: style },
    _react.Children.map(children, function (child) {
      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
        nestedLevel: nestedLevel + 1
      }) : child;
    })
  );
};

NestedList.propTypes =  false ? {
  children: _propTypes2.default.node,
  nestedLevel: _propTypes2.default.number.isRequired,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = NestedList;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Subheader = __webpack_require__(347);

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Subheader2.default;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subheader = function Subheader(props, context) {
  var children = props.children,
      inset = props.inset,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
  var _context$muiTheme = context.muiTheme,
      prepareStyles = _context$muiTheme.prepareStyles,
      subheader = _context$muiTheme.subheader;


  var styles = {
    root: {
      boxSizing: 'border-box',
      color: subheader.color,
      fontSize: 14,
      fontWeight: subheader.fontWeight,
      lineHeight: '48px',
      paddingLeft: inset ? 72 : 16,
      width: '100%'
    }
  };

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
    children
  );
};

Subheader.muiName = 'Subheader';

Subheader.propTypes =  false ? {
  /**
   * Node that will be placed inside the `Subheader`.
   */
  children: _propTypes2.default.node,
  /**
   * If true, the `Subheader` will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

Subheader.defaultProps = {
  inset: false
};

Subheader.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};

exports.default = Subheader;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _events = __webpack_require__(79);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDescendant = function isDescendant(el, target) {
  if (target !== null) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

var clickAwayEvents = ['mouseup', 'touchend'];
var bind = function bind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.on(document, event, callback);
  });
};
var unbind = function unbind(callback) {
  return clickAwayEvents.forEach(function (event) {
    return _events2.default.off(document, event, callback);
  });
};

var ClickAwayListener = function (_Component) {
  (0, _inherits3.default)(ClickAwayListener, _Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.isCurrentlyMounted) {
        var el = _reactDom2.default.findDOMNode(_this);

        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.isCurrentlyMounted = true;
      if (this.props.onClickAway) {
        bind(this.handleClickAway);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.onClickAway !== this.props.onClickAway) {
        unbind(this.handleClickAway);
        if (this.props.onClickAway) {
          bind(this.handleClickAway);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isCurrentlyMounted = false;
      unbind(this.handleClickAway);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return ClickAwayListener;
}(_react.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes2.default.element,
  onClickAway: _propTypes2.default.func
} : {};
exports.default = ClickAwayListener;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotKeyHolder = undefined;

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HotKeyHolder = exports.HotKeyHolder = function () {
  function HotKeyHolder() {
    var _this = this;

    (0, _classCallCheck3.default)(this, HotKeyHolder);

    this.clear = function () {
      _this.timerId = null;
      _this.lastKeys = null;
    };
  }

  (0, _createClass3.default)(HotKeyHolder, [{
    key: 'append',
    value: function append(key) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(this.clear, 500);
      return this.lastKeys = (this.lastKeys || '') + key;
    }
  }]);
  return HotKeyHolder;
}();

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.DropDownMenu = undefined;

var _DropDownMenu2 = __webpack_require__(351);

var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);

var _MenuItem2 = __webpack_require__(122);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DropDownMenu = _DropDownMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _DropDownMenu3.default;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(14);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

var _arrowDropDown = __webpack_require__(352);

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _Menu = __webpack_require__(126);

var _Menu2 = _interopRequireDefault(_Menu);

var _ClearFix = __webpack_require__(353);

var _ClearFix2 = _interopRequireDefault(_ClearFix);

var _Popover = __webpack_require__(123);

var _Popover2 = _interopRequireDefault(_Popover);

var _PopoverAnimationVertical = __webpack_require__(355);

var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);

var _keycode = __webpack_require__(80);

var _keycode2 = _interopRequireDefault(_keycode);

var _events = __webpack_require__(79);

var _events2 = _interopRequireDefault(_events);

var _IconButton = __webpack_require__(78);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context) {
  var disabled = props.disabled;

  var spacing = context.muiTheme.baseTheme.spacing;
  var palette = context.muiTheme.baseTheme.palette;
  var accentColor = context.muiTheme.dropDownMenu.accentColor;
  return {
    control: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      height: '100%',
      position: 'relative',
      width: '100%'
    },
    icon: {
      fill: accentColor,
      position: 'absolute',
      right: spacing.desktopGutterLess,
      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
    },
    iconChildren: {
      fill: 'inherit'
    },
    label: {
      color: disabled ? palette.disabledColor : palette.textColor,
      height: spacing.desktopToolbarHeight + 'px',
      lineHeight: spacing.desktopToolbarHeight + 'px',
      overflow: 'hidden',
      opacity: 1,
      position: 'relative',
      paddingLeft: spacing.desktopGutter,
      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
      textOverflow: 'ellipsis',
      top: 0,
      whiteSpace: 'nowrap'
    },
    labelWhenOpen: {
      opacity: 0,
      top: spacing.desktopToolbarHeight / 8
    },
    root: {
      display: 'inline-block',
      fontSize: spacing.desktopDropDownMenuFontSize,
      height: spacing.desktopSubheaderHeight,
      fontFamily: context.muiTheme.baseTheme.fontFamily,
      outline: 'none',
      position: 'relative',
      transition: _transitions2.default.easeOut()
    },
    rootWhenOpen: {
      opacity: 1
    },
    underline: {
      borderTop: 'solid 1px ' + accentColor,
      bottom: 1,
      left: 0,
      margin: '-1px ' + spacing.desktopGutter + 'px',
      right: 0,
      position: 'absolute'
    }
  };
}

var DropDownMenu = function (_Component) {
  (0, _inherits3.default)(DropDownMenu, _Component);

  function DropDownMenu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DropDownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleClickControl = function (event) {
      event.preventDefault();
      if (!_this.props.disabled) {
        _this.setState({
          open: !_this.state.open,
          anchorEl: _this.rootNode
        });
      }
    }, _this.handleRequestCloseMenu = function () {
      _this.close(false);
    }, _this.handleEscKeyDownMenu = function () {
      _this.close(true);
    }, _this.handleKeyDown = function (event) {
      switch ((0, _keycode2.default)(event)) {
        case 'up':
        case 'down':
        case 'space':
        case 'enter':
          event.preventDefault();
          _this.setState({
            open: true,
            anchorEl: _this.rootNode
          });
          break;
      }
    }, _this.handleItemClick = function (event, child, index) {
      if (_this.props.multiple) {
        if (!_this.state.open) {
          _this.setState({ open: true });
        }
      } else {
        event.persist();
        _this.setState({
          open: false
        }, function () {
          if (_this.props.onChange) {
            _this.props.onChange(event, index, child.props.value);
          }

          _this.close(_events2.default.isKeyboard(event));
        });
      }
    }, _this.handleChange = function (event, value) {
      if (_this.props.multiple && _this.props.onChange) {
        _this.props.onChange(event, undefined, value);
      }
    }, _this.close = function (isKeyboard) {
      _this.setState({
        open: false
      }, function () {
        if (_this.props.onClose) {
          _this.props.onClose();
        }

        if (isKeyboard) {
          var dropArrow = _this.arrowNode;
          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
          dropNode.focus();
          dropArrow.setKeyboardFocus(true);
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // The nested styles for drop-down-menu are modified by toolbar and possibly
  // other user components, so it will give full access to its js styles rather
  // than just the parent.


  (0, _createClass3.default)(DropDownMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.autoWidth) {
        this.setWidth();
      }
      if (this.props.openImmediately) {
        // TODO: Temporary fix to make openImmediately work with popover.
        /* eslint-disable react/no-did-mount-set-state */
        setTimeout(function () {
          return _this2.setState({
            open: true,
            anchorEl: _this2.rootNode
          });
        }, 0);
        /* eslint-enable react/no-did-mount-set-state */
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.props.autoWidth) {
        this.setWidth();
      }
    }
  }, {
    key: 'getInputNode',


    /**
     * This method is deprecated but still here because the TextField
     * need it in order to work. TODO: That will be addressed later.
     */
    value: function getInputNode() {
      var _this3 = this;

      var rootNode = this.rootNode;

      rootNode.focus = function () {
        if (!_this3.props.disabled) {
          _this3.setState({
            open: !_this3.state.open,
            anchorEl: _this3.rootNode
          });
        }
      };

      return rootNode;
    }
  }, {
    key: 'setWidth',
    value: function setWidth() {
      var el = this.rootNode;
      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
        el.style.width = 'auto';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          animated = _props.animated,
          animation = _props.animation,
          autoWidth = _props.autoWidth,
          multiple = _props.multiple,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          iconStyle = _props.iconStyle,
          labelStyle = _props.labelStyle,
          listStyle = _props.listStyle,
          maxHeight = _props.maxHeight,
          menuStyleProp = _props.menuStyle,
          selectionRenderer = _props.selectionRenderer,
          onClose = _props.onClose,
          openImmediately = _props.openImmediately,
          menuItemStyle = _props.menuItemStyle,
          selectedMenuItemStyle = _props.selectedMenuItemStyle,
          style = _props.style,
          underlineStyle = _props.underlineStyle,
          value = _props.value,
          iconButton = _props.iconButton,
          anchorOrigin = _props.anchorOrigin,
          targetOrigin = _props.targetOrigin,
          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
      var _state = this.state,
          anchorEl = _state.anchorEl,
          open = _state.open;
      var prepareStyles = this.context.muiTheme.prepareStyles;

      var styles = getStyles(this.props, this.context);

      var displayValue = '';
      if (!multiple) {
        _react2.default.Children.forEach(children, function (child) {
          if (child && value === child.props.value) {
            if (selectionRenderer) {
              displayValue = selectionRenderer(value, child);
            } else {
              // This will need to be improved (in case primaryText is a node)
              displayValue = child.props.label || child.props.primaryText;
            }
          }
        });
      } else {
        var values = [];
        var selectionRendererChildren = [];
        _react2.default.Children.forEach(children, function (child) {
          if (child && value && value.indexOf(child.props.value) > -1) {
            if (selectionRenderer) {
              values.push(child.props.value);
              selectionRendererChildren.push(child);
            } else {
              values.push(child.props.label || child.props.primaryText);
            }
          }
        });

        displayValue = [];
        if (selectionRenderer) {
          displayValue = selectionRenderer(values, selectionRendererChildren);
        } else {
          displayValue = values.join(', ');
        }
      }

      var menuStyle = void 0;
      if (anchorEl && !autoWidth) {
        menuStyle = (0, _simpleAssign2.default)({
          width: anchorEl.clientWidth
        }, menuStyleProp);
      } else {
        menuStyle = menuStyleProp;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, other, {
          ref: function ref(node) {
            _this4.rootNode = node;
          },
          className: className,
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
        }),
        _react2.default.createElement(
          _ClearFix2.default,
          { style: styles.control, onClick: this.handleClickControl },
          _react2.default.createElement(
            'div',
            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
            displayValue
          ),
          _react2.default.createElement(
            _IconButton2.default,
            {
              disabled: disabled,
              onKeyDown: this.handleKeyDown,
              ref: function ref(node) {
                _this4.arrowNode = node;
              },
              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
              iconStyle: styles.iconChildren
            },
            iconButton
          ),
          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
        ),
        _react2.default.createElement(
          _Popover2.default,
          {
            anchorOrigin: anchorOrigin,
            targetOrigin: targetOrigin,
            anchorEl: anchorEl,
            animation: animation || _PopoverAnimationVertical2.default,
            open: open,
            animated: animated,
            onRequestClose: this.handleRequestCloseMenu
          },
          _react2.default.createElement(
            _Menu2.default,
            {
              multiple: multiple,
              maxHeight: maxHeight,
              desktop: true,
              value: value,
              onEscKeyDown: this.handleEscKeyDownMenu,
              style: menuStyle,
              listStyle: listStyle,
              onItemClick: this.handleItemClick,
              onChange: this.handleChange,
              menuItemStyle: menuItemStyle,
              selectedMenuItemStyle: selectedMenuItemStyle,
              autoWidth: autoWidth,
              width: !autoWidth && menuStyle ? menuStyle.width : null
            },
            children
          )
        )
      );
    }
  }]);
  return DropDownMenu;
}(_react.Component);

DropDownMenu.muiName = 'DropDownMenu';
DropDownMenu.defaultProps = {
  animated: true,
  autoWidth: true,
  disabled: false,
  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
  openImmediately: false,
  maxHeight: 500,
  multiple: false,
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
DropDownMenu.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
DropDownMenu.propTypes =  false ? {
  /**
   * This is the point on the anchor that the popover's
   * `targetOrigin` will attach to.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  anchorOrigin: _propTypes4.default.origin,
  /**
   * If true, the popover will apply transitions when
   * it gets added to the DOM.
   */
  animated: _propTypes2.default.bool,
  /**
   * Override the default animation component used.
   */
  animation: _propTypes2.default.func,
  /**
   * The width will automatically be set according to the items inside the menu.
   * To control this width in css instead, set this prop to `false`.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
   * prop `label` that value will be used to render the representation of that
   * item within the field.
   */
  children: _propTypes2.default.node,
  /**
   * The css class name of the root element.
   */
  className: _propTypes2.default.string,
  /**
   * Disables the menu.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Overrides default `SvgIcon` dropdown arrow component.
   */
  iconButton: _propTypes2.default.node,
  /**
   * Overrides the styles of icon element.
   */
  iconStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of label when the `DropDownMenu` is inactive.
   */
  labelStyle: _propTypes2.default.object,
  /**
   * The style object to use to override underlying list style.
   */
  listStyle: _propTypes2.default.object,
  /**
   * The maximum height of the `Menu` when it is displayed.
   */
  maxHeight: _propTypes2.default.number,
  /**
   * Override the inline-styles of menu items.
   */
  menuItemStyle: _propTypes2.default.object,
  /**
   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
   */
  menuStyle: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support
   * multiple selections.
   */
  multiple: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {object} event Click event targeting the menu item that was clicked.
   * @param {number} key The index of the clicked menu item in the `children` collection.
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback function fired when the menu is closed.
   */
  onClose: _propTypes2.default.func,
  /**
   * Set to true to have the `DropDownMenu` automatically open on mount.
   */
  openImmediately: _propTypes2.default.bool,
  /**
   * Override the inline-styles of selected menu items.
   */
  selectedMenuItemStyle: _propTypes2.default.object,
  /**
   * Callback function fired when a menu item is clicked, other than the one currently selected.
   *
   * @param {any} value If `multiple` is true, the menu's `value`
   * array with either the menu item's `value` added (if
   * it wasn't already selected) or omitted (if it was already selected).
   * Otherwise, the `value` of the menu item.
   * @param {any} menuItem The selected `MenuItem`.
   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
   */
  selectionRenderer: _propTypes2.default.func,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  /**
   * This is the point on the popover which will attach to
   * the anchor's origin.
   * Options:
   * vertical: [top, center, bottom]
   * horizontal: [left, middle, right].
   */
  targetOrigin: _propTypes4.default.origin,
  /**
   * Overrides the inline-styles of the underline.
   */
  underlineStyle: _propTypes2.default.object,
  /**
   * If `multiple` is true, an array of the `value`s of the selected
   * menu items. Otherwise, the `value` of the selected menu item.
   * If provided, the menu will be a controlled component.
   */
  value: _propTypes2.default.any
} : {};
exports.default = DropDownMenu;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(39);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(41);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
  );
};
NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
NavigationArrowDropDown.muiName = 'SvgIcon';

exports.default = NavigationArrowDropDown;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(12);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BeforeAfterWrapper = __webpack_require__(354);

var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  before: {
    content: "' '",
    display: 'table'
  },
  after: {
    content: "' '",
    clear: 'both',
    display: 'table'
  }
};

var ClearFix = function ClearFix(_ref) {
  var style = _ref.style,
      children = _ref.children,
      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
  return _react2.default.createElement(
    _BeforeAfterWrapper2.default,
    (0, _extends3.default)({}, other, {
      beforeStyle: styles.before,
      afterStyle: styles.after,
      style: style
    }),
    children
  );
};

ClearFix.muiName = 'ClearFix';

ClearFix.propTypes =  false ? {
  children: _propTypes2.default.node,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = ClearFix;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(11);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  BeforeAfterWrapper
 *    An alternative for the ::before and ::after css pseudo-elements for
 *    components whose styles are defined in javascript instead of css.
 *
 *  Usage: For the element that we want to apply before and after elements to,
 *    wrap its children with BeforeAfterWrapper. For example:
 *
 *                                            <Paper>
 *  <Paper>                                     <div> // See notice
 *    <BeforeAfterWrapper>        renders         <div/> // before element
 *      [children of paper]       ------>         [children of paper]
 *    </BeforeAfterWrapper>                       <div/> // after element
 *  </Paper>                                    </div>
 *                                            </Paper>
 *
 *  Notice: Notice that this div bundles together our elements. If the element
 *    that we want to apply before and after elements is a HTML tag (i.e. a
 *    div, p, or button tag), we can avoid this extra nesting by passing using
 *    the BeforeAfterWrapper in place of said tag like so:
 *
 *  <p>
 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
 *      [children of p]          ------>         [children of p]
 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
 *  </p>
 *
 *  BeforeAfterWrapper features spread functionality. This means that we can
 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
 *
 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
 *  and afterElement have a defined style position.
 */

var styles = {
  box: {
    boxSizing: 'border-box'
  }
};

var BeforeAfterWrapper = function (_Component) {
  (0, _inherits3.default)(BeforeAfterWrapper, _Component);

  function BeforeAfterWrapper() {
    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(BeforeAfterWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          beforeStyle = _props.beforeStyle,
          afterStyle = _props.afterStyle,
          beforeElementType = _props.beforeElementType,
          afterElementType = _props.afterElementType,
          elementType = _props.elementType,
          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
      var prepareStyles = this.context.muiTheme.prepareStyles;


      var beforeElement = void 0;
      var afterElement = void 0;

      if (beforeStyle) {
        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
          key: '::before'
        });
      }

      if (afterStyle) {
        afterElement = _react2.default.createElement(this.props.afterElementType, {
          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
          key: '::after'
        });
      }

      var children = [beforeElement, this.props.children, afterElement];

      var props = other;
      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));

      return _react2.default.createElement(this.props.elementType, props, children);
    }
  }]);
  return BeforeAfterWrapper;
}(_react.Component);

BeforeAfterWrapper.defaultProps = {
  beforeElementType: 'div',
  afterElementType: 'div',
  elementType: 'div'
};
BeforeAfterWrapper.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
BeforeAfterWrapper.propTypes =  false ? {
  afterElementType: _propTypes2.default.string,
  afterStyle: _propTypes2.default.object,
  beforeElementType: _propTypes2.default.string,
  beforeStyle: _propTypes2.default.object,
  children: _propTypes2.default.node,
  elementType: _propTypes2.default.string,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object
} : {};
exports.default = BeforeAfterWrapper;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(5);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(3);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(4);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(6);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(7);

var _inherits3 = _interopRequireDefault(_inherits2);

var _simpleAssign = __webpack_require__(9);

var _simpleAssign2 = _interopRequireDefault(_simpleAssign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(53);

var _Paper2 = _interopRequireDefault(_Paper);

var _transitions = __webpack_require__(15);

var _transitions2 = _interopRequireDefault(_transitions);

var _propTypes3 = __webpack_require__(21);

var _propTypes4 = _interopRequireDefault(_propTypes3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStyles(props, context, state) {
  var targetOrigin = props.targetOrigin;
  var open = state.open;
  var muiTheme = context.muiTheme;

  var horizontal = targetOrigin.horizontal.replace('middle', 'center');

  return {
    root: {
      position: 'fixed',
      zIndex: muiTheme.zIndex.popover,
      opacity: open ? 1 : 0,
      transform: open ? 'scaleY(1)' : 'scaleY(0)',
      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
      maxHeight: '100%'
    }
  };
}

var PopoverAnimationVertical = function (_Component) {
  (0, _inherits3.default)(PopoverAnimationVertical, _Component);

  function PopoverAnimationVertical() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopoverAnimationVertical, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        open: nextProps.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          zDepth = _props.zDepth;


      var styles = getStyles(this.props, this.context, this.state);

      return _react2.default.createElement(
        _Paper2.default,
        {
          style: (0, _simpleAssign2.default)(styles.root, style),
          zDepth: zDepth,
          className: className
        },
        this.props.children
      );
    }
  }]);
  return PopoverAnimationVertical;
}(_react.Component);

PopoverAnimationVertical.defaultProps = {
  style: {},
  zDepth: 1
};
PopoverAnimationVertical.contextTypes = {
  muiTheme: _propTypes2.default.object.isRequired
};
PopoverAnimationVertical.propTypes =  false ? {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  open: _propTypes2.default.bool.isRequired,
  /**
   * Override the inline-styles of the root element.
   */
  style: _propTypes2.default.object,
  targetOrigin: _propTypes4.default.origin.isRequired,
  zDepth: _propTypes4.default.zDepth
} : {};
exports.default = PopoverAnimationVertical;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(127),
    now = __webpack_require__(357),
    toNumber = __webpack_require__(359);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(128);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43)))

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(127),
    isSymbol = __webpack_require__(360);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(361),
    isObjectLike = __webpack_require__(364);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(129),
    getRawTag = __webpack_require__(362),
    objectToString = __webpack_require__(363);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(129);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewServiceDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_details__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__product_details_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__show_categorypath_js__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductDetails=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];var NewServiceDetails=function(_Component){_inherits(NewServiceDetails,_Component);function NewServiceDetails(props){_classCallCheck(this,NewServiceDetails);var _this=_possibleConstructorReturn(this,(NewServiceDetails.__proto__||Object.getPrototypeOf(NewServiceDetails)).call(this,props));_this.getNewServiceDetails=_this.getNewServiceDetails.bind(_this);_this.state={type:'Dienstleistung',id:_this.props.match.params['id'],name:'',board:'',uuid:'',description:'',references:'',categories:'',customer_reference:'',warrantor:'',expertise:'',price_from:'',price_to:'',pdf_file:'',tags:'',agreement:'',agb_agreement:''};if(!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&_this.id!==undefined){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(){return _this.getNewServiceDetails(_this.props.match.params['id']);});}else{_this.getNewServiceDetails(_this.props.match.params['id']);}return _this;}_createClass(NewServiceDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.match.params['id'],10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getNewServiceDetails(newID);this.setState({id:newID});}}},{key:'getNewServiceDetails',value:function getNewServiceDetails(productID){var self=this;var url='/api/show-service?id='+productID;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not service details.',exception);});promise.then(function(json){localStorage.setItem('product-name',json.name);self.setState({name:json.name?json.name:'(kein Name)',board:json.board?json.board:'',uuid:json.uuid?json.uuid:'',description:json.description?json.description:'(keine Angabe)',references:json.references?json.references:'(keine Angabe)',categories:json.categories?json.categories:'(keine Angabe)',customer_reference:json.customer_reference?json.customer_reference:'(keine Angabe)',warrantor:json.warrantor?json.warrantor:'(keine Angabe)',expertise:json.expertise?json.expertise:'(keine Angabe)',price_from:json.price_from!==undefined?json.price_from:'(keine Angabe)',price_to:json.price_to!==undefined?json.price_to:'(keine Angabe)',pdf_file:json.pdf_file?json.pdf_file:'(keine Angabe)',tags:json.tags?json.tags:'(keine Angabe)',agreement:json.agreement?json.agreement:'(keine Angabe)',agb_agreement:json.agb_agreement?json.agb_agreement:'(keine Angabe)'});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["t" /* ProductTypeWithoutParantheses */],{name:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price_from,price2:this.state.price_to,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productInfoHeader'},__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["a" /* CommUserInfo */],{id:this.props.match.params['id'],table:"service"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["s" /* ProductTypeWithLabel */],{productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["a" /* CommUserInfo */],{id:this.state.id,table:"document"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__show_categorypath_js__["a" /* CategoryPathWithLabel */],{ids:this.state.categories,startID:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["m" /* ProductRating */],{uuid:this.state.uuid}),!__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["l" /* ProductPrice */],{price:this.state.price})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsService,{onNewMessage:this.props.onNewMessage,uuid:this.state.uuid,productID:this.state.id,description:this.state.description,expertise:this.state.expertise,tags:this.state.tags,pdf_file:this.state.pdf_file,customer_reference:this.state.customer_reference,warrantor:this.state.warrantor,references:this.state.references}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price_from,price2:this.state.price_to,onNewMessage:this.props.onNewMessage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return NewServiceDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsService=function(_Component2){_inherits(ProductTabsService,_Component2);function ProductTabsService(props){_classCallCheck(this,ProductTabsService);var _this2=_possibleConstructorReturn(this,(ProductTabsService.__proto__||Object.getPrototypeOf(ProductTabsService)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsService,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'ref. Software'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===3?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(3);}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===4?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(4);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["e" /* ProductDescriptionService */],{style:this.state.activeTab===0?null:{display:'none'},description:this.props.description,service_expertise:this.props.expertise,tags:this.props.tags}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["n" /* ProductReferenceService */],{style:this.state.activeTab===1?null:{display:'none'},service_customer_reference:this.props.customer_reference,warrantor:this.props.warrantor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["q" /* ProductSoftwareNew */],{style:this.state.activeTab===2?null:{display:'none'},referenced_software:this.props.references}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["j" /* ProductMedia */],{style:this.state.activeTab===3?null:{display:'none'},uuid:this.props.pdf_file}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["p" /* ProductReviews */],{uuid:this.props.uuid,style:this.state.activeTab===4?null:{display:'none'},onNewMessage:this.props.onNewMessage})));}}]);return ProductTabsService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Stars; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stars_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stars_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__stars_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Stars=function(_Component){_inherits(Stars,_Component);function Stars(props){_classCallCheck(this,Stars);var _this=_possibleConstructorReturn(this,(Stars.__proto__||Object.getPrototypeOf(Stars)).call(this,props));_this.onStarClick=_this.onStarClick.bind(_this);_this.onStarHover=_this.onStarHover.bind(_this);_this.onStarLeave=_this.onStarLeave.bind(_this);_this.state={rating:props.rating||0,hover:0};return _this;}_createClass(Stars,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({rating:nextProps.rating});}},{key:'notifyRatingChanged',value:function notifyRatingChanged(value){if(this.props.notifyRatingChanged!==undefined){this.props.notifyRatingChanged(value);}return true;}},{key:'onStarClick',value:function onStarClick(value){if(value===this.state.rating){this.notifyRatingChanged(0);this.setState({rating:0});}else{this.notifyRatingChanged(value);this.setState({rating:value});}}},{key:'onStarHover',value:function onStarHover(value){this.setState({hover:value});}},{key:'onStarLeave',value:function onStarLeave(){this.setState({hover:0});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'DetailDiv Stars marginTop10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'Klicke auf einen Stern, um zu bewerten!',className:'',onMouseLeave:this.onStarLeave},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Starlet',onClick:function onClick(){return _this2.onStarClick(1);},onMouseLeave:this.onStarLeave,onMouseEnter:function onMouseEnter(){return _this2.onStarHover(1);},style:this.state.hover>=1||this.state.rating>=1?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Starlet',onClick:function onClick(){return _this2.onStarClick(2);},onMouseLeave:this.onStarLeave,onMouseEnter:function onMouseEnter(){return _this2.onStarHover(2);},style:this.state.hover>=2||this.state.rating>=2?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Starlet',onClick:function onClick(){return _this2.onStarClick(3);},onMouseLeave:this.onStarLeave,onMouseEnter:function onMouseEnter(){return _this2.onStarHover(3);},style:this.state.hover>=3||this.state.rating>=3?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Starlet',onClick:function onClick(){return _this2.onStarClick(4);},onMouseLeave:this.onStarLeave,onMouseEnter:function onMouseEnter(){return _this2.onStarHover(4);},style:this.state.hover>=4||this.state.rating>=4?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'Starlet',onClick:function onClick(){return _this2.onStarClick(5);},onMouseLeave:this.onStarLeave,onMouseEnter:function onMouseEnter(){return _this2.onStarHover(5);},style:this.state.hover>=5||this.state.rating>=5?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'FontXsmall textAlignCenter'},this.state.rating,' von 5 Sternen')));}}]);return Stars;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StaticStars; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stars_css__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stars_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stars_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StaticStars=function(_Component){_inherits(StaticStars,_Component);function StaticStars(props){_classCallCheck(this,StaticStars);var _this=_possibleConstructorReturn(this,(StaticStars.__proto__||Object.getPrototypeOf(StaticStars)).call(this,props));_this.getProductRating=_this.getProductRating.bind(_this);_this.state={ratingAverage:-1,count:0,uuid:''};return _this;}_createClass(StaticStars,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.uuid!==undefined&&nextProps.uuid!==null&&nextProps.uuid!==''&&nextProps.uuid!==this.state.uuid){this.setState({uuid:nextProps.uuid});this.getProductRating(nextProps.uuid);}}},{key:'getProductRating',value:function getProductRating(uuid){var self=this;var url='/api/get-rating?uuid='+uuid;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");fetch(url,{method:'GET',mode:'cors',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Durchschnittliche Bewertung konnte nicht geladen werden.');console.error('Could not load product rating average.',exception);}).then(function(json){self.setState({ratingAverage:json.round,count:json.count});});return true;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'StaticStars VerticalAlignmiddle',title:'Durchschnittliche Bewertung',style:{textAlign:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'StarStatic',style:this.state.ratingAverage>0?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'StarStatic',style:this.state.ratingAverage>1?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'StarStatic',style:this.state.ratingAverage>2?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'StarStatic',style:this.state.ratingAverage>3?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'StarStatic',style:this.state.ratingAverage>4?{color:'#1F6A81'}:{color:'lightgrey'}},'\u2605')),this.state.count!==undefined&&this.state.count>=1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.ratingAverage,'/5 bei ',this.state.count,' ',this.state.count===1?'Bewertung':'Bewertungen'):null);}}]);return StaticStars;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReviewEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__review_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__review_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__review_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReviewEntry=function(_Component){_inherits(ReviewEntry,_Component);function ReviewEntry(){_classCallCheck(this,ReviewEntry);return _possibleConstructorReturn(this,(ReviewEntry.__proto__||Object.getPrototypeOf(ReviewEntry)).apply(this,arguments));}_createClass(ReviewEntry,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ReviewEntry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',null,this.props.rating,'/5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.review));}}]);return ReviewEntry;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_details__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__product_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__product_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__show_categorypath_js__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductDetails=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];var DocumentDetails=function(_Component){_inherits(DocumentDetails,_Component);function DocumentDetails(props){_classCallCheck(this,DocumentDetails);var _this=_possibleConstructorReturn(this,(DocumentDetails.__proto__||Object.getPrototypeOf(DocumentDetails)).call(this,props));_this.getDocumentDetails=_this.getDocumentDetails.bind(_this);_this.state={id:_this.props.match.params.id,name:'',type:'Dokument',board:'',uuid:'',categories:'',price:0,doctype:'',aim:'',content:'',links:'',target:'',specialties:'',usage:'',review1:'',review2:'',tags:[],pdf_files:'',image_files:'',video_files:''};if(!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&_this.id!==undefined){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(){return _this.getDocumentDetails(_this.state.id);});}else{_this.getDocumentDetails(_this.state.id);}return _this;}_createClass(DocumentDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.id,10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getDocumentDetails(newID);this.setState({id:newID});}}},{key:'getDocumentDetails',value:function getDocumentDetails(productID){var self=this;var url='/api/show-document?id='+productID;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){console.error('Could not document details.',exception);});promise.then(function(json){localStorage.setItem('product-name',json.name);self.setState({name:json.name?json.name:'(kein Name)',board:json.board?json.board:'',uuid:json.uuid?json.uuid:'',categories:json.categories?json.categories:'(kein Name)',price:json.price!==undefined?json.price:'(keine Angabe)',doctype:json.doctype?json.doctype:'(von unbekanntem Typ)',aim:json.aim?json.aim:'(keine Angabe)',content:json.content?json.content:'(keine Angabe)',links:json.links?json.links:'(keine Angabe)',target:json.target?json.target:'(keine Angabe)',specialties:json.specialties?json.specialties:'(keine Angabe)',usage:json.usage?json.usage:'(keine Angabe)',review1:json.review1?json.review1:'(keine Angabe)',review2:json.review2?json.review2:'(keine Angabe)',tags:json.tags?json.tags:'(keine Angabe)',pdf_files:json.pdf_files?json.pdf_files:'(keine Angabe)',image_files:json.image_files?json.image_files:'(keine Angabe',video_files:json.video_files?json.video_files:'(keine Angabe)'});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["t" /* ProductTypeWithoutParantheses */],{name:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productInfoHeader'},__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["s" /* ProductTypeWithLabel */],{productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["a" /* CommUserInfo */],{id:this.state.id,table:"document"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__show_categorypath_js__["a" /* CategoryPathWithLabel */],{ids:this.state.categories,startID:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["m" /* ProductRating */],{uuid:this.state.uuid}),!__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["l" /* ProductPrice */],{price:this.state.price})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsDocument,{uuid:this.state.uuid,productID:this.state.id,aim:this.state.aim,doctype:this.state.doctype,content:this.state.content,links:this.state.links,target:this.state.target,specialties:this.state.specialties,usage:this.state.usage,review1:this.state.review1,review2:this.state.review2,tags:this.state.tags,pdf_files:this.state.pdf_files,image_files:this.state.image_files,video_files:this.state.video_files}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,history:this.props.history}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return DocumentDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsDocument=function(_Component2){_inherits(ProductTabsDocument,_Component2);function ProductTabsDocument(props){_classCallCheck(this,ProductTabsDocument);var _this2=_possibleConstructorReturn(this,(ProductTabsDocument.__proto__||Object.getPrototypeOf(ProductTabsDocument)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsDocument,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["b" /* ProductDescriptionDocument */],{style:this.state.activeTab===0?null:{display:'none'},aim:this.props.aim,doctype:this.props.doctype,content:this.props.content,links:this.props.links,target:this.props.target,specialties:this.props.specialties,usage:this.props.usage,review1:this.props.review1,review2:this.props.review2,tags:this.props.tags}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["p" /* ProductReviews */],{uuid:this.props.uuid,style:this.state.activeTab===1?null:{display:'none'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["k" /* ProductMediaMultiParent */],{style:this.state.activeTab===2?null:{display:'none'},heading1:'Dokumentation',uuids1:this.props.pdf_files,heading2:'Beschreibende Bilder oder Screenshots',uuids2:this.props.image_files,heading3:'Video',uuids3:this.props.video_files})));}}]);return ProductTabsDocument;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewSoftwareDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_details__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__product_details_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductDetails=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];var NewSoftwareDetails=function(_Component){_inherits(NewSoftwareDetails,_Component);function NewSoftwareDetails(props){_classCallCheck(this,NewSoftwareDetails);var _this=_possibleConstructorReturn(this,(NewSoftwareDetails.__proto__||Object.getPrototypeOf(NewSoftwareDetails)).call(this,props));_this.getNewSoftwareDetails=_this.getNewSoftwareDetails.bind(_this);_this.state={id:_this.props.match.params['id'],name:'',board:'',uuid:'',type:'Software',categories:'',aim:'',is_standalone_sw:'',standalone_sw:'',is_update_available:'',update_price_text:'',update_price:0,target_group:'',is_public:'',tags:[],price:0,price_from:0,price_to:0,direct_database_access:'',direct_database_access_desc:'',has_additional_interface:'',additional_interface:'',has_additional_licence:'',additional_licence:'',data_component_complete:'',data_component_options:'',data_manipulation:'',data_manipulation_protocol:'',manipulation_authorised:'',manipulation_authorised_desc:'',data_update_interval:0,has_update_side_effect:'',update_side_effect:'',has_release_plan:'',release_plan:'',is_preparation_needed:'',preparation_needed:'',has_customer_reference:'',customer_reference:'',warrantor:'',successful_deployment:'',successful_deployment_description:'',clinic_desc:'',clinic_number:'',user_number:'',satisfaction_rate:'',rating_desc:'',date:'',complexity_rate:'',statistics:'',reviews:'',numberOfStars:0,pdf_files:'',image_files:'',video_files:''};if(!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&_this.id!==undefined){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(){return _this.getNewSoftwareDetails(_this.props.params['id']);});}else{_this.getNewSoftwareDetails(_this.props.match.params['id']);}return _this;}_createClass(NewSoftwareDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.params['id'],10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getNewSoftwareDetails(newID);this.setState({id:newID});}}},{key:'getNewSoftwareDetails',value:function getNewSoftwareDetails(productID){var self=this;var url='/api/show-software?id='+productID;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Softwaredetails konnten nicht geladen werden.');console.error('Could not fetch software details.',exception);});promise.then(function(json){localStorage.setItem('product-name',json.name);self.setState({name:json.name?json.name:'(kein Name)',board:json.board?json.board:'',uuid:json.uuid?json.uuid:'',aim:json.aim?json.aim:'(keine Beschreibung)',categories:json.categories?json.categories:'(keine Angabe)',is_standalone_sw:json.is_standalone_sw?json.is_standalone_sw:'(keine Angabe)',standalone_sw:json.standalone_sw?json.standalone_sw:'(keine Beschreibung)',is_update_available:json.is_update_available?json.is_update_available:'(keine Angabe)',update_price_text:json.update_price_text?json.update_price_text:'(keine Beschreibung)',update_price:json.update_price?json.update_price:'(keine Angabe)',target_group:json.target_group?json.target_group:'(keine Angabe)',is_public:json.is_public?json.is_public:'(keine Angabe)',tags:json.tags?json.tags:'(keine Angabe)',price:json.price!==undefined?json.price:'(kein Preis Angegeben)',price_from:json.price_from!==undefined?json.price_from:'(keine Angabe)',price_to:json.price_to!==undefined?json.price_to:'(keine Angabe)',direct_database_access:json.direct_database_access?json.direct_database_access:'(keine Angabe)',direct_database_access_desc:json.direct_database_access_desc?json.direct_database_access_desc:'(keine Beschreibung)',has_additional_interface:json.has_additional_interface?json.has_additional_interface:'(keine Angabe)',additional_interface:json.additional_interface?json.additional_interface:'(keine Beschreibung)',has_additional_licence:json.has_additional_licence?json.has_additional_licence:'(keine Angabe)',additional_licence:json.additional_licence?json.additional_licence:'(keine Beschreibung)',data_component_complete:json.data_component_complete?json.data_component_complete:'(keine Angabe)',data_component_options:json.data_component_options?json.data_component_options:'(keine Beschreibung)',data_manipulation:json.data_manipulation?json.data_manipulation:'(keine Angabe)',data_manipulation_protocol:json.data_manipulation_protocol?json.data_manipulation_protocol:'(keine Beschreibung)',manipulation_authorised:json.manipulation_authorised?json.manipulation_authorised:'(keine Angabe)',manipulation_authorised_desc:json.manipulation_authorised_desc?json.manipulation_authorised_desc:'(keine Beschreibung)',data_update_interval:json.data_update_interval?json.data_update_interval:'(keine Angabe)',has_update_side_effect:json.has_update_side_effect?json.has_update_side_effect:'(keine Angabe)',update_side_effect:json.update_side_effect?json.update_side_effect:'(keine Beschreibung)',has_release_plan:json.has_release_plan?json.has_release_plan:'(keine Angabe)',release_plan:json.release_plan?json.release_plan:'(keine Beschreibung)',is_preparation_needed:json.is_preparation_needed?json.is_preparation_needed:'(keine Angabe)',preparation_needed:json.preparation_needed?json.preparation_needed:'(keine Beschreibung)',has_customer_reference:json.has_customer_reference?json.has_customer_reference:'(keine Angabe)',customer_reference:json.customer_reference?json.customer_reference:'(keine Beschreibung)',warrantor:json.warrantor?json.warrantor:'(keine Angabe)',successful_deployment:json.successful_deployment?json.successful_deployment:'(keine Angabe)',successful_deployment_description:json.successful_deployment_description?json.successful_deployment_description:'(keine Beschreibung)',clinic_desc:json.clinic_desc?json.clinic_desc:'(keine Angabe)',clinic_number:json.clinic_number?json.clinic_number:'(keine Beschreibung)',user_number:json.user_number?json.user_number:'(keine Angabe)',satisfaction_rate:json.satisfaction_rate?json.satisfaction_rate:'(keine Angabe)',rating_desc:json.rating_desc?json.rating_desc:'(keine Beschreibung)',date:json.date?json.date:'(keine Angabe)',complexity_rate:json.complexity_rate?json.complexity_rate:'(keine Angabe)',referenced_software:json.referenced_software?json.referenced_software:'(keine Angabe)',pdf_files:json.pdf_files?json.pdf_files:'(keine Dokumente)',image_files:json.image_files?json.image_files:'(keine Bilder)',video_files:json.video_files?json.video_files:'(kein Video)'});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["t" /* ProductTypeWithoutParantheses */],{name:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productInfoHeader'},__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["s" /* ProductTypeWithLabel */],{productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["a" /* CommUserInfo */],{id:this.props.match.params['id'],table:"software"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__["a" /* CategoryPathWithLabel */],{ids:this.state.categories,startID:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["m" /* ProductRating */],{uuid:this.state.uuid}),!__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["l" /* ProductPrice */],{price:this.state.price})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsSoftware,{onNewMessage:this.props.onNewMessage,uuid:this.state.uuid,productID:this.state.id,description:this.state.aim,categories:this.state.categories,is_separate_sw:this.state.is_standalone_sw,separate_sw:this.state.standalone_sw,has_update_offer:this.state.is_update_available,update_offer:this.state.update_price_text,price_update:this.state.update_price,sw_type:this.state.target_group,is_kommune:this.state.is_public,tags:this.state.tags,direct_database_access:this.state.direct_database_access,direct_database_access_desc:this.state.direct_database_access_desc,has_additional_interface:this.state.has_additional_interface,additional_interface:this.state.additional_interface,has_additional_licence:this.state.has_additional_licence,additional_licence:this.state.additional_licence,data_component_complete:this.state.data_component_complete,data_component_options:this.state.data_component_options,data_manupulation:this.state.data_manipulation,data_manupulation_protocol:this.state.data_manipulation_protocol,manipulation_authorised:this.state.manipulation_authorised,manipulation_authorised_desc:this.state.manipulation_authorised_desc,data_update_interval:this.state.data_update_interval,has_update_side_effect:this.state.has_update_side_effect,update_side_effect:this.state.update_side_effect,has_release_plan:this.state.has_release_plan,release_plan:this.state.release_plan,is_preparation_needed:this.state.is_preparation_needed,preparation_needed:this.state.preparation_needed,has_customer_reference:this.state.has_customer_reference,customer_reference:this.state.customer_reference,successful_deployment:this.state.successful_deployment,successful_deployment_description:this.state.successful_deployment_description,clinic_desc:this.state.clinic_desc,clinic_number:this.state.clinic_number,user_number:this.state.user_number,satisfaction_rate:this.state.satisfaction_rate,rating_desc:this.state.rating_desc,date:this.state.date,complexity_rate:this.state.complexity_rate,pdf_files:this.state.pdf_files,image_files:this.state.image_files,video_files:this.state.video_files}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return NewSoftwareDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsSoftware=function(_Component2){_inherits(ProductTabsSoftware,_Component2);function ProductTabsSoftware(props){_classCallCheck(this,ProductTabsSoftware);var _this2=_possibleConstructorReturn(this,(ProductTabsSoftware.__proto__||Object.getPrototypeOf(ProductTabsSoftware)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsSoftware,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Technische Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===3?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(3);}},'Statistik'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===4?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(4);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===5?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(5);}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["f" /* ProductDescriptionSoftware */],{style:this.state.activeTab===0?null:{display:'none'},description:this.props.description,is_separate_sw:this.props.is_separate_sw,separate_sw:this.props.separate_sw,has_update_offer:this.props.has_update_offer,update_offer:this.props.update_offer,price_update:this.props.price_update,sw_type:this.props.sw_type,is_kommune:this.props.is_kommune,tags:this.props.tags}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["r" /* ProductTechnicalDetails */],{style:this.state.activeTab===1?null:{display:'none'},direct_database_access:this.props.direct_database_access,direct_database_access_desc:this.props.direct_database_access_desc,has_additional_interface:this.props.has_additional_interface,additional_interface:this.props.additional_interface,has_additional_licence:this.props.has_additional_licence,additional_licence:this.props.additional_licence,data_component_complete:this.props.data_component_complete,data_component_options:this.props.data_component_options,data_manupulation:this.props.data_manupulation,data_manupulation_protocol:this.props.data_manupulation_protocol,manipulation_authorised:this.props.manipulation_authorised,manipulation_authorised_desc:this.props.manipulation_authorised_desc,data_update_interval:this.props.data_update_interval,has_update_side_effect:this.props.has_update_side_effect,update_side_effect:this.props.update_side_effect,has_release_plan:this.props.has_release_plan,release_plan:this.props.release_plan,is_preparation_needed:this.props.is_preparation_needed,preparation_needed:this.props.preparation_needed}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["o" /* ProductReferenceSoftwareNew */],{style:this.state.activeTab===2?null:{display:'none'},has_customer_reference:this.props.has_customer_reference,customer_reference:this.props.customer_reference}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["u" /* SoftwareStatistics */],{style:this.state.activeTab===3?null:{display:'none'},successful_deployment:this.props.successful_deployment,successful_deployment_description:this.props.successful_deployment_description,clinic_desc:this.props.clinic_desc,clinic_number:this.props.clinic_number,user_number:this.props.user_number,satisfaction_rate:this.props.satisfaction_rate,rating_desc:this.props.rating_desc,date:this.props.date,complexity_rate:this.props.complexity_rate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["p" /* ProductReviews */],{uuid:this.props.uuid,style:this.state.activeTab===4?null:{display:'none'},onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["k" /* ProductMediaMultiParent */],{style:this.state.activeTab===5?null:{display:'none'},heading1:'Dokumentation',uuids1:this.props.pdf_files,heading2:'Beschreibende Bilder oder Screenshots',uuids2:this.props.image_files,heading3:'Video',uuids3:this.props.video_files})));}}]);return ProductTabsSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TenderDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_details__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__product_details_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductDetails=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact-us/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];var TenderDetails=function(_Component){_inherits(TenderDetails,_Component);function TenderDetails(props){_classCallCheck(this,TenderDetails);var _this=_possibleConstructorReturn(this,(TenderDetails.__proto__||Object.getPrototypeOf(TenderDetails)).call(this,props));_this.getTenderDetails=_this.getTenderDetails.bind(_this);_this.state={id:_this.props.match.params['id'],name:'',board:'',uuid:'',type:'Ausschreibung',target_group:'',categories:'',description:'',price:'',aim:'',tags:'',pdf_files:',,,,',image_files:',,,,,,,,,',video_files:''};if(!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&_this.id!==undefined){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(){return _this.getTenderDetails(_this.props.match.params['id']);});}else{_this.getTenderDetails(_this.props.match.params['id']);}return _this;}_createClass(TenderDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.match.params['id'],10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getTenderDetails(newID);this.setState({id:newID});}}},{key:'getTenderDetails',value:function getTenderDetails(productID){var self=this;var url='/api/show-tender?id='+productID;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Ausschreibungdetails konnten nicht geladen werden.');console.error('Could not fetch tender details.',exception);});promise.then(function(json){localStorage.setItem('product-name',json.name);self.setState({name:json.name?json.name:'(kein Name)',board:json.board?json.board:'',uuid:json.uuid?json.uuid:'',categories:json.categories?json.categories:'(keine Angaben)',description:json.description?json.description:'(keine Angabe)',target_group:json.target_group?json.target_group:'(keine Angabe)',price:json.price!==undefined?json.price:'(keine Angabe)',aim:json.aim?json.aim:'(keine Angabe)',tags:json.tags?json.tags:'(keine Angabe)',pdf_files:json.pdf_files?json.pdf_files:'(keine Angabe)',image_files:json.image_files?json.image_files:'(keine Angabe)',video_files:json.video_files?json.video_files:'(keine Angabe)'});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["t" /* ProductTypeWithoutParantheses */],{name:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,price:this.state.price,productType:this.state.type,productName:this.state.name,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productInfoHeader'},__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["s" /* ProductTypeWithLabel */],{productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["a" /* CommUserInfo */],{id:this.props.match.params['id'],table:"tender"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__["a" /* CategoryPathWithLabel */],{ids:this.state.categories,startID:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["m" /* ProductRating */],{uuid:this.state.uuid}),!__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["v" /* TenderPrice */],{price:this.state.price})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsTender,{onNewMessage:this.props.onNewMessage,uuid:this.state.uuid,productID:this.state.id,aim:this.state.aim,description:this.state.description,categories:this.state.categories,target_group:this.state.target_group,tags:this.state.tags,pdf_files:this.state.pdf_files,image_files:this.state.image_files,video_files:this.state.video_files}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,price:this.state.price,productType:this.state.type,productName:this.state.name,onNewMessage:this.props.onNewMessage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return TenderDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsTender=function(_Component2){_inherits(ProductTabsTender,_Component2);function ProductTabsTender(props){_classCallCheck(this,ProductTabsTender);var _this2=_possibleConstructorReturn(this,(ProductTabsTender.__proto__||Object.getPrototypeOf(ProductTabsTender)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsTender,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["g" /* ProductDescriptionTender */],{style:this.state.activeTab===0?null:{display:'none'},description:this.props.description,tags:this.props.tags,target_group:this.props.target_group,aim:this.props.aim}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["p" /* ProductReviews */],{uuid:this.props.uuid,style:this.state.activeTab===1?null:{display:'none'},onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["k" /* ProductMediaMultiParent */],{style:this.state.activeTab===2?null:{display:'none'},heading1:'Dokumentation',uuids1:this.props.pdf_files,heading2:'Beschreibende Bilder oder Screenshots',uuids2:this.props.image_files,heading3:'Video',uuids3:this.props.video_files})));}}]);return ProductTabsTender;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OtherDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_details__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__product_details_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductDetails=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact-us/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];var OtherDetails=function(_Component){_inherits(OtherDetails,_Component);function OtherDetails(props){_classCallCheck(this,OtherDetails);var _this=_possibleConstructorReturn(this,(OtherDetails.__proto__||Object.getPrototypeOf(OtherDetails)).call(this,props));_this.getOtherDetails=_this.getOtherDetails.bind(_this);_this.state={id:_this.props.match.params['id'],name:'',board:'',uuid:'',type:'Hardware und sonstige Angebote',categories:'',aim:'',desc:'',is_public:false,tags:[],price:0,pdf_files:'',image_files:'',video_files:''};if(!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&_this.id!==undefined){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(){return _this.getOtherDetails(_this.props.match.params['id']);});}else{_this.getOtherDetails(_this.props.match.params['id']);}return _this;}_createClass(OtherDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.match.params['id'],10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getOtherDetails(newID);this.setState({id:newID});}}},{key:'getOtherDetails',value:function getOtherDetails(productID){var self=this;var url='/api/show-other-product?id='+productID;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Productdetails konnten nicht geladen werden.');console.error('Could not fetch product details.',exception);});promise.then(function(json){localStorage.setItem('product-name',json.name);self.setState({name:json.name?json.name:'(kein Name)',board:json.board?json.board:'',uuid:json.uuid?json.uuid:'',aim:json.aim?json.aim:'(keine Beschreibung)',categories:json.categories?json.categories:'(keine Beschreibung)',is_public:json.is_public?json.is_public:'(keine Beschreibung)',tags:json.tags?json.tags:'(keine Beschreibung)',price:json.price!==undefined?json.price:'(keine Beschreibung)',pdf_files:json.pdf_files?json.pdf_files:'(Nicht Vorhanden)',image_files:json.image_files?json.image_files:'(Nicht Vorhanden)',video_files:json.video_files?json.video_files:'(Nicht Vorhanden)'});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["t" /* ProductTypeWithoutParantheses */],{name:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productInfoHeader'},__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["s" /* ProductTypeWithLabel */],{productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["a" /* CommUserInfo */],{id:this.props.match.params['id'],table:"other"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__["a" /* CategoryPathWithLabel */],{ids:this.state.categories,startID:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["m" /* ProductRating */],{uuid:this.state.uuid}),!__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["l" /* ProductPrice */],{price:this.state.price})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsOther,{onNewMessage:this.props.onNewMessage,uuid:this.state.uuid,productID:this.state.id,categories:this.state.categories,tags:this.state.tags,aim:this.state.aim,is_public:this.state.is_public,pdf_files:this.state.pdf_files,image_files:this.state.image_files,video_files:this.state.video_files}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return OtherDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsOther=function(_Component2){_inherits(ProductTabsOther,_Component2);function ProductTabsOther(props){_classCallCheck(this,ProductTabsOther);var _this2=_possibleConstructorReturn(this,(ProductTabsOther.__proto__||Object.getPrototypeOf(ProductTabsOther)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsOther,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["c" /* ProductDescriptionOther */],{style:this.state.activeTab===0?null:{display:'none'},desc:this.props.desc,tags:this.props.tags,aim:this.props.aim}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["p" /* ProductReviews */],{uuid:this.props.uuid,style:this.state.activeTab===1?null:{display:'none'},onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["k" /* ProductMediaMultiParent */],{style:this.state.activeTab===2?null:{display:'none'},heading1:'Dokumentation',uuids1:this.props.pdf_files,heading2:'Beschreibende Bilder oder Screenshots',uuids2:this.props.image_files,heading3:'Video',uuids3:this.props.video_files})));}}]);return ProductTabsOther;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UsedSoftwareDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_details__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__product_details_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductDetails=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact-us/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];var UsedSoftwareDetails=function(_Component){_inherits(UsedSoftwareDetails,_Component);function UsedSoftwareDetails(props){_classCallCheck(this,UsedSoftwareDetails);var _this=_possibleConstructorReturn(this,(UsedSoftwareDetails.__proto__||Object.getPrototypeOf(UsedSoftwareDetails)).call(this,props));_this.getUsedSoftwareDetails=_this.getUsedSoftwareDetails.bind(_this);_this.state={id:_this.props.match.params['id'],name:'',board:'',uuid:'',type:'Gebrauchtsoftware',categories:'',aim:'',desc:'',is_update_available:false,update_price_text:'',is_public:false,tags:[],price:0,pdf_files:'',image_files:'',video_files:'',company:'',company_name:'',company_web:''};if(!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&_this.id!==undefined){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(){return _this.getUsedSoftwareDetails(_this.props.match.params['id']);});}else{_this.getUsedSoftwareDetails(_this.props.match.params['id']);}return _this;}_createClass(UsedSoftwareDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.match.params['id'],10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getUsedSoftwareDetails(newID);this.setState({id:newID});}}},{key:'getUsedSoftwareDetails',value:function getUsedSoftwareDetails(productID){var self=this;var url='/api/show-used-software?id='+productID;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Softwaredetails konnten nicht geladen werden.');console.error('Could not fetch software details.',exception);});promise.then(function(json){localStorage.setItem('product-name',json.name);self.setState({name:json.name?json.name:'(kein Name)',board:json.board?json.board:'',uuid:json.uuid?json.uuid:'',aim:json.aim?json.aim:'(keine Beschreibung)',desc:json.desc?json.desc:'(keine Beschreibung)',categories:json.categories?json.categories:'(keine Beschreibung)',is_update_available:json.is_update_available?json.is_update_available:'(keine Beschreibung)',update_price_text:json.update_price_text?json.update_price_text:'(keine Beschreibung)',is_public:json.is_public?json.is_public:'(keine Beschreibung)',tags:json.tags?json.tags:'(keine Beschreibung)',price:json.price!==undefined?json.price:'(keine Beschreibung)',pdf_files:json.pdf_files?json.pdf_files:'(Nicht Vorhanden)',image_files:json.image_files?json.image_files:'(Nicht Vorhanden)',video_files:json.video_files?json.video_files:'(Nicht Vorhanden)',company:json.company?json.company:'(keine Beschreibung)',company_name:json.company_name?json.company_name:'(keine Beschreibung)',company_web:json.company_web?json.company_web:'(keine Beschreibung)'});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["t" /* ProductTypeWithoutParantheses */],{name:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productInfoHeader'},__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["a" /* CommUserInfo */],{id:this.props.match.params['id'],table:"software"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__["a" /* CategoryPathWithLabel */],{ids:this.state.categories,startID:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["m" /* ProductRating */],{uuid:this.state.uuid}),!__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["l" /* ProductPrice */],{price:this.state.price})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsSoftware,{onNewMessage:this.props.onNewMessage,uuid:this.state.uuid,productID:this.state.id,desc:this.state.desc,categories:this.state.categories,tags:this.state.tags,aim:this.state.aim,is_update_available:this.state.is_update_available,update_price_text:this.state.update_price_text,is_public:this.state.is_public,company:this.state.company,company_name:this.state.company_name,company_web:this.state.company_web,pdf_files:this.state.pdf_files,image_files:this.state.image_files,video_files:this.state.video_files}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["i" /* ProductDetailsButtons */],{history:this.props.history,board:this.state.board,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return UsedSoftwareDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsSoftware=function(_Component2){_inherits(ProductTabsSoftware,_Component2);function ProductTabsSoftware(props){_classCallCheck(this,ProductTabsSoftware);var _this2=_possibleConstructorReturn(this,(ProductTabsSoftware.__proto__||Object.getPrototypeOf(ProductTabsSoftware)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsSoftware,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["h" /* ProductDescriptionUsedSoftware */],{style:this.state.activeTab===0?null:{display:'none'},desc:this.props.desc,tags:this.props.tags,aim:this.props.aim,is_public:this.props.is_public,company:this.props.company,company_name:this.props.company_name,company_web:this.props.company_web,is_update_available:this.props.is_update_available,update_price_text:this.props.update_price_text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["p" /* ProductReviews */],{uuid:this.props.uuid,style:this.state.activeTab===1?null:{display:'none'},onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__product_details__["k" /* ProductMediaMultiParent */],{style:this.state.activeTab===2?null:{display:'none'},heading1:'Dokumentation',uuids1:this.props.pdf_files,heading2:'Beschreibende Bilder oder Screenshots',uuids2:this.props.image_files,heading3:'Video',uuids3:this.props.video_files})));}}]);return ProductTabsSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateDocumentWithFeebox; });
/* unused harmony export UpdateDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__login_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__product_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__business_activities__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feebox_xu__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_form_components__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__document_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__document_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__document_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var introductoryText='<p>Es fallen im Gesundheitswesen im Allgemeinen, im Bereich des Krankenhauses im Speziellen, viele Forderungen für Dokumente an, die oft mit hohem Aufwand erstellt werden müssen.</p><p>Im operativen Geschäft müssen für die verschiedensten Aufgaben und Anforderungen Dokumente erstellt werden. Die Anforderungen sind meist über verschiedene Abteilungen gesehen ähnlich - und doch müssen immer wieder geforderte Dokumente mühselig erstellt werden. Das Ziel dieses Segmentes des Marktplatzes ist es, eine Angebotspalette für Dokumente jeglicher Art zur Verfügung zu stellen, damit nicht alles neu erfunden werden muss. Ein vormodelliertes Dokument anzupassen macht deutlich weniger Arbeit, als eines vom blanken Blatt Papier her neu zu schreiben. Dies kann z.B. betreffen </p><p><ul> <li>Datenschutz-Regelungen und -Umsetzungspapiere</li> <li>Vorlagen</li> <li>erfolgreiche oder erfolglose Anträge (z.B. Großgeräte-Anträge)</li> <li>Leistungsverzeichnisse</li> <li>Strategiepapiere</li> <li>Verträge jeglicher Art</li> <li>SOPs</li> <li>SLAs</li> <li>Dienstanweisungen</li> <li>Personalratsvorlagen</li> <li>nützliche Links</li> <li>sinnvolles aus Ministerien, BMG</li> <li>Gesetzesvorlagen, Verordnungen</li> <li>Fragebögen</li> <li>Excel-Sheets</li> <li>Präsentationen und Vorträge</li> <li>Outplacement-Verträge</li> <li>Trennungsrechnungskonzepte</li> <li>geschickte Skripte</li> <li>sonstige</li> </ul></p> Hier können Sie die von Ihnen erstellte Dokumente anbieten. Sie können jedoch auch kostenlose Dokumente zum Herunterladen anbieten.</p> <p> <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';var documentTypes=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'0'},'Datenschutz-Regelungen und -Umsetzungspapiere'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'1'},'Vorlagen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'2'},'erfolgreiche oder erfolglose Antr\xE4ge (z.B. Gro\xDFger\xE4te-Antr\xE4ge)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'3'},'Leistungsverzeichnisse'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'4'},'Strategiepapiere'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'5'},'Vertr\xE4ge jeglicher Art'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'6'},'SOPs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'7'},'SLAs'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'8'},'Dienstanweisungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'9'},'Personalratsvorlagen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'10'},'n\xFCtzliche Links'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'11'},'sinnvolles aus Ministerien, BMG'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'12'},'Gesetzesvorlagen, Verordnungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'13'},'Frageb\xF6gen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'14'},'Excel-Sheets'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'15'},'Pr\xE4sentationen und Vortr\xE4ge'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'16'},'Outplacement-Vertr\xE4ge'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'17'},'Trennungsrechnungskonzepte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'18'},'geschickte Skripte'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'19'},'Verzeichnis'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'20'},'sonstige')];var faqDocument=[];var CreateDocument=function(_Component){_inherits(CreateDocument,_Component);function CreateDocument(props){_classCallCheck(this,CreateDocument);var _this=_possibleConstructorReturn(this,(CreateDocument.__proto__||Object.getPrototypeOf(CreateDocument)).call(this,props));_this.fetchDataAndRedirect=_this.fetchDataAndRedirect.bind(_this);_this.fetchDataAndRedirect();return _this;}_createClass(CreateDocument,[{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-document';var promise=fetch(url,{method:'POST',headers:headers,body:''}).then(function(response){return response.json();}).catch(function(exception){alert('Could not create new document!',exception);console.error('Could not create new document!',exception);});promise.then(function(json){self.props.history.replace('/update-document/'+json.id);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CreateDocument'});}}]);return CreateDocument;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateDocumentWithFeebox=function(_Component2){_inherits(UpdateDocumentWithFeebox,_Component2);function UpdateDocumentWithFeebox(props){_classCallCheck(this,UpdateDocumentWithFeebox);var _this2=_possibleConstructorReturn(this,(UpdateDocumentWithFeebox.__proto__||Object.getPrototypeOf(UpdateDocumentWithFeebox)).call(this,props));_this2.updateFeeByPrice=_this2.updateFeeByPrice.bind(_this2);_this2.updateFeeByCategories=_this2.updateFeeByCategories.bind(_this2);_this2.countCategories=_this2.countCategories.bind(_this2);_this2.state={price:0,categoryCount:1};return _this2;}_createClass(UpdateDocumentWithFeebox,[{key:'updateFeeByPrice',value:function updateFeeByPrice(price){this.setState({price:price});return true;}},{key:'updateFeeByCategories',value:function updateFeeByCategories(categories){this.setState({categoryCount:this.countCategories(categories)});return true;}},{key:'countCategories',value:function countCategories(categories){// workaround: converting String to array (FIXME)
if(typeof categories==='string'){categories=categories.split(",");}console.log(categories);var tempCats=[];var count=0;for(var i=0;i<6;i++){if(categories!==undefined&&categories[i]!==null&&categories[i]!==""){if(!tempCats.includes(categories[i])){tempCats.push(categories[i]);count=count+1;}}}return count;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateDocumentWithFeebox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdateDocument,{match:this.props.match,history:this.props.history,updateFeeByPrice:this.updateFeeByPrice,updateFeeByCategories:this.updateFeeByCategories}),__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__feebox_xu__["a" /* FeeBoxXU */],{type:'document',price:this.state.price,categoryCount:this.state.categoryCount,feeStepConst:'100'}));}}]);return UpdateDocumentWithFeebox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateDocument=function(_Component3){_inherits(UpdateDocument,_Component3);function UpdateDocument(props){_classCallCheck(this,UpdateDocument);var _this3=_possibleConstructorReturn(this,(UpdateDocument.__proto__||Object.getPrototypeOf(UpdateDocument)).call(this,props));_this3.fetchDataAndRedirect=_this3.fetchDataAndRedirect.bind(_this3);_this3.update=_this3.update.bind(_this3);_this3.validateInput=_this3.validateInput.bind(_this3);_this3.isValid=_this3.isValid.bind(_this3);_this3.checkRequiredFields=_this3.checkRequiredFields.bind(_this3);_this3.save=_this3.save.bind(_this3);_this3.state={startID:2,id:null,name:'',categories:'',aim:'',content:'',links:'',target:'',specialties:'',usage:'',review1:'',review2:'',doctype:'',tags:'',price:0,pdf_files:',,,,',image_files:',,,,,,,,,',video_files:'',product_files:'',doc_agreement:false,agb_agreement:false};_this3.fetchDataAndRedirect();_this3.globalFormData={};return _this3;}_createClass(UpdateDocument,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextState!==this.state){return true;}else{return false;}}},{key:'update',value:function update(slot,value){if(slot==='price'&&this.props.updateFeeByPrice!==undefined){this.props.updateFeeByPrice(parseInt(value,10));}if(slot==='categories'&&this.props.updateFeeByCategories!==undefined){this.props.updateFeeByCategories(value);}this.globalFormData[slot]=value;}},{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var id=this.props.match.params.id;var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-document';var promise=fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte laden!');console.error('Could retrieve document data!',exception);});promise.then(function(json){if(self.props.updateFeeByPrice!==undefined){self.props.updateFeeByPrice(parseInt(json.price,10));}if(self.props.updateFeeByCategories!==undefined){self.props.updateFeeByCategories(json.categories);}self.setState({id:json.id,name:json.name,categories:json.categories,aim:json.aim,content:json.content,links:json.links,target:json.target,specialties:json.specialties,usage:json.usage,review1:json.review1,review2:json.review2,doctype:json.doctype,tags:json.tags,price:json.price,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,doc_agreement:json.doc_agreement,agb_agreement:json.agb_agreement,feeboxPrice:json.price});});}},{key:'isValid',value:function isValid(categories){if(categories===undefined)return false;if(categories===null)return false;if(categories==="")return false;if(typeof categories==='string'){categories=categories.split(/,/);}var catInput=categories.map(function(item){return parseInt(item,10);});for(var i=0;i<categories.length;i++){if(parseInt(catInput[i],10)===catInput[i]){return true;}}return false;}},{key:'validateInput',value:function validateInput(){if(this.globalFormData['name']===undefined){if(this.state.name.length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}if(this.globalFormData['name'].length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}return true;}},{key:'checkRequiredFields',value:function checkRequiredFields(){if(this.globalFormData['name']===undefined){if(this.state.name.length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}if(this.globalFormData['categories']===undefined&&!this.isValid(this.state.categories)){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(!this.isValid(this.globalFormData['categories'])){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(this.globalFormData['price']===undefined){if(this.state.price.length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}else{if(this.globalFormData['price'].length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}if(this.globalFormData['doc_agreement']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['doc_agreement']===undefined){if(this.state.doc_agreement!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agb_agreement']===false){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}if(this.globalFormData['agb_agreement']===undefined){if(this.state.agb_agreement!==true){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}}return true;}},{key:'save',value:function save(announce){if(announce===true){if(this.checkRequiredFields()===false){return;}}if(announce===true){if(this.validateInput()===false){return;}}var id=this.props.match.params.id;var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var formData=new FormData();Object.keys(this.globalFormData).map(function(key){return formData.append(key,self.globalFormData[key]);});formData.append("id",this.state.id);if(announce===true){formData.append('announce',true);}else{formData.append('announce',false);}formData.append('active',true);var url='/api/update-document';var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte speichern!');console.error('Could not save document data!',exception);});promise.then(function(json){alert('Werte wurden gespeichert.');if(announce===true){Object(__WEBPACK_IMPORTED_MODULE_7__business_activities__["a" /* logBusinessActivities */])("Dokument wurde gespeichert, allem zugestimmt und veroeffentlicht.",id,json.categories,json.price);}self.globalFormData={};if(self.props.updateFeeByPrice!==undefined){self.props.updateFeeByPrice(parseInt(json.price,10));}if(self.props.updateFeeByCategories!==undefined){self.props.updateFeeByCategories(json.categories);}self.setState({id:json.id,name:json.name,categories:json.categories,aim:json.aim,content:json.content,links:json.links,target:json.target,specialties:json.specialties,usage:json.usage,review1:json.review1,review2:json.review2,doctype:json.doctype,tags:json.tags,price:json.price,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,doc_agreement:json.doc_agreement,agb_agreement:json.agb_agreement,feeboxPrice:json.price});self.props.history.push('/product-list');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,(__WEBPACK_IMPORTED_MODULE_4__util__["f" /* isNonCommercialUser */]()||__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Anbieten eines Dokuments'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen Preis auffindbar.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["p" /* TextInfo */],{content:introductoryText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productForm1 marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodInputComp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["q" /* TextLine */],{heading:'Produktitel',heading2:' (Was bieten Sie an?)',obligatory:true,placeholder:'Name des Dokuments',maxLength:'200',value:this.state.name,slot:'name',update:this.update})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["l" /* Selection */],{heading:'Von welchem Typ ist ihr Dokument?',selectionValues:documentTypes,obligatory:true,value:this.state.doctype,slot:'doctype',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__["a" /* CategorySelectorList */],{value:this.state.categories,slot:'categories',update:this.update,categoryLimit:6}),!__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["k" /* Price */],{heading:'Preis des Dokuments in Euro',subheading:'85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution f\xFCr das Zurverf\xFCgungstellen der Lizenz ausbezahlt.',obligatory:true,maxLength:'9',value:this.state.price,slot:'price',kostenfrei:this.state.kostenfrei,update:this.update}),__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["k" /* Price */],{heading:'Preis des Dokuments in Euro',obligatory:true,maxLength:'6',value:this.state.price,slot:'price',kostenfrei:this.state.kostenfrei,update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Beschreibung?',placeholder:'Zweck des Dokumentes',value:this.state.aim,slot:'aim',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Was ist der Inhalt des Dokumentes? ',placeholder:'Inhalt des Dokumentes',value:this.state.content,slot:'content',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Gibt es einen oder mehrere Links?',placeholder:'zugeh\xF6rige Links',value:this.state.links,slot:'links',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Welche ist die Zielgruppe des Dokuments?',placeholder:'Zielgruppe des Dokumentes',value:this.state.target,slot:'target',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Besondere Merkmale des Dokuments?',placeholder:'Besonderheiten des Dokuments',value:this.state.specialties,slot:'specialties',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Wurden die Dokumente bereits erfolgreich begutachtet? Wenn ja, von wem?',placeholder:'begutachtet von...',value:this.state.review2,slot:'review2',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Wurden die Dokumente beispielsweise der Deutschen Forschungsgemeinschaft (DFG) oder einer Wirtschaftspr\xFCfungsgesellschaft vorgelegt?',placeholder:'wurden vorgelegt...',value:this.state.review1,slot:'review1',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["o" /* TextField */],{heading:'Wo wurde das Dokument bereits verwendet?',placeholder:'bisherige Verwendungen des Dokumentes',value:this.state.usage,slot:'usage',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["n" /* Tags */],{heading:'Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt).',placeholder:'Tags/Stichworte',value:this.state.tags,slot:'tags',update:this.update,match:this.props.match,maxTags:7,maxLength:150}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["i" /* MultipleFileUpload */],{heading:'Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)',value:this.state.pdf_files,slot:'pdf_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["i" /* MultipleFileUpload */],{heading:'Anhang: Beschreibende Bilder oder Screenshots',value:this.state.image_files,slot:'image_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["i" /* MultipleFileUpload */],{heading:'Anhang: Video, max. 5 GB',value:this.state.video_files,slot:'video_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["i" /* MultipleFileUpload */],{heading:'Hier haben Sie die M\xF6glichkeit, Ihr Produkt als eine Datei hochzuladen.',value:this.state.product_files,slot:'product_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["b" /* CheckBox */],{obligatory:true,heading:'* Erkl\xE4rung',content:'Ich erkl\xE4re hiermit, dass das oder die angebotenen Dokumente entweder meiner Institution oder mir selbst geh\xF6ren und mir der Verkauf oder die kostenfreie Weitergabe gestattet ist.',value:this.state.doc_agreement,slot:'doc_agreement',update:this.update}),!__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["a" /* AGBCheckBox */],{obligatory:true,value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/ueberlassungsvereinbarung.pdf',content1:'Das hier Eingestellte bezieht sich entweder auf einen Link oder ein kostenfreies Dokument oder im Falle eines Kaufs akzeptiere ich die ',fileType:'\xDCberlassungsvereinbarung',content2:'.',update:this.update}),__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["a" /* AGBCheckBox */],{obligatory:true,value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/einstellvertrag.pdf',content1:'Ich habe den ',fileType:'Einstellvertrag',content2:' gelesen und akzeptiere diesen.',update:this.update})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components__["m" /* SubmitButton */],{history:this.props.history,onSubmit:this.save}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqDocument})),!__WEBPACK_IMPORTED_MODULE_4__util__["f" /* isNonCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Sie besitzen nicht gen\xFCgend Rechte, um ein Dokument zu erstellen.'));}}]);return UpdateDocument;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateResearchSoftware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateResearchSoftware; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__business_activities__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__researchSoftwareMinimalDatePicker__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_form_components_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__researchsoftware_css__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__researchsoftware_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__researchsoftware_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var introductoryText='<p>Der Marktplatz der Ayacandas bietet die Möglichkeit, Produkte jeglicher Art aus dem Bereich Forschung und Lehre einfach zum Kauf anbieten zu können.<p>Wenn sie Software anbieten wollen, ist es nicht notwendig, den zugehörigen Code offenzulegen. (auch wenn dies erwünscht ist). Die Verpflichtung reduziert sich darauf, den Code zu beschreiben und seine Eigenschaften gründlich getestet zu haben.</p> <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';var complexityRate=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'0'},'bitte w\xE4hlen...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'1'},'1 - niedrige Komplexit\xE4t'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'2'},'2 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'3'},'3 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'4'},'4 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'5'},'5 - mittlere Komplexit\xE4t'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'6'},'6 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'7'},'7 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'8'},'8 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'9'},'9 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'10'},'10 - hohe Komplexit\xE4t')];var satisfactionRate=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'0'},'bitte w\xE4hlen...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'1'},'Sehr zufrieden'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'2'},'Zufrieden'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'3'},'Weniger zufrieden'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'4'},'Unzufrieden')];var faqResearchsoftware=[{content:"Ein Weiterverkauf innerhalb der meisten Förderprogramme ist unproblematisch, da er den Förderzweck nicht entfremdet. Ein Weiterverkauf verstößt somit <u>nicht</u> gegen die Bedingungen des Förderbescheids. Eine Mehrwerterschaffung sollte jedoch von der jeweiligen  Klinik an das zuständige Ministerium gemeldet werden.<br /><br />Das Anbieten ist unkritisch, sofern vom ursprünglichen Förderbescheid kein Geld entwendet oder veräußert wird und nicht gegen die Begutachtungslinie der DFG gehandelt wird. In diesem Zusammenhang darf nur Eigenleistung verkauft werden.",title:"Gibt es Probleme, wenn das Produkt mit der Hilfe von Förderbescheiden entwickelt wurde?",key:0},{content:"Einnahmen gehen, falls Sie nicht als Privatperson verkaufen, oft nicht an Sie, sondern an die Institution, in deren Namen Sie verkaufen. Solche Einnahmen können Sie Sich im Rahmen des Controllings als eigene Einnahmen durch Verrechnung gutschreiben lassen. ",title:"Was habe ich davon, wenn ich für meine Institution etwas verkaufe?",key:1},{content:"Wenn Sie als nicht-kommerzieller Nutzer ein Produkt anbieten, wird Ayacandas wesentliche Punkte für Sie übernehmen.",title:"Was ist mit dem Thema Haftung und Gewährleistung beim Einstellen von Produkten?",key:2},{content:"Außer bei Herstellern und Dienstleistern erfolgt die Kommunikation über die Foren auf Ayacandas.com ohne Aufdeckung Ihrer Identität.",title:"Warum darf man in den Foren seine Anonymität nicht aufdecken?",key:3}];var CreateResearchSoftware=function(_Component){_inherits(CreateResearchSoftware,_Component);function CreateResearchSoftware(props){_classCallCheck(this,CreateResearchSoftware);var _this=_possibleConstructorReturn(this,(CreateResearchSoftware.__proto__||Object.getPrototypeOf(CreateResearchSoftware)).call(this,props));_this.fetchDataAndRedirect=_this.fetchDataAndRedirect.bind(_this);_this.fetchDataAndRedirect();return _this;}_createClass(CreateResearchSoftware,[{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-researchsoftware';var promise=fetch(url,{method:'POST',headers:headers,body:''}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine neue Software für Forschung und Lehre anlegen!');console.error('Could not create new researchsoftware!',exception);});promise.then(function(json){self.props.history.replace('/update-researchsoftware/'+json.id);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CreateResearchsoftware'});}}]);return CreateResearchSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateResearchSoftware=function(_Component2){_inherits(UpdateResearchSoftware,_Component2);function UpdateResearchSoftware(props){_classCallCheck(this,UpdateResearchSoftware);var _this2=_possibleConstructorReturn(this,(UpdateResearchSoftware.__proto__||Object.getPrototypeOf(UpdateResearchSoftware)).call(this,props));_this2.fetchDataAndRedirect=_this2.fetchDataAndRedirect.bind(_this2);_this2.update=_this2.update.bind(_this2);_this2.validateInput=_this2.validateInput.bind(_this2);_this2.isValid=_this2.isValid.bind(_this2);_this2.checkRequiredFields=_this2.checkRequiredFields.bind(_this2);_this2.save=_this2.save.bind(_this2);_this2.state={startID:2,id:null,name:'',desc:'',categories:'',price:0,researchtype:'',aim:'',functionality:'',specialties:'',target:'',usage:'',tags:'',standalone_sw:'',is_standalone_sw:'',agreement:false,direct_database_access:null,direct_database_access_desc:'',has_additional_interface:null,additional_interface:'',has_additional_licence:null,additional_licence:'',data_component_complete:'',data_component_options:'',data_manipulation:'',data_manipulation_protocol:'',manipulation_authorised:null,manipulation_authorised_desc:'',data_update_interval:0,has_update_side_effect:'',update_side_effect:'',has_release_plan:'',release_plan:'',is_preparation_needed:'',preparation_needed:'',has_customer_reference:'',customer_reference:'',successful_deployment:null,successful_deployment_description:'',clinic_desc:'',clinic_number:0,user_number:0,complexity_rate:0,date:'',satisfaction_rate:0,rating_desc:'',pdf_files:',,,,',image_files:',,,,,,,,,',video_files:'',product_files:'',agb_agreement:false};_this2.fetchDataAndRedirect();_this2.globalFormData={};return _this2;}_createClass(UpdateResearchSoftware,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextState!==this.state){return true;}else{return false;}}},{key:'update',value:function update(slot,value){this.globalFormData[slot]=value;}},{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var id=this.props.match.params.id;var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-researchsoftware';var promise=fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte laden!');console.error('Could not retrieve researchsoftware data!',exception);});promise.then(function(json){self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,researchtype:json.researchtype,aim:json.aim,functionality:json.functionality,specialties:json.specialties,target:json.target,usage:json.usage,tags:json.tags,is_standalone_sw:json.is_standalone_sw,standalone_sw:json.standalone_sw,direct_database_access:json.direct_database_access,direct_database_access_desc:json.direct_database_access_desc,has_additional_interface:json.has_additional_interface,additional_interface:json.additional_interface,has_additional_licence:json.has_additional_licence,additional_licence:json.additional_licence,data_component_complete:json.data_component_complete,data_component_options:json.data_component_options,data_manipulation:json.data_manipulation,data_manipulation_protocol:json.data_manipulation_protocol,manipulation_authorised:json.manipulation_authorised,manipulation_authorised_desc:json.manipulation_authorised_desc,data_update_interval:json.data_update_interval,has_update_side_effect:json.has_update_side_effect,update_side_effect:json.update_side_effect,has_release_plan:json.has_release_plan,release_plan:json.release_plan,is_preparation_needed:json.is_preparation_needed,preparation_needed:json.preparation_needed,has_customer_reference:json.has_customer_reference,customer_reference:json.customer_reference,successful_deployment:json.successful_deployment,successful_deployment_description:json.successful_deployment_description,clinic_desc:json.clinic_desc,clinic_number:json.clinic_number,user_number:json.user_number,complexity_rate:json.complexity_rate,date:json.date,satisfaction_rate:json.satisfaction_rate,rating_desc:json.rating_desc,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement:json.agreement,agb_agreement:json.agb_agreement});});}},{key:'isValid',value:function isValid(categories){if(categories===undefined)return false;if(categories===null)return false;if(categories==="")return false;if(typeof categories==='string'){categories=categories.split(/,/);}var catInput=categories.map(function(item){return parseInt(item,10);});for(var i=0;i<categories.length;i++){if(parseInt(catInput[i],10)===catInput[i]){return true;}}return false;}},{key:'validateInput',value:function validateInput(){if(this.globalFormData['name']===undefined){if(this.state.name.length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}if(this.globalFormData['name'].length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}if(this.globalFormData['desc']===undefined){if(this.state.desc.length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.state.desc.length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}else{if(this.globalFormData['desc'].length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.globalFormData['desc'].length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}return true;}},{key:'checkRequiredFields',value:function checkRequiredFields(){if(this.globalFormData['name']===undefined){if(this.state.name.length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}if(this.globalFormData['categories']===undefined&&!this.isValid(this.state.categories)){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(!this.isValid(this.globalFormData['categories'])){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(this.globalFormData['desc']===undefined){if(this.state.desc.length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}else{if(this.globalFormData['desc'].length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}if(this.globalFormData['price']===undefined){if(this.state.price.length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}else{if(this.globalFormData['price'].length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}if(this.globalFormData['agreement']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement']===undefined){if(this.state.agreement!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agb_agreement']===false){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}if(this.globalFormData['agb_agreement']===undefined){if(this.state.agb_agreement!==true){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}}return true;}},{key:'save',value:function save(announce){if(announce===true){if(this.checkRequiredFields()===false){return;}}if(announce===true){if(this.validateInput()===false){return;}}var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var formData=new FormData();Object.keys(this.globalFormData).map(function(key){return formData.append(key,self.globalFormData[key]);});formData.append("id",this.state.id);if(announce===true){formData.append('announce',true);}else{formData.append('announce',false);}formData.append('active',true);var url='/api/update-researchsoftware';var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte speichern!');console.error('Could not save researchsoftware data!',exception);});promise.then(function(json){alert('Werte wurden gespeichert.');if(announce===true){Object(__WEBPACK_IMPORTED_MODULE_5__business_activities__["a" /* logBusinessActivities */])("Software fuer Forschung und Lehre wurde gespeichert, allem zugestimmt und veroeffentlicht.",json.id,json.categories,json.price);}self.globalFormData={};self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,researchtype:json.researchtype,aim:json.aim,functionality:json.functionality,specialties:json.specialties,target:json.target,usage:json.usage,tags:json.tags,is_standalone_sw:json.is_standalone_sw,standalone_sw:json.standalone_sw,direct_database_access:json.direct_database_access,direct_database_access_desc:json.direct_database_access_desc,has_additional_interface:json.has_additional_interface,additional_interface:json.additional_interface,has_additional_licence:json.has_additional_licence,additional_licence:json.additional_licence,data_component_complete:json.data_component_complete,data_component_options:json.data_component_options,data_manipulation:json.data_manipulation,data_manipulation_protocol:json.data_manipulation_protocol,data_update_interval:json.data_update_interval,has_update_side_effect:json.has_update_side_effect,update_side_effect:json.update_side_effect,has_release_plan:json.has_release_plan,release_plan:json.release_plan,is_preparation_needed:json.is_preparation_needed,preparation_needed:json.preparation_needed,has_customer_reference:json.has_customer_reference,customer_reference:json.customer_reference,successful_deployment:json.successful_deployment,successful_deployment_description:json.successful_deployment_description,clinic_desc:json.clinic_desc,clinic_number:json.clinic_number,user_number:json.user_number,complexity_rate:json.complexity_rate,date:json.date,satisfaction_rate:json.satisfaction_rate,rating_desc:json.rating_desc,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement:json.agreement,agb_agreement:json.agb_agreement});self.props.history.push('/product-list');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4__util__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1',id:'toplanding'},'Software f\xFCr Forschung und Lehre einstellen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen Preis auffindbar.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["p" /* TextInfo */],{content:introductoryText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productForm1  marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodInputComp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["q" /* TextLine */],{heading:' Was bieten Sie an?',subheading:'Unter diesem Titel wird ihr Produkt angezeigt.',obligatory:true,maxLength:'200',value:this.state.name,placeholder:'was bieten Sie an',slot:'name',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Beschreibung',obligatory:true,placeholder:'Beschreibung',value:this.state.desc,slot:'desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__["a" /* CategorySelectorList */],{value:this.state.categories,slot:'categories',update:this.update,categoryLimit:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["k" /* Price */],{heading:'Preis in Euro',subheading:'85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution f\xFCr das Zurverf\xFCgungstellen der Lizenz ausbezahlt.',obligatory:true,maxLength:'9',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["q" /* TextLine */],{heading:'Typ der Software?',maxLength:'100',value:this.state.researchtype,placeholder:'Typ der Software',slot:'researchtype',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Wof\xFCr wurde die Software geschrieben?',placeholder:'Zweck der Software',value:this.state.aim,slot:'aim',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Nennen Sie bitte eventuelle Besonderheiten der Software.',placeholder:'Besonderheiten der Software',value:this.state.functionality,slot:'functionality',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Bitte beschreiben Sie die Funktionen Ihrer Software.',placeholder:'Funktionsbeschreibung',value:this.state.specialties,slot:'specialties',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Welche ist die Zielgruppe der Software?',placeholder:'Zielgruppe der Software',value:this.state.target,slot:'target',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Wo wurde die Software bereits verwendet?',placeholder:'bisherige Verwendungen der Software',value:this.state.usage,slot:'usage',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Ist die Software ein eigenst\xE4ndiges Produkt (d.h sie ist kein Add-On) ?',placeholder:'Beschreibung',value:this.state.is_standalone_sw,value2:this.state.standalone_sw,slot:'is_standalone_sw',slot2:'standalone_sw',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["n" /* Tags */],{heading:'Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)',placeholder:'Tags/Stichworte',value:this.state.tags,slot:'tags',update:this.update,match:this.props.match,maxTags:7,maxLength:150}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)',value:this.state.pdf_files,slot:'pdf_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Beschreibende Bilder oder Screenshots',value:this.state.image_files,slot:'image_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Video, max. 5 GB',value:this.state.video_files,slot:'video_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Braucht die Software einen direkten Zugriff auf die Datenbank? Wenn ja, beschreiben Sie die Zugriffsart.',placeholder:'Beschreibung',value:this.state.direct_database_access,value2:this.state.direct_database_access_desc,slot:'direct_database_access',slot2:'direct_database_access_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden zus\xE4tzliche Schnittstellen ben\xF6tigt?',placeholder:'Beschreibung',value:this.state.has_additional_interface,value2:this.state.additional_interface,slot:'has_additional_interface',slot2:'additional_interface',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden zus\xE4tzliche Lizenzen ben\xF6tigt?',placeholder:'Beschreibung',value:this.state.has_additional_licence,value2:this.state.additional_licence,slot:'has_additional_licence',slot2:'additional_licence',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden alle Elemente f\xFCr den Datenzugriff mitgeliefert? Welche M\xF6glichkeiten bieten Sie an?',placeholder:'Beschreibung',value:this.state.data_component_complete,value2:this.state.data_component_options,slot:'data_component_complete',slot2:'data_component_options',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden Daten am Quellsystem manipuliert oder ver\xE4ndert? Falls ja: Wie wird dies protokolliert?',placeholder:'Beschreibung',value:this.state.data_manipulation,value2:this.state.data_manipulation_protocol,slot:'data_manipulation',slot2:'data_manipulation_protocol',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Erfolgt der Zugriff auf die Datenquelle \xFCber vom Hersteller autorisierte Zugriffsmethoden?',placeholder:'Beschreibung',value:this.state.manipulation_authorised,value2:this.state.manipulation_authorised_desc,slot:'manipulation_authorised',slot2:'manipulation_authorised_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["h" /* IntegerField */],{heading:'Falls eine synchrone Schnittstelle aktiv ist: Wie hoch ist das Aktualisierungsintervall in Minuten?',maxLength:'6',value:this.state.data_update_interval,placeholder:'Aktualisierungsintervall in Min.',slot:'data_update_interval',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Falls eine \u201Esynchrone Schnittstelle\u201C aktiv ist: Gibt es Aktualisierungsnebenwirkungen? (Wenn ja, welche?)',placeholder:'Beschreibung',value:this.state.has_update_side_effect,value2:this.state.update_side_effect,slot:'has_update_side_effect',slot2:'update_side_effect',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Gibt es einen Release-Plan oder geplante Weiterentwicklungen? Falls ja, bitte beschreiben Sie diese.',placeholder:'Beschreibung',value:this.state.has_release_plan,value2:this.state.release_plan,slot:'has_release_plan',slot2:'release_plan',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Sind Vorbereitungen f\xFCr eine Installation notwendig?',placeholder:'Beschreibung',value:this.state.is_preparation_needed,value2:this.state.preparation_needed,slot:'is_preparation_needed',slot2:'preparation_needed',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Gibt es Empfehlungen oder Erfahrungswerte zu Ihrer Software?',placeholder:'Referenzen',value:this.state.has_customer_reference,value2:this.state.customer_reference,slot:'has_customer_reference',slot2:'customer_reference',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["e" /* ConfirmedText */],{heading:'Wird die Software schon erfolgreich eingesetzt?',placeholder:'erfolgreich eingesetzt',value:this.state.successful_deployment,value2:this.state.successful_deployment_description,slot:'successful_deployment',slot2:'successful_deployment_description',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Welche sind die Einsatzbereiche Ihrer Software?',placeholder:'Einsatzbereiche',maxLength:'600',value:this.state.clinic_desc,slot:'clinic_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["h" /* IntegerField */],{heading:'Wieviele Nutzerinnen und Nutzer hat Ihre Software?',maxLength:'20',value:this.state.user_number,placeholder:'Nutzer Anzahl',slot:'user_number',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["h" /* IntegerField */],{heading:'Wieviele davon sind Kliniken?',maxLength:'20',value:this.state.clinic_number,placeholder:'Anzahl der Kliniken',slot:'clinic_number',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["c" /* ComplexityRate */],{heading:'Sch\xE4tzen Sie: Wie komplex ist Ihre Software f\xFCr Anwender?',subheading:'',complexityRate:complexityRate,obligatory:false,value:this.state.complexity_rate,slot:'complexity_rate',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__researchSoftwareMinimalDatePicker__["a" /* default */],{heading:'Seit wann ist Ihre Software in Nutzung?',value:this.state.date,slot:'date',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["c" /* ComplexityRate */],{heading:'Wie sch\xE4tzen Sie die mittlere Zufriedenheit der Nutzer(-innen) Ihrer Software ein?',complexityRate:satisfactionRate,obligatory:false,value:this.state.satisfaction_rate,slot:'satisfaction_rate',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["o" /* TextField */],{heading:'Eine negative Zufriedenheit der Nutzer(-innen) kann begr\xFCndet sein. Hier die M\xF6glichkeit f\xFCr eine Erkl\xE4rung.',maxLength:'600',value:this.state.rating_desc,slot:'rating_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Hier haben Sie die M\xF6glichkeit, Ihr Produkt als eine Datei hochzuladen.',value:this.state.product_files,slot:'product_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["b" /* CheckBox */],{obligatory:true,heading:'* Erkl\xE4rung',content:'Ich erkl\xE4re hiermit, dass die angebotene Software entweder meiner Institution oder mir selbst geh\xF6rt oder mir der Verkauf in der angebotenen Version gestattet worden ist.',value:this.state.agreement,slot:'agreement',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["a" /* AGBCheckBox */],{obligatory:true,value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/ueberlassungsvereinbarung.pdf',content1:'Ich habe die ',fileType:'\xDCberlassungsvereinbarung',content2:' gelesen und akzeptiere diese.',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpAndDownIcons'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_form_components_js__["m" /* SubmitButton */],{history:this.props.history,onSubmit:this.save}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqResearchsoftware})),!__WEBPACK_IMPORTED_MODULE_4__util__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Sie besitzen nicht gen\xFCgend Rechte, um eine Software f\xFCr Forschung und Lehre zu erstellen.'));}}]);return UpdateResearchSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResearchSoftwareDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_details__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__product_details_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__product_details_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProductDetails=[{content:"Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",title:"Nicht fündig geworden?",key:0}];var ResearchSoftwareDetails=function(_Component){_inherits(ResearchSoftwareDetails,_Component);function ResearchSoftwareDetails(props){_classCallCheck(this,ResearchSoftwareDetails);var _this=_possibleConstructorReturn(this,(ResearchSoftwareDetails.__proto__||Object.getPrototypeOf(ResearchSoftwareDetails)).call(this,props));_this.getResearchSoftwareDetails=_this.getResearchSoftwareDetails.bind(_this);_this.state={id:_this.props.match.params.id,name:'',type:"Software F+L",board:'',uuid:'',categories:'',desc:'',price:0,researchtype:'',aim:'',functionality:'',specialties:'',target:'',usage:'',tags:'',standalone_sw:'',is_standalone_sw:'',agreement:false,direct_database_access:null,direct_database_access_desc:'',has_additional_interface:null,additional_interface:'',has_additional_licence:null,additional_licence:'',data_component_complete:'',data_component_options:'',data_manipulation:'',data_manipulation_protocol:'',manipulation_authorised:null,manipulation_authorised_desc:'',data_update_interval:0,has_update_side_effect:'',update_side_effect:'',has_release_plan:'',release_plan:'',is_preparation_needed:'',preparation_needed:'',has_customer_reference:'',customer_reference:'',successful_deployment:null,successful_deployment_description:'',clinic_desc:'',clinic_number:0,user_number:0,complexity_rate:0,satisfaction_rate:0,date:'',rating_desc:'',pdf_files:'',image_files:'',video_files:''};if(!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&_this.id!==undefined){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(){return _this.getResearchSoftwareDetails(_this.props.match.params.id);});}else{_this.getResearchSoftwareDetails(_this.props.match.params.id);}return _this;}_createClass(ResearchSoftwareDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newID=parseInt(nextProps.match.params.id,10);var oldID=parseInt(this.state.id,10);if(oldID!==newID){this.getResearchSoftwareDetails(newID);this.setState({id:newID});}}},{key:'getResearchSoftwareDetails',value:function getResearchSoftwareDetails(id){var self=this;var url='/api/show-researchsoftware?id='+id;var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Software details konnten nicht geladen werden.');console.error('Could not software details.',exception);});promise.then(function(json){localStorage.setItem('product-name',json.name);self.setState({name:json.name?json.name:'(kein Name)',board:json.board?json.board:'',uuid:json.uuid?json.uuid:'',categories:json.categories?json.categories:'(keine Angabe)',desc:json.desc?json.desc:'(keine Angabe)',price:json.price!==undefined?json.price:'(keine Angabe)',researchtype:json.researchtype?json.researchtype:'(keine Angabe)',aim:json.aim?json.aim:'(keine Angabe)',functionality:json.functionality?json.functionality:'(keine Angabe)',specialties:json.specialties?json.specialties:'(keine Angabe)',target:json.target?json.target:'(keine Angabe)',usage:json.usage?json.usage:'(keine Angabe)',tags:json.tags?json.tags:'(keine Angabe)',standalone_sw:json.standalone_sw?json.standalone_sw:'(keine Angabe)',is_standalone_sw:json.is_standalone_sw?json.is_standalone_sw:'(keine Angabe)',direct_database_access:json.direct_database_access?json.direct_database_access:'(keine Angabe)',direct_database_access_desc:json.direct_database_access_desc?json.direct_database_access_desc:'(keine Angabe)',has_additional_interface:json.has_additional_interface?json.has_additional_interface:'(keine Angabe)',additional_interface:json.additional_interface?json.additional_interface:'(keine Angabe)',has_additional_licence:json.has_additional_licence?json.has_additional_licence:'(keine Angabe)',additional_licence:json.additional_licence?json.additional_licence:'(keine Angabe)',data_component_complete:json.data_component_complete?json.data_component_complete:'(keine Angabe)',data_component_options:json.data_component_options?json.data_component_options:'(keine Angabe)',data_manipulation:json.data_manipulation?json.data_manipulation:'(keine Angabe)',data_manipulation_protocol:json.data_manipulation_protocol?json.data_manipulation_protocol:'(keine Angabe)',manipulation_authorised:json.manipulation_authorised?json.manipulation_authorised:'(keine Angabe)',manipulation_authorised_desc:json.manipulation_authorised_desc?json.manipulation_authorised_desc:'(keine Angabe)',data_update_interval:json.data_update_interval?json.data_update_interval:'(keine Angabe)',has_update_side_effect:json.has_update_side_effect?json.has_update_side_effect:'(keine Angabe)',update_side_effect:json.update_side_effect?json.update_side_effect:'(keine Angabe)',has_release_plan:json.has_release_plan?json.has_release_plan:'(keine Angabe)',release_plan:json.release_plan?json.release_plan:'(keine Angabe)',is_preparation_needed:json.is_preparation_needed?json.is_preparation_needed:'(keine Angabe)',preparation_needed:json.preparation_needed?json.preparation_needed:'(keine Angabe)',has_customer_reference:json.has_customer_reference?json.has_customer_reference:'(keine Angabe)',customer_reference:json.customer_reference?json.customer_reference:'(keine Angabe)',successful_deployment:json.successful_deployment?json.successful_deployment:'(keine Angabe)',successful_deployment_description:json.successful_deployment_description?json.successful_deployment_description:'(keine Angabe)',clinic_desc:json.clinic_desc?json.clinic_desc:'(keine Angabe)',clinic_number:json.clinic_number?json.clinic_number:'(keine Angabe)',user_number:json.user_number?json.user_number:'(keine Angabe)',complexity_rate:json.complexity_rate?json.complexity_rate:'(keine Angabe)',satisfaction_rate:json.satisfaction_rate?json.satisfaction_rate:'(keine Angabe)',date:json.date?json.date:'(keine Angane)',rating_desc:json.rating_desc?json.rating_desc:'(keine Angabe)',agreement:json.agreement?json.agreement:'(keine Angabe)',pdf_files:json.pdf_files?json.pdf_files:'(keine Angabe)',image_files:json.image_files?json.image_files:'(keine Angabe',video_files:json.video_files?json.video_files:'(keine Angabe)'});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["t" /* ProductTypeWithoutParantheses */],{name:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["i" /* ProductDetailsButtons */],{board:this.state.board,history:this.props.history,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productInfoHeader'},__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur f\xFCr eingeloggte Nutzer sichtbar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["s" /* ProductTypeWithLabel */],{productType:this.state.type}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__show_categorypath_js__["a" /* CategoryPathWithLabel */],{ids:this.state.categories,startID:2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["m" /* ProductRating */],{uuid:this.state.uuid}),!__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["l" /* ProductPrice */],{price:this.state.price})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProductTabsResearchSoftware//description tab
,{onNewMessage:this.props.onNewMessage,uuid:this.state.uuid,desc:this.state.desc,is_standalone_sw:this.state.is_standalone_sw,standalone_sw:this.state.standalone_sw,aim:this.state.aim,researchtype:this.state.researchtype,functionality:this.state.functionality,specialties:this.state.specialties,target:this.state.target,usage:this.state.usage,tags:this.state.tags//technical details
,direct_database_access:this.state.direct_database_access,direct_database_access_desc:this.state.direct_database_access_desc,has_additional_interface:this.state.has_additional_interface,additional_interface:this.state.additional_interface,has_additional_licence:this.state.has_additional_licence,additional_licence:this.state.additional_interface,data_component_complete:this.state.data_component_complete,data_component_options:this.state.data_component_options,data_manipulation:this.state.has_additional_interface,data_manipulation_protocol:this.state.data_manipulation_protocol,manipulation_authorised:this.state.manipulation_authorised,manipulation_authorised_desc:this.state.manipulation_authorised_desc,data_update_interval:this.state.data_update_interval,has_update_side_effect:this.state.has_update_side_effect,update_side_effect:this.state.update_side_effect,has_release_plan:this.state.has_release_plan,release_plan:this.state.release_plan,is_preparation_needed:this.state.is_preparation_needed,preparation_needed:this.state.preparation_needed//reference software
,has_customer_reference:this.state.has_customer_reference,customer_reference:this.state.customer_reference//statistics
,successful_deployment:this.state.successful_deployment,successful_deployment_description:this.state.successful_deployment_description,clinic_desc:this.state.clinic_desc,clinic_number:this.state.clinic_number,user_number:this.state.user_number,date:this.state.date,complexity_rate:this.state.complexity_rate,satisfaction_rate:this.state.satisfaction_rate,rating_desc:this.state.rating_desc,pdf_files:this.state.pdf_files,image_files:this.state.image_files,video_files:this.state.video_files}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["i" /* ProductDetailsButtons */],{board:this.state.board,history:this.props.history,productID:this.state.id,productType:this.state.type,productName:this.state.name,price:this.state.price,onNewMessage:this.props.onNewMessage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return ResearchSoftwareDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProductTabsResearchSoftware=function(_Component2){_inherits(ProductTabsResearchSoftware,_Component2);function ProductTabsResearchSoftware(props){_classCallCheck(this,ProductTabsResearchSoftware);var _this2=_possibleConstructorReturn(this,(ProductTabsResearchSoftware.__proto__||Object.getPrototypeOf(ProductTabsResearchSoftware)).call(this,props));_this2.makeActive=_this2.makeActive.bind(_this2);_this2.state={activeTab:0};return _this2;}_createClass(ProductTabsResearchSoftware,[{key:'makeActive',value:function makeActive(i){this.setState({activeTab:i});}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProductTabsButtons'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===0?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(0);}},'Beschreibung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===1?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(1);}},'Technische Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===2?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(2);}},'Referenz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===3?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(3);}},'Statistik'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===4?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(4);}},'Reviews'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.state.activeTab===5?"ProductTabsButton active":"ProductTabsButton",onClick:function onClick(event){return _this3.makeActive(5);}},'Medien'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["d" /* ProductDescriptionResearchSoftware */],{style:this.state.activeTab===0?null:{display:'none'},desc:this.props.desc,aim:this.props.aim,researchtype:this.props.researchtype,is_standalone_sw:this.props.is_standalone_sw,standalone_sw:this.props.standalone_sw,functionality:this.props.functionality,specialties:this.props.specialties,target:this.props.target,usage:this.props.usage,tags:this.props.tags}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["r" /* ProductTechnicalDetails */],{style:this.state.activeTab===1?null:{display:'none'},direct_database_access:this.props.direct_database_access,direct_database_access_desc:this.props.direct_database_access_desc,has_additional_interface:this.props.has_additional_interface,additional_interface:this.props.additional_interface,has_additional_licence:this.props.has_additional_licence,additional_licence:this.props.additional_licence,data_component_complete:this.props.data_component_complete,data_component_options:this.props.data_component_options,data_manupulation:this.props.data_manupulation,data_manupulation_protocol:this.props.data_manupulation_protocol,manipulation_authorised:this.props.manipulation_authorised,manipulation_authorised_desc:this.props.manipulation_authorised_desc,data_update_interval:this.props.data_update_interval,has_update_side_effect:this.props.has_update_side_effect,update_side_effect:this.props.update_side_effect,has_release_plan:this.props.has_release_plan,release_plan:this.props.release_plan,is_preparation_needed:this.props.is_preparation_needed,preparation_needed:this.props.preparation_needed}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["o" /* ProductReferenceSoftwareNew */],{style:this.state.activeTab===2?null:{display:'none'},has_customer_reference:this.props.has_customer_reference,customer_reference:this.props.customer_reference}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["u" /* SoftwareStatistics */],{style:this.state.activeTab===3?null:{display:'none'},successful_deployment:this.props.successful_deployment,successful_deployment_description:this.props.successful_deployment_description,clinic_desc:this.props.clinic_desc,user_number:this.props.user_number,clinic_number:this.props.clinic_number,statistic_user_counts:this.props.statistic_user_counts,satisfaction_rate:this.props.satisfaction_rate,rating_desc:this.props.rating_desc,date:this.props.date,complexity_rate:this.props.complexity_rate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["p" /* ProductReviews */],{uuid:this.props.uuid,style:this.state.activeTab===4?null:{display:'none'},onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__product_details__["k" /* ProductMediaMultiParent */],{style:this.state.activeTab===5?null:{display:'none'},heading1:'Dokumentation',uuids1:this.props.pdf_files,heading2:'Beschreibende Bilder oder Screenshots',uuids2:this.props.image_files,heading3:'Video',uuids3:this.props.video_files})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__footer_js__["a" /* Footer */],{faqs:faqProductDetails}));}}]);return ProductTabsResearchSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateSoftware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateSoftwareWithFeebox; });
/* unused harmony export UpdateSoftware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__business_activities__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__new_software_css__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__new_software_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__new_software_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__feebox_xu__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__researchSoftwareMinimalDatePicker__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__category_selector_rewrite__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_form_components_js__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var introductoryTextNonCom='<p>An dieser Stelle können Sie Software, Software-Module, spezielles Customizing eines Systems, Excel-Programmierungen und vieles mehr einstellen.<br/>Alles, was das weite Feld Software betrifft - sofern es kein Medizinprodukt ist. <br />Also z.B. auch Maskenabfolgen und Codes für einen Spezialbereich im klinischen Informationssystem. Oder ein Controlling-Excel-Sheet, das seit Jahren ausgereift ist. Aber ebenso eine technische Spezifikation oder ein Leistungsverzeichnis, das für andere nützlich sein kann.<br/> <br/><p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';var introductoryTextCom='<p>An dieser Stelle können Sie Software, Software-Module, spezielles Customizing eines Systems, Excel-Programmierungen und vieles mehr einstellen.<br/><br /> Alles, was das weiter Feld Software betrifft - sofern es kein Medizinprodukt ist. <br /><br />Also z.B. auch Maskenabfolgen und Codes für einen Spezialbereich im klinischen Informationssystem. Oder ein Controlling-Excel-Sheet, das seit Jahren ausgereift ist. Aber ebenso eine technische Spezifikation oder ein Leistungsverzeichnis, das für andere nützlich sein kann.<br /><br >Sie bezahlen eine Gebühr für das Einstellen in den Marktplatz und die oder der Suchende bekommt bei der Ergebnisanzeige Ihre vollständigen Daten.<br /><br />Als kommerzieller Anbieter ist selbstverständlich <u>keine</u> Offenlegung des Codes gefordert.<br/> <br/><p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';var checkBoxInfo="Wenn Sie ein nicht kommerzielles Produkt anlegen, ist es erforderlich, dem Käufer den Quell-Code zur Verfügung zu stellen. (Der Quellcode wird nicht weiterverkauft.) Nur so kann Ayacandas die Gewährleistung übernehmen.";var faqSoftware=[{content:"Der Käufer soll und muss die Möglichkeit haben, das Produkt, das er kauft, an seine Bedürfnisse anzupassen. Dies ist meist bereits technisch notwendig, um Software zum Laufen zu bekommen. ",title:"Warum müssen Software-Produkte quelloffen weitergegeben werden?",key:0},{content:"Dies wird im Kaufvertrag ausdrücklich und unter Vertragsstrafe untersagt. Der Käufer darf das Produkt für sich selbst verwenden und anpassen..",title:"Kann der Käufer das Produkt weiterverkaufen? ",key:1},{content:"Wenn eine neue und wesentlich veränderte Version in den Marktplatz von Ayacandas eingestellt wird - eine echte Weiterentwicklung - , bekommt der neue Verkäufer 30% fest. Die restlichen 70% werden unter allen Schreibern vorheriger Versionen paritätisch aufgeteilt.",title:"Was ist, wenn der Käufer das Produkt essentiell weiterentwickelt und damit eine neue Version erstellt?",key:2},{content:"Bitte melden Sie Sich bei uns - wir werden umgehend versuchen, eine Lösung zu finden und den Angebotsbaum erweitern.",title:"Was ist, wenn eine Kategorie nicht auffindbar ist oder fehlt? ",key:3},{content:"Ein Weiterverkauf innerhalb der meisten Förderprogramme ist unproblematisch, da er den Förderzweck nicht entfremdet. Ein Weiterverkauf verstößt somit <u>nicht</u> gegen die Bedingungen des Förderbescheids. Eine Mehrwerterschaffung sollte jedoch von der jeweiligen  Klinik an das zuständige Ministerium gemeldet werden.<br /><br />Das Anbieten ist unkritisch, sofern vom ursprünglichen Förderbescheid kein Geld entwendet oder veräußert wird und nicht gegen die Begutachtungslinie der DFG gehandelt wird. In diesem Zusammenhang darf nur Eigenleistung verkauft werden.",title:"Gibt es Probleme, wenn das Produkt mit der Hilfe von Förderbescheiden entwickelt wurde?",key:4},{content:"Einnahmen gehen, falls Sie nicht als Privatperson verkaufen, oft nicht an Sie, sondern an die Institution, in deren Namen Sie verkaufen. Solche Einnahmen können Sie Sich im Rahmen des Controllings als eigene Einnahmen durch Verrechnung gutschreiben lassen.",title:"Was habe ich davon, wenn ich für meine Institution etwas verkaufe - das Geld gehört doch dann weder mir noch meiner Abteilung?",key:5}];var softwareTypes=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'6'},'bitte w\xE4hlen...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'0'},'Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'1'},'Praxen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'2'},'MVZ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'3'},'Kleingruppen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'4'},'Einzelpersonen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'5'},'sonstige/keine Auslegung')];var complexityRate=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'0'},'bitte w\xE4hlen...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'1'},'1 - niedrige Komplexit\xE4t'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'2'},'2 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'3'},'3 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'4'},'4 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'5'},'5 - mittlere Komplexit\xE4t'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'6'},'6 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'7'},'7 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'8'},'8 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'9'},'9 - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'10'},'10 - hohe Komplexit\xE4t')];var satisfactionRate=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'0'},'bitte w\xE4hlen...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'1'},'Sehr zufrieden'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'2'},'Zufrieden'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'3'},'Weniger zufrieden'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'4'},'Unzufrieden')];var CreateSoftware=function(_Component){_inherits(CreateSoftware,_Component);function CreateSoftware(props){_classCallCheck(this,CreateSoftware);var _this=_possibleConstructorReturn(this,(CreateSoftware.__proto__||Object.getPrototypeOf(CreateSoftware)).call(this,props));_this.fetchDataAndRedirect=_this.fetchDataAndRedirect.bind(_this);_this.fetchDataAndRedirect();return _this;}_createClass(CreateSoftware,[{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/new-create-software';var promise=fetch(url,{method:'POST',headers:headers,body:''}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine neue Software anlegen!');console.error('Could not create new software!',exception);});promise.then(function(json){self.props.history.replace('/update-software/'+json.id);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CreateSoftware'});}}]);return CreateSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateSoftwareWithFeebox=function(_Component2){_inherits(UpdateSoftwareWithFeebox,_Component2);function UpdateSoftwareWithFeebox(props){_classCallCheck(this,UpdateSoftwareWithFeebox);var _this2=_possibleConstructorReturn(this,(UpdateSoftwareWithFeebox.__proto__||Object.getPrototypeOf(UpdateSoftwareWithFeebox)).call(this,props));_this2.updateFeeByPrice=_this2.updateFeeByPrice.bind(_this2);_this2.updateFeeByCategories=_this2.updateFeeByCategories.bind(_this2);_this2.countCategories=_this2.countCategories.bind(_this2);_this2.state={price:0,categoryCount:1};return _this2;}_createClass(UpdateSoftwareWithFeebox,[{key:'updateFeeByPrice',value:function updateFeeByPrice(price){this.setState({price:price});return true;}},{key:'updateFeeByCategories',value:function updateFeeByCategories(categories){this.setState({categoryCount:this.countCategories(categories)});return true;}},{key:'countCategories',value:function countCategories(categories){// workaround: converting String to array (FIXME)
if(typeof categories==='string'){categories=categories.split(",");}console.log(categories);var tempCats=[];var count=0;for(var i=0;i<6;i++){if(categories!==undefined&&categories[i]!==null&&categories[i]!==""){if(!tempCats.includes(categories[i])){tempCats.push(categories[i]);count=count+1;}}}return count;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateSoftwareWithFeebox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdateSoftware,{history:this.props.history,match:this.props.match,params:this.props.params,updateFeeByPrice:this.updateFeeByPrice,updateFeeByCategories:this.updateFeeByCategories,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__feebox_xu__["a" /* FeeBoxXU */],{type:'software',price:this.state.price,categoryCount:this.state.categoryCount}));}}]);return UpdateSoftwareWithFeebox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateSoftware=function(_Component3){_inherits(UpdateSoftware,_Component3);function UpdateSoftware(props){_classCallCheck(this,UpdateSoftware);var _this3=_possibleConstructorReturn(this,(UpdateSoftware.__proto__||Object.getPrototypeOf(UpdateSoftware)).call(this,props));_this3.fetchDataAndRedirect=_this3.fetchDataAndRedirect.bind(_this3);_this3.update=_this3.update.bind(_this3);_this3.validateInput=_this3.validateInput.bind(_this3);_this3.checkRequiredFields=_this3.checkRequiredFields.bind(_this3);_this3.isValid=_this3.isValid.bind(_this3);_this3.save=_this3.save.bind(_this3);_this3.state={startID:2,id:null,name:'',categories:'',price:0,aim:'',tags:'',standalone_sw:'',is_standalone_sw:'',agreement:false,direct_database_access:null,direct_database_access_desc:'',has_additional_interface:null,additional_interface:'',has_additional_licence:null,additional_licence:'',data_component_complete:false,data_component_options:'',data_manipulation:'',data_manipulation_protocol:'',manipulation_authorised:null,manipulation_authorised_desc:'',data_update_interval:0,has_update_side_effect:false,update_side_effect:'',has_release_plan:'',release_plan:'',is_preparation_needed:'',preparation_needed:'',has_customer_reference:'',customer_reference:'',successful_deployment:null,successful_deployment_description:'',clinic_desc:'',clinic_number:0,user_number:0,complexity_rate:0,date:'',satisfaction_rate:0,rating_desc:'',agb_agreement:false,is_public:false,is_update_available:false,update_price:'',update_price_text:'',target_group:'',pdf_files:',,,,',image_files:',,,,,,,,,',video_files:'',product_files:'',agreement_1:false,agreement_2:false,agreement_3:false,agreement_4:false,agreement_5:false,agreement_6:false};_this3.fetchDataAndRedirect();_this3.globalFormData={};return _this3;}_createClass(UpdateSoftware,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextState!==this.state){return true;}else{return false;}}},{key:'update',value:function update(slot,value){if(slot==='price'&&this.props.updateFeeByPrice!==undefined){this.props.updateFeeByPrice(parseInt(value,10));}if(slot==='categories'&&this.props.updateFeeByCategories!==undefined){this.props.updateFeeByCategories(value);}this.globalFormData[slot]=value;}},{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var id=this.props.match.params.id;var self=this;var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/new-create-software';var promise=fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte laden!');console.error('Could not retrieve researchsoftware data!',exception);});promise.then(function(json){self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,aim:json.aim,tags:json.tags,standalone_sw:json.standalone_sw,is_standalone_sw:json.is_standalone_sw,agreement:json.agreement,direct_database_access:json.direct_database_access,direct_database_access_desc:json.direct_database_access_desc,has_additional_interface:json.has_additional_interface,additional_interface:json.additional_interface,has_additional_licence:json.has_additional_licence,additional_licence:json.additional_licence,data_component_complete:json.data_component_complete,data_component_options:json.data_component_options,data_manipulation:json.data_manipulation,data_manipulation_protocol:json.data_manipulation_protocol,manipulation_authorised:json.manipulation_authorised,manipulation_authorised_desc:json.manipulation_authorised_desc,data_update_interval:json.data_update_interval,has_update_side_effect:json.has_update_side_effect,update_side_effect:json.update_side_effect,has_release_plan:json.has_release_plan,release_plan:json.release_plan,is_preparation_needed:json.is_preparation_needed,preparation_needed:json.preparation_needed,has_customer_reference:json.has_customer_reference,customer_reference:json.customer_reference,successful_deployment:json.successful_deployment,successful_deployment_description:json.successful_deployment_description,clinic_desc:json.clinic_desc,clinic_number:json.clinic_number,user_number:json.user_number,complexity_rate:json.complexity_rate,date:json.date,satisfaction_rate:json.satisfaction_rate,rating_desc:json.rating_desc,agb_agreement:json.agb_agreement,is_public:json.is_public,is_update_available:json.is_update_available,update_price:json.update_price,update_price_text:json.update_price_text,target_group:json.target_group,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement_1:json.agreement_1,agreement_2:json.agreement_2,agreement_3:json.agreement_3,agreement_4:json.agreement_4,agreement_5:json.agreement_5,agreement_6:json.agreement_6});});}},{key:'isValid',value:function isValid(categories){if(categories===undefined)return false;if(categories===null)return false;if(categories==="")return false;if(typeof categories==='string'){categories=categories.split(/,/);}var catInput=categories.map(function(item){return parseInt(item,10);});for(var i=0;i<categories.length;i++){if(parseInt(catInput[i],10)===catInput[i]){return true;}}return false;}},{key:'validateInput',value:function validateInput(){if(this.globalFormData['name']===undefined){if(this.state.name.length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}if(this.globalFormData['name'].length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.state.aim.length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}else{if(this.globalFormData['aim'].length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.globalFormData['aim'].length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}return true;}},{key:'checkRequiredFields',value:function checkRequiredFields(){if(this.globalFormData['name']===undefined){if(this.state.name.length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfelder. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}if(this.globalFormData['categories']===undefined&&!this.isValid(this.state.categories)){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(!this.isValid(this.globalFormData['categories'])){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<1){alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}else{if(this.globalFormData['aim'].length<1){alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}if(this.globalFormData['price']===undefined){if(this.state.price.length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}else{if(this.globalFormData['price'].length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}/*
       if (this.globalFormData['is_public'] === undefined) {
       if (this.state.is_public !== true) {
       alert("Bitte geben Sie an, ob die Software aus einer öffentlichen Instutition angeboten wird.");
       return false;
       }
       }

       if (this.globalFormData['is_public'] === false) {
       alert("Bitte geben Sie an, ob die Software aus einer öffentlichen Instutition angeboten wird.");
       return false;
       }

     *//*
       if (this.globalFormData['agreement'] === undefined) {
       if (this.state.agreement !== true) {
       alert("Bitte stimmen Sie der Erklärung zu.0");
       return false;
       }
       }

       if (this.globalFormData['agreement'] === false) {
       alert("Bitte stimmen Sie der Erklärung zu.0");
       return false;
       }
     *//*
       if (this.globalFormData['agreement_1'] === undefined) {
       if (this.state.agreement_1 !== true) {
       alert("Bitte stimmen Sie der Erklärung zu.1");
       return false;
       }
       }

       if (this.globalFormData['agreement_1'] === false) {
       alert("Bitte stimmen Sie der Erklärung zu.1");
       return false;
       }
     */if(this.globalFormData['agreement_2']===undefined){if(this.state.agreement_2!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_2']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_3']===undefined){if(this.state.agreement_3!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_3']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_4']===undefined){if(this.state.agreement_4!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_4']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(!__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()){if(this.globalFormData['agreement_5']===undefined){if(this.state.agreement_5!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_5']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_6']===undefined){if(this.state.agreement_6!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_6']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agb_agreement']===false){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}if(this.globalFormData['agb_agreement']===undefined){if(this.state.agb_agreement!==true){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}}return true;}},{key:'save',value:function save(announce){if(announce===true){if(this.checkRequiredFields()===false){return;}}if(announce===true){if(this.validateInput()===false){return;}}var self=this;var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var formData=new FormData();Object.keys(this.globalFormData).map(function(key){return formData.append(key,self.globalFormData[key]);});formData.append("id",this.state.id);if(announce===true){formData.append('announce',true);}else{formData.append('announce',false);}formData.append('active',true);var url='/api/new-update-software';var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte speichern!');console.error('Could not save researchsoftware data!',exception);});promise.then(function(json){alert('Werte wurden gespeichert.');if(announce===true){Object(__WEBPACK_IMPORTED_MODULE_4__business_activities__["a" /* logBusinessActivities */])("Software gespeichert, allem zugestimmt und veroeffentlicht.",json.id);}self.globalFormData={};self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,aim:json.aim,tags:json.tags,standalone_sw:json.standalone_sw,is_standalone_sw:json.is_standalone_sw,agreement:json.agreement,direct_database_access:json.direct_database_access,direct_database_access_desc:json.direct_database_access_desc,has_additional_interface:json.has_additional_interface,additional_interface:json.additional_interface,has_additional_licence:json.has_additional_licence,additional_licence:json.additional_licence,data_component_complete:json.data_component_complete,data_component_options:json.data_component_options,data_manipulation:json.data_manipulation,data_manipulation_protocol:json.data_manipulation_protocol,manipulation_authorised:json.manipulation_authorised,manipulation_authorised_desc:json.manipulation_authorised_desc,data_update_interval:json.data_update_interval,has_update_side_effect:json.has_update_side_effect,update_side_effect:json.has_update_side_effect,has_release_plan:json.has_release_plan,release_plan:json.release_plan,is_preparation_needed:json.is_preparation_needed,preparation_needed:json.preparation_needed,has_customer_reference:json.has_customer_reference,customer_reference:json.customer_reference,successful_deployment:json.successful_deployment,successful_deployment_description:json.successful_deployment_description,clinic_desc:json.clinic_desc,clinic_number:json.clinic_number,user_number:json.user_number,complexity_rate:json.complexity_rate,date:json.date,satisfaction_rate:json.satisfaction_rate,rating_desc:json.rating_desc,agb_agreement:json.agb_agreement,is_public:json.is_public,is_update_available:json.is_update_available,update_price:json.update_price,update_price_text:json.update_price_text,target_group:json.target_group,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement_1:json.agreement_1,agreement_2:json.agreement_2,agreement_3:json.agreement_3,agreement_4:json.agreement_4,agreement_5:json.agreement_5,agreement_6:json.agreement_6});self.props.history.push('/product-list');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* isNonCommercialUser */]()||__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1',id:'toplanding'},'Anbieten einer Software'),!__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen Preis auffindbar.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["p" /* TextInfo */],{content:introductoryTextNonCom})),__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen Preis auffindbar.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["p" /* TextInfo */],{content:introductoryTextCom})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productForm1  marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodInputComp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__category_selector_rewrite__["a" /* CategorySelectorList */],{value:this.state.categories,slot:'categories',update:this.update,categoryLimit:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["q" /* TextLine */],{heading:' Was bieten Sie an?',subheading:'Unter diesem Titel wird ihr Produkt angezeigt.',obligatory:true,maxLength:'200',value:this.state.name,placeholder:'was bieten Sie an',slot:'name',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["o" /* TextField */],{heading:'Beschreibung?',obligatory:true,maxLength:'2000',placeholder:'Zweck der Software',value:this.state.aim,slot:'aim',update:this.update}),!__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["k" /* Price */],{heading:'Preis in Euro',subheading:'85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution f\xFCr das Zurverf\xFCgungstellen der Lizenz ausbezahlt.',obligatory:true,maxLength:'6',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["k" /* Price */],{heading:'Preis in Euro',subheading:'M\xF6chten Sie keine Preis-Angabe machen, dann geben Sie bitte 99999 an.',obligatory:true,maxLength:'6',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["d" /* Confirmed */],{obligatory:true,heading:'Wird diese Software von einer \xF6ffentlichen Organistation angeboten? (Beispielsweise von einer Gemeinde, Kommune, Universit\xE4t, Anstalt eines Landes)',value:this.state.is_public,slot:'is_public',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Ist die Software ein eigenst\xE4ndiges Produkt (d.h sie ist kein Add-On)?',placeholder:'Beschreibung',value:this.state.is_standalone_sw,value2:this.state.standalone_sw,slot:'is_standalone_sw',slot2:'standalone_sw',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["f" /* ConfirmedTextWithPrice */],{heading:'Gibt es Wartungen oder Updates?',heading2:'Falls ja, zu welchen Kosten pro Jahr?',placeholder:'Update/Wartung',value:this.state.is_update_available,value3:this.state.update_price,value4:this.state.update_price_text,slot:'is_update_available',slot3:'update_price',slot4:'update_price_text',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["l" /* Selection */],{heading:'F\xFCr welche Einrichtung\tist das Produkt prim\xE4r ausgelegt?',selectionValues:softwareTypes,obligatory:false,value:this.state.target_group,slot:'target_group',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["n" /* Tags */],{heading:'Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)',placeholder:'Tags/Stichworte',value:this.state.tags,slot:'tags',update:this.update,match:this.props.match,params:this.props.params,maxTags:7,maxLength:150,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)',value:this.state.pdf_files,slot:'pdf_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Beschreibende Bilder oder Screenshots',value:this.state.image_files,slot:'image_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Video, max. 5 GB',value:this.state.video_files,slot:'video_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Braucht die Software einen direkten Zugriff auf die Datenbank? Wenn ja, beschreiben Sie die Zugriffsart.',placeholder:'Beschreibung',value:this.state.direct_database_access,value2:this.state.direct_database_access_desc,slot:'direct_database_access',slot2:'direct_database_access_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden zus\xE4tzliche Schnittstellen ben\xF6tigt?',placeholder:'Beschreibung',value:this.state.has_additional_interface,value2:this.state.additional_interface,slot:'has_additional_interface',slot2:'additional_interface',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden zus\xE4tzliche Lizenzen ben\xF6tigt?',placeholder:'Beschreibung',value:this.state.has_additional_licence,value2:this.state.additional_licence,slot:'has_additional_licence',slot2:'additional_licence',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden alle Elemente f\xFCr den Datenzugriff mitgeliefert? Welche M\xF6glichkeiten bieten Sie an?',placeholder:'Beschreibung',value:this.state.data_component_complete,value2:this.state.data_component_options,slot:'data_component_complete',slot2:'data_component_options',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Werden Daten am Quellsystem manipuliert oder ver\xE4ndert? Falls ja: Wie wird dies protokolliert?',placeholder:'Beschreibung',value:this.state.data_manipulation,value2:this.state.data_manipulation_protocol,slot:'data_manipulation',slot2:'data_manipulation_protocol',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Erfolgt der Zugriff auf die Datenquelle \xFCber von Entwicklern zugelassene Zugriffsmethoden?',placeholder:'Beschreibung',value:this.state.manipulation_authorised,value2:this.state.manipulation_authorised_desc,slot:'manipulation_authorised',slot2:'manipulation_authorised_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["h" /* IntegerField */],{heading:'Falls eine \u201Esynchrone Schnittstelle\u201C aktiv ist: Gibt es Aktualisierungsnebenwirkungen? (Wenn ja, welche?)',maxLength:'20',value:this.state.data_update_interval,placeholder:'Das Aktualisierungsintervall in Min.',slot:'data_update_interval',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Falls eine synchrone Schnittstelle aktiv ist: Gibt es Aktualisierungsnebenwirkungen? Wenn ja, welche?',placeholder:'Beschreibung',value:this.state.has_update_side_effect,value2:this.state.update_side_effect,slot:'has_update_side_effect',slot2:'update_side_effect',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Gibt es einen Release-Plan oder geplante Weiterentwicklungen? Falls ja, bitte beschreiben Sie diese.',placeholder:'Beschreibung',value:this.state.has_release_plan,value2:this.state.release_plan,slot:'has_release_plan',slot2:'release_plan',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Sind Vorbereitungen f\xFCr eine Installation notwendig?',placeholder:'Beschreibung',value:this.state.is_preparation_needed,value2:this.state.preparation_needed,slot:'is_preparation_needed',slot2:'preparation_needed',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Gibt es Empfehlungen oder Erfahrungswerte zu Ihrer Software?',placeholder:'Referenzen',value:this.state.has_customer_reference,value2:this.state.customer_reference,slot:'has_customer_reference',slot2:'customer_reference',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["e" /* ConfirmedText */],{heading:'Wird die Software schon erfolgreich eingesetzt?',placeholder:'erfolgreich eingesetzt',value:this.state.successful_deployment,value2:this.state.successful_deployment_description,slot:'successful_deployment',slot2:'successful_deployment_description',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["o" /* TextField */],{heading:'Welche sind die Einsatzbereiche Ihrer Software?',placeholder:'Einsatzbereiche',maxLength:'600',value:this.state.clinic_desc,slot:'clinic_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["h" /* IntegerField */],{heading:'Wieviele Nutzerinnen und Nutzer hat Ihre Software?',maxLength:'20',value:this.state.user_number,placeholder:'Nutzer Anzahl',slot:'user_number',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["h" /* IntegerField */],{heading:'Wieviele davon sind Kliniken?',maxLength:'20',value:this.state.clinic_number,placeholder:'Anzahl der Kliniken',slot:'clinic_number',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["c" /* ComplexityRate */],{heading:'Sch\xE4tzen Sie: Wie komplex ist Ihre Software f\xFCr Anwender?',complexityRate:complexityRate,obligatory:false,value:this.state.complexity_rate,slot:'complexity_rate',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__researchSoftwareMinimalDatePicker__["a" /* default */],{heading:'Seit wann ist Ihre Software in Nutzung?',value:this.state.date,slot:'date',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["c" /* ComplexityRate */],{heading:'Wie sch\xE4tzen Sie die mittlere Zufriedenheit der Nutzer(-innen) Ihrer Software ein?',complexityRate:satisfactionRate,obligatory:false,value:this.state.satisfaction_rate,slot:'satisfaction_rate',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["o" /* TextField */],{heading:'Eine negative Zufriedenheit der Nutzer(-innen) kann begr\xFCndet sein. Hier die M\xF6glichkeit f\xFCr eine Erkl\xE4rung.',maxLength:'600',value:this.state.rating_desc,slot:'rating_desc',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Hier haben Sie die M\xF6glichkeit, Ihr Produkt als eine Datei hochzuladen.',value:this.state.product_files,slot:'product_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodHeaderTexts margin-bottom3'},'* Erkl\xE4rung zum Besitz'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'TextInfoText margin-bottom4'},'Bitte versichern Sie, dass die angebotene Software'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["b" /* CheckBox */],{content:' Sie oder Ihre Organisation die Rechte f\xFCr den Verkauf haben.',value:this.state.agreement_2,slot:'agreement_2',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["b" /* CheckBox */],{content:'dass Sie nicht jemand anderes \'geistiges Eigentum\' anbieten.',value:this.state.agreement_3,slot:'agreement_3',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["b" /* CheckBox */],{content:'Ihre Organisation, f\xFCr die Sie anbieten, damit einverstanden ist.',value:this.state.agreement_4,slot:'agreement_4',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["b" /* CheckBox */],{content:'und Sie als Ansprechpartner zur Verf\xFCgung stehen..',value:this.state.agreement_6,slot:'agreement_6',update:this.update}),!__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["a" /* AGBCheckBox */],{value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/ueberlassungsvereinbarung.pdf',content1:'Ich habe die ',fileType:'\xDCberlassungsvereinbarung',content2:' gelesen und akzeptiere diese.',update:this.update}),__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["a" /* AGBCheckBox */],{value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/einstellvertrag.pdf',content1:'Ich habe den ',fileType:'Einstellvertrag',content2:' gelesen und akzeptiere diesen.',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),!__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["p" /* TextInfo */],{content:checkBoxInfo}),!__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["b" /* CheckBox */],{content:'Ich erkl\xE4re mich bereit, dem K\xE4ufer unter der Verpflichtung, dies nicht ohne meine Genehmigung weiterzuverkaufen, den Quellcode zur Verf\xFCgung zu stellen.',value:this.state.agreement_5,slot:'agreement_5',update:this.update}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_form_components_js__["m" /* SubmitButton */],{history:this.props.history,onSubmit:this.save}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqSoftware})),!__WEBPACK_IMPORTED_MODULE_3__util__["f" /* isNonCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_3__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Sie besitzen nicht gen\xFCgend Rechte, um eine Software zu erstellen.'));}}]);return UpdateSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateUsedSoftware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateUsedSoftwareWithFeebox; });
/* unused harmony export UpdateUsedSoftware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category_selector_rewrite__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__business_activities__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__used_software_css__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__used_software_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__used_software_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feebox_xu__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_form_components_js__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var introductoryText='<p>Hier können Kliniken Software, die sie gekauft haben, deren Lizenzen sie aber nicht nutzen, anbieten. Dies wird von Ayacandas begleitet und juristisch abgesicher. <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';var faqSoftware=[{content:"Immer wieder werden Systeme gewechselt oder durch neue Technologien ersetzt - die Software, die dafür teuer gekauft wurde, bleibt dann oft ungenutzt liegen. Hier soll die Möglichkeit gegeben werden, ungenutzte Software-Lizenzen noch zu verkaufen. <br /> <br /> Denn es zeigt sich, dass viele Kliniken z.B. noch mit alter Software arbeiten, so dass für diese auch ältere Versionen sehr nützlich sein können. ",title:"Wozu der Bereich der Gebrauchtsoftware?",key:0},{content:"Der Europäische Gerichtshof führt in seinem Urteil aus, dass der Grundsatz der Erschöpfung des Verbreitungsrechts nicht nur dann gilt, wenn der Urheberrechtsinhaber die Kopien seiner Software auf einem Datenträger (CD-ROM oder DVD) vermarktet, sondern auch dann, wenn er sie durch Herunterladen von seiner Internetseite verbreitet. In diesem Zusammenhang stellt der Gerichtshof klar, dass jeder spätere Erwerber einer Kopie, für die das Verbreitungsrecht des Urheberrechtsinhabers erloschen ist, rechtmäßiger Erwerber in diesem Sinne ist. Er kann also die ihm vom Ersterwerber verkaufte Kopie auf seinen Computer herunterladen. Dieses Herunterladen ist als Vervielfältigung eines Computerprogramms anzusehen, die für die bestimmungsgemäße Nutzung dieses Programms durch den neuen Erwerber erforderlich ist … <br /> <br /> EuGH (3/7/12, RsC-128/11)<br /><br /> „… Außerdem erstreckt sich die Erschöpfung des Verbreitungsrechts auf die Programmkopie in der vom Urheberrechtsinhaber verbesserten und aktualisierten Fassung …“ <br /><br /> EuGH (3/7/12, RsC-128/11)",title:"Wie verhält sich der Verkauf rechtlich? ",key:1},{content:"Nein. Keine.<br /><br />„… Weiter führt der Gerichtshof aus, dass der ursprüngliche Erwerber einer körperlichen oder nichtkörperlichen Programmkopie, an der das Verbreitungsrecht des Erwerbers erschöpft ist, die auf seinen Computer heruntergeladene Kopie zum Zeitpunkt des Weiterverkaufs unbrauchbar machen muss …“<br /><br />EuGH (3/7/12, RsC-128/11)<br /><br />",title:"Darf ich noch Kopien der entsprechenden Software behalten? ",key:2},{content:"Klare Antwort: Ja, wenn diese vollständig verkauft werden. Bei allen anderen Versionen besteht zumindest ein Nachweis-Problem, dass einen in eine rechtlich dunkelgraue Zone führt.<br /><br />„… Stellt der Urheberrechtsinhaber seinem Kunden nämlich eine – körperliche oder nichtkörperliche – Kopie zur Verfügung, und schließt er gleichzeitig gegen Zahlung eines Entgelts einen Lizenzvertrag, durch den der Kunde das unbefristete Nutzungsrecht an dieser Kopie erhält, so verkauft er diese Kopie an den Kunden und erschöpft damit sein ausschließliches Verbreitungsrecht. Durch ein solches Geschäft wird nämlich das Eigentum an dieser Kopie übertragen. Somit kann sich der Rechtsinhaber, selbst wenn der Lizenzvertrag eine spätere Veräußerung untersagt, dem Weiterverkauf dieser Kopie nicht mehr widersetzen …“<br /><br />EuGH (3/7/12, RsC-128/11)<br /><br />„… Der Gerichtshof weist jedoch darauf hin, dass die Erschöpfung des Verbreitungsrechts den Ersterwerber nicht dazu berechtigt, die Lizenz aufzuspalten und teilweise weiterzuverkaufen, falls die von ihm erworbene Lizenz für eine seinen Bedarf übersteigende Zahl von Nutzern gilt …“<br /><br />EuGH (3/7/12, RsC-128/11)<br /><br />",title:"Können Volumenverträge weiterverkauft werden? ",key:3},{content:"Der Verkauf erfolgt direkt von Ihnen zum Käufer, die Firma Ayacandas bekommt eine Vermittlungsgebühr.",title:" Wie geht der Verkauf über die Firma Ayacandas?",key:4}];var CreateUsedSoftware=function(_Component){_inherits(CreateUsedSoftware,_Component);function CreateUsedSoftware(props){_classCallCheck(this,CreateUsedSoftware);var _this=_possibleConstructorReturn(this,(CreateUsedSoftware.__proto__||Object.getPrototypeOf(CreateUsedSoftware)).call(this,props));_this.fetchDataAndRedirect=_this.fetchDataAndRedirect.bind(_this);_this.fetchDataAndRedirect();return _this;}_createClass(CreateUsedSoftware,[{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-used-software';var promise=fetch(url,{method:'POST',headers:headers,body:''}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine neue Software anlegen!');console.error('Could not create new software!',exception);});promise.then(function(json){self.props.history.replace('/update-used-software/'+json.id);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CreateUsedSoftware'});}}]);return CreateUsedSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateUsedSoftwareWithFeebox=function(_Component2){_inherits(UpdateUsedSoftwareWithFeebox,_Component2);function UpdateUsedSoftwareWithFeebox(props){_classCallCheck(this,UpdateUsedSoftwareWithFeebox);var _this2=_possibleConstructorReturn(this,(UpdateUsedSoftwareWithFeebox.__proto__||Object.getPrototypeOf(UpdateUsedSoftwareWithFeebox)).call(this,props));_this2.updateFeeByPrice=_this2.updateFeeByPrice.bind(_this2);_this2.updateFeeByCategories=_this2.updateFeeByCategories.bind(_this2);_this2.countCategories=_this2.countCategories.bind(_this2);_this2.state={price:0,categoryCount:1};return _this2;}_createClass(UpdateUsedSoftwareWithFeebox,[{key:'updateFeeByPrice',value:function updateFeeByPrice(price){this.setState({price:price});return true;}},{key:'updateFeeByCategories',value:function updateFeeByCategories(categories){this.setState({categoryCount:this.countCategories(categories)});return true;}},{key:'countCategories',value:function countCategories(categories){// workaround: converting String to array (FIXME)
if(typeof categories==='string'){categories=categories.split(",");}console.log(categories);var tempCats=[];var count=0;for(var i=0;i<6;i++){if(categories!==undefined&&categories[i]!==null&&categories[i]!==""){if(!tempCats.includes(categories[i])){tempCats.push(categories[i]);count=count+1;}}}return count;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateUsedSoftwareWithFeebox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdateUsedSoftware,{history:this.props.history,match:this.props.match,updateFeeByPrice:this.updateFeeByPrice,updateFeeByCategories:this.updateFeeByCategories}),__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__feebox_xu__["a" /* FeeBoxXU */],{type:'software',price:this.state.price,categoryCount:this.state.categoryCount}));}}]);return UpdateUsedSoftwareWithFeebox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateUsedSoftware=function(_Component3){_inherits(UpdateUsedSoftware,_Component3);function UpdateUsedSoftware(props){_classCallCheck(this,UpdateUsedSoftware);var _this3=_possibleConstructorReturn(this,(UpdateUsedSoftware.__proto__||Object.getPrototypeOf(UpdateUsedSoftware)).call(this,props));_this3.fetchDataAndRedirect=_this3.fetchDataAndRedirect.bind(_this3);_this3.update=_this3.update.bind(_this3);_this3.validateInput=_this3.validateInput.bind(_this3);_this3.checkRequiredFields=_this3.checkRequiredFields.bind(_this3);_this3.isValid=_this3.isValid.bind(_this3);_this3.save=_this3.save.bind(_this3);_this3.state={startID:2,id:null,name:'',categories:'',price:0,aim:'',tags:'',desc:'',agb_agreement:false,is_public:false,is_update_available:false,update_price_text:'',pdf_files:',,,,',image_files:',,,,,,,,,',video_files:'',product_files:'',agreement_1:false,agreement_2:false,agreement_3:false,agreement_4:false,agreement_6:false,// new for used-software
company:'',company_name:'',company_web:''};_this3.fetchDataAndRedirect();_this3.globalFormData={};return _this3;}_createClass(UpdateUsedSoftware,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextState!==this.state){return true;}else{return false;}}},{key:'update',value:function update(slot,value){if(slot==='price'&&this.props.updateFeeByPrice!==undefined){this.props.updateFeeByPrice(parseInt(value,10));}if(slot==='categories'&&this.props.updateFeeByCategories!==undefined){this.props.updateFeeByCategories(value);}this.globalFormData[slot]=value;}},{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var id=this.props.match.params['id'];var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-used-software';var promise=fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte laden!');console.error('Could not retrieve used-oftware data!',exception);});promise.then(function(json){self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,aim:json.aim,tags:json.tags,agb_agreement:json.agb_agreement,is_public:json.is_public,is_update_available:json.is_update_available,update_price:json.update_price,update_price_text:json.update_price_text,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement_2:json.agreement_2,agreement_3:json.agreement_3,agreement_4:json.agreement_4,agreement_6:json.agreement_6,// new to used-software
company:json.company,company_name:json.company_name,company_web:json.company_web});});}},{key:'isValid',value:function isValid(categories){if(categories===undefined)return false;if(categories===null)return false;if(categories==="")return false;if(typeof categories==='string'){categories=categories.split(/,/);}var catInput=categories.map(function(item){return parseInt(item,10);});for(var i=0;i<categories.length;i++){if(parseInt(catInput[i],10)===catInput[i]){return true;}}return false;}},{key:'validateInput',value:function validateInput(){if(this.globalFormData['name']===undefined){if(this.state.name.length>200){alert("Der Name ist zu lang, bitte beschrenken Sie sich auf 200 Zeichen.");return false;}}else{if(this.globalFormData['name'].length<=3){alert("Der Name ist zu kurz, bitte geben Sie einen Namen mit mindestens vier Buchstaben ein.");return false;}if(this.globalFormData['name'].length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<=9){alert("Die Beschreibung ist zu kurz. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");return false;}if(this.state.aim.length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}else{if(this.globalFormData['aim'].length<=9){alert("Die Beschreibung ist zu kurz. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");return false;}if(this.globalFormData['aim'].length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}return true;}},{key:'checkRequiredFields',value:function checkRequiredFields(){if(this.globalFormData['name']===undefined){if(this.state.name.length<=3){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie mindestens vier Zeichen ein.");return false;}}else{if(this.globalFormData['name'].length<=3){alert("Der Name ist ein Pflichtfelder. Bitte geben Sie mindestens vier Zeichen ein.");return false;}}if(this.globalFormData['categories']===undefined&&!this.isValid(this.state.categories)){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(!this.isValid(this.globalFormData['categories'])){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<=9){alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");return false;}}else{if(this.globalFormData['aim'].length<=9){alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");return false;}}if(this.globalFormData['price']===undefined){if(this.state.price.length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}else{if(this.globalFormData['price'].length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}if(this.globalFormData['agreement_2']===undefined){if(this.state.agreement_2!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_2']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_3']===undefined){if(this.state.agreement_3!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_3']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_4']===undefined){if(this.state.agreement_4!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_4']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_6']===undefined){if(this.state.agreement_6!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_6']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agb_agreement']===false){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}if(this.globalFormData['agb_agreement']===undefined){if(this.state.agb_agreement!==true){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}}return true;}},{key:'save',value:function save(announce){if(announce===true){if(this.checkRequiredFields()===false){return;}}if(announce===true){if(this.validateInput()===false){return;}}var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var formData=new FormData();Object.keys(this.globalFormData).map(function(key){return formData.append(key,self.globalFormData[key]);});formData.append("id",this.state.id);if(announce===true){formData.append('announce',true);}else{formData.append('announce',false);}formData.append('active',true);var url='/api/update-used-software';var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte speichern!');console.error('Could not save used-software data!',exception);});promise.then(function(json){alert('Werte wurden gespeichert.');if(announce===true){Object(__WEBPACK_IMPORTED_MODULE_5__business_activities__["a" /* logBusinessActivities */])("Software gespeichert, allem zugestimmt und veroeffentlicht.",json.id);}self.globalFormData={};self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,aim:json.aim,tags:json.tags,agb_agreement:json.agb_agreement,is_public:json.is_public,is_update_available:json.is_update_available,update_price_text:json.update_price_text,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement_2:json.agreement_2,agreement_3:json.agreement_3,agreement_4:json.agreement_4,agreement_6:json.agreement_6,// new to used-software
company:json.company,compnay_name:json.company_name,compnay_web:json.company_web});self.props.history.push('/product-list');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1',id:'toplanding'},'Anbieten einer Gebrauchtsoftware'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},'Nach abgeschlossener Einstellung Ihres Angebotes bleibt dieses f\xFCr ein Jahr auf der Ayacandas.com zum angegebenen Preis auffindbar.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["p" /* TextInfo */],{content:introductoryText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productForm1  marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodInputComp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["q" /* TextLine */],{heading:' Was bieten Sie an?',subheading:'Unter diesem Titel wird ihr Produkt angezeigt.',obligatory:true,maxLength:'200',value:this.state.name,placeholder:'was bieten Sie an',slot:'name',update:this.update})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["o" /* TextField */],{heading:'Beschreibung',obligatory:true,maxLength:'2000',value:this.state.aim,placeholder:'Zweck',slot:'aim',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__category_selector_rewrite__["a" /* CategorySelectorList */],{value:this.state.categories,slot:'categories',update:this.update,categoryLimit:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["o" /* TextField */],{heading:'Hersteller',obligatory:false,placeholder:'Firma',value:this.state.company,slot:'company',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["o" /* TextField */],{heading:'Genaue Herstellerbezeichnung der Software',obligatory:false,placeholder:'Bezeichnung durch Firma',value:this.state.company_name,slot:'company_name',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["o" /* TextField */],{heading:'Gibt es eine Hersteller-Webseite mit genaueren Informationen \xFCber die Software?',obligatory:false,placeholder:'Firmenwebseite',value:this.state.company_web,slot:'company_web',update:this.update}),!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["k" /* Price */],{heading:'Preis in Euro',subheading:'85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution f\xFCr das Zurverf\xFCgungstellen der Lizenz ausbezahlt.',obligatory:true,maxLength:'6',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["k" /* Price */],{heading:'Preis in Euro',obligatory:true,maxLength:'6',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["d" /* Confirmed */],{obligatory:false,heading:'Ist die Software ein Medizinprodukt?',value:this.state.is_public,slot:'is_public',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["e" /* ConfirmedText */],{heading:'Muss die Software aktualisiert werden?',placeholder:'Update/Wartung',value:this.state.is_update_available,value2:this.state.update_price_text,slot:'is_update_available',slot2:'update_price_text',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["n" /* Tags */],{heading:'Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)',placeholder:'Tags/Stichworte',value:this.state.tags,slot:'tags',update:this.update,match:this.props.match,maxTags:7,maxLength:150,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)',value:this.state.pdf_files,slot:'pdf_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Beschreibende Bilder oder Screenshotst',value:this.state.image_files,slot:'image_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Video, max. 5 GB',value:this.state.video_files,slot:'video_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Hier haben Sie die M\xF6glichkeit, Ihr Produkt als eine Datei hochzuladen.',value:this.state.product_files,slot:'product_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["b" /* CheckBox */],{heading:'* Erkl\xE4rung zum Besitz',content:'Ich kann den Kauf der Lizenz oder der Nutzungserlaubnis der Software-Lizenzen nachweisen.',value:this.state.agreement_2,slot:'agreement_2',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["b" /* CheckBox */],{content:'Ich bin mit dem Preis zum Einstellen der Software in den Marktplatz einverstanden.',value:this.state.agreement_3,slot:'agreement_3',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["b" /* CheckBox */],{content:'Hiermit garantiere ich, dass ich im Falle eines Verkaufs die Software und die zugeh\xF6rigen Lizenzschl\xFCssel von allen mir bekannten Medien l\xF6schen werde.',value:this.state.agreement_4,slot:'agreement_4',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["b" /* CheckBox */],{content:'Ich werde als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung stehen.',value:this.state.agreement_6,slot:'agreement_6',update:this.update}),!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["a" /* AGBCheckBox */],{value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/ueberlassungsvereinbarung.pdf',content1:'Ich habe die ',fileType:'\xDCberlassungsvereinbarung',content2:' gelesen und akzeptiere diese.',update:this.update}),__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["a" /* AGBCheckBox */],{value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/einstellvertrag.pdf',content1:'Ich habe den ',fileType:'Einstellvertrag',content2:' gelesen und akzeptiere diesen.',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'textUsed'},'Im Falle eines Verkaufs werden die Software und die zugeh\xF6rigen Lizenzschl\xFCssel gel\xF6scht.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["m" /* SubmitButton */],{history:this.props.history,onSubmit:this.save}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqSoftware})),!__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Sie besitzen nicht gen\xFCgend Rechte, um eine Gebraucht-Software zu erstellen.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqSoftware})));}}]);return UpdateUsedSoftware;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateServiceWithFeebox; });
/* unused harmony export UpdateService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__business_activities__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_form_components__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feebox_xu__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__new_services_css__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__new_services_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__new_services_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var introductoryText="<p> <a> Der Marktplatz ermöglicht das Anbieten von Dienstleistungen oder Installationen.</a> <br/><br/> <a> Damit Ihr Angebot schneller gefunden werden kann, muss es mindestens einer Kategorie zugeordnet werden.</a> <br/><br/> <a>Dienstleistungsangebote beziehen sich immer auf Personen, nicht auf Gruppen oder Firmen.</a><br/><br/> <a>Der Gesamtpreis skaliert mit der Anzahl der ausgewählten Kategorien.</a><br/><br/> <a>Nach abgeschlossener Einstellung Ihres Angebotes bleibt dieses für ein Jahr auf der Ayacandas.com zum angegebenen Preis auffindbar.</a><br/><br/> <a>Nachträgliche Veränderungen an Ihrem Produkt, welche zu einer Preissenkung führen würden, geben kein Anrecht auf eine Rückzahlung der entstandenen Preisdifferenz.</a><br /><br /> <a>Eine kleine Anzahl der Felder sind mit einem '*' gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</a></p>";var faqServices=[{content:"Es gibt Dienstleistungen allgemeiner Art und Dienstleistungen von Beratern. Dienstleistungsangebote von Beratern sollen sich immer auf Personen beziehen, nicht auf Gruppen oder Firmen. ",title:"Kann ich allgemeine Dienstleistungen anbieten?",key:0},{content:"Alle Arten von PDF-Dokumenten können hinterlegt werden, natürlich auch ein Beraterprofil.",title:"Kann auch z.B. ein Beraterprofil hinterlegt werden?",key:1},{content:"Jeder Dienstleistung muss mindestens eine Kategorie im Angebotsbaum zugeordnet werden, für die die Dienstleistung erbracht wird. Dadurch wird eine zu allgemeine Definition verhindert.",title:"Kann eine Dienstleistung auch allgemein definiert werden?",key:2},{content:"Ein Platz im Marktplatz ist wie eine Anzeige und kostet Geld. Der von der Firma Ayacandas berechnete Preis ist abhängig von der Anzahl der referenzierten Kategorien. ",title:"Wie berechnet sich der Preis zum Einstellen der Dienstleistung? ",key:3},{content:"Das Angebot wird im Marktplatz für den angezeigten Preis für ein Jahr lang aktiviert. (Nur nebenbei: Nachträgliche Veränderungen von Merkmalen, die zu einer Reduzierung des Preises führen, geben kein Recht auf Rückzahlung des Differenzpreises.)",title:"Wie lange bleibt die Anzeige einer Dienstleistung im Marktplatz erhalten?",key:4}];var CreateService=function(_Component){_inherits(CreateService,_Component);function CreateService(props){_classCallCheck(this,CreateService);var _this=_possibleConstructorReturn(this,(CreateService.__proto__||Object.getPrototypeOf(CreateService)).call(this,props));_this.fetchDataAndRedirect=_this.fetchDataAndRedirect.bind(_this);_this.fetchDataAndRedirect();return _this;}_createClass(CreateService,[{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/new-create-service';var promise=fetch(url,{method:'POST',headers:headers,body:''}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine neue Dienstleistung anlegen!');console.error('Could not create new service!',exception);});promise.then(function(json){self.props.history.replace('/update-service/'+json.id);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CreateService'});}}]);return CreateService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateServiceWithFeebox=function(_Component2){_inherits(UpdateServiceWithFeebox,_Component2);function UpdateServiceWithFeebox(props){_classCallCheck(this,UpdateServiceWithFeebox);//this.updateFeeByPrice = this.updateFeeByPrice.bind(this);
var _this2=_possibleConstructorReturn(this,(UpdateServiceWithFeebox.__proto__||Object.getPrototypeOf(UpdateServiceWithFeebox)).call(this,props));_this2.updateFeeByCategories=_this2.updateFeeByCategories.bind(_this2);_this2.countCategories=_this2.countCategories.bind(_this2);_this2.state={price:0,categoryCount:1};return _this2;}/*
     updateFeeByPrice(price) {
     this.setState({price: price});
     return true;
     }
   */_createClass(UpdateServiceWithFeebox,[{key:'updateFeeByCategories',value:function updateFeeByCategories(categories){this.setState({categoryCount:this.countCategories(categories)});return true;}},{key:'countCategories',value:function countCategories(categories){// workaround: converting String to array (FIXME)
if(typeof categories==='string'){categories=categories.split(",");}console.log(categories);var tempCats=[];var count=0;for(var i=0;i<6;i++){if(categories!==undefined&&categories[i]!==null&&categories[i]!==""){if(!tempCats.includes(categories[i])){tempCats.push(categories[i]);count=count+1;}}}return count;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateSoftwareWithFeebox',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdateService,{history:this.props.history,match:this.props.match,updateFeeByCategories:this.updateFeeByCategories}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__feebox_xu__["a" /* FeeBoxXU */],{type:'service',categoryCount:this.state.categoryCount,feeStepConst:'400'}));}}]);return UpdateServiceWithFeebox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateService=function(_Component3){_inherits(UpdateService,_Component3);function UpdateService(props){_classCallCheck(this,UpdateService);var _this3=_possibleConstructorReturn(this,(UpdateService.__proto__||Object.getPrototypeOf(UpdateService)).call(this,props));_this3.fetchDataAndRedirect=_this3.fetchDataAndRedirect.bind(_this3);_this3.update=_this3.update.bind(_this3);_this3.validateInput=_this3.validateInput.bind(_this3);_this3.isValid=_this3.isValid.bind(_this3);_this3.checkRequiredFields=_this3.checkRequiredFields.bind(_this3);_this3.save=_this3.save.bind(_this3);_this3.state={startID:2,id:null,name:'',description:'',references:'',categories:'',customer_reference:'',warrantor:'',expertise:'',price_from:'',price_to:'',pdf_file:null,product_files:'',tags:'',agreement:'',agb_agreement:''};_this3.fetchDataAndRedirect();_this3.globalFormData={};return _this3;}_createClass(UpdateService,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextState!==this.state){return true;}else{return false;}}},{key:'update',value:function update(slot,value){if(slot==='categories'&&this.props.updateFeeByCategories!==undefined){this.props.updateFeeByCategories(value);}this.globalFormData[slot]=value;}},{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var id=this.props.match.params.id;var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/new-create-service';var promise=fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte laden!');console.error('Could not retrieve services data!',exception);});promise.then(function(json){self.setState({id:json.id,name:json.name,description:json.description,categories:json.categories,customer_reference:json.customer_reference,references:json.references,warrantor:json.warrantor,expertise:json.expertise,price_from:json.price_from,price_to:json.price_to,pdf_file:json.pdf_file,product_files:json.product_files,tags:json.tags,agreement:json.agreement,agb_agreement:json.agb_agreement});});}},{key:'isValid',value:function isValid(categories){if(categories===undefined)return false;if(categories===null)return false;if(categories==="")return false;if(typeof categories==='string'){categories=categories.split(/,/);}var catInput=categories.map(function(item){return parseInt(item,10);});for(var i=0;i<categories.length;i++){if(parseInt(catInput[i],10)===catInput[i]){return true;}}return false;}},{key:'validateInput',value:function validateInput(){if(this.globalFormData['name']===undefined){if(this.state.name.length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}if(this.globalFormData['name'].length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}if(this.globalFormData['description']===undefined){if(this.state.description.length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.state.description.length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}else{if(this.globalFormData['description'].length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.globalFormData['description'].length>2000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}return true;}},{key:'checkRequiredFields',value:function checkRequiredFields(){if(this.globalFormData['name']===undefined){if(this.state.name.length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}if(this.globalFormData['categories']===undefined&&!this.isValid(this.state.categories)){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(!this.isValid(this.globalFormData['categories'])){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(this.globalFormData['price_from']===undefined||this.globalFormData['price_to']===undefined){if(this.state.price_from.length===0||this.state.price_from.length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}else{if(this.globalFormData['price_from'].length===0||this.globalFormData['price_from'].length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}if(this.globalFormData['description']===undefined){if(this.state.description.length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}else{if(this.globalFormData['description'].length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}if(this.globalFormData['agreement']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement']===undefined){if(this.state.agreement!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agb_agreement']===false){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}if(this.globalFormData['agb_agreement']===undefined){if(this.state.agb_agreement!==true){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}}return true;}},{key:'save',value:function save(announce){if(announce===true){if(this.checkRequiredFields()===false){return;}}if(announce===true){if(this.validateInput()===false){return;}}var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var formData=new FormData();Object.keys(this.globalFormData).map(function(key){return formData.append(key,self.globalFormData[key]);});formData.append("id",this.state.id);if(announce===true){formData.append('announce',true);}else{formData.append('announce',false);}formData.append('active',true);var url='/api/new-update-service';var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte speichern!');console.error('Could not save services data!',exception);});promise.then(function(json){alert('Werte wurden gespeichert.');if(announce===true){Object(__WEBPACK_IMPORTED_MODULE_5__business_activities__["a" /* logBusinessActivities */])("Dienstleistung wurde gespeichert, allem zugestimmt und veroeffentlicht.",json.id);}self.globalFormData={};self.setState({id:json.id,name:json.name,description:json.description,references:json.references,categories:json.categories,customer_reference:json.customer_reference,warrantor:json.warrantor,expertise:json.expertise,price_from:json.price_from,price_to:json.price_to,pdf_file:json.pdf_file,product_files:json.product_files,tags:json.tags,agreement:json.agreement,agb_agreement:json.agb_agreement});self.props.history.push('/product-list');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,(__WEBPACK_IMPORTED_MODULE_4__util__["f" /* isNonCommercialUser */]()||__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Anbieten einer Dienstleistung'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["p" /* TextInfo */],{content:introductoryText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productForm1  marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["q" /* TextLine */],{heading:' Was bieten Sie an?',subheading:'Unter diesem Titel wird ihr Produkt angezeigt.',obligatory:true,maxLength:'200',value:this.state.name,placeholder:'was bieten Sie an',slot:'name',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__["a" /* CategorySelectorList */],{value:this.state.categories,slot:'categories',update:this.update,categoryLimit:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["k" /* Price */],{heading:'Listenpreis der Dienstleistung oder Installation in Euro?',subheading:'Preis von:',obligatory:true,maxLength:'6',value:this.state.price_from,slot:'price_from',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["k" /* Price */],{subheading:'Preis bis:',maxLength:'6',value:this.state.price_to,slot:'price_to',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["o" /* TextField */],{heading:'Beschreibung',obligatory:true,placeholder:'Beschreibung',maxLength:'2000',value:this.state.description,slot:'description',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["o" /* TextField */],{heading:'Haben Sie Referenzen?',obligatory:false,placeholder:'Referenzen',maxLength:'2000',value:this.state.customer_reference,slot:'customer_reference',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["j" /* PDFUpload */],{heading:'Dienstleistungs- oder Firmenprofil als PDF-Datei',subheading:'Bitte w\xE4hlen Sie zun\xE4chst die Dateien f\xFCr den Upload von ihrem lokalen Rechner aus und dr\xFCcken Sie danach Hochladen.',obligatory:false,slot:'pdf_file',value:this.state.pdf_file,update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["o" /* TextField */],{heading:'Sind B\xFCrgen als Referenz vorhanden?',obligatory:false,placeholder:'B\xFCrgen als Referenz',maxLength:'2000',value:this.state.warrantor,slot:'warrantor',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["o" /* TextField */],{heading:'Sind Sie auf bestimmte Bereiche spezialisiert?',obligatory:false,placeholder:'auf bestimmte Bereiche spezialisiert',maxLength:'2000',value:this.state.expertise,slot:'expertise',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["g" /* Duallistbox */],{heading:'Sie k\xF6nnen eine Dienstleistung auch spezifisch zu Produkten anbieten. Sie wird dann beim Aufruf des jeweiligen Produktes angezeigt. Bitte w\xE4hlen Sie aus der Liste der verf\xFCgbaren Produkte aus.',obligatory:false,value:this.state.references,slot:'references',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["n" /* Tags */],{heading:'Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)',placeholder:'Tags/Stichworte',value:this.state.tags,slot:'tags',update:this.update,match:this.props.match,maxTags:7,maxLength:150}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["i" /* MultipleFileUpload */],{heading:'Hier haben Sie die M\xF6glichkeit, Ihr Produkt als eine Datei hochzuladen.',value:this.state.product_files,slot:'product_files',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["b" /* CheckBox */],{heading:'* Einverst\xE4ndnis-Erkl\xE4rung',obligatory:true,content:'Ich habe die anfallenden Geb\xFChren zum Einstellen zur Kenntnis genommen und m\xF6chte meinen Eintrag kostenpflichtig ver\xF6ffentlichen.',value:this.state.agreement,slot:'agreement',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["a" /* AGBCheckBox */],{obligatory:true,value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/einstellvertrag.pdf',content1:'Ich habe den ',fileType:'Einstellvertrag',content2:' gelesen und akzeptiere diesen und stehe als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung.',update:this.update})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components__["m" /* SubmitButton */],{history:this.props.history,onSubmit:this.save}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqServices})),!__WEBPACK_IMPORTED_MODULE_4__util__["f" /* isNonCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Sie besitzen nicht gen\xFCgend Rechte, um eine Dienstleistung zu erstellen.'));}}]);return UpdateService;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateOther; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateOtherWithFeebox; });
/* unused harmony export UpdateOther */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__business_activities__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__other_css__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__other_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__other_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feebox_xu__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_form_components_js__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var introductoryText='<p> Hier können Sie alles auf dem Marktplatz der Ayacandas anbieten, wofür Sie sonst keine besondere Kategorie gefunden haben. <br /> <br /> <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';var faqSoftware=[{content:"Hier können Sie alles auf dem Marktplatz der Ayacandas anbieten, wofür Sie sonst keine besondere Kategorie gefunden haben.</br></br>Diese Sparte wird in ihren Angeboten immer wieder überprüft werden, ab einer lohnenden Menge wird im Marktplatz der Ayacandas eine neue Unterkategorie aufgebaut.",title:"Auf welcher Seite befinden Sie Sich jetzt?",key:0}];var CreateOther=function(_Component){_inherits(CreateOther,_Component);function CreateOther(props){_classCallCheck(this,CreateOther);var _this=_possibleConstructorReturn(this,(CreateOther.__proto__||Object.getPrototypeOf(CreateOther)).call(this,props));_this.fetchDataAndRedirect=_this.fetchDataAndRedirect.bind(_this);_this.fetchDataAndRedirect();return _this;}_createClass(CreateOther,[{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-other-product';var promise=fetch(url,{method:'POST',headers:headers,body:''}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte kein "anderes Produkt" anlegen!');console.error('Could not create "other product"!',exception);});promise.then(function(json){self.props.history.replace('/update-other/'+json.id);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CreateOther'});}}]);return CreateOther;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateOtherWithFeebox=function(_Component2){_inherits(UpdateOtherWithFeebox,_Component2);function UpdateOtherWithFeebox(props){_classCallCheck(this,UpdateOtherWithFeebox);var _this2=_possibleConstructorReturn(this,(UpdateOtherWithFeebox.__proto__||Object.getPrototypeOf(UpdateOtherWithFeebox)).call(this,props));_this2.updateFeeByPrice=_this2.updateFeeByPrice.bind(_this2);_this2.updateFeeByCategories=_this2.updateFeeByCategories.bind(_this2);_this2.countCategories=_this2.countCategories.bind(_this2);_this2.state={price:0,categoryCount:1};return _this2;}_createClass(UpdateOtherWithFeebox,[{key:'updateFeeByPrice',value:function updateFeeByPrice(price){this.setState({price:price});return true;}},{key:'updateFeeByCategories',value:function updateFeeByCategories(categories){this.setState({categoryCount:this.countCategories(categories)});return true;}},{key:'countCategories',value:function countCategories(categories){// workaround: converting String to array (FIXME)
if(typeof categories==='string'){categories=categories.split(",");}console.log(categories);var tempCats=[];var count=0;for(var i=0;i<6;i++){if(categories!==undefined&&categories[i]!==null&&categories[i]!==""){if(!tempCats.includes(categories[i])){tempCats.push(categories[i]);count=count+1;}}}return count;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateOtherWithFeebox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdateOther,{history:this.props.history,match:this.props.match,updateFeeByPrice:this.updateFeeByPrice,updateFeeByCategories:this.updateFeeByCategories}),__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__feebox_xu__["a" /* FeeBoxXU */],{type:'software',price:this.state.price,categoryCount:this.state.categoryCount}));}}]);return UpdateOtherWithFeebox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateOther=function(_Component3){_inherits(UpdateOther,_Component3);function UpdateOther(props){_classCallCheck(this,UpdateOther);var _this3=_possibleConstructorReturn(this,(UpdateOther.__proto__||Object.getPrototypeOf(UpdateOther)).call(this,props));_this3.fetchDataAndRedirect=_this3.fetchDataAndRedirect.bind(_this3);_this3.update=_this3.update.bind(_this3);_this3.validateInput=_this3.validateInput.bind(_this3);_this3.checkRequiredFields=_this3.checkRequiredFields.bind(_this3);_this3.isValid=_this3.isValid.bind(_this3);_this3.save=_this3.save.bind(_this3);_this3.state={startID:2,id:null,name:'',categories:'',price:0,aim:'',tags:'',desc:'',agb_agreement:false,pdf_files:',,,,',image_files:',,,,,,,,,',video_files:'',product_files:'',agreement_1:false,agreement_2:false};_this3.fetchDataAndRedirect();_this3.globalFormData={};return _this3;}_createClass(UpdateOther,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextState!==this.state){return true;}else{return false;}}},{key:'update',value:function update(slot,value){if(slot==='price'&&this.props.updateFeeByPrice!==undefined){this.props.updateFeeByPrice(parseInt(value,10));}if(slot==='categories'&&this.props.updateFeeByCategories!==undefined){this.props.updateFeeByCategories(value);}this.globalFormData[slot]=value;}},{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var id=this.props.match.params['id'];var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-other-product';var promise=fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte laden!');console.error('Could not retrieve other data!',exception);});promise.then(function(json){self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,aim:json.aim,tags:json.tags,agb_agreement:json.agb_agreement,update_price_text:json.update_price_text,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:JSON.product_files,agreement_2:json.agreement_2});});}},{key:'isValid',value:function isValid(categories){if(categories===undefined)return false;if(categories===null)return false;if(categories==="")return false;if(typeof categories==='string'){categories=categories.split(/,/);}var catInput=categories.map(function(item){return parseInt(item,10);});for(var i=0;i<categories.length;i++){if(parseInt(catInput[i],10)===catInput[i]){return true;}}return false;}},{key:'validateInput',value:function validateInput(){if(this.globalFormData['name']===undefined){if(this.state.name.length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}if(this.globalFormData['name'].length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.state.aim.length>5000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 5000 Zeichen.");return false;}}else{if(this.globalFormData['aim'].length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.globalFormData['aim'].length>5000){alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 5000 Zeichen.");return false;}}return true;}},{key:'checkRequiredFields',value:function checkRequiredFields(){if(this.globalFormData['name']===undefined){if(this.state.name.length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfelder. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}if(this.globalFormData['categories']===undefined&&!this.isValid(this.state.categories)){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(!this.isValid(this.globalFormData['categories'])){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}else{if(this.globalFormData['aim'].length<1){alert("Die Beschreibung ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}if(this.globalFormData['price']===undefined){if(this.state.price.length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}else{if(this.globalFormData['price'].length===0){alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");return false;}}if(this.globalFormData['agreement_2']===undefined){if(this.state.agreement_2!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_2']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agb_agreement']===false){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}if(this.globalFormData['agb_agreement']===undefined){if(this.state.agb_agreement!==true){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}}return true;}},{key:'save',value:function save(announce){if(announce===true){if(this.checkRequiredFields()===false){return;}}if(announce===true){if(this.validateInput()===false){return;}}var self=this;var headers=__WEBPACK_IMPORTED_MODULE_4__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var formData=new FormData();Object.keys(this.globalFormData).map(function(key){return formData.append(key,self.globalFormData[key]);});formData.append("id",this.state.id);if(announce===true){formData.append('announce',true);}else{formData.append('announce',false);}formData.append('active',true);var url='/api/update-other-product';var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte speichern!');console.error('Could not save other data!',exception);});promise.then(function(json){alert('Werte wurden gespeichert.');if(announce===true){Object(__WEBPACK_IMPORTED_MODULE_5__business_activities__["a" /* logBusinessActivities */])("Hardware und sonstige Angebote gespeichert, allem zugestimmt und veroeffentlicht.",json.id);}self.globalFormData={};self.setState({id:json.id,name:json.name,desc:json.desc,categories:json.categories,price:json.price,aim:json.aim,tags:json.tags,agb_agreement:json.agb_agreement,is_public:json.is_public,is_update_available:json.is_update_available,update_price_text:json.update_price_text,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:JSON.product_files,agreement_2:json.agreement_2,agreement_3:json.agreement_3,agreement_4:json.agreement_4,agreement_6:json.agreement_6,// new to used-software
company:json.company,compnay_name:json.company_name,compnay_web:json.company_web});self.props.history.push('/product-list');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Anbieten einer Hardware oder sonstige Angebote'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["p" /* TextInfo */],{content:introductoryText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productForm1 marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'prodInputComp'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["q" /* TextLine */],{heading:' Was bieten Sie an?',subheading:'Unter diesem Titel wird ihr Produkt angezeigt.',obligatory:true,maxLength:'200',value:this.state.name,placeholder:'was bieten Sie an',slot:'name',update:this.update})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__category_selector_rewrite__["a" /* CategorySelectorList */],{value:this.state.categories,slot:'categories',update:this.update,categoryLimit:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["o" /* TextField */],{heading:'Beschreibung',obligatory:true,maxLength:'5000',value:this.state.aim,placeholder:'Beschreibung',slot:'aim',update:this.update}),!__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["k" /* Price */],{heading:'Listenpreis in Euro',subheading:'85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution f\xFCr das Zurverf\xFCgungstellen der Lizenz ausbezahlt.',obligatory:true,maxLength:'6',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["k" /* Price */],{heading:'Preis in Euro',obligatory:true,maxLength:'6',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["n" /* Tags */],{heading:'Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)',placeholder:'Tags/Stichworte',value:this.state.tags,slot:'tags',update:this.update,match:this.props.match,maxTags:7,maxLength:150,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)',value:this.state.pdf_files,slot:'pdf_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Beschreibende Bilder oder Screenshots',value:this.state.image_files,slot:'image_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Anhang: Video, max. 5 GB',value:this.state.video_files,slot:'video_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Hier haben Sie die M\xF6glichkeit, Ihr Produkt als eine Datei hochzuladen.',value:this.state.product_files,slot:'product_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["b" /* CheckBox */],{heading:'* Erkl\xE4rung zum Besitz',content:'Ich erkl\xE4re hiermit, dass das oder die angebotenen Angebote entweder meiner Institution oder mir selbst geh\xF6ren und mir der Verkauf oder die kostenfreie Weitergabe gestattet ist.',value:this.state.agreement_2,slot:'agreement_2',update:this.update}),!__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["a" /* AGBCheckBox */],{value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/ueberlassungsvereinbarung.pdf',content1:'Ich habe die ',fileType:'\xDCberlassungsvereinbarung',content2:' gelesen und akzeptiere diese.',update:this.update}),__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["a" /* AGBCheckBox */],{value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/einstellvertrag.pdf',content1:'Ich habe den ',fileType:'Einstellvertrag',content2:' gelesen und akzeptiere diesen.',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_form_components_js__["m" /* SubmitButton */],{history:this.props.history,onSubmit:this.save}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqSoftware})),!__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isCommercialUser */]()&&!__WEBPACK_IMPORTED_MODULE_4__util__["f" /* isNonCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Sie besitzen nicht gen\xFCgend Rechte, um eine Gebraucht-Software zu erstellen.'));}}]);return UpdateOther;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateTender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpdateTenderWithFeebox; });
/* unused harmony export UpdateTender */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__category_selector_rewrite__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__business_activities__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_form_components_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__feebox_xu__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tender_css__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tender_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tender_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqTender=[];var introductoryText='<p>Ausschreibungen im Klinikbereich können sehr aufwändig in der Beantwortung sein. Und viele Antworten auf Ausschreibungen beinhalten neue Konzepte, die auch für andere Kliniken interessant sein können. <br /><br />Hier können Sie, wenn Sie eine Ausschreibung beantwortet haben, das Paket entlang des Leistungsumfangs erneut anbieten. In den meisten Fällen wird es sich um finanzielle Größenordnungen handeln, die eine erneute Ausschreibung eines neuen Kunden erfordern. Jedoch kann es für Sie einen großen Vorteil bieten, wenn Ihr entwickeltes Konzept die Grundlage für eine neue Ausschreibung bildet. Und: Sie kommen ins Gespräch mit möglichen neuen Kunden. Die sich bewusst ihr Konzept ansehen.<br/><p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';var tenderTypes=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'6'},'bitte w\xE4hlen...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'0'},'Kliniken'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'1'},'Praxen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'2'},'MVZ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'3'},'Kleingruppen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'4'},'Einzelpersonen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:'5'},'sonstige/keine Auslegung')];var CreateTender=function(_Component){_inherits(CreateTender,_Component);function CreateTender(props){_classCallCheck(this,CreateTender);var _this=_possibleConstructorReturn(this,(CreateTender.__proto__||Object.getPrototypeOf(CreateTender)).call(this,props));_this.fetchDataAndRedirect=_this.fetchDataAndRedirect.bind(_this);_this.fetchDataAndRedirect();return _this;}_createClass(CreateTender,[{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-tender';var promise=fetch(url,{method:'POST',headers:headers,body:''}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Ausschreibung anlegen!');console.error('Could not create tender!',exception);});promise.then(function(json){self.props.history.replace('/update-tender/'+json.id);});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'CreateTender'});}}]);return CreateTender;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateTenderWithFeebox=function(_Component2){_inherits(UpdateTenderWithFeebox,_Component2);function UpdateTenderWithFeebox(props){_classCallCheck(this,UpdateTenderWithFeebox);var _this2=_possibleConstructorReturn(this,(UpdateTenderWithFeebox.__proto__||Object.getPrototypeOf(UpdateTenderWithFeebox)).call(this,props));_this2.updateFeeByCategories=_this2.updateFeeByCategories.bind(_this2);_this2.countCategories=_this2.countCategories.bind(_this2);_this2.state={price:0,categoryCount:1};return _this2;}_createClass(UpdateTenderWithFeebox,[{key:'updateFeeByCategories',value:function updateFeeByCategories(categories){this.setState({categoryCount:this.countCategories(categories)});return true;}},{key:'countCategories',value:function countCategories(categories){// workaround: converting String to array (FIXME)
if(typeof categories==='string'){categories=categories.split(",");}console.log(categories);var tempCats=[];var count=0;for(var i=0;i<6;i++){if(categories!==undefined&&categories[i]!==null&&categories[i]!==""){if(!tempCats.includes(categories[i])){tempCats.push(categories[i]);count=count+1;}}}return count;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateTenderWithFeebox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpdateTender,{history:this.props.history,match:this.props.match,updateFeeByCategories:this.updateFeeByCategories,onNewMessage:alert}),__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__feebox_xu__["a" /* FeeBoxXU */],{type:'tender',categoryCount:this.state.categoryCount,feeStepConst:'400'}));}}]);return UpdateTenderWithFeebox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UpdateTender=function(_Component3){_inherits(UpdateTender,_Component3);function UpdateTender(props){_classCallCheck(this,UpdateTender);var _this3=_possibleConstructorReturn(this,(UpdateTender.__proto__||Object.getPrototypeOf(UpdateTender)).call(this,props));_this3.fetchDataAndRedirect=_this3.fetchDataAndRedirect.bind(_this3);_this3.update=_this3.update.bind(_this3);_this3.validateInput=_this3.validateInput.bind(_this3);_this3.checkRequiredFields=_this3.checkRequiredFields.bind(_this3);_this3.isValid=_this3.isValid.bind(_this3);_this3.save=_this3.save.bind(_this3);_this3.state={startID:2,id:null,name:'',categories:'',description:'',price:'',target_group:'',aim:'',tags:'',agb_agreement:false,pdf_files:',,,,',image_files:',,,,,,,,,',video_files:'',product_files:'',agreement_1:false,agreement_2:false,agreement_3:false,agreement_4:false};_this3.fetchDataAndRedirect();_this3.globalFormData={};return _this3;}_createClass(UpdateTender,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState){if(nextState!==this.state){return true;}else{return false;}}},{key:'update',value:function update(slot,value){if(slot==='categories'&&this.props.updateFeeByCategories!==undefined){this.props.updateFeeByCategories(value);}this.globalFormData[slot]=value;}},{key:'fetchDataAndRedirect',value:function fetchDataAndRedirect(){var id=this.props.match.params['id'];var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");headers.append('Content-Type','application/x-www-form-urlencoded');var url='/api/create-tender';var promise=fetch(url,{method:'POST',headers:headers,body:'id='+id}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte laden!');console.error('Could not retrieve tender data!',exception);});promise.then(function(json){self.setState({id:json.id,name:json.name,categories:json.categories,description:json.description,price:json.price,target_group:json.target_group,aim:json.aim,tags:json.tags,agb_agreement:json.agb_agreement,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement_1:json.agreement_1,agreement_2:json.agreement_2,agreement_3:json.agreement_3,agreement_4:json.agreement_4});});}},{key:'isValid',value:function isValid(categories){if(categories===undefined)return false;if(categories===null)return false;if(categories==="")return false;if(typeof categories==='string'){categories=categories.split(/,/);}var catInput=categories.map(function(item){return parseInt(item,10);});for(var i=0;i<categories.length;i++){if(parseInt(catInput[i],10)===catInput[i]){return true;}}return false;}},{key:'validateInput',value:function validateInput(){if(this.globalFormData['name']===undefined){if(this.state.name.length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}if(this.globalFormData['name'].length>200){alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");return false;}}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<1){alert("Der Zweck des Produktes ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.state.aim.length>2000){alert("Der Zweck des Produktes ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}else{if(this.globalFormData['aim'].length<1){alert("Der Zweck des Produktes ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}if(this.globalFormData['aim'].length>2000){alert("Der Zweck des Produktes ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");return false;}}return true;}},{key:'checkRequiredFields',value:function checkRequiredFields(){if(this.globalFormData['name']===undefined){if(this.state.name.length<1){alert("Der Name ist ein Pflichtfeld. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}else{if(this.globalFormData['name'].length<1){alert("Der Name ist ein Pflichtfelder. Bitte geben Sie Ihrem Angebot einen Namen.");return false;}}if(this.globalFormData['categories']===undefined&&!this.isValid(this.state.categories)){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(!this.isValid(this.globalFormData['categories'])){alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");return false;}if(this.globalFormData['aim']===undefined){if(this.state.aim.length<1){alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}else{if(this.globalFormData['aim'].length<1){alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot.");return false;}}if(this.globalFormData['agreement_1']===undefined){if(this.state.agreement_1!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_1']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_2']===undefined){if(this.state.agreement_2!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_2']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_3']===undefined){if(this.state.agreement_3!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_3']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agreement_4']===undefined){if(this.state.agreement_4!==true){alert("Bitte stimmen Sie der Erklärung zu.");return false;}}if(this.globalFormData['agreement_4']===false){alert("Bitte stimmen Sie der Erklärung zu.");return false;}if(this.globalFormData['agb_agreement']===false){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}if(this.globalFormData['agb_agreement']===undefined){if(this.state.agb_agreement!==true){alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");return false;}}return true;}},{key:'save',value:function save(announce){if(announce===true){if(this.checkRequiredFields()===false){return;}}if(announce===true){if(this.validateInput()===false){return;}}var self=this;var headers=__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var formData=new FormData();Object.keys(this.globalFormData).map(function(key){return formData.append(key,self.globalFormData[key]);});formData.append("id",this.state.id);if(announce===true){formData.append('announce',true);}else{formData.append('announce',false);}formData.append('active',true);var url='/api/update-tender';var promise=fetch(url,{method:'POST',headers:headers,body:formData}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte keine Werte speichern!');console.error('Could not save tender data!',exception);});promise.then(function(json){alert('Werte wurden gespeichert.');if(announce===true){Object(__WEBPACK_IMPORTED_MODULE_5__business_activities__["a" /* logBusinessActivities */])("Ausschreibung gespeichert, allem zugestimmt und veroeffentlicht.",json.id);}self.globalFormData={};self.setState({id:json.id,name:json.name,categories:json.categories,description:json.description,price:json.price,target_group:json.target_group,aim:json.aim,tags:json.tags,agb_agreement:json.agb_agreement,pdf_files:json.pdf_files,image_files:json.image_files,video_files:json.video_files,product_files:json.product_files,agreement_1:json.agreement_1,agreement_2:json.agreement_2,agreement_3:json.agreement_3,agreement_4:json.agreement_4});self.props.history.push('/product-list');});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Anbieten der Angebote \xFCber gelaufene Ausschreibungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["p" /* TextInfo */],{content:introductoryText})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productForm1 marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["q" /* TextLine */],{heading:'Was bieten Sie an?',subheading:'Unter diesem Titel wird ihr Produkt angezeigt.',obligatory:true,maxLength:'200',value:this.state.name,placeholder:'was bieten Sie an',slot:'name',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["o" /* TextField */],{heading:'Beschreibung',obligatory:true,maxLength:'2000',placeholder:'Zweck der Software',value:this.state.aim,slot:'aim',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__category_selector_rewrite__["a" /* CategorySelectorList */],{value:this.state.categories,slot:'categories',update:this.update,categoryLimit:6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["q" /* TextLine */],{heading:'In welcher finanziellen Gr\xF6\xDFenordnung bewegt sich Ihr Angebot?',obligatory:false,maxLength:'50',value:this.state.price,slot:'price',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["o" /* TextField */],{heading:'Bitte beschreiben Sie ausf\xFChrlich noch einmal, was Sie anbieten.',obligatory:false,maxLength:'5000',placeholder:'Beschreibung',value:this.state.description,slot:'description',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["l" /* Selection */],{heading:'F\xFCr welche Einrichtung\tist das Produkt prim\xE4r ausgelegt?',selectionValues:tenderTypes,obligatory:false,value:this.state.target_group,slot:'target_group',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["n" /* Tags */],{heading:'Unter welchen Stichworten soll Ihr Angebot gefunden werden? Geben Sie bis zu sieben durch Komma getrennte Tags bzw. Stichworte ein.',placeholder:'Tags/Stichworte',value:this.state.tags,slot:'tags',update:this.update,match:this.props.match,maxTags:7,maxLength:150,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Dokumentation z.B. im PDF-Format (bitte nur fachliches Material)',subheading:'Bitte w\xE4hlen Sie zun\xE4chst die Dateien f\xFCr den Upload von ihrem lokalen Rechner durch klicken auf ein freies Feld aus und dr\xFCcken Sie danach Hochladen.',value:this.state.pdf_files,slot:'pdf_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Beschreibende Bilder oder Screenshots zu dem Produkt',subheading:'Ayacandas beh\xE4lt sich vor, die Aufl\xF6sung von Bildern zu \xE4ndern, wenn diese ungew\xF6hnlich viel Speicher brauchen sollten.',value:this.state.image_files,slot:'image_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Ein Video mit maximal 5 GB Gr\xF6\xDFe zum Produkt',value:this.state.video_files,slot:'video_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["i" /* MultipleFileUpload */],{heading:'Hier haben Sie die M\xF6glichkeit, Ihr Produkt als eine Datei hochzuladen.',value:this.state.product_files,slot:'product_files',update:this.update,onNewMessage:this.props.onNewMessage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["b" /* CheckBox */],{heading:'* Erkl\xE4rung zum Besitz',content:'Bitte versichern Sie, dass das Angebotene entweder Ihnen geh\xF6rt oder Sie oder Ihre Organisation die Urheberrechte auf das Angebotene besitzen.',value:this.state.agreement_1,slot:'agreement_1',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["b" /* CheckBox */],{content:'dass Sie nicht jemand anderes \'geistiges Eigentum\' anbieten.',value:this.state.agreement_2,slot:'agreement_2',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["b" /* CheckBox */],{content:'dass Ihre Institution, f\xFCr die Sie anbieten, mit dem Anbieten hier einverstanden ist.',value:this.state.agreement_3,slot:'agreement_3',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["b" /* CheckBox */],{content:'und dass Sie als Ansprechpartner f\xFCr das Angebot zur Verf\xFCgung stehen werden.',value:this.state.agreement_4,slot:'agreement_4',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["a" /* AGBCheckBox */],{value:this.state.agb_agreement,slot:'agb_agreement',agbUrl:'/einstellvertrag.pdf',content1:'Ich habe den ',fileType:'Einstellvertrag',content2:' gelesen und akzeptiere diesen.',update:this.update}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_form_components_js__["m" /* SubmitButton */],{history:this.props.history,onSubmit:this.save}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqTender})),!__WEBPACK_IMPORTED_MODULE_1__util__["d" /* isCommercialUser */]()&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Sie besitzen nicht gen\xFCgend Rechte, um eine Ausschreibung zu erstellen.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqTender})));}}]);return UpdateTender;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActivationNoticeAfterRegistration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivationNotice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__activation_css__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__activation_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__activation_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqActivation=[];var ActivationNoticeAfterRegistration=function(_Component){_inherits(ActivationNoticeAfterRegistration,_Component);function ActivationNoticeAfterRegistration(){_classCallCheck(this,ActivationNoticeAfterRegistration);return _possibleConstructorReturn(this,(ActivationNoticeAfterRegistration.__proto__||Object.getPrototypeOf(ActivationNoticeAfterRegistration)).apply(this,arguments));}_createClass(ActivationNoticeAfterRegistration,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Wir haben eine Aktivierungsmail an die von Ihnen genannte E-Mail-Adresse gesendet.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Bitte klicken Sie auf den Link in dieser E-Mail, um Ihren Account zu aktivieren.'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqActivation}));}}]);return ActivationNoticeAfterRegistration;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ActivationNotice=function(_Component2){_inherits(ActivationNotice,_Component2);function ActivationNotice(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,ActivationNotice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=ActivationNotice.__proto__||Object.getPrototypeOf(ActivationNotice)).call.apply(_ref,[this].concat(args))),_this2),_this2.handleResendClick=function(e){e.preventDefault();var storedUser=localStorage.getItem('verification_user');if(storedUser!==null){var user=JSON.parse(storedUser);if(user.email_invalid){fetch('/api/resend-verification?username='+user.username).then(function(resp){return resp.json();}).then(function(json){if(json.success){alert('E-Mail mit Aktivierungslink wurde soeben versendet.');_this2.props.history.replace('/');}});}}},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(ActivationNotice,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Ihr Account ist noch nicht aktiviert.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Bitte klicken Sie auf den Aktivierungslink in der von uns gesendeten E-Mail an die von Ihnen angegebene E-Mail-Adresse.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'#resend',onClick:this.handleResendClick},'Aktiverungslink erneut senden'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqActivation}));}}]);return ActivationNotice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var activationFaq=[];var VerifyEmail=function(_Component){_inherits(VerifyEmail,_Component);function VerifyEmail(props){_classCallCheck(this,VerifyEmail);var _this=_possibleConstructorReturn(this,(VerifyEmail.__proto__||Object.getPrototypeOf(VerifyEmail)).call(this,props));_this.state={successfullyVerified:null};return _this;}_createClass(VerifyEmail,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var token=this.props.match.params.token;var url='/api/verify-email?token='+token;fetch(url).then(function(resp){return resp.json();}).then(function(data){_this2.setState({successfullyVerified:data.success});}).catch(function(){return _this2.setState({successfullyVerified:false});});}},{key:'render',value:function render(){var _this3=this;if(this.state.successfullyVerified===null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%',marginTop:'50px'}});}else if(this.state.successfullyVerified){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Ihr Profil wurde erfolgreich aktiviert.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{title:'',className:'button',onClick:function onClick(event){return _this3.props.history.push("/login");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:'',to:'/login'},'Zum Login'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:activationFaq}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Aktivierung fehlgeschlagen!'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:activationFaq}));}}]);return VerifyEmail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VerifyEmail);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Videos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__videos_css__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__videos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__videos_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqVideos=[];var Videos=function(_Component){_inherits(Videos,_Component);function Videos(props){_classCallCheck(this,Videos);var _this=_possibleConstructorReturn(this,(Videos.__proto__||Object.getPrototypeOf(Videos)).call(this,props));_this.state={};return _this;}_createClass(Videos,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Eine kurze Erkl\xE4rung des Marktplatzes als Video:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'VideoBody'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'Kurze Erkl\xE4rung des Marktplatzes',width:'560',height:'315',src:'https://www.youtube.com/embed/u8-vxGjRQgc',frameborder:'0',allowfullscreen:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqVideos}));}}]);return Videos;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Board; });
/* unused harmony export Post */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__file_upload_ng__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__board_css__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__board_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__board_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__footer_js__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqForum=[];var Board=function(_Component){_inherits(Board,_Component);function Board(props){_classCallCheck(this,Board);var _this=_possibleConstructorReturn(this,(Board.__proto__||Object.getPrototypeOf(Board)).call(this,props));_this.createUUID=_this.createUUID.bind(_this);_this.getPosts=_this.getPosts.bind(_this);_this.unflatten=_this.unflatten.bind(_this);_this.newPost=_this.newPost.bind(_this);_this.deletePost=_this.deletePost.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.thread=_this.thread.bind(_this);_this.expandAll=_this.expandAll.bind(_this);_this.collapseAll=_this.collapseAll.bind(_this);_this.state={posts:[],tree:[],globalExpanded:null,filter:''};return _this;}_createClass(Board,[{key:'componentWillMount',value:function componentWillMount(){this.getPosts();}},{key:'createUUID',value:function createUUID(){//taken from StackOverflow
var uuid='xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,function(c){var r=Math.random()*16|0,v=c==='x'?r:r&0x3|0x8;return v.toString(16);});return uuid;}},{key:'getPosts',value:function getPosts(){var filter=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var self=this;var url='/api/get-posts?uuid='+this.props.match.params.uuid+'&filter='+filter;var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Forenbeiträge konnten nicht geladen werden.');console.error('Could not load board posts.',exception);});promise.then(function(json){self.setState({posts:json,tree:self.unflatten(json)});});}},{key:'newPost',value:function newPost(pid,title){if(JSON.parse(localStorage.getItem('user')).username!=='guest'){if(pid===undefined){pid=0;}var posts=this.state.posts.slice();var id=this.createUUID();var user=JSON.parse(localStorage.getItem('user')).username;posts.unshift({id:id,key:id,pid:pid,message:'',title:title!==undefined?title:'',expanded:true,saved:true,file:'',active:true,user:user});this.setState({posts:posts,tree:this.unflatten(posts)});}}},{key:'deletePost',value:function deletePost(id){var self=this;var url='/api/delete-post';var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();var body='id='+id;headers.append("Content-Type","application/x-www-form-urlencoded");var promise=fetch(url,{method:'POST',headers:headers,body:body}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte den Beitrag nicht löschen.');console.error('Could not delete this post.',exception);});promise.then(function(json){self.setState({posts:[],tree:[]},self.getPosts());});}},{key:'onSave',value:function onSave(){this.getPosts();}},{key:'unflatten',value:function unflatten(postList){var _this2=this;var parent=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{id:0};var tree=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var children=postList.filter(function(post){return post.pid===parent.id;});if(children.length>0){if(parent.id===0){tree=children;}else{parent['children']=children;}children.map(function(child){return _this2.unflatten(postList,child);});}return tree;}},{key:'thread',value:function thread(node,boardUUID,newPost,deletePost){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Post,{id:node.id,key:node.id,pid:node.pid,title:node.title,message:node.message,boardUUID:boardUUID,user:node.user,file:node.file,active:node.active,owner_name:node.owner_name,owner_role:node.owner_role,children:node.children!==undefined?node.children.map(function(child){return _this3.thread(child,boardUUID,newPost,deletePost);}):null,newPost:newPost,deletePost:deletePost,expanded:this.state.globalExpanded!==null?this.state.globalExpanded:node.expanded,saved:node.saved,onSave:this.onSave});}},{key:'expandAll',value:function expandAll(){if(window.confirm("Alle nicht gespeicherten Beiträge gehen verloren. Wirklich alles aufklappen?")){this.setState({globalExpanded:true,posts:[],tree:[]},this.getPosts());}}},{key:'collapseAll',value:function collapseAll(){if(window.confirm("Alle nicht gespeicherten Beiträge gehen verloren. Wirklich alles zuklappen?")){this.setState({globalExpanded:false,posts:[],tree:[]},this.getPosts());}}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Board',id:'mobileBoard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Produktforum zu: ',localStorage.getItem('product-name')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button margin-right',onClick:function onClick(event){return window.confirm("Alle nicht gespeicherten Beiträge gehen verloren. Möchten Sie wirklich zurück?")?_this4.props.history.goBack():false;}},'\u21B0 zur\xFCck'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button margin-right',onClick:this.expandAll},'alles aufklappen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button margin-right',onClick:this.collapseAll},'alles zuklappen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'xx-small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'BoardSearchInput margin-right',type:'text',placeholder:'(Suchfilter - ein Teilwort)',onChange:function onChange(event){return _this4.setState({filter:event.target.value},_this4.getPosts(event.target.value));}})),__WEBPACK_IMPORTED_MODULE_3__util__["e" /* isGuestUser */]()===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h5',{className:'guestTitel'},'(f\xFCr G\xE4ste nur lesender Zugriff)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:function onClick(event){return _this4.newPost();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'ein neues Thema erstellen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop50'},this.state.tree.map(function(node){return _this4.thread(node,_this4.props.match.params.uuid,_this4.newPost,_this4.deletePost);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__footer_js__["a" /* Footer */],{faqs:faqForum}));}}]);return Board;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Post=function(_Component2){_inherits(Post,_Component2);function Post(props){_classCallCheck(this,Post);var _this5=_possibleConstructorReturn(this,(Post.__proto__||Object.getPrototypeOf(Post)).call(this,props));_this5.savePost=_this5.savePost.bind(_this5);_this5.onChangeTitle=_this5.onChangeTitle.bind(_this5);_this5.onChangeMessage=_this5.onChangeMessage.bind(_this5);_this5.onUpload=_this5.onUpload.bind(_this5);_this5.getFileInfo=_this5.getFileInfo.bind(_this5);_this5.state={expanded:_this5.props.expanded,saved:_this5.props.saved===false?false:true,title:_this5.props.title!==undefined?_this5.props.title:'',message:_this5.props.message!==undefined?_this5.props.message:'',user:_this5.props.user,owner_name:_this5.props.owner_name,owner_role:_this5.props.owner_role,file:_this5.props.file!==undefined?_this5.props.file:'',filename:_this5.props.file!==undefined&&_this5.props.file!==''?_this5.getFileInfo(_this5.props.file):''};return _this5;}_createClass(Post,[{key:'componentWillMount',value:function componentWillMount(){this.getFileInfo(this.state.file);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.file!==this.state.file){this.getFileInfo(nextProps.file);}}},{key:'savePost',value:function savePost(id,pid,message,title,board,user,file){var _this6=this;var self=this;var url='/api/upsert-post';var headers=__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]();var body='id='+id+'&pid='+pid+'&message='+message+'&title='+title+'&board='+board+'&user='+user+'&file='+file;headers.append("Content-Type","application/x-www-form-urlencoded");var promise=fetch(url,{method:'POST',headers:headers,body:body}).then(function(response){return response.json();}).catch(function(exception){alert('Konnte den Beitrag nicht speichern.');console.error('Could not save this post.',exception);});promise.then(function(json){return self.setState({saved:true,expanded:false},_this6.props.onSave());});window.scrollTo(0,0);}},{key:'onChangeTitle',value:function onChangeTitle(newTitle){this.setState({saved:false,title:newTitle});return true;}},{key:'onChangeMessage',value:function onChangeMessage(newMessage){this.setState({saved:false,message:newMessage});return true;}},{key:'onUpload',value:function onUpload(uuid,_,filename){this.setState({file:uuid,filename:filename,saved:false});}},{key:'getFileInfo',value:function getFileInfo(uuid){if(uuid!==undefined&&uuid!==null&&uuid!==''){var self=this;fetch('/api/get-file-infos?uuids='+uuid,{headers:__WEBPACK_IMPORTED_MODULE_3__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).catch(function(error){return console.log("Could not get file infos. ",error);}).then(function(json){return self.setState({filename:json[0].fileName});});}return true;}},{key:'render',value:function render(){var _this7=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Post',style:this.props.pid===0?{marginTop:'50px'}:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.state.saved?{borderLeft:'solid 5px',borderColor:'#1F6A81',backgroundColor:'rgba(255,255,255,0.7)'}:{borderLeft:'solid 5px',borderColor:'#e50000',backgroundColor:'rgba(255,255,255,0.7)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.state.saved?{border:'solid 1px #1F6A81'}:{border:'solid 1px #e50000'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundColor:'rgba(255,255,255,0.7)',fontWeight:'bold',padding:'2%',position:'relative'}},this.state.expanded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PostTitle,{user:this.state.user,onChange:this.onChangeTitle,value:this.state.title}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(event){return _this7.setState({expanded:!_this7.state.expanded&&_this7.props.active===true});},style:{cursor:'pointer',color:'#1F6A81'}},this.state.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'2%',cursor:'pointer',fontSize:'large',color:'#1F6A81'},title:this.state.expanded===true?'zuklappen':'aufklappen',onClick:function onClick(event){return _this7.setState({expanded:!_this7.state.expanded&&_this7.props.active===true});}},this.state.expanded===true?'↑':'↓'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:function onClick(event){return _this7.setState({expanded:!_this7.state.expanded&&_this7.props.active===true});},style:{cursor:'pointer',marginLeft:'40px'}},this.state.message.substr(0,30)+'...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'postUserNameMobile',onClick:function onClick(event){return _this7.setState({expanded:!_this7.state.expanded&&_this7.props.active===true});},style:{cursor:'pointer',position:'absolute',color:'#1F6A81',right:'10px'}},this.state.user===this.state.owner_name&&this.state.owner_role==='none-commercial'?'Anbieter':this.state.user)),this.state.expanded===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundColor:'rgba(255, 255, 255, 0.3)',padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PostMessage,{user:this.state.user,onChange:this.onChangeMessage,value:this.state.message})):null,this.state.expanded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'margin-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button margin-right',style:!this.state.saved?{color:'lightgrey'}:{color:'#1F6A81'},onClick:function onClick(event){return _this7.state.saved&&_this7.props.newPost(_this7.props.id,_this7.props.title);}},'antworten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button margin-right',style:this.state.saved?{color:'lightgrey'}:{color:'#1F6A81'},onClick:function onClick(event){return!_this7.state.saved&&_this7.savePost(_this7.props.id,_this7.props.pid,_this7.state.message,_this7.state.title,_this7.props.boardUUID,JSON.parse(localStorage.getItem('user')).username,_this7.state.file);}},'speichern'),JSON.parse(localStorage.getItem('user')).username===this.state.user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button',onClick:function onClick(event){return window.confirm("Wirklich löschen?")?_this7.props.deletePost(_this7.props.id):false;}},'l\xF6schen'):null,this.state.file===''&&JSON.parse(localStorage.getItem('user')).username===this.state.user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'BoardFieUpload margin-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__file_upload_ng__["a" /* FileUploadNG */],{onFinish:this.onUpload})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PostAttachment marginTop2 margin-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Dateianhang: ',this.state.filename),JSON.parse(localStorage.getItem('user')).username===this.state.user?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#e50000',cursor:'pointer',fontSize:'medium'},onClick:function onClick(){return _this7.setState({file:'',saved:false});}},' \u2717 '):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{style:{color:'#1F6A81',fontSize:'large',textDecoration:'none'},to:'/'+this.state.file+'/'+this.state.filename,target:'_blank'},' \u2193 ')))):null)),this.props.children);}}]);return Post;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PostTitle=function(_Component3){_inherits(PostTitle,_Component3);function PostTitle(props){_classCallCheck(this,PostTitle);var _this8=_possibleConstructorReturn(this,(PostTitle.__proto__||Object.getPrototypeOf(PostTitle)).call(this,props));_this8.onChange=_this8.onChange.bind(_this8);_this8.state={value:_this8.props.value!==undefined?_this8.props.value:'',maxLength:_this8.props.maxLength?_this8.props.maxLength:100};return _this8;}_createClass(PostTitle,[{key:'onChange',value:function onChange(event){if(this.props.user===JSON.parse(localStorage.getItem('user')).username&&event.target.value.length<=this.state.maxLength){this.props.onChange(event.target.value);this.setState({value:event.target.value});}return true;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PostTitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'PostTitleInput',type:'text',placeholder:'',value:this.state.value,onChange:this.onChange}));}}]);return PostTitle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PostMessage=function(_Component4){_inherits(PostMessage,_Component4);function PostMessage(props){_classCallCheck(this,PostMessage);var _this9=_possibleConstructorReturn(this,(PostMessage.__proto__||Object.getPrototypeOf(PostMessage)).call(this,props));_this9.onChange=_this9.onChange.bind(_this9);_this9.state={value:_this9.props.value!==undefined?_this9.props.value:'',maxLength:_this9.props.maxLength?_this9.props.maxLength:3000};return _this9;}_createClass(PostMessage,[{key:'onChange',value:function onChange(event){if(this.props.user===JSON.parse(localStorage.getItem('user')).username&&event.target.value.length<=this.state.maxLength){this.props.onChange(event.target.value);this.setState({value:event.target.value});}return true;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'PostMessage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea',{className:'PostMessage',placeholder:'',value:this.state.value,onChange:this.onChange,rows:'6',cols:'100'}));}}]);return PostMessage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Update; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__update_css__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__update_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__update_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resource_suggestion_png__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__resource_suggestion_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__resource_suggestion_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource_security_png__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource_security_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__resource_security_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqUpdates=[];var Update=function(_Component){_inherits(Update,_Component);function Update(){_classCallCheck(this,Update);return _possibleConstructorReturn(this,(Update.__proto__||Object.getPrototypeOf(Update)).apply(this,arguments));}_createClass(Update,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Hier finden Sie aktuelle Hinweise zu den Produkten, zu Sicherheit und Datenschutz sowie Empfehlungen der Redaktion'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateRowTiles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateTileDownOneTile center pointer ',onClick:function onClick(event){return _this2.props.history.push("/suggestion");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__resource_suggestion_png___default.a,alt:'Dienstleistung'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'Empfehlungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText landingNotClikableProducts'},'Gesetze und Verordnungen Datenschutz ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Studien Abrechnung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Formulare weitere Hinweise ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'weitere Empfehlungen ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'UpdateTileDownOneTile center pointer ',onClick:function onClick(event){return _this2.props.history.push("/requirements");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingOneTileContent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__resource_security_png___default.a,alt:'Dienstleistung'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingHeaderText'},'IT-Sicherheit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'landingContentText landingNotClikableProducts'},'Organisatorische Unterst\xFCtzung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Datenschutz ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Abrechnung ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'weitere Hinweise ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__footer_js__["a" /* Footer */],{faqs:faqUpdates}));}}]);return Update;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAABcRAAAXEQHKJvM/AAAEmUlEQVRYR2P4//8/Aw0xMw5xJiL0MhBUQC42NTNjhLFdMgrz/bpnnfMob16ATR4XJmgJpZhBQaudI67kP1t0wX+OxIr/DOrGiwjpgeslpIASzMTBySeTXPJcobDtv1xmzT/53Mb/isXt/zlkFB3AljMw4A09ghZQgll4+RWAjvoPchSIlsuo/qdcPfG/oJVrGyG9NHccMOTEZNMqfsjnNUEcB8SKxR3/RT3D1hPSS3PHsQqJqgJD6zc85IAYFMUSoSmnGVlYOQnpJ2gBJZjPwCJJoaD1v1x2Hdxx8rkN/+Wyav+yCAirENJP0AJyMAMjI7gcE3YJmK5U3gN3GCz9yaZX/mLhE1QmaA4hBaRioMPAOZCJjY1XJrHovUJ+M4bjgFH9n4VfSJWgWYQUkIsFLF26lSp6QQ75g+I4YOaQSSl7wcLDL0nIDIKWEIuRyyx2CRlL+Zz6/8i5FJ5bi9r/iwfE7WVgYqJPDYHsMBZeATnp+IJnCkWQghfNcf+Uyrr/i7iHzCJkJjbH4aqoERoYmeBq0Et4LmXNQKADfitCHIaB5YG5FlTOcSmq++MyX19fH24mhmRATJwaA59YFo+2UTqPlmEqEKfxaBtnAnEGC7+gIjYDOaQVHMV8o3aBEj+4qsqo/ovVcaDMkF71i1tVO4KZm0cKWA5qgzCbiIQhMye3GJKZTFgdlzB10Ub21Nr/ShV9/5XKeyEYyFZrnv1fxC1oGbJabg39WDHf6F2gsgwUXfI5DTgdBsdAedmUss8yKaWfgBkDjIFFy0+Z5NKPDEJS2cjmYzguaeby3SwRuRiGghwp6hG6EaSGR9MwWiax+L1iSSc4mohyFFoIgkMZikEZB2QWe2Tef8vgKDecjkuctngzSzgWx5X1/Bd28lsAUiMZlnoGVIETcgSJ+B9HTOF/t/q+PeQ6bj5IDbAoOAwqEoiwkCTMHpX/36Njxh1yHQcOOTH/2P00c1zbtGuD03GRuf+dihsWDz7HZdX+ZwvP/m8VER81KB3HDiwlHLJLJw0+x2VC0pxn16zbg9Fx/ziAPTTn0qaVg85x8tn1/1mD0n6Ze/mbDzrHgao/Bm2L+chuGTSOU67s/8+goj8D6g7GQeU4UN3NoGowA9ktg8Fx/0ANB5B5DBx8QYPLcRnV/xRLu/6LeoVvRnfLgDtOobD1v0xSyTtGFhZwJxtvS5gYx4n7xx6gkuP+gfq1Yj6Re9DdQYbjfOeD1EiEJJ8BZX1QlBDhAKyOAvVdQU16UEYAdgVCKHaciGsguJkuCOqTAn0MMhiUXkCtYQhuB0cTyFJcGKwO2OoFFR1y2XW/+I1t6rA5DIfjluzA2Uz3DN8EUgPsgLECOzV2XEqa4TwaBqFC9t4ThOw8ZwET9Xpg8/2FdFzeEyB+jIITCl9LRWVdAnpwvoCZQye3ul4oC58gvGMNG8LA6zi/1imbGFyi/7NG5AFxLgQD2/YcKdX/GdSMFqOrxzCQgYEdiNmwYA5sg4UgMVyDiBgC9VNmOdlVdZ4O6Zt7PLh39mEQDumfdzKkd85R55AIC0KOoyZG4fz794+YUW5i1FAFAwDnOA/k6g6qvwAAAABJRU5ErkJggg=="

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAAACXBIWXMAABcRAAAXEQHKJvM/AAAFVUlEQVRYR+WYe1DUVRTHFxDTBB/51oii1x/OWJAzNWmOjc0kGqMO8jDiKSJvFHkIsjws5BFIyVNIs6QREDAQkEAwE3QBWUUl5A01I08tg1Bg2dv9/ujHLCt4d40dmvGPL+wu55zfh3vuOffcFRBCBMpKKpWqsWzkbBW2lxXTYPyDiLrs+6rm9rWx538W2iakln4cGl9jGJpQvf3L5Kqws0VxRTV1Zg+HhmfLQI7zVURMA14jUqkG/1rU0LrJLOZEyUI7XzLnM08yy2Iv0TT34DRzpwfRttxPZlvsIwY+EV0ZV8U2MnGUWkWmgTxYXOGloMW7DhA1U1ey3MGfzLP2JrM+3cvB8NKicPgbXqubuRHHlLQzQxLJTPgrs4JMA9lg9CE5gq0OBCu2bLc/B/i6e8jAtsjk6uCM/GNRuRdCLI6eLHnbO7wPYPOsvchyaicwcSX0s3vNXb2rEUcyMqIx0bOUhuMVmlWYJNjhQlbuCSDzbbw5CdPzYnv7+hfL2w4MDi3Jrqix0/cJ73iOrqqOYwCB7zrhkd9Yz1EYjhYAtz/ELb+/BxikU8vSk7zqGjx48XaDISv4348GtYzCkyo1zNzJS05CIjB2JtHnSr5m+SkEx8s4KqVM3dSNLLX3Iy/Y+hBZsJEJ9pCUbnqpzMZ/PyC6FWmGL/ZiY0f3Kt7uaeE4R1Fj23rsMayaJq3Ez7MKo+VtJhMPXl7f8uEi6g8wpDc0+6cjT/JTBI5TUnGZF9KxdLcf3TtC0tLV+wY+Z/3X8qLprUCbgewSUnNZ9grBOSanZWLF0C6Mo74Rsezlxa/ekbzSSOw9tJ41vpEd3Q/6lrF8mcGt408VYL+gHbgcz0jHZ8quGpRXfdt8xZ6DHNyLtHqbO3veZPkwg+5K/CEHJwB6mlNKWgbLfjIViGuNV1K4uVZeXLW399zXY/kwg47C7aNwo52eZT+Z6MqZPotwo2n9j3AmSsOxDmLX4xmnUa2CHc7E87vsk6yAk+lqQ+uGFQ4HuaHgNbfgQX4QmEj82cu9AWDJrfotp8uu2WeJblhCuddumeVU3dy5+XCCGEcXghpFJFVerG3YxNtkVUwgkYz+fV98845RID2HUaWLaEN/xSVoOPlCuWfhjV+38baZoutWaeXVdr1/9S8ZWzn8GJZINN/xjegUGNpy6YPQOtSocDLQYBI9GhCv0ZB5G0WFUwFzH87Xl50DR3Tob8x++FzWRvCJPblc1/SRHNyI5ubDidXaVvu5ANMh7McFNEOVjW3rng04XZomTBtcWrY7kudp+nSdhFJdZ6GU5atSOIChWAx8I7q/yCqMSiy67LM14lgtJmAAsvxVCreQrthb3mGDTZ09+rKtYEtYohjth8IrDDjlcKjckDMFMfL9qbimzggPwnDKiqEonFhpOLrP0L/4YPx4hIaLCxBaDyvGY3BNUwSHCXm1V9i9+rtdq2TTyh15dP5j+asUDg0Vk+27/lFt/Y8GtRErMD3/KJo3bly6CsRQGRyEqx+9wHTyAZFmDKeAY/kqA6d0QeCsnEOviuE/Fo9deqqa2teiveBhLP8J4aaqWnHBxthddqd5Ix/wwcDD+QY+4V1ozCx/lcItoABrDkT+QccfLdmC8Pr+7AkMpyx/lcLhuqhPVwnVCdnEn8r3+DYzdeOh2FpUMstfpXCoVlyUZ5i7c98mzaBXP4GJC3ez13MNGmb5qxRuKvVEOMPQhOsYCFGB0yFkYC4dGCoa2z54DG594FeNOCsxUUyHcA3ARHylvmXDODiciRlXxLbR50oOxRf+4jcdijt/yT8mrzT47v0/dcbg+O/g/k/iB4h/AF+BqwQJxO0QAAAAAElFTkSuQmCC"

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Requirements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_css__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__editor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__requirement_css__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__requirement_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__requirement_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqRequirements=[];var Requirements=function(_Component){_inherits(Requirements,_Component);function Requirements(props){_classCallCheck(this,Requirements);var _this=_possibleConstructorReturn(this,(Requirements.__proto__||Object.getPrototypeOf(Requirements)).call(this,props));_this.getRequirementsContent=_this.getRequirementsContent.bind(_this);_this.state={staticHTML:''};return _this;}_createClass(Requirements,[{key:'componentWillMount',value:function componentWillMount(){this.getRequirementsContent();}},{key:'getRequirementsContent',value:function getRequirementsContent(){var self=this;var url='/api/get-editor-content?type=requirements';var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Aktuelle gesetzliche Anforderung konnten nicht geladen werden.');console.error('Could not fetch requirements content.',exception);});promise.then(function(json){self.setState({staticHTML:json.text.requirements});return;});return;}},{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'F\xFCr nicht eingeloggte Nutzer ist die Seite nicht sichtbar.'))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Aktuelle gesetzliche Anforderungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'requirements'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop30',dangerouslySetInnerHTML:{__html:this.state.staticHTML}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__footer_js__["a" /* Footer */],{faqs:faqRequirements}));}}}]);return Requirements;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Suggestion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_css__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editor_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__editor_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__suggestion_css__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__suggestion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__suggestion_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqSuggestion=[];var Suggestion=function(_Component){_inherits(Suggestion,_Component);function Suggestion(props){_classCallCheck(this,Suggestion);var _this=_possibleConstructorReturn(this,(Suggestion.__proto__||Object.getPrototypeOf(Suggestion)).call(this,props));_this.getSuggestionContent=_this.getSuggestionContent.bind(_this);_this.state={staticHTML:''};return _this;}_createClass(Suggestion,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;if(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()===true){__WEBPACK_IMPORTED_MODULE_1__util__["g" /* loginGuest */](function(_){return _this2.getSuggestionContent();});}else{this.getSuggestionContent();}}},{key:'getSuggestionContent',value:function getSuggestionContent(){var self=this;var url='/api/get-editor-content?type=recommendations';var headers=Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */])();headers.append("Accept","application/json");var promise=fetch(url,{method:'GET',headers:headers}).then(function(response){return response.json();}).catch(function(exception){alert('Empfehlungen konnten nicht geladen werden.');console.error('Could not fetch suggestion content.',exception);});promise.then(function(json){self.setState({staticHTML:json.text.recommendations});return;});return;}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'Empfehlungen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggestion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:this.state.staticHTML}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqSuggestion}));}}]);return Suggestion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfilePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_css__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__profile_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var faqProfile=[];function FormGroup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('legend',null,props.label),props.children);};var LabeledInput=function(_Component){_inherits(LabeledInput,_Component);function LabeledInput(props){_classCallCheck(this,LabeledInput);var _this=_possibleConstructorReturn(this,(LabeledInput.__proto__||Object.getPrototypeOf(LabeledInput)).call(this,props));_this.handleOnChange=_this.handleOnChange.bind(_this);_this.state={value:props.value||'',checked:props.checked||false};return _this;}_createClass(LabeledInput,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.value!==this.state.value||nextProps.checked!==this.state.checked){this.setState({value:nextProps.value,checked:nextProps.checked});}}},{key:'handleOnChange',value:function handleOnChange(event){var value=event.target.tag==="checkbox"?event.target.checked:event.target.value;this.setState({value:value});this.props.onChange(event);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"LabeledInput "+this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.props.name},this.props.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:this.props.type||"text",name:this.props.name||"",value:this.state.value,onChange:this.handleOnChange,disabled:this.props.disabled||false,placeholder:this.props.placeholder||"",checked:this.state.checked||false,required:this.props.required,maxLength:this.props.maxLength})));}}]);return LabeledInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var LabeledCheckbox=function(_Component2){_inherits(LabeledCheckbox,_Component2);function LabeledCheckbox(props){_classCallCheck(this,LabeledCheckbox);var _this2=_possibleConstructorReturn(this,(LabeledCheckbox.__proto__||Object.getPrototypeOf(LabeledCheckbox)).call(this,props));_this2.handleToggle=_this2.handleToggle.bind(_this2);_this2.state={value:props.value||false};return _this2;}_createClass(LabeledCheckbox,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var value=nextProps.value;if(value!==this.state.value){this.setState({value:value});}}},{key:'handleToggle',value:function handleToggle(){this.setState({value:!this.state.value});this.props.onChange(!this.state.value);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{className:'LabeledCheckbox',name:this.props.name,label:this.props.label,type:'checkbox',checked:this.state.value,onChange:this.handleToggle,disabled:this.props.disabled});}}]);return LabeledCheckbox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var LabeledSelect=function(_Component3){_inherits(LabeledSelect,_Component3);function LabeledSelect(props){_classCallCheck(this,LabeledSelect);var _this3=_possibleConstructorReturn(this,(LabeledSelect.__proto__||Object.getPrototypeOf(LabeledSelect)).call(this,props));_this3.handleSelectChange=_this3.handleSelectChange.bind(_this3);_this3.state={value:props.value};return _this3;}_createClass(LabeledSelect,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var value=nextProps.value;if(value!==this.state.value){this.setState({value:value});}}},{key:'handleSelectChange',value:function handleSelectChange(event){var value=event.target.value;this.setState({value:value});this.props.onChange(event);}},{key:'render',value:function render(){var options=this.props.options.map(function(opt,i){if((typeof opt==='undefined'?'undefined':_typeof(opt))==='object'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:opt.value},opt.label);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:i,value:opt},opt);}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'LabeledInput LabeledSelect'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Label'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:this.props.name},this.props.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{className:'InputSelect',name:this.props.name,value:this.state.value,defaultValue:this.props.defaultValue,disabled:this.props.disabled,onChange:this.handleSelectChange},options)));}}]);return LabeledSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProfileForm=function(_Component4){_inherits(ProfileForm,_Component4);function ProfileForm(props){_classCallCheck(this,ProfileForm);var _this4=_possibleConstructorReturn(this,(ProfileForm.__proto__||Object.getPrototypeOf(ProfileForm)).call(this,props));_this4.handleSubmit=_this4.handleSubmit.bind(_this4);_this4.handleInputChange=_this4.handleInputChange.bind(_this4);_this4.state={user_name:'',email:'',valid_email:false,company:'',department:'',street:'',street_number:'',additional_address:'',city:'',zip_code:''};return _this4;}_createClass(ProfileForm,[{key:'componentDidMount',value:function componentDidMount(){var _this5=this;var url='/api/profile/'+this.props.userName;fetch(url,{headers:__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */]()}).then(function(resp){return resp.json();}).then(function(json){return _this5.setState(json);});}},{key:'handleInputChange',value:function handleInputChange(event){var name=event.target.name;var value=event.target.value;this.setState(_defineProperty({},name,value));}},{key:'handleSubmit',value:function handleSubmit(event){var _this6=this;event.preventDefault();var url='/api/profile/'+this.props.userName;fetch(url,{method:"PUT",headers:__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */](),body:JSON.stringify(this.state)}).then(function(resp){return resp.json();}).then(function(json){if(json.success){alert('Profil aktualisiert');_this6.props.history.push('/product-list');}else{console.error('ProfileForm: Profile update failed');}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProfileForm'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Profildaten \xE4ndern'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop50 ProfilData'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormGroup,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'user_name',label:'Foren-Nutzername',type:'text',value:this.state.user_name,disabled:true,maxLength:50}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'email',label:'Email-Adresse',type:'text',value:this.state.email,disabled:true,maxLength:200}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledCheckbox,{name:'email_valid',label:'Email aktiviert',value:this.state.valid_email,disabled:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'first_name',label:'Vorname',type:'text',value:this.state.first_name,onChange:this.handleInputChange,maxLength:30}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'last_name',label:'Nachname',type:'text',value:this.state.last_name,onChange:this.handleInputChange,maxLength:30}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'company',label:'Firma',type:'text',value:this.state.company,onChange:this.handleInputChange,maxLength:30}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'department',label:'Abteilung',type:'text',value:this.state.department,onChange:this.handleInputChange,maxLength:50}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'street',label:'Stra\xDFe',type:'text',value:this.state.street,onChange:this.handleInputChange,maxLength:50}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'street_number',label:'Hausnummer',value:this.state.street_number,onChange:this.handleInputChange,maxLength:10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'additional_address',label:'Adresszusatz',type:'text',value:this.state.additional_address,onChange:this.handleInputChange,maxLength:30}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'zip_code',label:'Postleitzahl',value:this.state.zip_code,onChange:this.handleInputChange,maxLength:10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'city',label:'Stadt',type:'text',value:this.state.city,onChange:this.handleInputChange,maxLength:30}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledSelect,{name:'country',label:'Land',value:this.state.country,options:['Deutschland','Österreich','Liechtenstein','Belgien','Italien','Schweiz','Luxemburg','Dänemark','Polen','Frankreich','England'],onChange:this.handleInputChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop10 ToEndRightV2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'buttonInput',type:'submit',value:'\xDCbernehmen'}))))));}}]);return ProfileForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProfileChangePasswordForm=function(_Component5){_inherits(ProfileChangePasswordForm,_Component5);function ProfileChangePasswordForm(props){_classCallCheck(this,ProfileChangePasswordForm);var _this7=_possibleConstructorReturn(this,(ProfileChangePasswordForm.__proto__||Object.getPrototypeOf(ProfileChangePasswordForm)).call(this,props));_this7.handleSubmit=_this7.handleSubmit.bind(_this7);_this7.handleInputChange=_this7.handleInputChange.bind(_this7);_this7.errorMessages={wrong_password:'Passworteingabe falsch.',password_mismatch:'Passwörter stimmen nicht überein.'};_this7.state={current_password:'',new_password:'',new_password_verify:'',error:{required_fields:[]}};return _this7;}_createClass(ProfileChangePasswordForm,[{key:'componentDidMount',value:function componentDidMount(){if('oldPassword'in this.props.match.params)this.setState({current_password:this.props.match.params.oldPassword});}},{key:'handleSubmit',value:function handleSubmit(event){var _this8=this;event.preventDefault();fetch('/api/change-password',{method:'POST',headers:__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defaultHeaders */](),body:JSON.stringify(this.state)}).then(function(resp){return resp.json().then(function(json){if(resp.status>=400){_this8.setState(json);}else{_this8.props.history.replace('/product-list');}});});}},{key:'handleInputChange',value:function handleInputChange(event){var name=event.target.name;var value=event.target.value;this.setState(_defineProperty({},name,value));}},{key:'markError',value:function markError(name){return this.state.error.required_fields.includes(name)?'red':'';}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProfilePassword'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'productHeader1'},'Passwort \xE4ndern'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ProfilData marginTop30'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormGroup,null,this.state.error.message_flag!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'red'},this.errorMessages[this.state.error.message_flag]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'current_password',label:'Altes Passwort',type:'password',className:this.markError('current_password'),required:true,value:this.state.current_password,onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'new_password',label:'Neues Passwort',type:'password',className:this.markError('new_password'),required:true,value:this.state.new_password,onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabeledInput,{name:'new_password_verify',label:'Neues Passwort wiederholen',type:'password',className:this.markError('new_password_verify'),required:true,value:this.state.new_password_verify,onChange:this.handleInputChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'marginTop10 ToEndRightV2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'',onClick:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'buttonInput',value:'Passwort \xE4ndern',type:'submit'})))));}}]);return ProfileChangePasswordForm;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ProfilePage=function(_Component6){_inherits(ProfilePage,_Component6);function ProfilePage(props){_classCallCheck(this,ProfilePage);var _this9=_possibleConstructorReturn(this,(ProfilePage.__proto__||Object.getPrototypeOf(ProfilePage)).call(this,props));var userName=JSON.parse(localStorage.getItem('user')).username;_this9.state={userName:userName};return _this9;}_createClass(ProfilePage,[{key:'render',value:function render(){if(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isGuestUser */]()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content',id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'contentHeaderText'},'F\xFCr nicht eingeloggte Nutzer ist die Seite nicht sichtbar.'))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProfileForm,{userName:this.state.userName,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProfileChangePasswordForm,{history:this.props.history,match:this.props.match,userName:this.state.userName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__footer_js__["a" /* Footer */],{faqs:faqProfile}));}}}]);return ProfilePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagePage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_select_js__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_tabs__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tabs_style_react_tabs_css__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tabs_style_react_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_tabs_style_react_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__manage_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__manage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__manage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_downArrow_png__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__resource_downArrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__resource_downArrow_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ManagePage=function(_Component){_inherits(ManagePage,_Component);function ManagePage(props){_classCallCheck(this,ManagePage);var _this=_possibleConstructorReturn(this,(ManagePage.__proto__||Object.getPrototypeOf(ManagePage)).call(this,props));_this.showFeedback=function(response){response.json().then(function(json){var msg="Erledigt, betroffene Produkte:\n"+JSON.stringify(json);alert(msg);});};_this.handleTransfer=function(){var fromRef=_this.userSelectFrom.current;var toRef=_this.userSelectTo.current;var fromId=fromRef.state.row;var toId=toRef.state.row;if(!(fromId||toId))alert("Leere Auswahl (von, zu)");else if(!toId)alert("Leere Auswahl (zu)");else if(!fromId)alert("Leere Auswahl (von)");else{var msg="Produkte zuweisen von Nutzer "+fromId+" zu Nutzer "+toId+"?";if(window.confirm(msg)){var headers=Object(__WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* defaultHeaders */])();headers.append('Content-Type','application/x-www-form-urlencoded');fetch('/api/transfer-products',{method:'POST',headers:headers,body:'from='+fromId+'&to='+toId}).then(__WEBPACK_IMPORTED_MODULE_2__util_js__["b" /* handleErrors */]).then(_this.showFeedback).catch(function(error){return console.log(error);});}}};_this.handleToggleActive=function(flag){var userRef=_this.userSelectToggleActive.current;var toggleId=userRef.state.row;if(!toggleId)alert("Leere Auswahl");else{var msg="Produkte von Nutzer "+toggleId+(flag?" aktivieren":" deaktivieren")+"?";if(window.confirm(msg)){var headers=Object(__WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* defaultHeaders */])();headers.append('Content-Type','application/x-www-form-urlencoded');fetch('/api/toggle-products-active',{method:'POST',headers:headers,body:'for-user='+toggleId+(flag?"&flag=T":"")}).then(__WEBPACK_IMPORTED_MODULE_2__util_js__["b" /* handleErrors */]).then(_this.showFeedback).catch(function(error){return console.log(error);});}}};var userName=JSON.parse(localStorage.getItem('user')).username;_this.state={userName:userName,allUsers:[]};_this.userSelectFrom=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.userSelectTo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.userSelectToggleActive=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ManagePage,[{key:'componentDidMount',value:function componentDidMount(){var self=this;fetch('/api/get-users',{headers:Object(__WEBPACK_IMPORTED_MODULE_2__util_js__["a" /* defaultHeaders */])()}).then(__WEBPACK_IMPORTED_MODULE_2__util_js__["b" /* handleErrors */]).then(function(response){return response.json();}).then(function(data){self.setState({allUsers:data});}).catch(function(error){return console.log(error);});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Landing',id:'contentId'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* Header */],{username:this.props.username,propagateLogin:this.props.propagateLogin}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ContentWithBackground'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["d" /* Tabs */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["b" /* TabList */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["a" /* Tab */],null,'Produkte zuweisen'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["a" /* Tab */],null,'Produkte (de)aktivieren')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["c" /* TabPanel */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__user_select_js__["a" /* default */],{users:this.state.allUsers,caption:'VON',ref:this.userSelectFrom}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__resource_downArrow_png___default.a,alt:'down arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__resource_downArrow_png___default.a,alt:'down arrow'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__user_select_js__["a" /* default */],{users:this.state.allUsers,caption:'ZU',ref:this.userSelectTo}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleTransfer},'Produkte zuweisen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_tabs__["c" /* TabPanel */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__user_select_js__["a" /* default */],{users:this.state.allUsers,caption:'Nutzer',ref:this.userSelectToggleActive}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.handleToggleActive(false);}},'Produkte deaktivieren'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return _this2.handleToggleActive(true);}},'Produkte aktivieren')))));}}]);return ManagePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_select_css__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__user_select_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JsonTable=__webpack_require__(416);var UserSelect=function(_Component){_inherits(UserSelect,_Component);function UserSelect(props){_classCallCheck(this,UserSelect);var _this=_possibleConstructorReturn(this,(UserSelect.__proto__||Object.getPrototypeOf(UserSelect)).call(this,props));_this.onClickHeader=function(e,column){_this.setState({sort:column});};_this.onClickRow=function(e,item){_this.setState({row:item.id});};_this.state={row:false,sort:false};return _this;}_createClass(UserSelect,[{key:'render',value:function render(){var self=this,items=this.props.users.slice();if(this.state.sort){items.sort(function(a,b){return a[self.state.sort]>b[self.state.sort]?1:-1;});}var columns=[{label:'User ID',key:'id'},{label:'Nachname',key:'last_name'},{label:'Vorname',key:'first_name'},{label:'Email',key:'email'},{label:'Nutzername',key:'user_name'},{label:'Rolle',key:'role'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(JsonTable,{caption:this.props.caption,rows:items,columns:columns,settings:this.getSettings(),onClickHeader:this.onClickHeader,onClickRow:this.onClickRow}));}},{key:'getSettings',value:function getSettings(){var self=this;return{keyField:'id',headerClass:function headerClass(current,key){if(self.state.sort===key)return current+' headerSelected';return current;},rowClass:function rowClass(current,item){if(self.state.row===item.id)return current+' rowSelected';return current;}};}}]);return UserSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserSelect);

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var gridHeader_1 = __webpack_require__(417);
var gridBody_1 = __webpack_require__(420);
var gridFooter_1 = __webpack_require__(424);
var polyfills_1 = __webpack_require__(425);
polyfills_1.polyfills();
var JsonTable = /** @class */ (function (_super) {
    __extends(JsonTable, _super);
    function JsonTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultSettings = {
            header: true,
            noRowsMessage: 'No items',
            classPrefix: 'json',
        };
        _this.headerGrouping = false;
        return _this;
    }
    JsonTable.prototype.render = function () {
        this.createSettings();
        this.columns = this.createColumns();
        this.className = this.props.className || this.settings.classPrefix + "Table";
        var header = this.settings.header ? React.createElement(gridHeader_1.GridHeader, { theadClassName: this.props.theadClassName, key: 'jt-header', settings: this.settings, columns: this.columns, onClickHeader: this.props.onClickHeader, grouping: this.headerGrouping }) : null;
        var caption = this.props.caption ? React.createElement("caption", null, this.props.caption) : null;
        var table = React.createElement("div", null,
            React.createElement("div", { style: { position: "relative", overflow: "hidden" } },
                React.createElement("table", { className: this.className, key: 'jt-table' },
                    caption,
                    header,
                    React.createElement(gridBody_1.GridBody, { key: 'jt-body', settings: this.settings, columns: this.columns, rows: this.props.rows, onClickRow: this.props.onClickRow, onClickCell: this.props.onClickCell }),
                    React.createElement(gridFooter_1.GridFooter, { key: 'jt-footer' }))));
        return this.settings.freezeHeader ?
            React.createElement("div", { className: "scrollingtable" },
                React.createElement("div", null,
                    React.createElement("div", null, table))) : table;
    };
    JsonTable.prototype.createSettings = function () {
        if (this.props.settings) {
            this.settings = this.props.settings;
        }
        else {
            this.settings = this.defaultSettings;
        }
        if (this.settings.header == null)
            this.settings.header = true;
        if (this.settings.noRowsMessage == null)
            this.settings.noRowsMessage = this.defaultSettings.noRowsMessage;
        if (this.settings.classPrefix == null)
            this.settings.classPrefix = this.defaultSettings.classPrefix;
    };
    JsonTable.prototype.createColumns = function () {
        var _this = this;
        if (!this.props.rows || this.props.rows.length === 0) {
            return [];
        }
        var columns;
        if (!this.props.columns) {
            columns = Object.keys(this.props.rows[0]).map(function (key) {
                return {
                    key: key,
                    label: key,
                    cell: _this.settings.cellRenderer || key,
                };
            });
        }
        else {
            columns = this.props.columns.map(function (column) {
                if (typeof column == 'string') {
                    return {
                        key: column,
                        label: column,
                        cell: _this.settings.cellRenderer || column
                    };
                }
                if (typeof column == 'object') {
                    var key = column.key || column.label;
                    if (column.group)
                        _this.headerGrouping = true;
                    return {
                        key: key,
                        label: column.label || key,
                        cell: _this.settings.cellRenderer || column.cell || key,
                        objectDisplayStyle: column.objectDisplayStyle,
                        group: column.group
                    };
                }
            });
        }
        if (this.props.excludeColumns && this.props.excludeColumns.length !== 0) {
            var toDelete_1 = [];
            this.props.excludeColumns.forEach(function (key) {
                toDelete_1.push(columns.findIndex(function (column) { return column.key === key; }));
            });
            toDelete_1.forEach(function (index) {
                if (index !== -1)
                    columns.splice(index, 1);
            });
        }
        var copyObject = function (index, columnDefinition) {
            if (index !== -1) {
                Object.keys(columnDefinition).forEach(function (key) {
                    columns[index][key] = columnDefinition[key];
                });
                return true;
            }
            return false;
        };
        if (this.props.columnDefinitions && this.props.columnDefinitions.length > 0) {
            this.props.columnDefinitions.forEach(function (def) {
                var index = columns.findIndex(function (column) { return column.key === def.key; });
                if (!copyObject(index, def)) {
                    var dotIndex_1 = def.key.indexOf('.');
                    if (dotIndex_1 !== -1) {
                        index = columns.findIndex(function (column) { return column.key === def.key.substring(0, dotIndex_1); });
                        if (copyObject(index, def)) {
                            columns[index].cell = _this.settings.cellRenderer || def.cell || def.key;
                        }
                        else {
                            index = columns.findIndex(function (column) { return column.key.indexOf(def.key.substring(0, dotIndex_1 + 1)) !== -1; });
                            if (index !== -1) {
                                var newIndex = index + 1;
                                columns.splice(newIndex, 0, def);
                                copyObject(newIndex, def);
                                columns[newIndex].cell = _this.settings.cellRenderer || def.cell || def.key;
                            }
                        }
                    }
                }
                if (def.group)
                    _this.headerGrouping = true;
            });
        }
        if (this.headerGrouping) {
            var group_1;
            var colSpans_1 = new Map();
            var colSpan_1 = 1;
            columns.forEach(function (column) {
                if (column.group) {
                    if (column.group === group_1) {
                        colSpans_1.set(column.group, ++colSpan_1);
                    }
                    else {
                        group_1 = column.group;
                        column.groupIndex = 0;
                        colSpan_1 = 1;
                    }
                }
            });
            Array.from(colSpans_1.keys()).forEach(function (group) {
                var index = columns.findIndex(function (column) { return column.group === group && column.groupIndex === 0; });
                columns[index].colSpan = colSpans_1.get(group);
            });
        }
        return columns;
    };
    return JsonTable;
}(React.Component));
exports.JsonTable = JsonTable;
module.exports = JsonTable;
//# sourceMappingURL=grid.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var gridHeaderRow_1 = __webpack_require__(418);
var GridHeader = /** @class */ (function (_super) {
    __extends(GridHeader, _super);
    function GridHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridHeader.prototype.render = function () {
        var groupHeader = this.props.grouping ? React.createElement(gridHeaderRow_1.GridHeaderRow, { columns: this.props.columns, onClickHeader: this.props.onClickHeader, settings: this.props.settings, groupCell: true }) : null;
        return React.createElement("thead", { className: this.props.theadClassName },
            groupHeader,
            React.createElement(gridHeaderRow_1.GridHeaderRow, { columns: this.props.columns, onClickHeader: this.props.onClickHeader, settings: this.props.settings, groupCell: false, grouping: this.props.grouping }));
    };
    return GridHeader;
}(React.Component));
exports.GridHeader = GridHeader;
//# sourceMappingURL=gridHeader.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var gridHeaderRowCell_1 = __webpack_require__(419);
var GridHeaderRow = /** @class */ (function (_super) {
    __extends(GridHeaderRow, _super);
    function GridHeaderRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridHeaderRow.prototype.render = function () {
        var _this = this;
        return React.createElement("tr", null, this.props.columns.map(function (column, index) {
            var key = "jt-header-th-" + index;
            return React.createElement(gridHeaderRowCell_1.GridHeaderRowCell, { settings: _this.props.settings, column: column, key: key, grouping: _this.props.grouping, groupCell: _this.props.groupCell, onClickHeader: _this.props.onClickHeader });
        }));
    };
    return GridHeaderRow;
}(React.Component));
exports.GridHeaderRow = GridHeaderRow;
//# sourceMappingURL=gridHeaderRow.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var GridHeaderRowCell = /** @class */ (function (_super) {
    __extends(GridHeaderRowCell, _super);
    function GridHeaderRowCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridHeaderRowCell.prototype.render = function () {
        var headerClass = this.props.settings.headerClass;
        //let label: string;
        var rowSpan = null;
        var colSpan = 1;
        var skip = false;
        if (this.props.groupCell) {
            if (this.props.column.group) {
                if (this.props.column.groupIndex === 0) {
                    this.header = this.props.column.group;
                    colSpan = this.props.column.colSpan;
                }
                else {
                    skip = true;
                }
            }
            else {
                this.header = this.props.column.label;
                rowSpan = 2;
            }
        }
        else {
            if (this.props.grouping) {
                if (this.props.column.group) {
                    this.header = this.props.column.label;
                }
                else {
                    skip = true;
                }
            }
            else {
                this.header = this.props.column.label;
            }
        }
        //this.key = (this.props.column.group && this.header === this.props.column.group) ? this.header.replace(/\W+/g, '') : this.props.column.key;
        this.key = (this.props.column.group && this.header === this.props.column.group) ? this.header : this.props.column.key;
        var className = this.props.settings.classPrefix + "Column " + this.props.settings.classPrefix + "Column_" + this.key.replace(/\W+/g, '');
        if (headerClass) {
            className = headerClass(className, this.key);
        }
        var content = this.props.settings.freezeHeader ? React.createElement("div", null,
            React.createElement("div", null, this.header),
            React.createElement("div", null, this.header)) : this.header;
        return skip ? null : this.createTh(className, rowSpan, colSpan, content);
    };
    GridHeaderRowCell.prototype.createTh = function (className, rowSpan, colSpan, content) {
        return React.createElement("th", { className: className, onClick: this.onClick.bind(this, this.key), "data-key": this.key, rowSpan: rowSpan, colSpan: colSpan }, content);
    };
    GridHeaderRowCell.prototype.onClick = function (key, e) {
        if (this.props.onClickHeader) {
            this.props.onClickHeader(e, key);
        }
    };
    return GridHeaderRowCell;
}(React.Component));
exports.GridHeaderRowCell = GridHeaderRowCell;
//# sourceMappingURL=gridHeaderRowCell.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var gridRow_1 = __webpack_require__(421);
var GridBody = /** @class */ (function (_super) {
    __extends(GridBody, _super);
    function GridBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridBody.prototype.render = function () {
        var _this = this;
        var rows = this.props.rows && this.props.rows.length > 0 ?
            this.props.rows.map(function (row, index) {
                var key = "jt-body-tr-" + index;
                return React.createElement(gridRow_1.GridRow, { row: row, columns: _this.props.columns, settings: _this.props.settings, onClickCell: _this.props.onClickCell, onClickRow: _this.props.onClickRow, index: index, key: key });
            }) :
            React.createElement("tr", null,
                React.createElement("td", null, this.props.settings.noRowsMessage));
        return React.createElement("tbody", null, rows);
    };
    return GridBody;
}(React.Component));
exports.GridBody = GridBody;
//# sourceMappingURL=gridBody.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var gridRowCell_1 = __webpack_require__(422);
var utils_1 = __webpack_require__(423);
var GridRow = /** @class */ (function (_super) {
    __extends(GridRow, _super);
    function GridRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridRow.prototype.render = function () {
        var _this = this;
        var rowClass = this.props.settings.rowClass;
        var className = this.props.settings.classPrefix + "Row " + this.props.settings.classPrefix + (this.props.index % 2 ? 'Odd' : 'Even');
        if (rowClass) {
            className = rowClass(className, this.props.row);
        }
        return React.createElement("tr", { className: className, onClick: this.onClick.bind(this, this.props.row) }, this.props.columns.map(function (column, index) {
            var item;
            if (typeof column.cell === 'function') {
                item = column.cell(_this.props.row, column.key);
            }
            else if (column.cell.indexOf('.') !== -1) {
                item = utils_1.Utils.getObjectByKey(_this.props.row, column.cell);
            }
            else {
                item = _this.props.row[column.cell];
            }
            if (typeof item === 'object' && typeof column.cell !== 'function') {
                var objectDisplayStyle = column.objectDisplayStyle || 'string';
                var preClassName = _this.props.settings.classPrefix + "CellPre " + _this.props.settings.classPrefix + "CellPre_" + column.key;
                switch (objectDisplayStyle) {
                    case 'string':
                        item = utils_1.Utils.flattenToString(item);
                        break;
                    case 'json':
                        item = JSON.stringify(item);
                        break;
                    case 'jsonSpaced':
                        item = React.createElement("pre", { className: preClassName }, JSON.stringify(item, null, 2));
                        break;
                    case 'flatJson':
                        item = JSON.stringify(utils_1.Utils.flatten(item));
                        break;
                    case 'flatJsonSpaced':
                        item = React.createElement("pre", { className: preClassName }, JSON.stringify(utils_1.Utils.flatten(item), null, 2));
                        break;
                    default:
                        item = utils_1.Utils.flattenToString(item);
                }
            }
            var key = "jt-body-td-" + index;
            return React.createElement(gridRowCell_1.GridRowCell, { settings: _this.props.settings, onClickCell: _this.props.onClickCell, item: item, row: _this.props.row, column: column, key: key });
        }));
    };
    GridRow.prototype.onClick = function (item, e) {
        if (this.props.onClickRow) {
            this.props.onClickRow(e, item);
        }
    };
    return GridRow;
}(React.Component));
exports.GridRow = GridRow;
//# sourceMappingURL=gridRow.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var GridRowCell = /** @class */ (function (_super) {
    __extends(GridRowCell, _super);
    function GridRowCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridRowCell.prototype.render = function () {
        var cellClass = this.props.settings.cellClass;
        var className = this.props.settings.classPrefix + "Cell " + this.props.settings.classPrefix + "Cell_" + this.props.column.key;
        if (cellClass) {
            className = cellClass(className, this.props.column.key, this.props.row);
        }
        return React.createElement("td", { className: className, "data-key": this.props.column.key, onClick: this.onClick.bind(this, this.props.column.key) }, this.props.item);
    };
    GridRowCell.prototype.onClick = function (key, e) {
        if (this.props.onClickCell) {
            this.props.onClickCell(e, key, this.props.row);
        }
    };
    return GridRowCell;
}(React.Component));
exports.GridRowCell = GridRowCell;
//# sourceMappingURL=gridRowCell.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// https://gist.github.com/penguinboy/762197
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.flatten = function (obj) {
        var toReturn = {};
        for (var i in obj) {
            if (!obj.hasOwnProperty(i))
                continue;
            if ((typeof obj[i]) == 'object') {
                var flatObject = Utils.flatten(obj[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x))
                        continue;
                    toReturn[i + '.' + x] = flatObject[x];
                }
            }
            else {
                toReturn[i] = obj[i];
            }
        }
        return toReturn;
    };
    Utils.flattenToString = function (obj) {
        var flat = Utils.flatten(obj);
        var values = Object.keys(flat).map(function (key) {
            return key + ": " + flat[key];
        });
        return values.join(', ');
    };
    // https://stackoverflow.com/a/45322101
    Utils.getObjectByKey = function (obj, key) {
        if (key.indexOf('.') !== 1) {
            return key.split('.').reduce(function (prev, curr) {
                return prev ? prev[curr] : null;
            }, obj);
        }
        else {
            return obj[key];
        }
    };
    Utils.stringRandom = function (chars) {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < chars; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    };
    return Utils;
}());
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var GridFooter = /** @class */ (function (_super) {
    __extends(GridFooter, _super);
    function GridFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridFooter.prototype.render = function () {
        return React.createElement("tfoot", null);
    };
    return GridFooter;
}(React.Component));
exports.GridFooter = GridFooter;
//# sourceMappingURL=gridFooter.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function polyfills() {
    // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
    if (!Array.prototype.findIndex) {
        Object.defineProperty(Array.prototype, 'findIndex', {
            value: function (predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }
                var o = Object(this);
                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;
                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];
                // 5. Let k be 0.
                var k = 0;
                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return k.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return k;
                    }
                    // e. Increase k by 1.
                    k++;
                }
                // 7. Return -1.
                return -1;
            }
        });
    }
    // Production steps of ECMA-262, Edition 6, 22.1.2.1
    if (!Array.from) {
        Array.from = (function () {
            var toStr = Object.prototype.toString;
            var isCallable = function (fn) {
                return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
            };
            var toInteger = function (value) {
                var number = Number(value);
                if (isNaN(number)) {
                    return 0;
                }
                if (number === 0 || !isFinite(number)) {
                    return number;
                }
                return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
            };
            var maxSafeInteger = Math.pow(2, 53) - 1;
            var toLength = function (value) {
                var len = toInteger(value);
                return Math.min(Math.max(len, 0), maxSafeInteger);
            };
            // The length property of the from method is 1.
            return function from(arrayLike /*, mapFn, thisArg */) {
                // 1. Let C be the this value.
                var C = this;
                // 2. Let items be ToObject(arrayLike).
                var items = Object(arrayLike);
                // 3. ReturnIfAbrupt(items).
                if (arrayLike == null) {
                    throw new TypeError('Array.from requires an array-like object - not null or undefined');
                }
                // 4. If mapfn is undefined, then let mapping be false.
                var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                var T;
                if (typeof mapFn !== 'undefined') {
                    // 5. else
                    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                    if (!isCallable(mapFn)) {
                        throw new TypeError('Array.from: when provided, the second argument must be a function');
                    }
                    // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    if (arguments.length > 2) {
                        T = arguments[2];
                    }
                }
                // 10. Let lenValue be Get(items, "length").
                // 11. Let len be ToLength(lenValue).
                var len = toLength(items.length);
                // 13. If IsConstructor(C) is true, then
                // 13. a. Let A be the result of calling the [[Construct]] internal method
                // of C with an argument list containing the single item len.
                // 14. a. Else, Let A be ArrayCreate(len).
                var A = isCallable(C) ? Object(new C(len)) : new Array(len);
                // 16. Let k be 0.
                var k = 0;
                // 17. Repeat, while k < len… (also steps a - h)
                var kValue;
                while (k < len) {
                    kValue = items[k];
                    if (mapFn) {
                        A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                    }
                    else {
                        A[k] = kValue;
                    }
                    k += 1;
                }
                // 18. Let putStatus be Put(A, "length", len, true).
                A.length = len;
                // 20. Return A.
                return A;
            };
        }());
    }
}
exports.polyfills = polyfills;
//# sourceMappingURL=polyfills.js.map

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tabs__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabList__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__components_TabList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tab__ = __webpack_require__(430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__components_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__components_TabPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_uuid__ = __webpack_require__(135);
/* unused harmony reexport resetIdCounter */






/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_propTypes__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_count__ = __webpack_require__(136);
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var MODE_CONTROLLED = 0;
var MODE_UNCONTROLLED = 1;

var Tabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleSelected = function (index, last, event) {
      var onSelect = _this.props.onSelect;
      var mode = _this.state.mode; // Call change event handler

      if (typeof onSelect === 'function') {
        // Check if the change event handler cancels the tab change
        if (onSelect(index, last, event) === false) return;
      }

      var state = {
        // Set focus if the change was triggered from the keyboard
        focus: event.type === 'keydown'
      };

      if (mode === MODE_UNCONTROLLED) {
        // Update selected index
        state.selectedIndex = index;
      }

      _this.setState(state);
    };

    _this.state = Tabs.copyPropsToState(_this.props, {}, props.defaultFocus);
    return _this;
  }

  Tabs.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return Tabs.copyPropsToState(props, state);
  };

  Tabs.getModeFromProps = function getModeFromProps(props) {
    return props.selectedIndex === null ? MODE_UNCONTROLLED : MODE_CONTROLLED;
  };

  // preserve the existing selectedIndex from state.
  // If the state has not selectedIndex, default to the defaultIndex or 0
  Tabs.copyPropsToState = function copyPropsToState(props, state, focus) {
    if (focus === void 0) {
      focus = false;
    }

    if (false) {
      throw new Error("Switching between controlled mode (by using `selectedIndex`) and uncontrolled mode is not supported in `Tabs`.\nFor more information about controlled and uncontrolled mode of react-tabs see the README.");
    }

    var newState = {
      focus: focus,
      mode: Tabs.getModeFromProps(props)
    };

    if (newState.mode === MODE_UNCONTROLLED) {
      var maxTabIndex = Object(__WEBPACK_IMPORTED_MODULE_4__helpers_count__["b" /* getTabsCount */])(props.children) - 1;
      var selectedIndex = null;

      if (state.selectedIndex != null) {
        selectedIndex = Math.min(state.selectedIndex, maxTabIndex);
      } else {
        selectedIndex = props.defaultIndex || 0;
      }

      newState.selectedIndex = selectedIndex;
    }

    return newState;
  };

  var _proto = Tabs.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        defaultIndex = _this$props.defaultIndex,
        defaultFocus = _this$props.defaultFocus,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "defaultIndex", "defaultFocus"]);

    var _this$state = this.state,
        focus = _this$state.focus,
        selectedIndex = _this$state.selectedIndex;
    props.focus = focus;
    props.onSelect = this.handleSelected;

    if (selectedIndex != null) {
      props.selectedIndex = selectedIndex;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__UncontrolledTabs__["a" /* default */], props, children);
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tabs.defaultProps = {
  defaultFocus: false,
  forceRenderTabPanel: false,
  selectedIndex: null,
  defaultIndex: null
};

Tabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  defaultFocus: PropTypes.bool,
  defaultIndex: PropTypes.number,
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: onSelectPropType,
  selectedIndex: selectedIndexPropType,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};
Tabs.tabsRole = 'Tabs';

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UncontrolledTabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_uuid__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_propTypes__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_count__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__ = __webpack_require__(54);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }










function isNode(node) {
  return node && 'getAttribute' in node;
} // Determine if a node from event.target is a Tab element


function isTabNode(node) {
  return isNode(node) && node.getAttribute('role') === 'tab';
} // Determine if a tab node is disabled


function isTabDisabled(node) {
  return isNode(node) && node.getAttribute('aria-disabled') === 'true';
}

var canUseActiveElement;

try {
  canUseActiveElement = !!(typeof window !== 'undefined' && window.document && window.document.activeElement);
} catch (e) {
  // Work around for IE bug when accessing document.activeElement in an iframe
  // Refer to the following resources:
  // http://stackoverflow.com/a/10982960/369687
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12733599
  canUseActiveElement = false;
}

var UncontrolledTabs =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(UncontrolledTabs, _Component);

  function UncontrolledTabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.tabNodes = [];

    _this.handleKeyDown = function (e) {
      if (_this.isTabFromContainer(e.target)) {
        var index = _this.props.selectedIndex;
        var preventDefault = false;
        var useSelectedIndex = false;

        if (e.keyCode === 32 || e.keyCode === 13) {
          preventDefault = true;
          useSelectedIndex = false;

          _this.handleClick(e);
        }

        if (e.keyCode === 37 || e.keyCode === 38) {
          // Select next tab to the left
          index = _this.getPrevTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 39 || e.keyCode === 40) {
          // Select next tab to the right
          index = _this.getNextTab(index);
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 35) {
          // Select last tab (End key)
          index = _this.getLastTab();
          preventDefault = true;
          useSelectedIndex = true;
        } else if (e.keyCode === 36) {
          // Select first tab (Home key)
          index = _this.getFirstTab();
          preventDefault = true;
          useSelectedIndex = true;
        } // This prevents scrollbars from moving around


        if (preventDefault) {
          e.preventDefault();
        } // Only use the selected index in the state if we're not using the tabbed index


        if (useSelectedIndex) {
          _this.setSelected(index, e);
        }
      }
    };

    _this.handleClick = function (e) {
      var node = e.target; // eslint-disable-next-line no-cond-assign

      do {
        if (_this.isTabFromContainer(node)) {
          if (isTabDisabled(node)) {
            return;
          }

          var index = [].slice.call(node.parentNode.children).filter(isTabNode).indexOf(node);

          _this.setSelected(index, e);

          return;
        }
      } while ((node = node.parentNode) != null);
    };

    return _this;
  }

  var _proto = UncontrolledTabs.prototype;

  _proto.setSelected = function setSelected(index, event) {
    // Check index boundary
    if (index < 0 || index >= this.getTabsCount()) return;
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        selectedIndex = _this$props.selectedIndex; // Call change event handler

    onSelect(index, selectedIndex, event);
  };

  _proto.getNextTab = function getNextTab(index) {
    var count = this.getTabsCount(); // Look for non-disabled tab from index to the last tab on the right

    for (var i = index + 1; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from first on left to index


    for (var _i = 0; _i < index; _i++) {
      if (!isTabDisabled(this.getTab(_i))) {
        return _i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getPrevTab = function getPrevTab(index) {
    var i = index; // Look for non-disabled tab from index to first tab on the left

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // If no tab found, continue searching from last tab on right to index


    i = this.getTabsCount();

    while (i-- > index) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    } // No tabs are disabled, return index


    return index;
  };

  _proto.getFirstTab = function getFirstTab() {
    var count = this.getTabsCount(); // Look for non disabled tab from the first tab

    for (var i = 0; i < count; i++) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getLastTab = function getLastTab() {
    var i = this.getTabsCount(); // Look for non disabled tab from the last tab

    while (i--) {
      if (!isTabDisabled(this.getTab(i))) {
        return i;
      }
    }

    return null;
  };

  _proto.getTabsCount = function getTabsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["b" /* getTabsCount */])(children);
  };

  _proto.getPanelsCount = function getPanelsCount() {
    var children = this.props.children;
    return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_count__["a" /* getPanelsCount */])(children);
  };

  _proto.getTab = function getTab(index) {
    return this.tabNodes["tabs-" + index];
  };

  _proto.getChildren = function getChildren() {
    var _this2 = this;

    var index = 0;
    var _this$props2 = this.props,
        children = _this$props2.children,
        disabledTabClassName = _this$props2.disabledTabClassName,
        focus = _this$props2.focus,
        forceRenderTabPanel = _this$props2.forceRenderTabPanel,
        selectedIndex = _this$props2.selectedIndex,
        selectedTabClassName = _this$props2.selectedTabClassName,
        selectedTabPanelClassName = _this$props2.selectedTabPanelClassName;
    this.tabIds = this.tabIds || [];
    this.panelIds = this.panelIds || [];
    var diff = this.tabIds.length - this.getTabsCount(); // Add ids if new tabs have been added
    // Don't bother removing ids, just keep them in case they are added again
    // This is more efficient, and keeps the uuid counter under control

    while (diff++ < 0) {
      this.tabIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
      this.panelIds.push(Object(__WEBPACK_IMPORTED_MODULE_3__helpers_uuid__["a" /* default */])());
    } // Map children to dynamically setup refs


    return Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(children, function (child) {
      var result = child; // Clone TabList and Tab components to have refs

      if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["b" /* isTabList */])(child)) {
        var listIndex = 0; // Figure out if the current focus in the DOM is set on a Tab
        // If it is we should keep the focus on the next selected tab

        var wasTabFocused = false;

        if (canUseActiveElement) {
          wasTabFocused = __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.toArray(child.props.children).filter(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["a" /* isTab */]).some(function (tab, i) {
            return document.activeElement === _this2.getTab(i);
          });
        }

        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
          children: Object(__WEBPACK_IMPORTED_MODULE_6__helpers_childrenDeepMap__["b" /* deepMap */])(child.props.children, function (tab) {
            var key = "tabs-" + listIndex;
            var selected = selectedIndex === listIndex;
            var props = {
              tabRef: function tabRef(node) {
                _this2.tabNodes[key] = node;
              },
              id: _this2.tabIds[listIndex],
              panelId: _this2.panelIds[listIndex],
              selected: selected,
              focus: selected && (focus || wasTabFocused)
            };
            if (selectedTabClassName) props.selectedClassName = selectedTabClassName;
            if (disabledTabClassName) props.disabledClassName = disabledTabClassName;
            listIndex++;
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tab, props);
          })
        });
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__helpers_elementTypes__["c" /* isTabPanel */])(child)) {
        var props = {
          id: _this2.panelIds[index],
          tabId: _this2.tabIds[index],
          selected: selectedIndex === index
        };
        if (forceRenderTabPanel) props.forceRender = forceRenderTabPanel;
        if (selectedTabPanelClassName) props.selectedClassName = selectedTabPanelClassName;
        index++;
        result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, props);
      }

      return result;
    });
  };

  /**
   * Determine if a node from event.target is a Tab element for the current Tabs container.
   * If the clicked element is not a Tab, it returns false.
   * If it finds another Tabs container between the Tab and `this`, it returns false.
   */
  _proto.isTabFromContainer = function isTabFromContainer(node) {
    // return immediately if the clicked element is not a Tab.
    if (!isTabNode(node)) {
      return false;
    } // Check if the first occurrence of a Tabs container is `this` one.


    var nodeAncestor = node.parentElement;

    do {
      if (nodeAncestor === this.node) return true;
      if (nodeAncestor.getAttribute('data-tabs')) break;
      nodeAncestor = nodeAncestor.parentElement;
    } while (nodeAncestor);

    return false;
  };

  _proto.render = function render() {
    var _this3 = this;

    // Delete all known props, so they don't get added to DOM
    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        disabledTabClassName = _this$props3.disabledTabClassName,
        domRef = _this$props3.domRef,
        focus = _this$props3.focus,
        forceRenderTabPanel = _this$props3.forceRenderTabPanel,
        onSelect = _this$props3.onSelect,
        selectedIndex = _this$props3.selectedIndex,
        selectedTabClassName = _this$props3.selectedTabClassName,
        selectedTabPanelClassName = _this$props3.selectedTabPanelClassName,
        attributes = _objectWithoutPropertiesLoose(_this$props3, ["children", "className", "disabledTabClassName", "domRef", "focus", "forceRenderTabPanel", "onSelect", "selectedIndex", "selectedTabClassName", "selectedTabPanelClassName"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      ref: function ref(node) {
        _this3.node = node;
        if (domRef) domRef(node);
      },
      "data-tabs": true
    }), this.getChildren());
  };

  return UncontrolledTabs;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

UncontrolledTabs.defaultProps = {
  className: 'react-tabs',
  focus: false
};

UncontrolledTabs.propTypes =  false ? {
  children: childrenPropType,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabledTabClassName: PropTypes.string,
  domRef: PropTypes.func,
  focus: PropTypes.bool,
  forceRenderTabPanel: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  selectedTabClassName: PropTypes.string,
  selectedTabPanelClassName: PropTypes.string
} : {};

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var TabList =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabList, _Component);

  function TabList() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className),
      role: "tablist"
    }), children);
  };

  return TabList;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabList.defaultProps = {
  className: 'react-tabs__tab-list'
};

TabList.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
} : {};
TabList.tabsRole = 'TabList';

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab';

var Tab =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tab, _Component);

  function Tab() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.checkFocus();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.checkFocus();
  };

  _proto.checkFocus = function checkFocus() {
    var _this$props = this.props,
        selected = _this$props.selected,
        focus = _this$props.focus;

    if (selected && focus) {
      this.node.focus();
    }
  };

  _proto.render = function render() {
    var _cx,
        _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        disabledClassName = _this$props2.disabledClassName,
        focus = _this$props2.focus,
        id = _this$props2.id,
        panelId = _this$props2.panelId,
        selected = _this$props2.selected,
        selectedClassName = _this$props2.selectedClassName,
        tabIndex = _this$props2.tabIndex,
        tabRef = _this$props2.tabRef,
        attributes = _objectWithoutPropertiesLoose(_this$props2, ["children", "className", "disabled", "disabledClassName", "focus", "id", "panelId", "selected", "selectedClassName", "tabIndex", "tabRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx[disabledClassName] = disabled, _cx)),
      ref: function ref(node) {
        _this.node = node;
        if (tabRef) tabRef(node);
      },
      role: "tab",
      id: id,
      "aria-selected": selected ? 'true' : 'false',
      "aria-disabled": disabled ? 'true' : 'false',
      "aria-controls": panelId,
      tabIndex: tabIndex || (selected ? '0' : null)
    }), children);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Tab.defaultProps = {
  className: DEFAULT_CLASS,
  disabledClassName: DEFAULT_CLASS + "--disabled",
  focus: false,
  id: null,
  panelId: null,
  selected: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

Tab.propTypes =  false ? {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  disabledClassName: PropTypes.string,
  focus: PropTypes.bool,
  // private
  id: PropTypes.string,
  // private
  panelId: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabRef: PropTypes.func // private

} : {};
Tab.tabsRole = 'Tab';

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DEFAULT_CLASS = 'react-tabs__tab-panel';

var TabPanel =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(TabPanel, _Component);

  function TabPanel() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabPanel.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        forceRender = _this$props.forceRender,
        id = _this$props.id,
        selected = _this$props.selected,
        selectedClassName = _this$props.selectedClassName,
        tabId = _this$props.tabId,
        attributes = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", _extends({}, attributes, {
      className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(className, (_cx = {}, _cx[selectedClassName] = selected, _cx)),
      role: "tabpanel",
      id: id,
      "aria-labelledby": tabId
    }), forceRender || selected ? children : null);
  };

  return TabPanel;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

TabPanel.defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: DEFAULT_CLASS + "--selected"
};

TabPanel.propTypes =  false ? {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  forceRender: PropTypes.bool,
  id: PropTypes.string,
  // private
  selected: PropTypes.bool,
  // private
  selectedClassName: PropTypes.string,
  tabId: PropTypes.string // private

} : {};
TabPanel.tabsRole = 'TabPanel';

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAKCAYAAACuaZ5oAAAACXBIWXMAABcRAAAXEQHKJvM/AAAAvUlEQVQoU2OQy2xIAOILQKzw//9/BmpgoFkOQPwAiA0YoIz/QPwBiAMIaSaEgWY0QM0D4QUgAQWoD+CCQCxAyCAsBmM1B5fNIIUGhAxF0hsADQFYSCTA5NAVOiApBOECAgYLAPEENIcpIKvBpWkDkiYQGyPIQD6UQw2SCdgcgc91BUiaQQnBAU0OOUgccJmD0wIkV8JSGQg3oPnuADbfEW0B1BJQkC1AMhRuGSG9RFmAZFECNDjAGYiQehgGAL2RWdzoE+Y2AAAAAElFTkSuQmCC"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.47dc4a01.js